import { uninitState, statusSuccess, successState, IntlSelectors, statusLoading, statusUninit, loadingState, actions as actions$1, failedState, combineReducers, persistReducer, sessionStorage, assertApiConfig, ApiConfigSelectors, useIntl, useFeatureToggles, useApiConfig, reducer as reducer$9, useDispatch, useSelector, statusFailed, LOADING, UNINIT, statusWarning, useSaga, Locales, useViewHistory, ViewHistoryKey, withIntl, withApiConfig, SagaRegistry, ReducersRegistry } from '@grandvisionhq/state';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { Helpers, StockIndicator } from '@grandvisionhq/inventory';
import { getNestedProperty, getLocalizedValue, getLocalizedAttrValue, getAttrValue, isPresent, getLocalizedAttrValues, getJoinedLocalizedAttrValues, placeholderImage, isString, getFrontImage, isDefined as isDefined$1, isNumber, DateUtils, createImageUrl, useLocalStorage, PrescriptionValueUtils, sortPrescriptionParameters, isNil, isBoolean, sanitizeStringForUrl, optionalKey, calculateHeaderHeight, isPlainObject, isModifiedClickEvent, withLazyLoading } from '@grandvisionhq/utils';
import { createSelector } from 'reselect';
import { Selectors, Actions, ConfiguratorStepTitleAndDescription, StepForm, useConfiguratorContext, ConnectedStepForm, Configurator } from '@grandvisionhq/configurator';
import { takeLatest, call, put, select, all, race, take, delay } from 'redux-saga/effects';
import { Products, useApiClient } from '@grandvisionhq/api-client';
import { DataLayer, calcPrice, useWasSeenByUser, getIncludedVatAmount, priceVatCalc, pushSdAction, createPriceSpecification, parseProductData, ActionType, useAlgoliaAnalytics, WebPage, AlgoliaAnalytics, Product } from '@grandvisionhq/analytics';
import { Util, Select, RadioButtons, DateOfBirthSelect, DatePicker, Form, RequiredFieldsLabel } from '@grandvisionhq/forms';
import { ReduxDataSource, AddToCart, MiniCart, AddToCartNotification } from '@grandvisionhq/carts';
import * as React from 'react';
import React__default, { useState, useImperativeHandle, Component, useContext, useRef, useEffect, useMemo, useCallback, createContext } from 'react';
import classnames from 'classnames';
import { MediaQuery, LazyImage, SkeletonLoader, Price, Carousel, Loader, Button, Modal, LockBodyScroll, List, toast, IconButton, Expander, PriceTag, RadioButton, Card, LoaderScreen, Tooltip, RichTextArea, Alert, CheckboxList, FilesList, Sticky, StickyCallToAction, EyeSideIndicator, DateTime, QuantitySelector, ScrollIntoView, Tabs, Tab, SliderCarousel, Breadcrumbs, Util as Util$1, Image, SelectionGroup } from '@grandvisionhq/common';
import { Heading, Text, Checkbox, RoundedButton, Hr, ResponsiveImage, getSelectionBoxStyles, Radio, ButtonWithDropdown, Label, Container } from '@grandvisionhq/elements';
import { InView, useInView } from 'react-intersection-observer';
import loadScript from 'load-script';
import { Icon, FeatureIcon } from '@grandvisionhq/icons';
import { useReviewsContext, Actions as Actions$1, ReviewSnippet } from '@grandvisionhq/reviews';
import { useExperiment } from '@grandvisionhq/experiment';
import { usePersistentRandomId } from '@grandvisionhq/persistent-random-id';
import { useUpload, Upload, useUploadHandler, Types, UploadProvider } from '@grandvisionhq/upload';
import { debounce } from 'throttle-debounce';
import { createSlotsContext } from '@grandvisionhq/slots';
import { gql, useLazyQuery, useQuery } from '@grandvisionhq/graphql';
import { UspGroup } from '@grandvisionhq/content';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import useOnClickOutside from 'use-onclickoutside';
import { PreferredStoreFinder } from '@grandvisionhq/stores';
import { motion } from 'framer-motion';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};
function __extends$1(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

// using hardcoded english locale here to map:
// https://github.com/GrandVisionHQ/gv-core-components/blob/69612677a059e714191bee6c94b62f7866e039f1/packages/common/src/ColorPicker/color-mapping.tsx#L1
var COLOR_MAPPING_LOCALE = 'en-GB';
function getDiscountText(locale, variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return '';
    }
    var priceObject = variant.prices[0];
    var description = getNestedProperty(priceObject, 'discounted.discount.obj.description');
    return getLocalizedValue(description, locale);
}
var getExtrasId = function (product) {
    if (!product || !product.masterVariant || !Array.isArray(product.masterVariant.attributes)) {
        return undefined;
    }
    var extrasAttribute = product.masterVariant.attributes.find(function (attr) { return attr.name === 'lensExtras'; });
    if (!extrasAttribute || !extrasAttribute.value) {
        return undefined;
    }
    return extrasAttribute.value.id;
};
function getPrice$1(variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    var price = variant.prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode,
        };
    }
    var discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount,
    };
}
function getProductTypeName$1(product) {
    var result = product &&
        product.productType &&
        product.productType.obj &&
        CommerceToolsApi.isProductTypeName(product.productType.obj.name)
        ? product.productType.obj.name
        : false;
    return !!result ? result : undefined;
}
function getProductModelName(variant, locale, productType) {
    if (CommerceToolsApi.isLenses(productType)) {
        return getLocalizedAttrValue(variant, 'materialType', locale);
    }
    return variant.name || '';
}
var getProductTitle = function (productType, product, variant, locale) {
    var _a, _b;
    var brand = productType.toLowerCase() === 'contact-lenses'
        ? getLocalizedValue(product.name, locale)
        : String(getAttrValue(variant, 'brand'));
    var replacementFrequency = getLocalizedAttrValue((_a = product === null || product === void 0 ? void 0 : product.masterVariant) !== null && _a !== void 0 ? _a : {}, 'replacementFrequency', locale) || '';
    var brandModel = getAttrValue(variant, 'brandModel') || '';
    var brandModelCode = getAttrValue(variant, 'brandModelCode') || '';
    var brandModelColorCode = getAttrValue((_b = product === null || product === void 0 ? void 0 : product.masterVariant) !== null && _b !== void 0 ? _b : {}, 'brandModelColorCode') || '';
    return (replacementFrequency + " " + brand + " " + brandModel + " " + (brandModelCode !== brandModel ? brandModelCode : '') + " " + brandModelColorCode)
        .replace(/\s+/g, ' ')
        .trim();
};
function getActiveVariant$1(product, sku) {
    if (!sku) {
        return product.masterVariant;
    }
    if (product.masterVariant.sku === sku) {
        return product.masterVariant;
    }
    return product.variants.find(function (variant) { return variant.sku === sku; }) || product.masterVariant;
}
function getAvailability$1(variant) {
    return variant.availability
        ? {
            availableQuantity: Helpers.getAvailableQuantity(variant.availability),
        }
        : {};
}
var getLensPropertyValue = function (variant, attrName) {
    var value = getAttrValue(variant, attrName);
    // We only care about numbers and strings
    if (!isPresent(value) || !(typeof value === 'number' || typeof value === 'string')) {
        return undefined;
    }
    return String(value);
};
function getSunglassesFeatureValue(variant, attrName, attrType) {
    var value = getAttrValue(variant, attrName);
    // We want to only return a value of type number in case that's the requested attr type.
    if (attrType === 'number') {
        return typeof value === 'number' ? value : undefined;
    }
    // We want to only return a value of type boolean in case that's the requested attr type.
    if (attrType === 'boolean') {
        return typeof value === 'boolean' ? value : undefined;
    }
    return undefined;
}
function getVariantInfo$1(product, productType, locale, variant, staticsUrl, isBynderImagesEnabled) {
    var _a;
    var activeVariant = !variant || typeof variant === 'string' ? getActiveVariant$1(product, variant) : variant;
    var allowBackOrderAttribute = getAttrValue(activeVariant, 'allowBackOrder');
    var allowBackOrder = typeof allowBackOrderAttribute === 'undefined' ? undefined : !!allowBackOrderAttribute;
    var sharedProductInfo = {
        sku: activeVariant.sku || '',
        modelName: getProductModelName(activeVariant, locale, productType),
        header: getLocalizedAttrValue(activeVariant, 'header', locale),
        description: getLocalizedAttrValue(activeVariant, 'description', locale),
        images: getProductImages$1(activeVariant, staticsUrl, isBynderImagesEnabled),
        usps: getLocalizedAttrValues(activeVariant, 'usps', locale) || [],
        price: getPrice$1(activeVariant),
        brand: String(getAttrValue(activeVariant, 'brand')),
        discountText: getDiscountText(locale, activeVariant),
        allowBackOrder: allowBackOrder,
        excludedFromCheckout: !!getAttrValue(activeVariant, 'excludedFromCheckout'),
        channelAvailability: activeVariant.channelAvailability,
    };
    var sharedFrameInfo = {
        name: activeVariant.name || '',
        frameColorLabel: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale),
        frameColor: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', COLOR_MAPPING_LOCALE),
        frameShape: getLocalizedAttrValue(activeVariant, 'frameShape', locale),
        frameMaterial: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale),
        gender: getLocalizedAttrValues(activeVariant, 'gender', locale) || ['UNISEX'],
        isKids: false,
        isOfferedWithPrescriptions: (_a = activeVariant.isOfferedWithPrescriptions) !== null && _a !== void 0 ? _a : false,
        sku: activeVariant.sku || '',
    };
    var genderKeys = getLocalizedAttrValues(activeVariant, 'gender', locale);
    if (genderKeys && Array.isArray(genderKeys) && genderKeys.length) {
        sharedFrameInfo.isKids = genderKeys.some(function (a) { return a.toLowerCase() === 'kids'; });
    }
    // Contact-lenses
    if (CommerceToolsApi.isLenses(productType)) {
        var info = __assign$1(__assign$1({}, sharedProductInfo), { productType: 'Contact-lenses', brand: getLocalizedValue(product.name, locale), replacementFrequency: getLocalizedAttrValue(activeVariant, 'replacementFrequency', locale), materialType: getLocalizedAttrValue(activeVariant, 'materialType', locale), lensType: getLocalizedAttrValue(activeVariant, 'lensType', locale), material: getLocalizedAttrValue(activeVariant, 'material', locale), waterContent: getLocalizedAttrValue(activeVariant, 'waterContent', locale), packageQuantity: Number(getAttrValue(activeVariant, 'packageQuantity')), features: {
                hydration: !!getAttrValue(activeVariant, 'cbHydration'),
                softness: !!getAttrValue(activeVariant, 'cbSoftness'),
                breathability: !!getAttrValue(activeVariant, 'cbBreathability'),
                fatigue: !!getAttrValue(activeVariant, 'cbFatigue'),
                uv: !!getAttrValue(activeVariant, 'cbUV'),
                basics: !!getAttrValue(activeVariant, 'cbBasics'),
            }, lensProperties: {
                power: getLensPropertyValue(activeVariant, 'power'),
                baseCurve: getLensPropertyValue(activeVariant, 'baseCurve'),
                diameter: getLensPropertyValue(activeVariant, 'diameter'),
                axis: getLensPropertyValue(activeVariant, 'axis'),
                cylinder: getLensPropertyValue(activeVariant, 'cylinder'),
                addition: getLensPropertyValue(activeVariant, 'addition'),
                color: getLensPropertyValue(activeVariant, 'color'),
            }, promotionalText: getLocalizedAttrValue(activeVariant, 'promotionalText', locale) });
        return info;
        // Sunglasses
    }
    else if (CommerceToolsApi.isSunglasses(productType)) {
        var availability = getAvailability$1(activeVariant);
        var info = __assign$1(__assign$1(__assign$1(__assign$1({}, sharedProductInfo), sharedFrameInfo), { productType: 'Sunglasses', lensColor: getJoinedLocalizedAttrValues(activeVariant, 'lensColor', locale), features: {
                uvCategory: getSunglassesFeatureValue(activeVariant, 'UVCategory', 'number'),
                polarized: getSunglassesFeatureValue(activeVariant, 'polarized', 'boolean'),
                glazable: getSunglassesFeatureValue(activeVariant, 'glazeble', 'boolean'),
            } }), { availability: availability });
        return info;
    } //Solutions
    else if (CommerceToolsApi.isSolutions(productType)) {
        var availability = getAvailability$1(activeVariant);
        return __assign$1(__assign$1(__assign$1({}, sharedProductInfo), { contactLensCareType: getLocalizedAttrValue(activeVariant, 'contactLensCareType', locale), packageOption: String(getAttrValue(activeVariant, 'packageOption')), productType: 'Solutions', description: getLocalizedValue(product.description, locale), targetUsers: getLocalizedAttrValue(activeVariant, 'targetUsers', locale), convenience: getLocalizedAttrValue(activeVariant, 'convenience', locale), keyInstructions: getLocalizedAttrValue(activeVariant, 'keyInstructions', locale), features: {
                cleaning: getAttrValue(activeVariant, 'cbCleaning'),
                comfort: getAttrValue(activeVariant, 'cbComfort'),
                disinfect: getAttrValue(activeVariant, 'cbDisinfect'),
                hydration: getAttrValue(activeVariant, 'cbHydration'),
                rinsing: getAttrValue(activeVariant, 'cbRinsing'),
                sensitivity: getAttrValue(activeVariant, 'cbSensitivity'),
            } }), { availability: availability });
    } // Ready-readers
    else if (CommerceToolsApi.isReadyReaders(productType)) {
        var availability = getAvailability$1(activeVariant);
        return __assign$1(__assign$1(__assign$1(__assign$1({}, sharedProductInfo), sharedFrameInfo), { productType: 'Ready-readers', features: {
                blueFilter: getAttrValue(activeVariant, 'blueFilter'),
                isOfferedWithPrescriptions: getAttrValue(activeVariant, 'isOfferedWithPrescriptions'),
            } }), { availability: availability });
    }
    //Frames
    else {
        var info = __assign$1(__assign$1(__assign$1({}, sharedProductInfo), sharedFrameInfo), { productType: 'Frames', availability: getAvailability$1(activeVariant) });
        return info;
    }
}
function getVariants$1(variants, staticsUrl, _a, product, formatProductUrl, isBynderImagesEnabled) {
    var productType = _a.productType;
    return variants.map(function (variant) {
        var _a, _b;
        return ({
            sku: variant.sku,
            image: (_b = (_a = getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled)[0]) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '',
            url: formatProductUrl({
                productType: productType,
                sku: variant.sku,
                slug: product.slug,
            }),
        });
    });
}
function getVariantPickerLabel(variant) {
    return [variant.lensColor, variant.frameColorLabel].filter(function (str) { return str.trim() !== ''; }).join(' / ');
}
function getProductAltTag(name, product, productType, locale) {
    var brand = getAttrValue(product, 'brand');
    var frameColor = getJoinedLocalizedAttrValues(product, 'frameColor', locale);
    var lensColor = getJoinedLocalizedAttrValues(product, 'lensColor', locale);
    if (productType &&
        (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType))) {
        return typeof name === 'string' ? name : getLocalizedValue(name, locale);
    }
    var colorInfo = (productType && CommerceToolsApi.isFrames(productType)) || !lensColor
        ? frameColor
        : "" + lensColor + (frameColor && " / " + frameColor);
    return brand + " " + product.name + " " + colorInfo;
}
/**
 * This function decides where and how to load the product images
 * There are two different paths, one with a supplied staticsUrl and one without
 *  - If a staticsUrl is supplied, we return the full image urls
 *  - If bynder images are enabled, we return the full image urls from the media property
 *  - If no staticsUrl is given and bynder is not enabled, we return the image filename in a legacy format
 */
function getProductImages$1(variant, staticsUrl, isBynderImagesEnabled) {
    var _a;
    // Return legacy format
    if (!staticsUrl && !isBynderImagesEnabled) {
        var _b = __read((_a = variant.images) !== null && _a !== void 0 ? _a : [], 2), primary = _b[0], secondary = _b[1];
        return { primary: primary, secondary: secondary };
    }
    return getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled);
}
/**
 * Prepends variant images with staticsUrl
 */
function getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled) {
    if (isBynderImagesEnabled) {
        var images = getNestedProperty(variant, 'media.images', []);
        return images;
    }
    if (!variant.images || !variant.images.length) {
        return [placeholderImage];
    }
    return variant.images.map(function (image) {
        return {
            url: "" + staticsUrl + image.url,
            dimensions: __assign$1({}, image.dimensions),
        };
    });
}

var helpers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getDiscountText: getDiscountText,
    getExtrasId: getExtrasId,
    getPrice: getPrice$1,
    getProductTypeName: getProductTypeName$1,
    getProductModelName: getProductModelName,
    getProductTitle: getProductTitle,
    getActiveVariant: getActiveVariant$1,
    getLensPropertyValue: getLensPropertyValue,
    getSunglassesFeatureValue: getSunglassesFeatureValue,
    getVariantInfo: getVariantInfo$1,
    getVariants: getVariants$1,
    getVariantPickerLabel: getVariantPickerLabel,
    getProductAltTag: getProductAltTag,
    getProductImages: getProductImages$1,
    getFullImageUrls: getFullImageUrls
});

var reduceVariantInfo = function (locale) { return function (mem, variant) {
    var _a;
    if (!variant.sku || !variant.isMatchingVariant || !variant.attributes) {
        return mem;
    }
    var variationAttribute = getAttrValue(variant, 'variationAttribute');
    if (!variationAttribute || !isString(variationAttribute)) {
        return mem;
    }
    var title = getLocalizedAttrValue(variant, variationAttribute, locale);
    if (!title) {
        return mem;
    }
    var isDefault = getAttrValue(variant, 'default') === true;
    return __spreadArray$1(__spreadArray$1([], __read(mem)), [
        __assign$1({ sku: variant.sku, title: title, isDefault: isDefault }, (((_a = variant.images) === null || _a === void 0 ? void 0 : _a.length) ? { image: variant.images[0] } : {})),
    ]);
}; };
var getVariants = function (product, sku, locale) {
    var productHasOnlyMasterVariant = !product.variants.length;
    return productHasOnlyMasterVariant
        ? {}
        : {
            variants: __spreadArray$1([product.masterVariant], __read(product.variants)).reduce(reduceVariantInfo(locale), []),
        };
};
var getBaseInfo = function (product, sku, locale) {
    var _a, _b, _c, _d, _e, _f, _g;
    var variant = getActiveVariant$1(product, sku);
    var isMasterVariant = product.masterVariant.sku === variant.sku;
    var productHasOnlyMasterVariant = !product.variants.length;
    var isDefault = false;
    // We only want to consider the "default" value of a master variant if the product doesn't have any variants
    if (isMasterVariant && productHasOnlyMasterVariant) {
        isDefault = getAttrValue(variant, 'default') === true;
    }
    else if (!isMasterVariant) {
        isDefault = getAttrValue(variant, 'default') === true;
    }
    var rootImage;
    // We always take the root image from the masterVariant
    var _h = __read((_a = product.masterVariant.images) !== null && _a !== void 0 ? _a : [], 2), firstMasterImage = _h[0], secondMasterImage = _h[1];
    var _j = __read((_b = variant.images) !== null && _b !== void 0 ? _b : [], 1), variantImage = _j[0];
    // If it has variants the second image is the root image
    if (!isMasterVariant) {
        // If the SKU isn't the masterVariant's SKU we're constructing this object for when a variant has been selected
        rootImage = variantImage;
    }
    else {
        rootImage = productHasOnlyMasterVariant ? firstMasterImage : secondMasterImage;
    }
    var discountDescription = (_g = (_f = (_e = (_d = (_c = variant.prices) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.discounted) === null || _e === void 0 ? void 0 : _e.discount) === null || _f === void 0 ? void 0 : _f.obj) === null || _g === void 0 ? void 0 : _g.description;
    var discountText = discountDescription
        ? getLocalizedValue(discountDescription, locale)
        : undefined;
    return __assign$1(__assign$1({ sku: sku, title: getLocalizedValue(product.name, locale), description: product.description ? getLocalizedValue(product.description, locale) : undefined, price: getPrice$1(variant), isDefault: isDefault }, (discountText && { discountText: discountText })), (rootImage ? { image: rootImage } : {}));
};
var getUsps = function (product, sku, locale) {
    var variant = getActiveVariant$1(product, sku);
    return getLocalizedAttrValues(variant, 'prescriptionGlassPackageUsps', locale);
};
var convertToFrameInfo = function (product, sku, locale) {
    var variant = getActiveVariant$1(product, sku);
    var brand = typeof getAttrValue(variant, 'brand') !== 'object' ? String(getAttrValue(variant, 'brand')) : '';
    var codeAttr = getAttrValue(variant, 'brandModelCode');
    var code = typeof codeAttr === 'string' ? codeAttr : '';
    var title = getLocalizedValue(product.name, locale) || [brand, code].filter(Boolean).join(' ');
    return {
        brand: brand,
        code: code,
        price: getPrice$1(variant),
        sku: sku,
        title: title,
    };
};
var convertToLensTypeInfo = function (product, sku, locale) { return (__assign$1(__assign$1({}, getBaseInfo(product, sku, locale)), getVariants(product, sku, locale))); };
var convertToPackageInfo = function (product, sku, locale) {
    var _a, _b, _c;
    var variant = getActiveVariant$1(product, sku);
    return __assign$1(__assign$1({}, getBaseInfo(product, sku, locale)), { usps: getUsps(product, sku, locale), areAddOnsOptional: (_c = (_b = (_a = variant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.name === 'areAddonsOptional'; })) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : true });
};
var convertToLensAddOnInfo = function (product, sku, locale) { return (__assign$1(__assign$1({}, getBaseInfo(product, sku, locale)), getVariants(product, sku, locale))); };
var lowToHigh = function (extractPrice) { return function (left, right) {
    return (extractPrice(left) || 0) - (extractPrice(right) || 0);
}; };

var stateProp$1 = function (s) { return s; };
var configuratorIdProp$1 = function (_, _a) {
    var id = _a.id;
    return id;
};
var frameSkuProp = function (_, _a) {
    var frameSku = _a.frameSku;
    return frameSku;
};
var lensTypeSkuProp = function (_, _a) {
    var lensTypeSku = _a.lensTypeSku;
    return lensTypeSku;
};
var packageSkuProp = function (_, _a) {
    var packageSku = _a.packageSku;
    return packageSku;
};
var addOnSkuProp = function (_, _a) {
    var addOnSku = _a.addOnSku;
    return addOnSku;
};
var getPrescriptionGlasses = function (state) {
    return state.prescriptionGlasses;
};
createSelector(getPrescriptionGlasses, function (pg) { return pg.prescription; });

var getProducts = createSelector(getPrescriptionGlasses, function (pg) { return pg.products; });
var getFrames = createSelector(getProducts, function (p) { return p.frames; });
var getLensTypes$2 = createSelector(getProducts, function (p) { return p.lensTypes; });
/**
 * Returns the SKUs of the lens-types that we've already loaded from the server
 */
createSelector(getLensTypes$2, function (lensTypes) { return new Set(Object.keys(lensTypes)); });
var getPackages$2 = createSelector(getProducts, function (p) { return p.packages; });
createSelector(getPackages$2, function (packages) { return new Set(Object.keys(packages)); });
var getFrame = createSelector(getFrames, frameSkuProp, function (frames, frameSku) { return frames[frameSku]; });
var getLensType = createSelector(getLensTypes$2, lensTypeSkuProp, function (lensTypes, lensTypeSku) { return lensTypes[lensTypeSku]; });
var getPackage = createSelector(getPackages$2, packageSkuProp, function (packages, packageSku) { return packages[packageSku]; });
var getAddOns$1 = createSelector(getProducts, function (p) { return p.addOns; });
createSelector(getAddOns$1, function (addOns) { return new Set(Object.keys(addOns)); });
var getAddOn = createSelector(getAddOns$1, addOnSkuProp, function (addOns, addOnSku) { return addOns[addOnSku]; });
var getBundleProductVariants = createSelector(getProducts, function (p) { return p.variants; });
/**
 * Whenever a lens type is not a master variant, we need to be able to find its parent lens type
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */
var lookupParentLensType = createSelector(getBundleProductVariants, getLensTypes$2, lensTypeSkuProp, function (variants, lensTypes, lensTypeSku) {
    var masterSku = variants[lensTypeSku];
    if (!masterSku) {
        return undefined;
    }
    return lensTypes[masterSku];
});
/**
 * Whenever a lens add-on is not a master variant, we need to be able to find its parent add-on
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */
var lookupParentAddOn = createSelector(getBundleProductVariants, getAddOns$1, addOnSkuProp, function (variants, addOns, addOnSku) {
    var masterSku = variants[addOnSku];
    if (!masterSku) {
        return undefined;
    }
    return addOns[masterSku];
});

var getBundles = createSelector(getPrescriptionGlasses, function (pg) { return pg.bundles; });
/**
 * Frames
 */
var getBundleFrames = createSelector(getBundles, function (b) { return b.frames; });
var getBundleFrame = createSelector(getBundleFrames, frameSkuProp, function (frames, frameSku) { return frames[frameSku]; });
/**
 * Lens Types
 */
var getBundleLensTypes = createSelector(getBundles, function (b) { return b.lensTypes; });
var getBundleLensType = createSelector(getBundleLensTypes, lensTypeSkuProp, function (lensTypes, lensTypeSku) { return lensTypes[lensTypeSku]; });
/**
 * Packages
 */
var getBundlePackages = createSelector(getBundles, function (b) { return b.packages; });
var getBundlePackage = createSelector(getBundlePackages, packageSkuProp, function (packages, packageSku) { return packages[packageSku]; });
/**
 * Add-ons
 */
var getBundleAddOns = createSelector(getBundles, function (b) { return b.addOns; });
var convertToParamArray = function (o) {
    return Object.entries(o).map(function (_a) {
        var _b = __read(_a, 2), name = _b[0], param = _b[1];
        return ({
            name: name,
            values: param ? param.values : new Set(),
        });
    });
};
var getOpticalParameters = createSelector(getBundleFrame, getBundleLensType, function (bundle, lensType) {
    if (!bundle) {
        return uninitState();
    }
    if (!statusSuccess(lensType)) {
        return lensType;
    }
    return successState(__spreadArray$1(__spreadArray$1([], __read(convertToParamArray(lensType.result.opticalParameters))), __read(convertToParamArray(bundle.opticalParameters))));
});

var isDefined = function (v) { return typeof v !== 'undefined'; };
var isDefinedAndHasPrice = function (v) {
    return isDefined(v) && isDefined(v.price);
};
/**
 * Checks if the SKU belongs to a master variant. This decides whether the "product" gets
 * its own tile, or that it should be part of a tile as a variant.
 */
var isMasterProduct = function (product, sku) { return (product === null || product === void 0 ? void 0 : product.masterVariant.sku) === sku; };
/**
 * These are public selectors that are meant to be used from the container components outside of this state dir
 */
var isAnyStillLoading = function (resources, skus) {
    return __spreadArray$1([], __read(skus)).reduce(function (isLoading, sku) {
        var _a;
        if (isLoading) {
            return isLoading;
        }
        var resource = (_a = resources[sku]) !== null && _a !== void 0 ? _a : uninitState();
        return statusLoading(resource) || statusUninit(resource);
    }, false);
};
var getLensTypes$1 = createSelector(getBundleFrame, getBundleLensTypes, IntlSelectors.getLocale, function (s) { return s; }, function (bundle, lensTypes, locale, s) {
    if (!bundle || !locale) {
        return uninitState();
    }
    var lensTypeSkus = bundle.lensTypeSkus;
    if (isAnyStillLoading(lensTypes, lensTypeSkus)) {
        return loadingState();
    }
    var results = __spreadArray$1([], __read(lensTypeSkus)).map(function (lensTypeSku) {
        var lensType = getLensType(s, { lensTypeSku: lensTypeSku });
        if (!lensType) {
            return undefined;
        }
        if (!isMasterProduct(lensType, lensTypeSku)) {
            return undefined;
        }
        return convertToLensTypeInfo(lensType, lensTypeSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (lensType) { var _a, _b, _c; return (_b = (_a = lensType.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = lensType.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return successState(results);
});
var getPackages$1 = createSelector(getBundleLensType, getBundlePackages, IntlSelectors.getLocale, function (s) { return s; }, function (lensType, packages, locale, s) {
    if (!lensType || !locale) {
        return uninitState();
    }
    if (!statusSuccess(lensType)) {
        return lensType;
    }
    var packageSkus = lensType.result.packageSkus;
    if (isAnyStillLoading(packages, packageSkus)) {
        return loadingState();
    }
    var results = __spreadArray$1([], __read(packageSkus)).map(function (packageSku) {
        var packageProduct = getPackage(s, { packageSku: packageSku });
        if (!packageProduct) {
            return undefined;
        }
        if (!isMasterProduct(packageProduct, packageSku)) {
            return undefined;
        }
        return convertToPackageInfo(packageProduct, packageSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (packageInfo) { var _a, _b, _c; return (_b = (_a = packageInfo.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = packageInfo.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return successState(results);
});
var getLensAddOns = createSelector(getBundlePackage, getBundleAddOns, IntlSelectors.getLocale, function (s) { return s; }, function (bundlePackage, addOns, locale, s) {
    if (!bundlePackage || !locale) {
        return uninitState();
    }
    if (!statusSuccess(bundlePackage)) {
        return bundlePackage;
    }
    var addOnSkus = bundlePackage.result.addOnSkus;
    if (isAnyStillLoading(addOns, addOnSkus)) {
        return loadingState();
    }
    var results = __spreadArray$1([], __read(addOnSkus)).map(function (addOnSku) {
        var addOnProduct = getAddOn(s, { addOnSku: addOnSku });
        if (!addOnProduct) {
            return undefined;
        }
        if (!isMasterProduct(addOnProduct, addOnSku)) {
            return undefined;
        }
        return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (addOnInfo) { var _a, _b, _c; return (_b = (_a = addOnInfo.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = addOnInfo.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return successState(results);
});

var add = actions$1.action('products/prescription-glasses/add-to-cart');
var addSuccess = actions$1.action('products/prescription-glasses/add-to-cart-success');
var addFailed = actions$1.action('products/prescription-glasses/add-to-cart-failed', function (error) { return ({ error: error }); });

var fetchLensTypes = actions$1.action('products/prescription-glasses/fetch-lens-types', actions$1.payload());
var fetchLensTypesSuccess = actions$1.action('products/prescription-glasses/fetch-lens-types-success', actions$1.payload());
var fetchLensTypesFailed = actions$1.action('products/prescription-glasses/fetch-lens-types-failed', actions$1.payload());
var fetchPackages = actions$1.action('products/prescription-glasses/fetch-packages', actions$1.payload());
var fetchPackagesSuccess = actions$1.action('products/prescription-glasses/fetch-packages-success', actions$1.payload());
var fetchPackagesFailed = actions$1.action('products/prescription-glasses/fetch-packages-failed', actions$1.payload());
var fetchAddOns = actions$1.action('products/prescription-glasses/fetch-add-ons', actions$1.payload());
var fetchAddOnsSuccess = actions$1.action('products/prescription-glasses/fetch-add-ons-success', actions$1.payload());
var fetchAddOnsFailed = actions$1.action('products/prescription-glasses/fetch-add-ons-failed', actions$1.payload());

var selectLensType = actions$1.action('products/prescription-glasses/select-lens-type', actions$1.payload());
var selectLensTypeFailed = actions$1.action('products/prescription-glasses/select-lens-type-failed', actions$1.payload());
var selectLensTypeSuccess = actions$1.action('products/prescription-glasses/select-lens-type-success', actions$1.payload());
var selectPackage = actions$1.action('products/prescription-glasses/select-package', actions$1.payload());
var selectPackageFailed = actions$1.action('products/prescription-glasses/select-package-failed', actions$1.payload());
var selectPackageSuccess = actions$1.action('products/prescription-glasses/select-package-success', actions$1.payload());
var resetSelectedPackage = actions$1.action('products/prescription-glasses/reset-selected-package', actions$1.payload());
var selectAddOn = actions$1.action('products/prescription-glasses/select-add-on', actions$1.payload());
var selectAddOnFailed = actions$1.action('products/prescription-glasses/select-add-on-failed', actions$1.payload());
var selectAddOnSuccess = actions$1.action('products/prescription-glasses/select-add-on-success', actions$1.payload());
var resetSelectedAddOn = actions$1.action('products/prescription-glasses/reset-selected-add-on', actions$1.payload());
var updateUploadReference = actions$1.action('products/prescription-glasses/update-upload-reference', actions$1.payload());
var removeUploadReference = actions$1.action('products/prescription-glasses/remove-upload-reference', actions$1.payload());
var updatePrescriptionValue = actions$1.action('products/prescription-glasses/update-prescription-value', actions$1.payload());
var updatePrescriptionInfo = actions$1.action('products/prescription-glasses/update-prescription-info', actions$1.payload());
var updatePrescriptionType = actions$1.action('products/prescription-glasses/update-prescription-type', actions$1.payload());
var updateVerificationAllowed = actions$1.action('products/prescription-glasses/update-verification-allowed', actions$1.payload());

var getFileUploadResult = function (result) {
    if (typeof result === 'string') {
        return result;
    }
    if (!result) {
        return null;
    }
    var key = ('errors' in result ? result.errors[0].code : result.message).toLowerCase();
    var keyToLabelMap = {
        'file-invalid-type': 'file not supported',
        'file-too-large': 'file too large',
        'too-many-files': 'too many files',
    };
    if (key.includes('recaptcha')) {
        return 'upload not possible - recaptcha';
    }
    return keyToLabelMap[key] || null;
};

var fileUploadResult = actions$1.action('products/prescription-glasses/file-upload-result', function (result) { return ({
    result: getFileUploadResult(result),
}); });

var addToCart$1 = actions$1.action('products/prescription-glasses/legacy__add-to-cart');
var addToCartFailed$1 = actions$1.action('products/prescription-glasses/legacy__add-to-cart-failed', function (error) { return ({ error: error }); });
var addToCartSuccess$1 = actions$1.action('products/prescription-glasses/legacy__add-to-cart-success', actions$1.payload());

var startPrescriptionGlassesConfiguration = actions$1.action('products/prescription-glasses/start', actions$1.payload());
actions$1.action('products/prescription-glasses/next-step');
actions$1.action('products/prescription-glasses/next-step-success', actions$1.payload());
actions$1.action('products/prescription-glasses/next-step-failed', actions$1.payload());
actions$1.action('products/prescription-glasses/previous-step');
actions$1.action('products/prescription-glasses/previous-step-failed', actions$1.payload());
actions$1.action('products/prescription-glasses/previous-step-success', actions$1.payload());

var extractSkus = function (attributeName) { return function (variant) {
    var _a;
    var attribute = (_a = variant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.name === attributeName; });
    if (!attribute) {
        return new Set();
    }
    if (Array.isArray(attribute.value)) {
        return new Set(attribute.value);
    }
    else if (typeof attribute.value === 'string') {
        return new Set(attribute.value.split(','));
    }
    return new Set();
}; };
var extractLensTypeSkus = extractSkus('compatibleLensTypeProducts');
var extractPackageSkus = extractSkus('compatiblePackageProducts');
var extractAddOnSkus = extractSkus('compatibleOptionProduct');
var extractOpticalParameters = function (variant) {
    if (!variant.opticalParameters) {
        return {};
    }
    return Object.entries(variant.opticalParameters).reduce(function (m, _a) {
        var _b;
        var _c = __read(_a, 2), name = _c[0], value = _c[1];
        return (__assign$1(__assign$1({}, m), (_b = {}, _b[name] = {
            values: value ? new Set(value.values) : new Set(),
        }, _b)));
    }, {});
};
var indexVariantsBySku = function (products) {
    return products
        .reduce(function (m, p) { return __spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(m)), [
        [p.masterVariant.sku, p.masterVariant]
    ]), __read(p.variants.map(function (v) { return [v.sku, v]; }))); }, [])
        .filter(function (v) { return !!v[0]; })
        .reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), sku = _c[0], v = _c[1];
        return (__assign$1(__assign$1({}, acc), (_b = {}, _b[sku] = v, _b)));
    }, {});
};
var createStates = function (skus, stateCreator) {
    return __spreadArray$1([], __read(skus)).reduce(function (acc, sku) {
        var _a;
        var state = stateCreator(sku);
        if (!state) {
            return acc;
        }
        return __assign$1(__assign$1({}, acc), (_a = {}, _a[sku] = state, _a));
    }, {});
};
var initialState$7 = {
    lensTypes: {},
    packages: {},
    addOns: {},
    frames: {},
};
var reducer$8 = actions$1.reducer(initialState$7, 
/**
 * Initializes a new configuration when necessary
 */
actions$1.on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var _c = _a.payload, frame = _c.frame, frameSku = _c.frameSku;
    var variant = getActiveVariant$1(frame, frameSku);
    return __assign$1(__assign$1({}, s), { frames: (_b = {},
            _b[frameSku] = {
                lensTypeSkus: extractLensTypeSkus(variant),
                opticalParameters: extractOpticalParameters(frame.masterVariant),
            },
            _b) });
}), actions$1.on(fetchLensTypes, function (s, a) { return (__assign$1(__assign$1({}, s), { lensTypes: __assign$1(__assign$1({}, s.lensTypes), createStates(a.payload.skus, function () { return loadingState(); })) })); }), actions$1.on(fetchLensTypesFailed, function (s, a) { return (__assign$1(__assign$1({}, s), { lensTypes: __assign$1(__assign$1({}, s.lensTypes), createStates(a.payload.skus, function () { return failedState(a.payload.error); })) })); }), actions$1.on(fetchLensTypesSuccess, function (s, a) {
    var variantLookup = indexVariantsBySku(a.payload.products);
    return __assign$1(__assign$1({}, s), { lensTypes: __assign$1(__assign$1(__assign$1({}, s.lensTypes), createStates(a.payload.tried, function (sku) {
            var variant = variantLookup[sku];
            if (!variant) {
                return;
            }
            return successState({
                packageSkus: extractPackageSkus(variant),
                opticalParameters: extractOpticalParameters(variant),
            });
        })), createStates(a.payload.missing, function (sku) {
            return failedState(new Error("Couldn't find lens type with SKU \"" + sku + "\""));
        })) });
}), actions$1.on(fetchPackages, function (s, _a) {
    var skus = _a.payload.skus;
    return (__assign$1(__assign$1({}, s), { packages: __assign$1(__assign$1({}, s.packages), createStates(skus, function () { return loadingState(); })) }));
}), actions$1.on(fetchPackagesFailed, function (s, a) { return (__assign$1(__assign$1({}, s), { packages: __assign$1(__assign$1({}, s.packages), createStates(a.payload.skus, function () { return failedState(a.payload.error); })) })); }), actions$1.on(fetchPackagesSuccess, function (s, a) { return (__assign$1(__assign$1({}, s), { packages: __assign$1(__assign$1(__assign$1({}, s.packages), createStates(a.payload.tried, function (sku) {
        var product = a.payload.products.find(function (p) { return p.masterVariant.sku === sku; });
        if (!product) {
            return;
        }
        return successState({
            addOnSkus: extractAddOnSkus(product.masterVariant),
        });
    })), createStates(a.payload.missing, function (sku) {
        return failedState(new Error("Couldn't find package with SKU \"" + sku + "\""));
    })) })); }), actions$1.on(fetchAddOns, function (s, _a) {
    var skus = _a.payload.skus;
    return (__assign$1(__assign$1({}, s), { addOns: __assign$1(__assign$1({}, s.addOns), createStates(skus, function () { return loadingState(); })) }));
}), actions$1.on(fetchAddOnsFailed, function (s, a) { return (__assign$1(__assign$1({}, s), { addOns: __assign$1(__assign$1({}, s.addOns), createStates(a.payload.skus, function () { return failedState(a.payload.error); })) })); }), actions$1.on(fetchAddOnsSuccess, function (s, a) { return (__assign$1(__assign$1({}, s), { addOns: __assign$1(__assign$1(__assign$1({}, s.addOns), createStates(a.payload.tried, function () { return successState(undefined); })), createStates(a.payload.missing, function (sku) {
        return failedState(new Error("Couldn't find add-on with SKU \"" + sku + "\""));
    })) })); }));

var RX_SCOPE = 'pg-prescription';
var PD_SCOPE = 'pg-pupillary-distance';
var PRESCRIPTION_STEP_UPLOAD_ERROR_ID = 'prescription-step-upload-error';
var PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID = 'prescription-step-upload-description';

var isPrescriptionValue = function (value) {
    return typeof value === 'number';
};

var defaultState$1 = Object.freeze({
    left: {},
    right: {},
});

var getConfiguration$1 = createSelector(getPrescriptionGlasses, frameSkuProp, function (pg, frameSku) { return pg.configurations[frameSku]; });
var getLensTypeSku = createSelector(getConfiguration$1, function (config) { var _a; return (_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.sku; });
var getPackageSku = createSelector(getConfiguration$1, function (config) { return config === null || config === void 0 ? void 0 : config.package; });
var getAddOnSku = createSelector(getConfiguration$1, function (config) { return config === null || config === void 0 ? void 0 : config.addOn; });
var getPrescription$4 = createSelector(getConfiguration$1, function (c) { var _a, _b; return (_b = (_a = c === null || c === void 0 ? void 0 : c.lensType) === null || _a === void 0 ? void 0 : _a.prescriptionInfo) !== null && _b !== void 0 ? _b : defaultState$1; });

var getPrescriptionType$2 = createSelector(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.prescriptionType; });
/**
 * The currently selected lens-type product for the given frame SKU
 */
var getSelectedLensType$1 = createSelector(getLensTypeSku, IntlSelectors.getLocale, function (s) { return s; }, function (lensTypeSku, locale, state) {
    if (!lensTypeSku || !locale) {
        return undefined;
    }
    var lensTypeProduct = lookupParentLensType(state, { lensTypeSku: lensTypeSku });
    if (!lensTypeProduct) {
        return undefined;
    }
    return convertToLensTypeInfo(lensTypeProduct, lensTypeSku, locale);
});
/**
 * The currently selected package product for the given frame SKU
 */
var getSelectedPackage$1 = createSelector(getPackageSku, IntlSelectors.getLocale, function (s) { return s; }, function (packageSku, locale, state) {
    if (!packageSku || !locale) {
        return undefined;
    }
    var packageProduct = getPackage(state, {
        packageSku: packageSku,
    });
    if (!packageProduct) {
        return undefined;
    }
    return convertToPackageInfo(packageProduct, packageSku, locale);
});
/**
 * The currently selected add-on product for the given frame SKU
 */
var getSelectedAddOn$1 = createSelector(getAddOnSku, IntlSelectors.getLocale, function (s) { return s; }, function (addOnSku, locale, state) {
    if (!addOnSku || !locale) {
        return;
    }
    var addOnProduct = lookupParentAddOn(state, {
        addOnSku: addOnSku,
    });
    if (!addOnProduct) {
        return undefined;
    }
    return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */
var getPrescription$3 = createSelector(getPrescription$4, getLensTypeSku, getOpticalParameters, function (prescription, lensTypeSku, parameters) {
    if (!lensTypeSku) {
        return uninitState();
    }
    if (!statusSuccess(parameters)) {
        return parameters;
    }
    return successState(__assign$1(__assign$1({ parameters: parameters.result }, prescription), { uploadReferences: prescription.uploadReferences || {} }));
});
/**
 * The prescription info as entered on the current frame / lens
 */
var getAdditionalPrescriptionInfoFormState$1 = createSelector(getPrescription$4, function (prescription) { var _a; return (_a = prescription.additionalInfo) !== null && _a !== void 0 ? _a : {}; });
// Returns the values in b that aren't present in a
var diff = function (a, b) { return new Set(__spreadArray$1([], __read(b)).filter(function (i) { return !a.has(i); })); };
/**
 * Get the validation state of the currently selected lens-type for the given frameSku
 */
var getManualPrescriptionValidationState$1 = createSelector(getPrescription$4, getLensTypeSku, getOpticalParameters, function (prescription, lensTypeSku, parameters) {
    if (!lensTypeSku) {
        return undefined;
    }
    if (!statusSuccess(parameters)) {
        return undefined;
    }
    var parameterNames = new Set(parameters.result.map(function (p) { return p.name; }));
    var leftHasExtra = diff(parameterNames, Object.keys(prescription.left)).size > 0;
    var rightHasExtra = diff(parameterNames, Object.keys(prescription.right)).size > 0;
    var initialValidationState = {
        isValid: !leftHasExtra && !rightHasExtra,
        left: {
            isValid: !leftHasExtra,
        },
        right: {
            isValid: !rightHasExtra,
        },
    };
    return parameters.result.reduce(function (acc, param) {
        var _a, _b;
        var leftValue = prescription.left[param.name];
        var rightValue = prescription.right[param.name];
        var isLeftValid = isPrescriptionValue(leftValue) && param.values.has(leftValue);
        var isRightValid = isPrescriptionValue(rightValue) && param.values.has(rightValue);
        var left = __assign$1(__assign$1({}, acc.left), (_a = { isValid: acc.left.isValid && isLeftValid }, _a[param.name] = isLeftValid, _a));
        var right = __assign$1(__assign$1({}, acc.right), (_b = { isValid: acc.right.isValid && isRightValid }, _b[param.name] = isRightValid, _b));
        return {
            isValid: acc.isValid && left.isValid && right.isValid,
            left: left,
            right: right,
        };
    }, initialValidationState);
});
var getPrescriptionUploadValidationState = createSelector(getPrescription$4, getLensTypeSku, function (prescription, lensTypeSku) {
    var _a;
    var _b, _c;
    if (!lensTypeSku) {
        return undefined;
    }
    var uploadReferences = prescription.uploadReferences;
    var hasUploadedRx = !!((_b = (uploadReferences || {})[RX_SCOPE]) === null || _b === void 0 ? void 0 : _b.storageToken);
    var hasUploadedPd = !!((_c = (uploadReferences || {})[PD_SCOPE]) === null || _c === void 0 ? void 0 : _c.storageToken);
    return _a = {
            isValid: hasUploadedRx && hasUploadedPd
        },
        _a[RX_SCOPE] = {
            isValid: hasUploadedRx,
        },
        _a[PD_SCOPE] = {
            isValid: hasUploadedPd,
        },
        _a;
});
var getVerificationAllowed$1 = createSelector(getPrescription$4, function (c) { var _a; return (_a = c === null || c === void 0 ? void 0 : c.verificationAllowed) !== null && _a !== void 0 ? _a : false; });

var getPrescriptionType$1 = function (s, frameSku) { var _a; return ((_a = s[frameSku]) === null || _a === void 0 ? void 0 : _a.prescriptionType) || 'NewPrescription'; };
var reducer$7 = actions$1.reducer({}, 
/**
 * Create a blank configuration but only on the first call
 */
actions$1.on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var _c = _a.payload, frameSku = _c.frameSku, prescriptionTypesOrder = _c.prescriptionTypesOrder;
    if (frameSku in s) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[frameSku] = {
        prescriptionType: (prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder[0]) || 'NewPrescription',
    }, _b));
}), 
/**
 * Changes the selected lens type. If no prescriptionPrefill is passed along we reset the prescription data
 */
actions$1.on(selectLensTypeSuccess, function (s, _a) {
    var _b;
    var _c, _d, _e;
    var payload = _a.payload;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if ((currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.sku) === payload.lensTypeSku) {
        // Don't do anything if we're reselecting the same SKU
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: {
            sku: payload.lensTypeSku,
            prescriptionInfo: __assign$1(__assign$1({}, ((_d = currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.prescriptionInfo) !== null && _d !== void 0 ? _d : {
                uploadReferences: {},
            })), ((_e = payload.prescriptionPrefill) !== null && _e !== void 0 ? _e : {
                left: {},
                right: {},
            })),
        } }), _b));
}), 
/**
 * Changes the selected package for the given frameSku
 */
actions$1.on(selectPackageSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, frameSku = _c.frameSku, packageSku = _c.packageSku;
    var frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.package) === packageSku) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[frameSku] = __assign$1(__assign$1({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), package: packageSku }), _b));
}), 
/**
 * This is used for when there's a package selected that isn't compatible with the current lens-type
 */
actions$1.on(resetSelectedPackage, function (s, _a) {
    var _b;
    var frameSku = _a.payload.frameSku;
    return (__assign$1(__assign$1({}, s), (_b = {}, _b[frameSku] = __assign$1(__assign$1({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), package: undefined }), _b)));
}), 
/**
 * Changes the selected add-on for the given frameSku
 */
actions$1.on(selectAddOnSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, frameSku = _c.frameSku, addOnSku = _c.addOnSku;
    var frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.addOn) === addOnSku) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[frameSku] = __assign$1(__assign$1({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), addOn: addOnSku }), _b));
}), 
/**
 * This is used for when there's a add-on selected that isn't compatible with the current package
 */
actions$1.on(resetSelectedAddOn, function (s, _a) {
    var _b;
    var frameSku = _a.payload.frameSku;
    return (__assign$1(__assign$1({}, s), (_b = {}, _b[frameSku] = __assign$1(__assign$1({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), addOn: undefined }), _b)));
}), 
/**
 * Changes the prescription parameters' value for the given frameSku
 */
actions$1.on(updatePrescriptionValue, function (s, _a) {
    var _b, _c, _d;
    var _e;
    var payload = _a.payload;
    var currentLensType = (_e = s[payload.frameSku]) === null || _e === void 0 ? void 0 : _e.lensType;
    if (!currentLensType) {
        return s;
    }
    var currentSide = currentLensType.prescriptionInfo[payload.side];
    if (currentSide[payload.parameter] === payload.value) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign$1(__assign$1({}, currentLensType), { prescriptionInfo: __assign$1(__assign$1({}, currentLensType.prescriptionInfo), (_c = {}, _c[payload.side] = __assign$1(__assign$1({}, currentSide), (_d = {}, _d[payload.parameter] = payload.value, _d)), _c)) }) }), _b));
}), 
/**
 * Changes the prescription info for the given frameSku
 */
actions$1.on(updatePrescriptionInfo, function (s, _a) {
    var _b;
    var _c, _d;
    var payload = _a.payload;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if (!currentLensType) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: ((_d = s[payload.frameSku]) === null || _d === void 0 ? void 0 : _d.prescriptionType) || 'NewPrescription', lensType: __assign$1(__assign$1({}, currentLensType), { prescriptionInfo: __assign$1(__assign$1({}, currentLensType.prescriptionInfo), { additionalInfo: payload.value }) }) }), _b));
}), 
/**
 * Changes the type of prescription, i.e. existing, email upload, manual input, etc...
 */
actions$1.on(updatePrescriptionType, function (s, _a) {
    var _b;
    var payload = _a.payload;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: payload.prescriptionType }), _b));
}), 
/**
 * Changes the verification allowed info for the given frameSku
 */
actions$1.on(updateVerificationAllowed, function (s, _a) {
    var _b;
    var _c;
    var payload = _a.payload;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if (!currentLensType) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign$1(__assign$1({}, currentLensType), { prescriptionInfo: __assign$1(__assign$1({}, currentLensType.prescriptionInfo), { verificationAllowed: payload.value }) }) }), _b));
}), actions$1.on(updateUploadReference, function (s, _a) {
    var _b, _c;
    var _d;
    var payload = _a.payload;
    var currentLensType = (_d = s[payload.frameSku]) === null || _d === void 0 ? void 0 : _d.lensType;
    if (!currentLensType) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign$1(__assign$1({}, currentLensType), { prescriptionInfo: __assign$1(__assign$1({}, currentLensType.prescriptionInfo), { uploadReferences: __assign$1(__assign$1({}, currentLensType.prescriptionInfo.uploadReferences), (_c = {}, _c[payload.scope] = payload.uploadReference, _c)) }) }) }), _b));
}), actions$1.on(removeUploadReference, function (s, _a) {
    var _b;
    var _c;
    var payload = _a.payload;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if (!currentLensType) {
        return s;
    }
    var currentUploadReferences = currentLensType.prescriptionInfo.uploadReferences;
    var _d = currentUploadReferences || {}, _e = payload.scope; _d[_e]; var remainingScopes = __rest(_d, [typeof _e === "symbol" ? _e : _e + ""]);
    return __assign$1(__assign$1({}, s), (_b = {}, _b[payload.frameSku] = __assign$1(__assign$1({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign$1(__assign$1({}, currentLensType), { prescriptionInfo: __assign$1(__assign$1({}, currentLensType.prescriptionInfo), { uploadReferences: remainingScopes }) }) }), _b));
}));

var getProductImageData = function (product, sku, width, staticsUrl, isBynderImagesEnabled) {
    var _a, _b, _c;
    var variant = getActiveVariant$1(product, sku);
    var ctImage = ((_a = variant.images) === null || _a === void 0 ? void 0 : _a.length) ? variant.images[0] : undefined;
    var ctHeight = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.h) || 0;
    var ctWidth = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.w) || 0;
    // Need to guess an aspect ratio as a fallback
    var aspectRatio = ctHeight > 0 && ctWidth > 0 ? ctHeight / ctWidth : 0.6;
    var calculatedHeight = Math.floor(width * aspectRatio);
    var calculatedWidth = Math.floor(width);
    if (isBynderImagesEnabled) {
        var image = getFrontImage((_b = variant.media) === null || _b === void 0 ? void 0 : _b.images);
        return {
            url: image.url + "?w=" + calculatedWidth + "&fm=jpeg&auto=format",
            dimensions: image.dimensions,
        };
    }
    if (!((_c = variant.images) === null || _c === void 0 ? void 0 : _c.length)) {
        return undefined;
    }
    return {
        url: "" + staticsUrl + variant.images[0].url + "?w=" + calculatedWidth + "&fm=jpeg&auto=format",
        dimensions: {
            h: calculatedHeight,
            w: calculatedWidth,
        },
    };
};

var frameImageProps = function (_, props) { return props; };
var getFrameImage$1 = createSelector(getFrame, frameSkuProp, frameImageProps, function (frame, frameSku, frameImageProps) {
    if (!frame) {
        return undefined;
    }
    var width = frameImageProps.width, staticsUrl = frameImageProps.staticsUrl, isBynderImagesEnabled = frameImageProps.isBynderImagesEnabled;
    return getProductImageData(frame, frameSku, width, staticsUrl, isBynderImagesEnabled);
});

var getConfigurator$1 = createSelector(getPrescriptionGlasses, function (pg) { return pg.configurator; });

/**
 * Exported selectors to be used in container components
 */
var getIsExtraValidationStepEnabled = createSelector(getConfigurator$1, function (c) { return c.isExtraValidationStepEnabled; });
var getFrameSku = createSelector(getConfigurator$1, function (c) { return c === null || c === void 0 ? void 0 : c.frameSku; });
var getFrameImage = createSelector(getFrameSku, function (s) { return s; }, function (_, props) { return props; }, function (frameSku, state, frameImageProps) {
    if (!frameSku) {
        return undefined;
    }
    var width = frameImageProps.width, staticsUrl = frameImageProps.staticsUrl, isBynderImagesEnabled = frameImageProps.isBynderImagesEnabled;
    return getFrameImage$1(state, {
        frameSku: frameSku,
        width: width,
        staticsUrl: staticsUrl,
        isBynderImagesEnabled: isBynderImagesEnabled,
    });
});
/**
 * Returns the FrameInfo of the frame that's currently being configured
 */
var getSelectedFrame = createSelector(getFrameSku, getFrames, IntlSelectors.getLocale, function (frameSku, frames, locale) {
    if (!frameSku || !locale) {
        return undefined;
    }
    var frame = frames[frameSku];
    if (!frame) {
        return undefined;
    }
    return convertToFrameInfo(frame, frameSku, locale);
});
var getSelectedFrameProductType = createSelector(getFrameSku, getFrames, function (frameSku, frames) {
    var _a;
    if (!frameSku) {
        return;
    }
    var frame = frames[frameSku];
    if (!frame) {
        return;
    }
    return (_a = frame.productType.obj) === null || _a === void 0 ? void 0 : _a.name;
});
/**
 * Get the prescription type enum value
 */
var getPrescriptionType = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getPrescriptionType$2(state, { frameSku: frameSku });
});
/**
 * The currently selected lens-type product the frame that's being configured
 */
var getSelectedLensType = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedLensType$1(state, { frameSku: frameSku });
});
/**
 * Returns the available lens-types for the frame that's currently being configured
 */
var getLensTypes = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return uninitState();
    }
    return getLensTypes$1(state, { frameSku: frameSku });
});
/**
 * The currently selected package product for the frame that's being configured
 */
var getSelectedPackage = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedPackage$1(state, { frameSku: frameSku });
});
var getPackages = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return uninitState();
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return uninitState();
    }
    return getPackages$1(state, { lensTypeSku: lensTypeSku });
});
/**
 * The currently selected add-on product for the frame that's being configured
 */
var getSelectedAddOn = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedAddOn$1(state, { frameSku: frameSku });
});
var getAddOns = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return uninitState();
    }
    var packageSku = getPackageSku(state, { frameSku: frameSku });
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku || !packageSku) {
        return uninitState();
    }
    return getLensAddOns(state, { packageSku: packageSku });
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */
var getPrescription$2 = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return uninitState();
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return uninitState();
    }
    return getPrescription$3(state, {
        frameSku: frameSku,
        lensTypeSku: lensTypeSku,
    });
});
/**
 * The prescription info as entered on the current frame / lens
 */
var getAdditionalPrescriptionInfoFormState = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return {};
    }
    return getAdditionalPrescriptionInfoFormState$1(state, { frameSku: frameSku });
});
/**
 * Get the validation state of the manual prescription form
 */
var getManualPrescriptionValidationState = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return undefined;
    }
    return getManualPrescriptionValidationState$1(state, {
        frameSku: frameSku,
        lensTypeSku: lensTypeSku,
    });
});
/**
 * Get the validation state of the Prescription Step,
 * considering the currently selected prescriptionType
 */
var getIsPrescriptionStepValid = createSelector(getFrameSku, getPrescriptionType, function (s) { return s; }, function (frameSku, prescriptionType, state) {
    var _a, _b;
    if (!frameSku) {
        return undefined;
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        return (_a = getPrescriptionUploadValidationState(state, { frameSku: frameSku })) === null || _a === void 0 ? void 0 : _a.isValid;
    }
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        return (_b = getManualPrescriptionValidationState(state)) === null || _b === void 0 ? void 0 : _b.isValid;
    }
    return undefined;
});
/**
 * Step related selectors
 */
var hasVisitedStepPrescription = createSelector(function (s) { return s; }, configuratorIdProp$1, function (s, id) { return Selectors.hasVisitedStep(s, { id: id, stepName: 'prescription' }); });
var hasVisitedStepLensPackage = createSelector(function (s) { return s; }, configuratorIdProp$1, function (s, id) { return Selectors.hasVisitedStep(s, { id: id, stepName: 'lensPackage' }); });
var hasVisitedStepAddOn = createSelector(function (s) { return s; }, configuratorIdProp$1, function (s, id) { return Selectors.hasVisitedStep(s, { id: id, stepName: 'lensAddOn' }); });
/**
 * Calculates the total price and total discounted price for the current configuration
 */
var getBundlePrice = createSelector(getSelectedFrame, getSelectedLensType, getSelectedPackage, hasVisitedStepLensPackage, getSelectedAddOn, hasVisitedStepAddOn, function (frame, lensType, lensPackage, hasVisitedStepLensPackage, addOn, hasVisitedStepAddOn) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    if (!frame || !frame.price) {
        return undefined;
    }
    var bundlePrices = [
        frame.price.originalPrice,
        (_b = (_a = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _a === void 0 ? void 0 : _a.originalPrice) !== null && _b !== void 0 ? _b : 0,
        hasVisitedStepLensPackage ? (_d = (_c = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _c === void 0 ? void 0 : _c.originalPrice) !== null && _d !== void 0 ? _d : 0 : 0,
        hasVisitedStepAddOn ? (_f = (_e = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _e === void 0 ? void 0 : _e.originalPrice) !== null && _f !== void 0 ? _f : 0 : 0,
    ];
    var originalPrice = bundlePrices.reduce(function (sum, current) { return sum + current; }, 0);
    var hasDiscounts = [
        frame.price.discountedPrice,
        (_g = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _g === void 0 ? void 0 : _g.discountedPrice,
        hasVisitedStepLensPackage && ((_h = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _h === void 0 ? void 0 : _h.discountedPrice),
        hasVisitedStepAddOn && ((_j = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _j === void 0 ? void 0 : _j.discountedPrice),
    ].filter(function (p) { return typeof p === 'number' && !isNaN(p); }).length > 0;
    var bundlePricesDiscounted = hasDiscounts
        ? [
            (_l = (_k = frame.price.discountedPrice) !== null && _k !== void 0 ? _k : frame.price.originalPrice) !== null && _l !== void 0 ? _l : 0,
            (_q = (_o = (_m = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _m === void 0 ? void 0 : _m.discountedPrice) !== null && _o !== void 0 ? _o : (_p = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _p === void 0 ? void 0 : _p.originalPrice) !== null && _q !== void 0 ? _q : 0,
            hasVisitedStepLensPackage
                ? (_u = (_s = (_r = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _r === void 0 ? void 0 : _r.discountedPrice) !== null && _s !== void 0 ? _s : (_t = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _t === void 0 ? void 0 : _t.originalPrice) !== null && _u !== void 0 ? _u : 0
                : 0,
            hasVisitedStepAddOn
                ? (_y = (_w = (_v = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _v === void 0 ? void 0 : _v.discountedPrice) !== null && _w !== void 0 ? _w : (_x = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _x === void 0 ? void 0 : _x.originalPrice) !== null && _y !== void 0 ? _y : 0
                : 0,
        ]
        : [];
    var discountedPrice = hasDiscounts
        ? bundlePricesDiscounted.reduce(function (sum, current) { return sum + current; }, 0)
        : undefined;
    return {
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        currency: frame.price.currency,
    };
});
var getFormatProductUrl$1 = createSelector(getConfigurator$1, function (c) { return c.formatProductUrl; });
var getVerificationAllowed = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getVerificationAllowed$1(state, { frameSku: frameSku });
});
/**
 * Returns a boolean whether the currently selected package allows add ons to be optional
 * The default value is always `true` unless it is specifically set to `false` in the product data
 */
var getAreAddOnsOptional = createSelector(getSelectedPackage, function (p) { var _a; return (_a = p === null || p === void 0 ? void 0 : p.areAddOnsOptional) !== null && _a !== void 0 ? _a : true; });

var initialState$6 = {};
var reducer$6 = actions$1.reducer(initialState$6, 
/**
 * Set the correct frameSku and always reset the configurator to the initial state
 */
actions$1.on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b = _a.payload, frameSku = _b.frameSku, formatProductUrl = _b.formatProductUrl, isExtraValidationStepEnabled = _b.isExtraValidationStepEnabled;
    return __assign$1(__assign$1({}, initialState$6), { frameSku: frameSku, formatProductUrl: formatProductUrl, isExtraValidationStepEnabled: isExtraValidationStepEnabled });
}), 
/**
 * When adding the config to cart has succeeded we start from 0
 */
actions$1.on(addToCartSuccess$1, addSuccess, function (s, _) { return (__assign$1(__assign$1({}, initialState$6), { frameSku: undefined })); }));

var reducer$5 = actions$1.reducer(defaultState$1, actions$1.on(updatePrescriptionValue, function (s, _a) {
    var _b, _c;
    var payload = _a.payload;
    return (__assign$1(__assign$1({}, s), (_b = {}, _b[payload.side] = __assign$1(__assign$1({}, s[payload.side]), (_c = {}, _c[payload.parameter] = payload.value, _c)), _b)));
}), actions$1.on(updateUploadReference, function (s, _a) {
    var _b;
    var payload = _a.payload;
    return (__assign$1(__assign$1({}, s), { uploadReferences: __assign$1(__assign$1({}, (s.uploadReferences || {})), (_b = {}, _b[payload.scope] = payload.uploadReference, _b)) }));
}), actions$1.on(removeUploadReference, function (s, _a) {
    var payload = _a.payload;
    var _b = s.uploadReferences || {}, _c = payload.scope; _b[_c]; var remainingScopes = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
    return __assign$1(__assign$1({}, s), { uploadReferences: remainingScopes });
}), 
/**
 * Changes the prescription expiry date for the given frameSku
 */
actions$1.on(updatePrescriptionInfo, function (s, _a) {
    var payload = _a.payload;
    return __assign$1(__assign$1({}, s), { additionalInfo: payload.value });
}));

var indexBySku = function (m, p) {
    var _a;
    if (!p.masterVariant.sku) {
        return m;
    }
    return __assign$1(__assign$1({}, m), (_a = {}, _a[p.masterVariant.sku] = p, _a));
};
var reduceProducts = function (products) { return products.reduce(indexBySku, {}); };
var initialState$5 = {
    frames: {},
    lensTypes: {},
    variants: {},
    packages: {},
    addOns: {},
};
var reduceVariant = function (masterSku) { return function (m, variant) {
    var _a;
    if (!variant.sku || !variant.isMatchingVariant) {
        return m;
    }
    return __assign$1(__assign$1({}, m), (_a = {}, _a[variant.sku] = masterSku, _a));
}; };
var indexAllVariantsBySKU = function (m, product) {
    var _a;
    var masterSku = product.masterVariant.sku;
    if (!masterSku) {
        return m;
    }
    return __assign$1(__assign$1(__assign$1({}, m), (_a = {}, _a[masterSku] = masterSku, _a)), product.variants.reduce(reduceVariant(masterSku), {}));
};
var addToLookup = function (s, products) { return (__assign$1(__assign$1({}, s.variants), products.reduce(indexAllVariantsBySKU, {}))); };
var reducer$4 = actions$1.reducer(initialState$5, actions$1.on(fetchLensTypesSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign$1(__assign$1({}, s), { lensTypes: __assign$1(__assign$1({}, s.lensTypes), reduceProducts(products)), variants: addToLookup(s, products) }));
}), actions$1.on(fetchPackagesSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign$1(__assign$1({}, s), { packages: __assign$1(__assign$1({}, s.packages), reduceProducts(products)) }));
}), actions$1.on(fetchAddOnsSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign$1(__assign$1({}, s), { addOns: __assign$1(__assign$1({}, s.addOns), reduceProducts(products)), variants: addToLookup(s, products) }));
}), actions$1.on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var _c = _a.payload, frame = _c.frame, frameSku = _c.frameSku;
    return (__assign$1(__assign$1({}, s), { frames: __assign$1(__assign$1({}, s.frames), (_b = {}, _b[frameSku] = frame, _b)) }));
}));

var getConfig = function (key) { return ({
    storage: sessionStorage,
    key: key,
}); };
var prescriptionGlassesReducer = combineReducers({
    bundles: reducer$8,
    configurations: persistReducer(getConfig('grandvision_pg_configurations'), reducer$7),
    prescription: persistReducer(getConfig('grandvision_pg_prescription'), reducer$5),
    products: reducer$4,
    configurator: reducer$6,
});

var defined = function (v) { return typeof v !== 'undefined'; };
function fetchBundleProducts(productType, skus) {
    var config, results, fetchedSkus, missing;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!skus.size) {
                    return [2 /*return*/, {
                            products: [],
                            tried: skus,
                            missing: new Set(),
                        }];
                }
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 1:
                config = _a.sent();
                assertApiConfig(config);
                return [4 /*yield*/, call(Products.query, config.productsUrl, {
                        expand: [
                            'masterVariant.prices[*].discounted.discount',
                            'variants[*].prices[*].discounted.discount',
                        ],
                        filters: ["variants.sku:" + encodeURIComponent(__spreadArray$1([], __read(skus)).map(function (id) { return "\"" + id + "\""; }).join(','))],
                    })];
            case 2:
                results = (_a.sent()).results;
                fetchedSkus = new Set(results
                    .reduce(function (skus, p) { return __spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(skus)), [p.masterVariant.sku]), __read((p.variants || []).map(function (v) { return v.sku; }))); }, [])
                    .filter(defined));
                missing = new Set(__spreadArray$1([], __read(skus)).filter(function (s) { return !fetchedSkus.has(s); }));
                return [2 /*return*/, {
                        products: results,
                        tried: skus,
                        missing: missing,
                    }];
        }
    });
}
/**
 * Lens Types
 */
function ensureLensTypesAreLoaded(_a) {
    var frameSku = _a.payload.frameSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(loadMissingLensTypes, frameSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function loadMissingLensTypes(frameSku) {
    var frame, lensTypes, lensTypeSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getBundleFrame, {
                    frameSku: frameSku,
                })];
            case 1:
                frame = _a.sent();
                if (!frame) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getBundleLensTypes)];
            case 2:
                lensTypes = _a.sent();
                lensTypeSkusToFetch = __spreadArray$1([], __read(frame.lensTypeSkus)).filter(function (sku) { return !(sku in lensTypes); });
                return [4 /*yield*/, put(fetchLensTypes({
                        frameSku: frameSku,
                        skus: new Set(lensTypeSkusToFetch),
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchLensTypes(_a) {
    var result, error_1;
    var _b = _a.payload, skus = _b.skus, frameSku = _b.frameSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(fetchBundleProducts, 'lens-type', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, put(fetchLensTypesSuccess(__assign$1({ frameSku: frameSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _c.sent();
                return [4 /*yield*/, put(fetchLensTypesFailed({ frameSku: frameSku, skus: skus, error: error_1 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Packages
 */
function loadMissingPackages(lensTypeSku) {
    var bundleLensType, packages, packageSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 1:
                bundleLensType = _a.sent();
                if (!bundleLensType || !statusSuccess(bundleLensType)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getBundlePackages)];
            case 2:
                packages = _a.sent();
                packageSkusToFetch = __spreadArray$1([], __read(bundleLensType.result.packageSkus)).filter(function (packageSku) { return !(packageSku in packages); });
                if (!packageSkusToFetch.length) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchPackages({
                        lensTypeSku: lensTypeSku,
                        skus: new Set(packageSkusToFetch),
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensurePackagesAreLoaded(_a) {
    var lensTypeSku = _a.payload.lensTypeSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(loadMissingPackages, lensTypeSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchPackages(_a) {
    var result, error_2;
    var _b = _a.payload, skus = _b.skus, lensTypeSku = _b.lensTypeSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(fetchBundleProducts, 'package', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, put(fetchPackagesSuccess(__assign$1({ lensTypeSku: lensTypeSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_2 = _c.sent();
                return [4 /*yield*/, put(fetchPackagesFailed({ lensTypeSku: lensTypeSku, skus: skus, error: error_2 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Add-ons
 */
function loadMissingAddOns(packageSku) {
    var bundlePackage, addons, addOnSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getBundlePackage, { packageSku: packageSku })];
            case 1:
                bundlePackage = _a.sent();
                if (!bundlePackage || !statusSuccess(bundlePackage)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getBundleAddOns)];
            case 2:
                addons = _a.sent();
                addOnSkusToFetch = __spreadArray$1([], __read(bundlePackage.result.addOnSkus)).filter(function (addOnSku) { return !(addOnSku in addons); });
                if (!addOnSkusToFetch.length) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchAddOns({
                        packageSku: packageSku,
                        skus: new Set(addOnSkusToFetch),
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensureAddOnsAreLoaded(_a) {
    var packageSku = _a.payload.packageSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(loadMissingAddOns, packageSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchAddOns(_a) {
    var result, error_3;
    var _b = _a.payload, skus = _b.skus, packageSku = _b.packageSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(fetchBundleProducts, 'addon', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, put(fetchAddOnsSuccess(__assign$1({ packageSku: packageSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_3 = _c.sent();
                return [4 /*yield*/, put(fetchAddOnsFailed({ packageSku: packageSku, skus: skus, error: error_3 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * These effects make sure data is loaded as soon as possible
 */
var listenForSelectionChanges = [
    takeLatest(startPrescriptionGlassesConfiguration.type, ensureLensTypesAreLoaded),
    takeLatest(selectLensTypeSuccess.type, ensurePackagesAreLoaded),
    takeLatest(selectPackageSuccess.type, ensureAddOnsAreLoaded),
];
/**
 * These listen for the actual fetching actions
 */
var listenForFetchEvents = [
    takeLatest(fetchLensTypes.type, onFetchLensTypes),
    takeLatest(fetchPackages.type, onFetchPackages),
    takeLatest(fetchAddOns.type, onFetchAddOns),
];
var bundleSagas = __spreadArray$1(__spreadArray$1([], __read(listenForFetchEvents)), __read(listenForSelectionChanges));

var getPrescription$1 = createSelector(getPrescriptionGlasses, function (pg) { return pg.prescription; });

var filterPrescriptionKeysAndValues = function (prescriptionProperties, validOpticalParameters) {
    var validOpticalParamsMap = validOpticalParameters.reduce(function (m, p) {
        var _a;
        return (__assign$1(__assign$1({}, m), (_a = {}, _a[p.name] = p.values, _a)));
    }, {});
    return Object.entries(prescriptionProperties).reduce(function (m, property) {
        var _a;
        var _b = __read(property, 2), pKey = _b[0], pValue = _b[1];
        var validPropertyValues = validOpticalParamsMap[pKey];
        if (!validPropertyValues || !pValue) {
            return m;
        }
        if (validPropertyValues.has(pValue)) {
            return __assign$1(__assign$1({}, m), (_a = {}, _a[pKey] = pValue, _a));
        }
        return m;
    }, {});
};
function onSelectLensType(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, put(selectLensTypeFailed({
                        frameSku: frameSku,
                        lensTypeSku: lensTypeSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var bundleFrame, lensType, prescription, opticalParameters, prescriptionPrefill, validParameters;
    var _b = _a.payload, frameSku = _b.frameSku, lensTypeSku = _b.lensTypeSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getBundleFrame, {
                    frameSku: frameSku,
                })];
            case 1:
                bundleFrame = _c.sent();
                if (!(!bundleFrame || !bundleFrame.lensTypeSkus.has(lensTypeSku))) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("Lens-type with SKU \"" + lensTypeSku + "\" can't be selected for frame with SKU \"" + frameSku + "\", valid lens-type SKUs are \"" + (bundleFrame && JSON.stringify(__spreadArray$1([], __read(bundleFrame.lensTypeSkus)))) + "\"")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3: return [4 /*yield*/, select(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 4:
                lensType = _c.sent();
                if (!!statusSuccess(lensType)) return [3 /*break*/, 6];
                return [5 /*yield**/, __values(fail(new Error('Lens-type not available')))];
            case 5: return [2 /*return*/, _c.sent()];
            case 6: return [4 /*yield*/, select(getPrescription$1)];
            case 7:
                prescription = _c.sent();
                return [4 /*yield*/, select(getOpticalParameters, { frameSku: frameSku, lensTypeSku: lensTypeSku })];
            case 8:
                opticalParameters = _c.sent();
                prescriptionPrefill = {
                    left: {},
                    right: {},
                    uploadReferences: {},
                };
                if (statusSuccess(opticalParameters)) {
                    validParameters = opticalParameters.result;
                    prescriptionPrefill = {
                        left: filterPrescriptionKeysAndValues(prescription.left, validParameters),
                        right: filterPrescriptionKeysAndValues(prescription.right, validParameters),
                        uploadReferences: prescription.uploadReferences,
                    };
                }
                return [4 /*yield*/, put(selectLensTypeSuccess({
                        frameSku: frameSku,
                        lensTypeSku: lensTypeSku,
                        prescriptionPrefill: prescriptionPrefill,
                        reason: reason,
                    }))];
            case 9:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function ensureCompatibleLensPackage(_a) {
    var selectedPackageSku, lensType;
    var _b = _a.payload, frameSku = _b.frameSku, lensTypeSku = _b.lensTypeSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getPackageSku, { frameSku: frameSku })];
            case 1:
                selectedPackageSku = _c.sent();
                if (!selectedPackageSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 2:
                lensType = _c.sent();
                if (!statusSuccess(lensType)) {
                    return [2 /*return*/];
                }
                if (!!lensType.result.packageSkus.has(selectedPackageSku)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(resetSelectedPackage({ frameSku: frameSku }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensureCompatibleLensAddOn(_a) {
    var selectedAddOnSku, bundlePackage;
    var _b = _a.payload, frameSku = _b.frameSku, packageSku = _b.packageSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getAddOnSku, {
                    frameSku: frameSku,
                })];
            case 1:
                selectedAddOnSku = _c.sent();
                if (!selectedAddOnSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getBundlePackage, { packageSku: packageSku })];
            case 2:
                bundlePackage = _c.sent();
                if (!statusSuccess(bundlePackage)) {
                    return [2 /*return*/];
                }
                if (!!bundlePackage.result.addOnSkus.has(selectedAddOnSku)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(resetSelectedAddOn({
                        frameSku: frameSku,
                        reason: 'default selection',
                    }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function onSelectPackage(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, put(selectPackageFailed({
                        frameSku: frameSku,
                        packageSku: packageSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var lensTypeSku, lensPackage, lensType;
    var _b = _a.payload, frameSku = _b.frameSku, packageSku = _b.packageSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getLensTypeSku, {
                    frameSku: frameSku,
                })];
            case 1:
                lensTypeSku = _c.sent();
                if (!!lensTypeSku) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("A lens-type needs to be selected before we can select a package")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3: return [4 /*yield*/, select(getBundlePackage, { packageSku: packageSku })];
            case 4:
                lensPackage = _c.sent();
                if (!!statusSuccess(lensPackage)) return [3 /*break*/, 6];
                return [5 /*yield**/, __values(fail(new Error('Lens-package is unavailable')))];
            case 5: return [2 /*return*/, _c.sent()];
            case 6: return [4 /*yield*/, select(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 7:
                lensType = _c.sent();
                if (!!statusSuccess(lensType)) return [3 /*break*/, 9];
                return [5 /*yield**/, __values(fail(new Error("Lens-type with SKU \"" + lensTypeSku + "\" is unavailable")))];
            case 8: return [2 /*return*/, _c.sent()];
            case 9:
                if (!!lensType.result.packageSkus.has(packageSku)) return [3 /*break*/, 11];
                return [5 /*yield**/, __values(fail(new Error("Package is not compatible with selected lens-type with SKU \"" + lensTypeSku)))];
            case 10: return [2 /*return*/, _c.sent()];
            case 11: return [4 /*yield*/, put(selectPackageSuccess({
                    frameSku: frameSku,
                    lensTypeSku: lensTypeSku,
                    packageSku: packageSku,
                    reason: reason,
                }))];
            case 12:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function onSelectAddOn(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, put(selectAddOnFailed({
                        frameSku: frameSku,
                        addOnSku: addOnSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var config, lensType, packageSku, bundlePackage;
    var _b = _a.payload, frameSku = _b.frameSku, addOnSku = _b.addOnSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getConfiguration$1, {
                    frameSku: frameSku,
                })];
            case 1:
                config = _c.sent();
                if (!!config) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("No add-on can be selected for Frame: " + frameSku + ", there's no active configuration for it")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                lensType = config.lensType, packageSku = config.package;
                if (!(!(lensType === null || lensType === void 0 ? void 0 : lensType.sku) || !packageSku)) return [3 /*break*/, 5];
                return [5 /*yield**/, __values(fail(new Error("To select an add-on we need a lens-type, and a package; current lens-type is \"" + (lensType === null || lensType === void 0 ? void 0 : lensType.sku) + "\", package is \"" + packageSku + "\"")))];
            case 4: return [2 /*return*/, _c.sent()];
            case 5: return [4 /*yield*/, select(getBundlePackage, { packageSku: packageSku })];
            case 6:
                bundlePackage = _c.sent();
                if (!!statusSuccess(bundlePackage)) return [3 /*break*/, 8];
                return [5 /*yield**/, __values(fail(new Error("Can't select add-on because package with SKU " + packageSku + " is unavailable")))];
            case 7: return [2 /*return*/, _c.sent()];
            case 8:
                if (!!bundlePackage.result.addOnSkus.has(addOnSku)) return [3 /*break*/, 10];
                return [5 /*yield**/, __values(fail(new Error("Add-on cannot be selected for selected package with SKU \"" + packageSku + "\"")))];
            case 9: return [2 /*return*/, _c.sent()];
            case 10: return [4 /*yield*/, put(selectAddOnSuccess({
                    frameSku: frameSku,
                    addOnSku: addOnSku,
                    reason: reason,
                }))];
            case 11:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
var selectionHandlers = [
    takeLatest(selectLensType.type, onSelectLensType),
    takeLatest(selectPackage.type, onSelectPackage),
    takeLatest(selectAddOn.type, onSelectAddOn),
];
var configurationSagas = __spreadArray$1(__spreadArray$1([], __read(selectionHandlers)), [
    takeLatest(selectLensTypeSuccess.type, ensureCompatibleLensPackage),
    takeLatest(selectPackageSuccess.type, ensureCompatibleLensAddOn),
]);

/**
 * Get the non-medical prescription details
 */
var getAdditionalPrescriptionInfo$1 = createSelector(getAdditionalPrescriptionInfoFormState, function (additionalPrescriptionInfoFormState) {
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    var _a = Util.getValuesFromState(additionalPrescriptionInfoFormState), examDate = _a.examDate, expiryDate = _a.expiryDate, rest = __rest(_a, ["examDate", "expiryDate"]);
    return __assign$1(__assign$1(__assign$1({}, (examDate ? { examDate: examDate } : {})), (expiryDate ? { expiryDate: expiryDate } : {})), { opticianDetails: __assign$1({}, rest) });
});
/*
 * Utilities for getAddToCartLineItem -----------
 */
var configureBundleLineItemsForCart = function (config) {
    if (!config) {
        return;
    }
    var bundleLineItems = [];
    Object.keys(config).forEach(function (item) {
        var _a;
        var sku;
        if (item === 'prescriptionType' || !config[item]) {
            return;
        }
        if (item === 'lensType' && ((_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.sku)) {
            sku = config.lensType.sku;
        }
        bundleLineItems.push({
            sku: sku !== null && sku !== void 0 ? sku : config[item],
        });
    });
    return bundleLineItems;
};
var configurePrescriptionInfo = function (config, additionalInfo) {
    var _a, _b;
    var prescriptionType = config === null || config === void 0 ? void 0 : config.prescriptionType;
    if (!prescriptionType) {
        return;
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return { type: 'email-prescription' };
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return { type: 'existing-customer' };
    }
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        var prescriptionInfo = (_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.prescriptionInfo;
        if (!prescriptionInfo) {
            return;
        }
        var right = prescriptionInfo.right, left = prescriptionInfo.left;
        return {
            type: 'new-prescription',
            details: __assign$1({ rightLens: right, leftLens: left }, additionalInfo),
        };
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        var uploadReferences = (_b = config === null || config === void 0 ? void 0 : config.lensType) === null || _b === void 0 ? void 0 : _b.prescriptionInfo.uploadReferences;
        if (!uploadReferences ||
            !uploadReferences['pg-prescription'] ||
            !uploadReferences['pg-pupillary-distance']) {
            return;
        }
        return {
            type: 'prescription-file',
            details: {
                prescriptionFile: uploadReferences['pg-prescription'],
                pupillaryDistanceFile: uploadReferences['pg-pupillary-distance'],
            },
        };
    }
};
/*
 * end Utility functions for getAddToCartLineItem -----------
 */
/*
 * Get a line item configured to be added to cart.
 */
var getAddToCartLineItem = createSelector(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    var lineItemRawConfig = getConfiguration$1(state, {
        frameSku: frameSku,
    });
    var additionalPrescriptionInfo = getAdditionalPrescriptionInfo$1(state);
    var bundleLineItems = configureBundleLineItemsForCart(lineItemRawConfig);
    var prescription = configurePrescriptionInfo(lineItemRawConfig, additionalPrescriptionInfo);
    if (!bundleLineItems || !prescription) {
        return undefined;
    }
    return {
        type: 'prescription-glasses',
        sku: frameSku,
        bundleLineItems: bundleLineItems,
        prescription: prescription,
    };
});

function getBundleProductTitle(bundleProduct) {
    var _a, _b;
    if (!bundleProduct) {
        return;
    }
    if ((_a = bundleProduct.variants) === null || _a === void 0 ? void 0 : _a.length) {
        var selected = (_b = bundleProduct.variants) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.sku === bundleProduct.sku; });
        // to prevent "title -"
        if (!selected || !(selected === null || selected === void 0 ? void 0 : selected.title)) {
            return bundleProduct.title;
        }
        return bundleProduct.title + " - " + selected.title;
    }
    else {
        return bundleProduct.title;
    }
}

function getLensProductVariantName(lensProduct) {
    var _a, _b;
    if (!((_a = lensProduct === null || lensProduct === void 0 ? void 0 : lensProduct.variants) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    var selected = (_b = lensProduct.variants) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.sku === lensProduct.sku; });
    var title = selected === null || selected === void 0 ? void 0 : selected.title;
    return title || undefined;
}

var stepMapping$1 = {
    lensType: {
        name: 'lens type',
        id: '100',
    },
    prescription: {
        name: 'prescription',
        id: '200',
    },
    prescriptionValidation: {
        name: 'prescription validation',
        id: '250',
    },
    lensPackage: {
        name: 'lens package',
        id: '300',
    },
    lensAddOn: {
        name: 'add-ons',
        id: '400',
    },
};
/**
 * SHARED SELECTORS
 * Most data layer selectors will use these
 */
var getStepData$1 = createSelector(configuratorIdProp$1, stateProp$1, function (id, s) {
    var currentStep = Selectors.getCurrentStep(s, { id: id });
    return currentStep ? stepMapping$1[currentStep.name] : undefined;
});
var getPrice = createSelector(getBundlePrice, function (bundlePrice) {
    if (!bundlePrice) {
        console.warn("Need bundle price to log data layer event. Received \"" + JSON.stringify(bundlePrice) + "\"");
        return;
    }
    var discountedPrice = bundlePrice.discountedPrice, originalPrice = bundlePrice.originalPrice;
    /**
     * Both "discountedPrice" and "originalPrice" are in cents, as per usual. There is no e.g. "centAmount" property
     * to check here anymore.
     */
    return discountedPrice ? (discountedPrice / 100).toFixed(2) : (originalPrice / 100).toFixed(2);
});
var formatPrescriptionValue = function (value) {
    return typeof value === 'number' && !isNaN(value) ? value.toFixed(2) : 'n/a';
};
/**
 * Creates a reducer function that converts PrescriptionValue to a data-layer PrescriptionValue
 */
var reduceParameter = function (values) { return function (info, _a) {
    var _b;
    var name = _a.name;
    return (__assign$1(__assign$1({}, info), (_b = {}, _b[name] = formatPrescriptionValue(values[name]), _b)));
}; };
var getLensParameters$1 = createSelector(getPrescription$2, function (pre) {
    if (!statusSuccess(pre)) {
        return;
    }
    var _a = pre.result, parameters = _a.parameters, left = _a.left, right = _a.right;
    return {
        OS: parameters.reduce(reduceParameter(left), {}),
        OD: parameters.reduce(reduceParameter(right), {}),
    };
});
var getSelectedLensNames = createSelector(getLensTypes$2, getSelectedLensType, function (s) { return s; }, function (lensTypes, selectedLensType, state) {
    if (!lensTypes || !selectedLensType) {
        return;
    }
    var lensTypeProduct = lookupParentLensType(state, {
        lensTypeSku: selectedLensType.sku,
    });
    if (!lensTypeProduct) {
        return;
    }
    var lensTypeInfo = convertToLensTypeInfo(lensTypeProduct, selectedLensType.sku, 'en');
    return {
        productName: lensTypeInfo.title,
        variantName: getLensProductVariantName(lensTypeInfo),
    };
});
var getSelectedPackageName = createSelector(getPackages$2, getSelectedPackage, function (packages, selectedPackage) {
    if (!packages || !selectedPackage) {
        return;
    }
    var packageProductData = packages[selectedPackage.sku];
    if (!packageProductData) {
        return;
    }
    return getLocalizedValue(packageProductData.name, 'en');
});
var getSelectedAddOnName = createSelector(getSelectedAddOn, function (s) { return s; }, function (selectedAddOn, state) {
    if (!selectedAddOn) {
        return 'no add-on';
    }
    var addOnProduct = lookupParentAddOn(state, {
        addOnSku: selectedAddOn.sku,
    });
    if (!addOnProduct) {
        return;
    }
    var addOnInfo = convertToLensAddOnInfo(addOnProduct, selectedAddOn.sku, 'en');
    return getBundleProductTitle(addOnInfo);
});
var getProductConfig$1 = createSelector(getSelectedLensNames, getSelectedPackageName, getSelectedAddOnName, getPrice, getLensParameters$1, hasVisitedStepAddOn, function (lensNames, packageName, addOnName, price, lens, hasVisitedStepAddOn) {
    return __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, ((lensNames === null || lensNames === void 0 ? void 0 : lensNames.productName) ? { lensType: lensNames.productName.toLowerCase() } : {})), ((lensNames === null || lensNames === void 0 ? void 0 : lensNames.variantName) ? { lensVariant: lensNames.variantName.toLowerCase() } : {})), (packageName ? { lensPackage: packageName.toLowerCase() } : {})), (hasVisitedStepAddOn && addOnName ? { 'add-ons': addOnName.toLowerCase() } : {})), { price: price !== null && price !== void 0 ? price : '0' }), (lens ? { lens: lens } : {}));
});
var getConfigFlow$1 = createSelector(getStepData$1, getPrescriptionType, hasVisitedStepPrescription, function (stepData, prescriptionType, hasVisitedStepPrescription) {
    /**
     * Should only occur on programmer error. We should always have this data available.
     */
    if (!stepData) {
        return undefined;
    }
    var rxInputMethodMapping = {
        NewPrescription: 'manual',
        EmailPrescription: 'email',
        ExistingCustomer: 'customer',
        PrescriptionFile: 'upload',
    };
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        /**
         * Note: there isn't yet a data layer implementation plan for the PrescriptionFile option. For that reason we're
         * not logging anything specific for that option to the data layer.
         */
        return {
            version: '1.0',
            step: stepData,
        };
    }
    return __assign$1({ version: '1.0', step: stepData }, (hasVisitedStepPrescription && isDefined$1(prescriptionType)
        ? { RxInputMethod: rxInputMethodMapping[prescriptionType] }
        : {}));
});
var getUser = createSelector(getPrescriptionType, function (prescriptionType) {
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        /**
         * Note: there isn't yet a data layer implementation plan for the PrescriptionFile option. For that reason we're
         * not logging anything specific for that option to the data layer.
         */
        return;
    }
    return {
        custStatus: CommerceToolsApi.isExistingCustomer(prescriptionType)
            ? 'customer'
            : 'prob noncustomer',
    };
});

function isSun(productType) {
    var _a;
    if (typeof productType === 'string') {
        return productType === 'Sunglasses';
    }
    return ((_a = productType.obj) === null || _a === void 0 ? void 0 : _a.name) === 'Sunglasses';
}
var getEventType = function (p) {
    var productType = typeof p === 'string' ? p : p.productType;
    return isSun(productType) ? 'RxSunConfigEvent' : 'RxGlassesConfigEvent';
};
function onStartConfiguration$1(_a) {
    var openConfiguratorEvent;
    var frame = _a.payload.frame;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                openConfiguratorEvent = {
                    event: getEventType(frame),
                    eventAction: 'click on button',
                    eventLabel: 'configure glasses button',
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(openConfiguratorEvent))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onPushEvent$1(id, eventAction, eventLabel) {
    var productConfig, configFlow, user, hasVisitedStepPrescription$1, productType, DATA_KEY, action;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getProductConfig$1, { id: id })];
            case 1:
                productConfig = _b.sent();
                return [4 /*yield*/, select(getConfigFlow$1, { id: id })];
            case 2:
                configFlow = _b.sent();
                return [4 /*yield*/, select(getUser)];
            case 3:
                user = _b.sent();
                return [4 /*yield*/, select(hasVisitedStepPrescription, { id: id })];
            case 4:
                hasVisitedStepPrescription$1 = _b.sent();
                return [4 /*yield*/, select(getSelectedFrameProductType)];
            case 5:
                productType = _b.sent();
                if (productType !== 'Frames' && productType !== 'Sunglasses') {
                    console.error("Did not receive a valid product type for pushing an event to the data layer. Expected \"Frames\" or \"Sunglasses\", received: " + productType);
                    return [2 /*return*/];
                }
                DATA_KEY = isSun(productType) ? 'RxSun' : 'RxGlasses';
                action = DataLayer.Actions.pushEvent(__assign$1(__assign$1({ event: getEventType(productType), eventAction: eventAction, eventLabel: eventLabel }, (hasVisitedStepPrescription$1 && user ? { user: user } : {})), (_a = {}, _a[DATA_KEY] = {
                    configFlow: configFlow,
                    productConfig: productConfig,
                }, _a)));
                return [4 /*yield*/, put(action)];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Actions that respond to different product selections during configuration of a product.
 */
var createSelectionHandler = function (id, eventAction) {
    return function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call(onPushEvent$1, id, eventAction)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
var manualLensTypeSelection = function (a) {
    return actions$1.isType(a, selectLensTypeSuccess) &&
        a.payload.reason === 'user selection';
};
var manualLensPackageSelection = function (a) {
    return actions$1.isType(a, selectPackageSuccess) &&
        a.payload.reason === 'user selection';
};
var manualAddOnSelection = function (a) {
    return (actions$1.isType(a, selectAddOnSuccess) ||
        actions$1.isType(a, resetSelectedAddOn)) &&
        a.payload.reason === 'user selection';
};
/**
 * Logs a 'view step' event an every step change
 */
function onViewStep$1(_a) {
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(onPushEvent$1, id, 'view step')];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs a 'select rx attribute' on every prescription value change
 * Also logs an event label with the parameter name and eye side, i.e. "axis left"
 */
function onUpdatePrescriptionValue(id, _a) {
    var _b = _a.payload, parameter = _b.parameter, side = _b.side;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(onPushEvent$1, id, 'select rx attribute', parameter + " " + side)];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs an 'existing customer' value change
 */
function onUpdatePrescriptionType(id, _a) {
    var rxInputMethodMapping, event;
    var _b = _a.payload, prescriptionType = _b.prescriptionType, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (reason === 'default selection') {
                    return [2 /*return*/];
                }
                rxInputMethodMapping = {
                    NewPrescription: {
                        eventAction: 'manual prescription',
                        eventLabel: 'manual',
                    },
                    EmailPrescription: {
                        eventAction: 'email prescription',
                        eventLabel: 'email',
                    },
                    ExistingCustomer: {
                        eventAction: 'existing customer',
                        eventLabel: 'customer',
                    },
                    PrescriptionFile: {
                        eventAction: 'upload prescription',
                        eventLabel: 'upload',
                    },
                };
                event = rxInputMethodMapping[prescriptionType];
                if (!event) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(onPushEvent$1, id, event.eventAction, event.eventLabel)];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function onFileUploadResult(id, _a) {
    var result = _a.result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!result) return [3 /*break*/, 2];
                return [4 /*yield*/, call(onPushEvent$1, id, 'upload message', result)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
/**
 * Logs when successfully moved to the next step
 */
function onNextStep$1(_a) {
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(onPushEvent$1, id, 'click on button', 'next step')];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * This saga binds the the configurator ID to the selection actions, which is necessary to provide
 * the correct data for data layer events.
 */
var getConfigurationChangesSagas = function (id) { return [
    takeLatest(updatePrescriptionValue.type, function (a) { return onUpdatePrescriptionValue(id, a); }),
    takeLatest(updatePrescriptionType.type, function (a) { return onUpdatePrescriptionType(id, a); }),
    // upload
    takeLatest(fileUploadResult.type, function (a) {
        return onFileUploadResult(id, a);
    }),
    takeLatest(manualLensTypeSelection, createSelectionHandler(id, 'select lens type')),
    takeLatest(manualLensPackageSelection, createSelectionHandler(id, 'select lens package')),
    takeLatest(manualAddOnSelection, createSelectionHandler(id, 'select add-on')),
    /**
     * Configurator stepping actions
     */
    takeLatest(Actions.isStepShownWithId(id), onViewStep$1),
    takeLatest(Actions.isNextStepWithId(id), onNextStep$1),
]; };
function listenForConfigurationChanges$1(id) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(getConfigurationChangesSagas(id))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var dataLayerSagas = [
    takeLatest(startPrescriptionGlassesConfiguration.type, onStartConfiguration$1),
];

var getAdditionalPrescriptionInfo = createSelector(getAdditionalPrescriptionInfoFormState, function (additionalPrescriptionInfoFormState) {
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    var _a = Util.getValuesFromState(additionalPrescriptionInfoFormState), examDate = _a.examDate, expiryDate = _a.expiryDate, rest = __rest(_a, ["examDate", "expiryDate"]);
    return {
        examDate: examDate,
        expiryDate: expiryDate,
        opticianDetails: JSON.stringify(rest),
    };
});

function filterUndefinedValues(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (value !== undefined ? __assign$1(__assign$1({}, acc), (_b = {}, _b[key] = value, _b)) : acc);
    }, {});
}
function removeEmptyProperties(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        var isEmpty = value === undefined || value === null || value === '';
        return isEmpty ? acc : __assign$1(__assign$1({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
}
function dispatchAndReturnError(message) {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                error = new Error(message);
                return [4 /*yield*/, put(addToCartFailed$1(error))];
            case 1:
                _a.sent();
                return [2 /*return*/, error];
        }
    });
}
function onAddToCart() {
    var intl, locale, frameSku, lensTypeSku, packageSku, addOnSku, addOnLineItem, prescription, bundleChildLineItems, startSequenceId, prescriptionType_1, additionalPrescriptionInfo, prescriptionData_1, getPrescriptionConfig, prescriptionConfig, country, currency, formatProductUrl, prescriptionGlassesBundleLineItems, startAction, error_1, _a, success, failed, timeout, sequence;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(IntlSelectors.getIntl)];
            case 1:
                intl = _c.sent();
                return [4 /*yield*/, select(IntlSelectors.getLocale)];
            case 2:
                locale = _c.sent();
                if (!(!intl || !locale)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(dispatchAndReturnError, "Need intl data to add product to cart")];
            case 3: return [2 /*return*/, _c.sent()];
            case 4: return [4 /*yield*/, select(getFrameSku)];
            case 5:
                frameSku = _c.sent();
                if (!!frameSku) return [3 /*break*/, 7];
                return [4 /*yield*/, call(dispatchAndReturnError, "Need a frame SKU to add product to cart")];
            case 6: return [2 /*return*/, _c.sent()];
            case 7: return [4 /*yield*/, select(getLensTypeSku, {
                    frameSku: frameSku,
                })];
            case 8:
                lensTypeSku = _c.sent();
                if (!!lensTypeSku) return [3 /*break*/, 10];
                return [4 /*yield*/, call(dispatchAndReturnError, "Need a lens type SKU to add product to cart")];
            case 9: return [2 /*return*/, _c.sent()];
            case 10: return [4 /*yield*/, select(getPackageSku, { frameSku: frameSku })];
            case 11:
                packageSku = _c.sent();
                if (!!packageSku) return [3 /*break*/, 13];
                return [4 /*yield*/, call(dispatchAndReturnError, "Need a package SKU to add product to cart")];
            case 12: return [2 /*return*/, _c.sent()];
            case 13: return [4 /*yield*/, select(getAddOnSku, { frameSku: frameSku })];
            case 14:
                addOnSku = _c.sent();
                addOnLineItem = addOnSku
                    ? [
                        {
                            productType: 'PrescriptionGlassPackageOptions',
                            sku: addOnSku,
                        },
                    ]
                    : [];
                return [4 /*yield*/, select(getPrescription$2)];
            case 15:
                prescription = _c.sent();
                bundleChildLineItems = __spreadArray$1([
                    {
                        productType: 'LensTypes',
                        sku: lensTypeSku,
                    },
                    {
                        productType: 'PrescriptionGlassPackages',
                        sku: packageSku,
                    }
                ], __read(addOnLineItem));
                _c.label = 16;
            case 16:
                _c.trys.push([16, 23, , 25]);
                if (!!statusSuccess(prescription)) return [3 /*break*/, 18];
                return [4 /*yield*/, call(dispatchAndReturnError, "No prescription found for frame with SKU " + frameSku)];
            case 17: return [2 /*return*/, _c.sent()];
            case 18: return [4 /*yield*/, select(getPrescriptionType)];
            case 19:
                prescriptionType_1 = _c.sent();
                return [4 /*yield*/, select(getAdditionalPrescriptionInfo)];
            case 20:
                additionalPrescriptionInfo = _c.sent();
                prescriptionData_1 = __assign$1({ rightLens: filterUndefinedValues(prescription.result.right), leftLens: filterUndefinedValues(prescription.result.left) }, removeEmptyProperties(additionalPrescriptionInfo));
                getPrescriptionConfig = function () {
                    if (CommerceToolsApi.isNewPrescription(prescriptionType_1)) {
                        return __assign$1({ type: prescriptionType_1 }, prescriptionData_1);
                    }
                    if (CommerceToolsApi.isExistingCustomer(prescriptionType_1) ||
                        CommerceToolsApi.isEmailPrescription(prescriptionType_1)) {
                        return { type: prescriptionType_1 };
                    }
                };
                prescriptionConfig = getPrescriptionConfig();
                country = intl.country, currency = intl.currency;
                return [4 /*yield*/, select(getFormatProductUrl$1)];
            case 21:
                formatProductUrl = _c.sent();
                prescriptionGlassesBundleLineItems = [
                    {
                        bundleMainLineItem: {
                            productType: 'Frames',
                            sku: frameSku,
                        },
                        bundleChildLineItems: bundleChildLineItems,
                        quantity: 1,
                        prescription: prescriptionConfig,
                    },
                ];
                startAction = ReduxDataSource.Actions.addToCart({
                    locale: locale,
                    country: country,
                    currency: currency,
                    formatProductUrl: formatProductUrl,
                    prescriptionGlassesBundleLineItems: prescriptionGlassesBundleLineItems,
                });
                startSequenceId = startAction.sequenceId;
                return [4 /*yield*/, put(startAction)];
            case 22:
                _c.sent();
                return [3 /*break*/, 25];
            case 23:
                error_1 = _c.sent();
                return [4 /*yield*/, call(dispatchAndReturnError, error_1)];
            case 24: return [2 /*return*/, _c.sent()];
            case 25:
                return [4 /*yield*/, race([
                        take(ReduxDataSource.Actions.ADD_TO_CART_SUCCESS),
                        take(ReduxDataSource.Actions.ADD_TO_CART_FAILED),
                        delay(30000, true),
                    ])];
            case 26:
                _a = __read.apply(void 0, [_c.sent(), 3]), success = _a[0], failed = _a[1], timeout = _a[2];
                sequence = (_b = failed === null || failed === void 0 ? void 0 : failed.sequenceId) !== null && _b !== void 0 ? _b : success === null || success === void 0 ? void 0 : success.sequenceId;
                if (typeof sequence === 'number' && sequence !== startSequenceId) {
                    // If the sequence ID doesn't match to the ID from the action we've put from this saga, we don't act on it
                    return [3 /*break*/, 25];
                }
                if (!timeout) return [3 /*break*/, 28];
                return [4 /*yield*/, call(dispatchAndReturnError, 'Adding configured products to cart exceeded the timeout of 30 seconds.')];
            case 27: return [2 /*return*/, _c.sent()];
            case 28:
                if (!failed) return [3 /*break*/, 30];
                return [4 /*yield*/, call(dispatchAndReturnError, failed.error)];
            case 29: return [2 /*return*/, _c.sent()];
            case 30:
                if (!success) return [3 /*break*/, 32];
                return [4 /*yield*/, put(addToCartSuccess$1({ frameSku: frameSku }))];
            case 31:
                _c.sent();
                return [2 /*return*/];
            case 32: return [4 /*yield*/, call(dispatchAndReturnError, 'unknown failure')];
            case 33: return [2 /*return*/, _c.sent()];
            case 34: return [2 /*return*/];
        }
    });
}
var legacyAddToCartSagas = [takeLatest(addToCart$1.type, onAddToCart)];

var productsSagas = __spreadArray$1(__spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(bundleSagas)), __read(configurationSagas)), __read(dataLayerSagas)), __read(legacyAddToCartSagas));
function prescriptionGlassesSaga () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(productsSagas)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var stateProp = function (s) { return s; };
var configuratorIdProp = function (_, _a) {
    var id = _a.id;
    return id;
};
var variantGroupProp = function (_, _a) {
    var variantGroup = _a.variantGroup;
    return variantGroup;
};
var getContactLensSubscription = function (state) {
    return state.contactLensSubscription;
};

var getConfiguration = createSelector(getContactLensSubscription, variantGroupProp, function (contactLensSubscription, variantGroup) {
    return contactLensSubscription.configurations[variantGroup];
});

var getSelectedDeliveryFrequency$1 = createSelector(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.deliveryFrequency; });
var getSelectedBillingPeriod$1 = createSelector(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.billingPeriod; });
var getSelectedStartDate$1 = createSelector(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.startDate; });
var getSelectedRatePlan$1 = createSelector(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.ratePlan; });
var getSelectedSolution$1 = createSelector(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.solution; });

var namespace$4 = 'products/contact-lens-subscription';
var selectDeliveryFrequency$1 = actions$1.action(namespace$4 + "/select-delivery-frequency", actions$1.payload());
actions$1.action(namespace$4 + "/select-delivery-frequency-failed", actions$1.payload());
var selectDeliveryFrequencySuccess = actions$1.action(namespace$4 + "/select-delivery-frequency-success", actions$1.payload());
var selectBillingPeriod$1 = actions$1.action(namespace$4 + "/select-billing-period", actions$1.payload());
actions$1.action(namespace$4 + "/select-billing-period-failed", actions$1.payload());
var selectBillingPeriodSuccess = actions$1.action(namespace$4 + "/select-billing-period-success", actions$1.payload());
var selectStartDate$2 = actions$1.action(namespace$4 + "/select-start-date", actions$1.payload());
var selectStartDateFailed = actions$1.action(namespace$4 + "/select-start-date-failed", actions$1.payload());
var selectStartDateSuccess = actions$1.action(namespace$4 + "/select-start-date-success", actions$1.payload());
actions$1.action(namespace$4 + "/select-rate-plan", actions$1.payload());
var selectRatePlanFailed = actions$1.action(namespace$4 + "/select-rate-plan-failed", actions$1.payload());
var selectRatePlanSuccess = actions$1.action(namespace$4 + "/select-rate-plan-success", actions$1.payload());
var selectSolution = actions$1.action(namespace$4 + "/select-solution", actions$1.payload());
var resetConfigurationState = actions$1.action(namespace$4 + "/reset-configurator-state");
var resetSelectedSolution = actions$1.action(namespace$4 + "/reset-solution", actions$1.payload());

var namespace$3 = 'products/contact-lens-subscription';
var addToCart = actions$1.action(namespace$3 + "/add-to-cart");
var addToCartFailed = actions$1.action(namespace$3 + "/add-to-cart-failed", function (error) { return ({ error: error }); });
var addToCartSuccess = actions$1.action(namespace$3 + "/add-to-cart-success");

var namespace$2 = 'products/datalayer';
var selectStartDate$1 = actions$1.action(namespace$2 + "/select-start-date", actions$1.payload());

var namespace$1 = 'products/contact-lens-subscription';
var fetchRatePlansFailed = actions$1.action(namespace$1 + "/fetch-rate-plans-failed", actions$1.payload());
var fetchRatePlansSuccess = actions$1.action(namespace$1 + "/fetch-rate-plans-success", actions$1.payload());

var namespace = 'products/contact-lens-subscription';
var startContactLensSubscriptionConfiguration = actions$1.action(namespace + "/start", actions$1.payload());
actions$1.action(namespace + "/start-success");

var defaultState = {};
var reducer$3 = actions$1.reducer(defaultState, actions$1.on(
/**
 * Create a blank configuration but only on the first call
 */
startContactLensSubscriptionConfiguration, function (s, _a) {
    var _b;
    var variantGroup = _a.payload.variantGroup;
    // If we have an existing configuration for a variant group (brand key) we use it.
    if (variantGroup in s) {
        return s;
    }
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = {}, _b));
}), 
/**
 * Changes the delivery frequency.
 */
actions$1.on(selectDeliveryFrequencySuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, deliveryFrequency = _c.deliveryFrequency;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { deliveryFrequency: deliveryFrequency }), _b));
}), 
/**
 * Changes the billing period.
 */
actions$1.on(selectBillingPeriodSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, billingPeriod = _c.billingPeriod;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { billingPeriod: billingPeriod }), _b));
}), 
/**
 * Changes the start date.
 */
actions$1.on(selectStartDateSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, startDate = _c.startDate;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { startDate: startDate }), _b));
}), 
/**
 * Changes the rate plan and (re)sets other selections to their rate plan
 * values to ensure all values are compatible with a plan.
 */
actions$1.on(selectRatePlanSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, ratePlan = _c.ratePlan;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { deliveryFrequency: ratePlan.shippingSchedule, billingPeriod: ratePlan.billingPeriod, ratePlan: ratePlan }), _b));
}), actions$1.on(selectSolution, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, solution = _c.solution;
    return __assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { solution: solution }), _b));
}), actions$1.on(resetConfigurationState, function () { return (__assign$1({}, defaultState)); }), actions$1.on(resetSelectedSolution, function (s, _a) {
    var _b;
    var variantGroup = _a.payload.variantGroup;
    return (__assign$1(__assign$1({}, s), (_b = {}, _b[variantGroup] = __assign$1(__assign$1({}, s[variantGroup]), { solution: undefined }), _b)));
}));

var NO_SOLUTION_SKU = '-1';

var getConfigurator = createSelector(getContactLensSubscription, function (contactLensSubscription) { return contactLensSubscription.configurator; });

var PrescriptionAttribute;
(function (PrescriptionAttribute) {
    PrescriptionAttribute["Addition"] = "addition";
    PrescriptionAttribute["Axis"] = "axis";
    PrescriptionAttribute["BaseCurve"] = "baseCurve";
    PrescriptionAttribute["Cylinder"] = "cylinder";
    PrescriptionAttribute["Diameter"] = "diameter";
    PrescriptionAttribute["Power"] = "power";
})(PrescriptionAttribute || (PrescriptionAttribute = {}));
var LensSide;
(function (LensSide) {
    LensSide["Left"] = "leftLens";
    LensSide["Right"] = "rightLens";
})(LensSide || (LensSide = {}));
var PRESCRIPTION_ATTRIBUTES = [
    PrescriptionAttribute.Addition,
    PrescriptionAttribute.Axis,
    PrescriptionAttribute.BaseCurve,
    PrescriptionAttribute.Cylinder,
    PrescriptionAttribute.Diameter,
    PrescriptionAttribute.Power,
];
var EYE_SIDE_LENS_MAP = { left: LensSide.Left, right: LensSide.Right };
var getVariantGroup = createSelector(getConfigurator, function (configurator) { return configurator.variantGroup; });
var getPackSize = createSelector(getConfigurator, function (configurator) { return configurator.packSize; });
var getUsageFrequency = createSelector(getConfigurator, function (configurator) { return configurator.usageFrequency; });
var getEyeSides = createSelector(getConfigurator, function (configurator) { return configurator.eyeSides; });
var getLensVariants = createSelector(getConfigurator, function (configurator) { return configurator.lensVariants; });
var getProduct = createSelector(getConfigurator, function (configurator) { return configurator.product; });
var getStaticsUrl = createSelector(getConfigurator, function (configurator) { return configurator === null || configurator === void 0 ? void 0 : configurator.staticsUrl; });
var getClsUsps = createSelector(getConfigurator, function (configurator) { var _a; return (_a = configurator.clsUsps) !== null && _a !== void 0 ? _a : []; });
var getRecommendedCategoryKey = createSelector(getConfigurator, function (configurator) { return configurator === null || configurator === void 0 ? void 0 : configurator.recommendedCategoryKey; });
/**
 * The currently selected delivery frequency of the variant group that is being configured
 */
var getSelectedDeliveryFrequency = createSelector(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedDeliveryFrequency$1(state, {
        variantGroup: variantGroup,
    });
});
/**
 * The currently selected billing period of the variant group that is being configured
 */
var getSelectedBillingPeriod = createSelector(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedBillingPeriod$1(state, {
        variantGroup: variantGroup,
    });
});
/**
 * The currently selected start date of the variant group that is being configured
 */
var getSelectedStartDate = createSelector(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedStartDate$1(state, {
        variantGroup: variantGroup,
    });
});
var getSelectedRatePlan = createSelector(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedRatePlan$1(state, { variantGroup: variantGroup });
});
var getSelectedSolution = createSelector(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedSolution$1(state, { variantGroup: variantGroup });
});
/**
 * located here instead of in ./steps to avoid circular dependency
 */
var getCurrentStep = createSelector(stateProp, configuratorIdProp, function (s, id) {
    return Selectors.getCurrentStep(s, { id: id });
});
/**
 * Aggregates
 */
var getConfigurationTotalPrice = createSelector(getSelectedRatePlan, getCurrentStep, getSelectedSolution, getEyeSides, function (selectedRatePlan, currentStep, selectedSolution, eyeSides) {
    var _a, _b, _c;
    if (!selectedRatePlan) {
        return undefined;
    }
    var lensPrice = (((_a = selectedRatePlan.totalPrice) === null || _a === void 0 ? void 0 : _a.centAmount) || 0) * eyeSides.length;
    var solutionPrice = ((_b = selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.price) === null || _b === void 0 ? void 0 : _b.discountedPrice) || ((_c = selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.price) === null || _c === void 0 ? void 0 : _c.originalPrice) || 0;
    return {
        originalPrice: lensPrice + solutionPrice,
        currency: selectedRatePlan.totalPrice.currencyCode,
    };
});
var getFormatProductUrl = createSelector(getConfigurator, function (configurator) { return configurator.formatProductUrl; });
var getPrescription = createSelector(getEyeSides, getLensVariants, function (eyeSides, lensVariants) {
    if (!eyeSides || !lensVariants) {
        return null;
    }
    var toLensPrescription = function (variant) {
        return PRESCRIPTION_ATTRIBUTES.reduce(function (previous, key) {
            var _a;
            var value = parseFloat(variant.attributes[key]);
            if (!isNumber(value))
                return previous;
            return __assign$1(__assign$1({}, previous), (_a = {}, _a[key] = value, _a));
        }, {
            sku: variant.sku || '',
            gan: variant.attributes.gan || '',
        });
    };
    var toPrescription = function (eyeSides, lensVariants) {
        return eyeSides.reduce(function (previous, eyeSide) {
            var _a;
            var variant = Object.values(lensVariants).find(function (variant) { return variant.eyeSide === eyeSide; });
            if (!variant)
                return previous;
            return __assign$1(__assign$1({}, previous), (_a = {}, _a[EYE_SIDE_LENS_MAP[eyeSide]] = toLensPrescription(variant), _a));
        }, {});
    };
    return toPrescription(eyeSides, lensVariants);
});
var getTypeDetails = createSelector(getSelectedDeliveryFrequency, getSelectedBillingPeriod, getSelectedStartDate, getPrescription, function (deliveryFrequency, billingPeriod, startDate, prescription) {
    if (!deliveryFrequency || !billingPeriod || !startDate || !prescription)
        return null;
    return {
        deliveryFrequency: deliveryFrequency,
        billingFrequency: billingPeriod,
        subscriptionStartDate: DateUtils.toLocalDate(startDate),
        prescription: prescription,
    };
});
var getBundleLineItems = createSelector(getVariantGroup, getEyeSides, getProduct, getSelectedRatePlan, getSelectedSolution, function (variantGroup, eyeSides, product, selectedRatePlan, selectedSolution) {
    if (!(eyeSides === null || eyeSides === void 0 ? void 0 : eyeSides.length) || !product || !selectedRatePlan)
        return null;
    var toGan = function (product) {
        var _a;
        if (!product)
            return '';
        return "" + ((_a = getAttrValue(product.masterVariant, 'gan')) !== null && _a !== void 0 ? _a : '');
    };
    var toLensBundleLineItem = function (product, variantGroup, ratePlan) { return ({
        sku: "" + (product === null || product === void 0 ? void 0 : product.masterVariant.sku),
        gan: toGan(product),
        ratePlanId: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.externalId) || '',
        quantity: 1,
        name: variantGroup || '',
        type: 'lens',
    }); };
    var toSolutionBundleLineItem = function (solution) {
        var _a, _b;
        return ({
            sku: (solution === null || solution === void 0 ? void 0 : solution.sku) || '',
            gan: (_a = solution === null || solution === void 0 ? void 0 : solution.gan) !== null && _a !== void 0 ? _a : '',
            ratePlanId: ((_b = solution === null || solution === void 0 ? void 0 : solution.ratePlan) === null || _b === void 0 ? void 0 : _b.externalId) || '',
            quantity: 1,
            name: (solution === null || solution === void 0 ? void 0 : solution.title) || '',
            type: 'solution',
        });
    };
    var bundleLineItems = eyeSides.map(function () {
        return toLensBundleLineItem(product, variantGroup, selectedRatePlan);
    });
    if (selectedSolution && selectedSolution.sku !== NO_SOLUTION_SKU) {
        bundleLineItems.push(toSolutionBundleLineItem(selectedSolution));
    }
    return bundleLineItems;
});
var getLineItemDraft = createSelector(getProduct, getBundleLineItems, getTypeDetails, function (product, bundleLineItems, typeDetails) {
    if (!product || !bundleLineItems || !typeDetails)
        return null;
    return {
        type: 'contact-lenses-subscription',
        sku: "" + (product === null || product === void 0 ? void 0 : product.masterVariant.sku),
        quantity: 1,
        bundleLineItems: bundleLineItems,
        typeDetails: typeDetails,
    };
});

var selectors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getVariantGroup: getVariantGroup,
    getPackSize: getPackSize,
    getUsageFrequency: getUsageFrequency,
    getEyeSides: getEyeSides,
    getLensVariants: getLensVariants,
    getProduct: getProduct,
    getStaticsUrl: getStaticsUrl,
    getClsUsps: getClsUsps,
    getRecommendedCategoryKey: getRecommendedCategoryKey,
    getSelectedDeliveryFrequency: getSelectedDeliveryFrequency,
    getSelectedBillingPeriod: getSelectedBillingPeriod,
    getSelectedStartDate: getSelectedStartDate,
    getSelectedRatePlan: getSelectedRatePlan,
    getSelectedSolution: getSelectedSolution,
    getCurrentStep: getCurrentStep,
    getConfigurationTotalPrice: getConfigurationTotalPrice,
    getFormatProductUrl: getFormatProductUrl,
    getPrescription: getPrescription,
    getTypeDetails: getTypeDetails,
    getLineItemDraft: getLineItemDraft
});

var initialState$4 = {
    lensVariants: [],
    eyeSides: [],
    clsUsps: [],
};
var reducer$2 = actions$1.reducer(initialState$4, 
/**
 * Set the correct frameSku and always reset the configurator to the initial state
 */
actions$1.on(startContactLensSubscriptionConfiguration, function (_s, _a) {
    var _b = _a.payload, clsUsps = _b.clsUsps, formatProductUrl = _b.formatProductUrl, input = _b.input, lensVariants = _b.lensVariants, product = _b.product, recommendedCategoryKey = _b.recommendedCategoryKey, staticsUrl = _b.staticsUrl, variantGroup = _b.variantGroup;
    return (__assign$1(__assign$1(__assign$1({}, initialState$4), input), { usageFrequency: input.usageFrequency, clsUsps: clsUsps, formatProductUrl: formatProductUrl, lensVariants: lensVariants, product: product, recommendedCategoryKey: recommendedCategoryKey, staticsUrl: staticsUrl, variantGroup: variantGroup }));
}), 
/**
 * When adding the config to cart has succeeded we start from the initialState
 */
actions$1.on(addToCartSuccess, function () { return (__assign$1({}, initialState$4)); }));

var getSubscriptions = createSelector(getContactLensSubscription, function (cls) { return cls.subscriptions; });

var getRatePlans = createSelector(getSubscriptions, function (s) { return s.ratePlans; });

var initialState$3 = Object.freeze({
    ratePlans: uninitState(),
});
var reducer$1 = actions$1.reducer(initialState$3, actions$1.on(startContactLensSubscriptionConfiguration, function (s) { return (__assign$1(__assign$1({}, s), { ratePlans: loadingState() })); }), actions$1.on(fetchRatePlansFailed, function (s, _a) {
    var error = _a.payload.error;
    return (__assign$1(__assign$1({}, s), { ratePlans: failedState(error) }));
}), actions$1.on(fetchRatePlansSuccess, function (s, _a) {
    var ratePlans = _a.payload.ratePlans;
    return (__assign$1(__assign$1({}, s), { ratePlans: successState(ratePlans) }));
}));

var contactLensSubscriptionReducer = combineReducers({
    configurations: reducer$3,
    configurator: reducer$2,
    subscriptions: reducer$1,
});

function selectDeliveryFrequency(_a) {
    var selectedDeliveryFrequency;
    var _b = _a.payload, variantGroup = _b.variantGroup, deliveryFrequency = _b.deliveryFrequency;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getSelectedDeliveryFrequency)];
            case 1:
                selectedDeliveryFrequency = _c.sent();
                if (!(selectedDeliveryFrequency !== deliveryFrequency)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(resetSelectedSolution({ variantGroup: variantGroup }))];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, put(selectDeliveryFrequencySuccess({
                    variantGroup: variantGroup,
                    deliveryFrequency: deliveryFrequency,
                }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectBillingPeriod(_a) {
    var selectedBillingPeriod;
    var _b = _a.payload, variantGroup = _b.variantGroup, billingPeriod = _b.billingPeriod;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getSelectedBillingPeriod)];
            case 1:
                selectedBillingPeriod = _c.sent();
                if (!(selectedBillingPeriod !== billingPeriod)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(resetSelectedSolution({ variantGroup: variantGroup }))];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, put(selectBillingPeriodSuccess({
                    variantGroup: variantGroup,
                    billingPeriod: billingPeriod,
                }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectStartDate(_a) {
    var _b = _a.payload, variantGroup = _b.variantGroup, startDate = _b.startDate;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, put(selectStartDateSuccess({
                    variantGroup: variantGroup,
                    startDate: startDate,
                }))];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectRatePlan(_a) {
    var selectedDeliveryFrequency, selectedBillingPeriod, ratePlans, compatibleRatePlans, resolvedRatePlan;
    var variantGroup = _a.payload.variantGroup;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getSelectedDeliveryFrequency)];
            case 1:
                selectedDeliveryFrequency = _b.sent();
                return [4 /*yield*/, select(getSelectedBillingPeriod)];
            case 2:
                selectedBillingPeriod = _b.sent();
                return [4 /*yield*/, select(getRatePlans)];
            case 3:
                ratePlans = _b.sent();
                if (!statusSuccess(ratePlans)) {
                    return [2 /*return*/];
                }
                compatibleRatePlans = [];
                if (selectedBillingPeriod) {
                    compatibleRatePlans = ratePlans.result.filter(function (rp) {
                        return rp.shippingSchedule === selectedDeliveryFrequency &&
                            rp.billingPeriod === selectedBillingPeriod;
                    });
                }
                if (!compatibleRatePlans.length && selectedDeliveryFrequency) {
                    compatibleRatePlans = ratePlans.result.filter(function (rp) { return rp.shippingSchedule === selectedDeliveryFrequency; });
                }
                if (!!compatibleRatePlans.length) return [3 /*break*/, 5];
                return [4 /*yield*/, put(selectRatePlanFailed({
                        variantGroup: variantGroup,
                        ratePlan: undefined,
                        error: new Error('Unable to resolve selections to a compatible rate plan.'),
                    }))];
            case 4: return [2 /*return*/, _b.sent()];
            case 5:
                resolvedRatePlan = compatibleRatePlans[0];
                return [4 /*yield*/, put(selectRatePlanSuccess({
                        variantGroup: variantGroup,
                        ratePlan: resolvedRatePlan,
                    }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
var configurationsSagas = [
    takeLatest(selectDeliveryFrequency$1.type, selectDeliveryFrequency),
    takeLatest(selectBillingPeriod$1.type, selectBillingPeriod),
    takeLatest(selectStartDate$2.type, selectStartDate),
    takeLatest(selectDeliveryFrequencySuccess.type, selectRatePlan),
    takeLatest(selectBillingPeriodSuccess.type, selectRatePlan),
];

var LABEL_PREFIX = 'products.contactLenses.configurator';
var CONFIGURATOR_ID = 'contact-lenses-subscription';

var UsageLevel$1;
(function (UsageLevel) {
    UsageLevel["One"] = "one_day_a_week";
    UsageLevel["Two"] = "two_days_a_week";
    UsageLevel["ThreeFour"] = "three_four_days_a_week";
    UsageLevel["FivePlus"] = "more_than_five_days_a_week";
})(UsageLevel$1 || (UsageLevel$1 = {}));
var BillingFrequency$1;
(function (BillingFrequency) {
    BillingFrequency["Monthly"] = "monthly";
    BillingFrequency["Quarterly"] = "quarterly";
})(BillingFrequency$1 || (BillingFrequency$1 = {}));
var DeliveryFrequency$1;
(function (DeliveryFrequency) {
    DeliveryFrequency["Monthly"] = "monthly";
    DeliveryFrequency["Quarterly"] = "quarterly";
})(DeliveryFrequency$1 || (DeliveryFrequency$1 = {}));

var types = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get UsageLevel () { return UsageLevel$1; },
    get BillingFrequency () { return BillingFrequency$1; },
    get DeliveryFrequency () { return DeliveryFrequency$1; }
});

var usageLevelToFrequency = function (usageLevel) {
    var _a;
    // Data layer labels are always english
    return ((_a = {},
        _a[UsageLevel$1.One] = '1 time a week',
        _a[UsageLevel$1.Two] = '2 times a week',
        _a[UsageLevel$1.ThreeFour] = '3 or 4 times a week',
        _a[UsageLevel$1.FivePlus] = 'more than 5 times a week',
        _a)[usageLevel]);
};
var mapBoxQuantity = function (packs, packageQuantity) {
    return packs + " " + (packs > 1 ? 'boxes' : 'box') + " of " + packageQuantity + " lenses";
};

var stepMapping = {
    deliveryFrequency: {
        name: 'delivery frequency',
        id: '200',
    },
    subscriptionPlan: {
        name: 'subscription plan',
        id: '300',
    },
    solution: {
        name: 'solutions',
        id: '400',
    },
};
/**
 * Local mappers
 */
var toFrequency = function (frequency) {
    return frequency === 'monthly' ? 'every month' : 'every quarter';
};
/**
 * SHARED SELECTORS
 * Most data layer selectors will use these
 */
var getStepData = createSelector(configuratorIdProp, stateProp, function (id, s) {
    var currentStep = Selectors.getCurrentStep(s, { id: id });
    return currentStep ? stepMapping[currentStep.name] : undefined;
});
var getBoxConfig = createSelector(getPackSize, getSelectedRatePlan, getUsageFrequency, function (packSize, ratePlan, usageLevel) {
    return {
        frequency: usageLevel && usageLevelToFrequency(usageLevel),
        quantity: mapBoxQuantity(packSize || 1, (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.packageQuantity) || 1),
    };
});
var getLensParameters = createSelector(getPrescription, function (prescription) {
    if (!prescription) {
        return;
    }
    var leftLens = prescription.leftLens, rightLens = prescription.rightLens;
    var toLens = function (lens) {
        var _a, _b, _c, _d, _e, _f;
        return lens && {
            baseCurve: ((_a = lens.baseCurve) === null || _a === void 0 ? void 0 : _a.toString()) || 'n/a',
            diameter: ((_b = lens.diameter) === null || _b === void 0 ? void 0 : _b.toString()) || 'n/a',
            addition: ((_c = lens.addition) === null || _c === void 0 ? void 0 : _c.toString()) || 'n/a',
            axis: ((_d = lens.axis) === null || _d === void 0 ? void 0 : _d.toString()) || 'n/a',
            power: ((_e = lens.power) === null || _e === void 0 ? void 0 : _e.toString()) || 'n/a',
            cylinder: ((_f = lens.cylinder) === null || _f === void 0 ? void 0 : _f.toString()) || 'n/a',
        };
    };
    return {
        OS: toLens(leftLens),
        OD: toLens(rightLens),
    };
});
var getConfigFlow = createSelector(getStepData, function (step) {
    if (!step)
        return undefined;
    return {
        version: '1.0',
        step: step,
    };
});
var getDeliveryProductConfig = createSelector(getBoxConfig, getLensParameters, getSelectedDeliveryFrequency, getConfigurationTotalPrice, function (box, lens, selectedDeliveryFrequency, configurationPrice) {
    if (!selectedDeliveryFrequency || !lens || !configurationPrice) {
        return undefined;
    }
    var deliveryFrequency = toFrequency(selectedDeliveryFrequency);
    var price = calcPrice(configurationPrice.originalPrice);
    return {
        purchaseType: 'subscription',
        box: box,
        lens: lens,
        deliveryFrequency: deliveryFrequency,
        price: price,
    };
});
var getSubscriptionPlanProductConfig = createSelector(getDeliveryProductConfig, getSelectedBillingPeriod, getSelectedStartDate, function (productConfig, selectedBillingPeriod, startDate) {
    if (!startDate || !selectedBillingPeriod || !productConfig) {
        return undefined;
    }
    var billingFrequency = toFrequency(selectedBillingPeriod);
    return __assign$1(__assign$1({}, productConfig), { billingFrequency: billingFrequency, startDate: DateUtils.toLocalDate(startDate) });
});
var getSolutionsProductConfig = createSelector(getSubscriptionPlanProductConfig, getSelectedSolution, function (productConfig, selectedSolution) {
    if (!selectedSolution || !productConfig) {
        return undefined;
    }
    var solution = selectedSolution
        ? {
            included: selectedSolution.sku === '-1' ? 'no' : 'yes',
            sku: selectedSolution.sku === '-1' ? undefined : selectedSolution.sku,
            name: selectedSolution.title === '-1' ? undefined : selectedSolution.title,
        }
        : undefined;
    return __assign$1(__assign$1({}, productConfig), { solution: solution });
});
var getProductConfig = createSelector(configuratorIdProp, stateProp, getConfigFlow, function (id, s, configFlow) {
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '200') {
        return getDeliveryProductConfig(s, { id: id });
    }
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '300') {
        return getSubscriptionPlanProductConfig(s, { id: id });
    }
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '400') {
        return getSolutionsProductConfig(s, { id: id });
    }
    return undefined;
});

var ContactLensesConfigEvent$1 = 'ContactLensesConfigEvent';
function onStartConfiguration() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onButtonEvent, 'choose plan')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Wrapper for all 'button click' events
 */
function onButtonEvent(eventLabel) {
    var buttonEvent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                buttonEvent = {
                    event: ContactLensesConfigEvent$1,
                    eventAction: 'click on button',
                    eventLabel: eventLabel,
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(buttonEvent))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Wrapper for all 'view step' events
 */
function onPushEvent(id, eventAction, eventLabel) {
    var productConfig, configFlow, event;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getProductConfig, {
                    id: id,
                })];
            case 1:
                productConfig = _a.sent();
                return [4 /*yield*/, select(getConfigFlow, { id: id })];
            case 2:
                configFlow = _a.sent();
                if (!productConfig || !configFlow) {
                    return [2 /*return*/];
                }
                event = {
                    event: ContactLensesConfigEvent$1,
                    eventAction: eventAction,
                    eventLabel: eventLabel,
                    RxContactLenses: {
                        configFlow: configFlow,
                        productConfig: productConfig,
                    },
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(event))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs a 'view step' event on every step change
 */
function onViewStep(_a) {
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(onPushEvent, id, 'view step')];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs when successfully moved to the next step
 */
function onNextStep() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onButtonEvent, 'next step')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs when successfully moved to the previous step
 */
function onPreviousStep() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onButtonEvent, 'step back')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs when footer expander is toggled
 */
function onToggleFooter(_a) {
    var isFooterOpen;
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(Selectors.isFooterOpen, { id: id })];
            case 1:
                isFooterOpen = _b.sent();
                return [4 /*yield*/, call(onButtonEvent, isFooterOpen ? 'expand plan overview' : 'close plan overview')];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs when modal is closed, based on the 'resetConfigurationState' action
 */
function onModalClose() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onButtonEvent, 'close modal')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Wrapper for all 'changed input' events
 */
function onChangeEvent(eventAction, productConfig, eventLabel) {
    var changeEvent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                changeEvent = {
                    event: ContactLensesConfigEvent$1,
                    eventAction: eventAction,
                    eventLabel: eventLabel,
                    RxContactLenses: {
                        productConfig: productConfig,
                    },
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(changeEvent))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Runs on change of delivery frequency
 */
var onDeliveryChange = function (id) {
    return function () {
        var productConfig, deliveryFrequency, price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getProductConfig, {
                        id: id,
                    })];
                case 1:
                    productConfig = _a.sent();
                    if (!productConfig)
                        return [2 /*return*/];
                    deliveryFrequency = productConfig.deliveryFrequency, price = productConfig.price;
                    return [4 /*yield*/, call(onChangeEvent, 'select delivery frequency', { deliveryFrequency: deliveryFrequency, price: price })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
/**
 * Runs on change of billing frequency
 */
var onBillingChange = function (id) {
    return function () {
        var productConfig, billingFrequency, price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getProductConfig, {
                        id: id,
                    })];
                case 1:
                    productConfig = _a.sent();
                    if (!productConfig)
                        return [2 /*return*/];
                    billingFrequency = productConfig.billingFrequency, price = productConfig.price;
                    return [4 /*yield*/, call(onChangeEvent, 'select billing frequency', { billingFrequency: billingFrequency, price: price })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
/**
 * Runs on change of subscription start date
 */
function onStartDateChange(_a) {
    var startDate = _a.payload.startDate;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(onChangeEvent, 'select start date', { startDate: startDate })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Runs on change of solution
 */
var onSolutionChange = function (id) {
    return function () {
        var productConfig, solution, price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getProductConfig, {
                        id: id,
                    })];
                case 1:
                    productConfig = _a.sent();
                    if (!productConfig)
                        return [2 /*return*/];
                    solution = productConfig.solution, price = productConfig.price;
                    return [4 /*yield*/, call(onChangeEvent, 'select solution', { solution: solution, price: price })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
/**
 * This function binds the the configurator ID to the selection actions, which is necessary to provide
 * the correct data for data layer events.
 */
function listenForConfigurationChanges(id) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(selectDeliveryFrequencySuccess.type, onDeliveryChange(id)),
                    takeLatest(selectBillingPeriodSuccess.type, onBillingChange(id)),
                    takeLatest(selectSolution.type, onSolutionChange(id)),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var datalayerSagas = [
    // CLS configurator actions
    takeLatest(startContactLensSubscriptionConfiguration.type, onStartConfiguration),
    takeLatest(resetConfigurationState.type, onModalClose),
    // Generic configurator actions
    takeLatest(Actions.isStepShownWithId(CONFIGURATOR_ID), onViewStep),
    takeLatest(Actions.isNextStepWithId(CONFIGURATOR_ID), onNextStep),
    takeLatest(Actions.isPreviousStepWithId(CONFIGURATOR_ID), onPreviousStep),
    takeLatest(Actions.isToggleFooterWithId(CONFIGURATOR_ID), onToggleFooter),
    // Data Layer actions
    // this action is listened to separately from the listenForConfigurationChanges because
    // it needs to be triggered explicitly on demand
    takeLatest(selectStartDate$1.type, onStartDateChange),
];

function contactLensSubscriptionSaga () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(__spreadArray$1(__spreadArray$1([], __read(configurationsSagas)), __read(datalayerSagas)))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var ProductReimbursableLogo = function (_a) {
    var logos = _a.logos, _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    var getLabel = useIntl().getLabel;
    if (!logos || (!logos.default && !logos.alternative)) {
        return null;
    }
    var logoUrl = variant === 'alternative' && logos.alternative ? logos.alternative : logos.default;
    return (React.createElement("div", { className: "product-reimbursable" },
        React.createElement("img", { className: "product-reimbursable__image", src: logoUrl, alt: getLabel('products.insuranceReimbursable') })));
};

var isLightProductModel = function (product) {
    return 'objectID' in product;
};
var isContactLenses = function (productType) {
    return CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
};

var Details = function (_a) {
    var brand = _a.brand, name = _a.name;
    return (React__default.createElement("header", { className: "product-block-details" },
        React__default.createElement(Heading, { className: "product-block-details__brand", variant: "subheading1" }, brand),
        React__default.createElement(Text, { className: "product-block-details__name", variant: "caption" }, name)));
};

var Images = function (_a) {
    var front = _a.front, angle = _a.angle;
    // Default width and height to set the right aspect ratios 320/180 = 16:9
    var defaultSettings = { width: 320, height: 180, rootMargin: '150px 0px' };
    var isPhone = MediaQuery.useIsPhone();
    var Placeholder = function (src, alt) { return (React__default.createElement("div", { className: "product-block-image-placeholder" },
        React__default.createElement(SkeletonLoader, null),
        React__default.createElement("noscript", null,
            React__default.createElement("img", { src: src, alt: alt, width: defaultSettings.width, height: defaultSettings.height })))); };
    return (React__default.createElement("section", { className: classnames('product-block-image-wrapper', {
            // Only enable hover behaviour if we have have an angle image as well and are not on a phone
            'product-block-image-wrapper--hover': !!angle && !isPhone,
        }), style: { paddingBottom: (defaultSettings.height / defaultSettings.width) * 100 + "%" } },
        front && (React__default.createElement("figure", { className: "product-block-image product-block-image--front" },
            React__default.createElement(LazyImage, __assign$1({}, defaultSettings, { className: "product-block-image__lazy-image", src: front.url, alt: front.alt || '', srcSet: front.srcSet, sizes: front.sizes, placeholder: Placeholder(front.url, front.alt) })))),
        angle && !isPhone && (React__default.createElement("figure", { className: "product-block-image product-block-image--angle" },
            React__default.createElement(LazyImage, __assign$1({}, defaultSettings, { className: "product-block-image__lazy-image", src: angle.url, alt: angle.alt || '', srcSet: angle.srcSet, sizes: angle.sizes, placeholder: Placeholder(angle.url, angle.alt) }))))));
};

var Prices = function (_a) {
    var price = _a.price, discountedPrice = _a.discountedPrice;
    var currency = useIntl().currency;
    var hasDiscount = !!discountedPrice && discountedPrice !== price;
    return (React.createElement("div", { className: "product-block-prices" },
        hasDiscount && React.createElement(Price, { value: price, currency: currency, size: "small", type: "strikethrough" }),
        React.createElement(Price, { value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price, currency: currency, size: "small", type: hasDiscount ? 'discount' : 'default' })));
};

var PromotionLabel = function (_a) {
    var children = _a.children;
    return (React__default.createElement("span", { className: "product-block-promotion-label" }, children));
};

var VariantSwitcherItem = function (_a) {
    var image = _a.image, sku = _a.sku, isActive = _a.isActive, onClick = _a.onClick;
    var handleClick = React__default.useCallback(function (e) {
        onClick(sku);
        e.preventDefault();
        e.stopPropagation();
    }, [sku]);
    if (!image) {
        return null;
    }
    return (React__default.createElement("button", { onClick: handleClick, "aria-label": image.alt || '', className: classnames('variant-switcher-item', {
            'variant-switcher-item--active': isActive,
        }) },
        React__default.createElement(LazyImage, { className: "variant-switcher-item__image", src: image.url, alt: image.alt || '', 
            // 16:9 ratio
            height: 22.5, width: 40 })));
};
var VariantSwitcher = function (_a) {
    var variants = _a.variants, activeSku = _a.activeSku, onVariantChange = _a.onVariantChange, className = _a.className;
    var itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
    var carouselItems = React__default.useMemo(function () {
        var max = Math.ceil(variants.length / itemsPerSlide);
        var items = [];
        for (var i = 0; i < max; i++) {
            var start = i * itemsPerSlide;
            var end = (i + 1) * itemsPerSlide;
            items.push(React__default.createElement("div", { key: "variant-switcher-" + i, className: classnames('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1,
                }) }, variants.slice(start, end).map(function (_a) {
                var sku = _a.sku, image = _a.image;
                return (React__default.createElement(VariantSwitcherItem, { key: sku, image: image, sku: sku, isActive: sku === activeSku, onClick: onVariantChange }));
            })));
        }
        return items;
    }, [variants, activeSku, onVariantChange, itemsPerSlide]);
    return (React__default.createElement("div", { className: classnames('variant-switcher', className) },
        React__default.createElement(Carousel, { pagination: false }, carouselItems)));
};

var ProductBlock = React.forwardRef(function (_a, ref) {
    var brand = _a.brand, name = _a.name, url = _a.url, productType = _a.productType, activeSku = _a.activeSku, images = _a.images, price = _a.price, discountedPrice = _a.discountedPrice, variants = _a.variants, offering = _a.offering, promotionLabel = _a.promotionLabel, className = _a.className, onVariantChange = _a.onVariantChange, onClick = _a.onClick, isInsuranceReimbursable = _a.isInsuranceReimbursable, reimbursableLogos = _a.reimbursableLogos, isReimbursableFiltered = _a.isReimbursableFiltered;
    var getFormattedLabel = useIntl().getFormattedLabel;
    var isLargeScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    if (!activeSku || !price || !url) {
        console.warn("Cannot render ProductBlock component without a valid price: " + price + " and url: " + url + " and active sku: " + activeSku + ".");
        return null;
    }
    return (React.createElement("a", { ref: ref, href: url, onClick: onClick, "aria-label": brand + " " + name, "data-t": "product-block", className: classnames('product-block', {
            'product-block--contact-lenses': isContactLenses(productType),
        }, className) },
        React.createElement("aside", { className: "product-block__header" },
            promotionLabel && React.createElement(PromotionLabel, null, promotionLabel),
            isLargeScreen && isInsuranceReimbursable && (React.createElement(ProductReimbursableLogo, { logos: reimbursableLogos, variant: isReimbursableFiltered ? 'alternative' : 'default' }))),
        React.createElement("div", { className: "product-block__main" },
            React.createElement(Images, { front: images.front, angle: images.angle }),
            React.createElement(Details, { brand: brand, name: name }),
            React.createElement(Prices, { price: price, discountedPrice: discountedPrice })),
        React.createElement("footer", { className: "product-block__footer" },
            !!(variants === null || variants === void 0 ? void 0 : variants.length) && (React.createElement(VariantSwitcher, { variants: variants, activeSku: activeSku, onVariantChange: onVariantChange, className: "product-block__variant-switcher" })),
            (offering === null || offering === void 0 ? void 0 : offering.includesLenses) && (React.createElement(Text, { className: "product-block__bottom-link" }, getFormattedLabel('products.glasses.offering.includesLenses', {
                parseLink: true,
                hideLabelKey: true,
            }))))));
});

var defaultParams = {
    fit: 'fill',
    format: 'jpeg',
};
// Calculates 16:9 aspect ratio height
var calcHeightToRatio = function (w) { return Math.round(w * (9 / 16)); };
var createImgUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    return "" + createImageUrl(url, __assign$1(__assign$1({}, defaultParams), params));
};
var createImageSrcSetItem = function (url, width, params) {
    return createImageUrl(url, __assign$1(__assign$1(__assign$1({}, defaultParams), params), { width: width, height: calcHeightToRatio(width) })) + " " + width + "w";
};
var createImageSrcSet = function (url, imageSizes, params) {
    return Object.values(imageSizes)
        .map(function (size) { return createImageSrcSetItem(url, size, params); })
        .toString();
};
var createImageSizes = function (imageSizes) {
    var sizes = Object.values(imageSizes);
    return Object.values(MediaQuery.Breakpoints)
        .map(function (bp, i) { return "(max-width: " + bp + "px) " + sizes[i] + "px"; })
        .join(', ');
};

var imageSizes = {
    S: 171,
    M: 192,
    L: 272,
    XL: 544,
};
function createResponsiveImage(image, alt, params) {
    var imageUrl = typeof image === 'string' ? image : image.url;
    var resolvedAlt = (typeof image === 'string' ? alt : image.alt) || alt;
    return {
        url: createImgUrl(imageUrl, params),
        alt: resolvedAlt,
        srcSet: createImageSrcSet(imageUrl, imageSizes),
        sizes: createImageSizes(imageSizes),
    };
}
var createAltTag = function (variant, locale) {
    var frameColor = getJoinedLocalizedAttrValues(variant, 'frameColor', locale);
    var lensColor = getJoinedLocalizedAttrValues(variant, 'lensColor', locale);
    var colorsLabel = [lensColor, frameColor].filter(function (s) { return s.trim() !== ''; }).join(' / ');
    return variant.name + " " + colorsLabel;
};
function getVariantImages(variant, locale, staticsUrl, params, responsive, isBynderEnabled) {
    if (responsive === void 0) { responsive = true; }
    if (isBynderEnabled === void 0) { isBynderEnabled = false; }
    var altTag = createAltTag(variant, locale);
    var settings = Boolean(params)
        ? params
        : { width: imageSizes.XL, height: calcHeightToRatio(imageSizes.XL) };
    if (isBynderEnabled) {
        return getProductImages(variant, responsive, altTag, settings);
    }
    return getLegacyImageUrls(variant, staticsUrl, responsive, altTag, settings);
}
// Map placeholderImage to correct format
var placeholderImg = {
    url: placeholderImage.url,
};
function getLegacyImageUrls(variant, staticsUrl, responsive, altTag, params) {
    if (!variant.images || !variant.images.length) {
        return [placeholderImg, placeholderImg];
    }
    var images = __spreadArray$1([], __read(variant.images));
    return images.map(function (img) {
        var imageUrl = "" + staticsUrl + img.url;
        return responsive
            ? createResponsiveImage(imageUrl, altTag, params)
            : {
                url: createImgUrl(imageUrl, params),
                alt: altTag,
            };
    });
}
function getProductImages(variant, responsive, altTag, params) {
    var _a;
    var images = (_a = variant.media) === null || _a === void 0 ? void 0 : _a.images;
    if (!images || !images.length) {
        return [placeholderImg];
    }
    return images.map(function (img) {
        var imageUrl = img.url;
        return responsive
            ? createResponsiveImage(imageUrl, altTag, params)
            : {
                url: createImgUrl(imageUrl, params),
                alt: altTag,
            };
    });
}

function getVariantInfo(locale, product, variant, productType) {
    var isLenses = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
    var isSolutions = CommerceToolsApi.isSolutions(productType);
    var brand = isLenses || isSolutions
        ? getLocalizedValue(product.name, locale)
        : String(getAttrValue(variant, 'brand'));
    var name = isLenses
        ? getLocalizedAttrValue(variant, 'replacementFrequency', locale)
        : isSolutions
            ? (getLocalizedAttrValue(variant, 'contactLensCareType', locale) || '') + " " + (getAttrValue(variant, 'packageOption') || '')
            : variant.name;
    var _a = getPrice$1(variant) || {}, originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice;
    var framePriceIncluded = CommerceToolsApi.isFrames(productType) && getAttrValue(variant, 'priceIncluded');
    var price = framePriceIncluded && typeof framePriceIncluded === 'object'
        ? Number(framePriceIncluded.centAmount)
        : originalPrice;
    return __assign$1({ brand: brand || '', name: name || '', sku: variant.sku, price: price }, (discountedPrice && discountedPrice !== originalPrice ? { discountedPrice: discountedPrice } : {}));
}

function getVariantUrl(formatProductUrl, product, variant, productType, additionalUrlParams) {
    if (!productType) {
        console.error("ProductType data is missing from product with id " + product.id + ", make sure you 'expand' the productType when fetching from commercetools.", product);
        return '#';
    }
    if (!variant.sku) {
        console.error("Variant for product with id " + product.id + " has no sku", {
            variant: variant,
            product: product,
        });
        return '#';
    }
    return formatProductUrl({
        productType: productType,
        sku: variant.sku,
        slug: product.slug,
    }, additionalUrlParams);
}

var getActiveVariant = function (variants, sku) { return (sku && variants.find(function (variant) { return variant.sku === sku; })) || variants[0]; };

var getProductTypeName = function (product) { var _a, _b; return (_b = (_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; };
function useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl, additionalUrlParams) {
    var locale = useIntl().locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var productType = React.useMemo(function () { return getProductTypeName(product); }, [product]);
    var variants = React.useMemo(function () { return __spreadArray$1([product.masterVariant], __read(product.variants)); }, [
        product.masterVariant,
        product.variants,
    ]);
    var activeVariant = React.useMemo(function () { return getActiveVariant(variants, activeSku); }, [
        variants,
        activeSku,
    ]);
    var variantInfo = getVariantInfo(locale, product, activeVariant, productType);
    var variantUrl = getVariantUrl(formatProductUrl, product, activeVariant, productType, additionalUrlParams);
    var promotionLabel = getDiscountText(locale, activeVariant);
    var variantImages = React.useMemo(function () {
        var _a = __read(getVariantImages(activeVariant, locale, staticsUrl, undefined, true, isBynderImagesEnabled), 2), front = _a[0], angle = _a[1];
        return { front: front, angle: angle };
    }, [staticsUrl, locale, activeVariant, isBynderImagesEnabled]);
    var otherVariants = React.useMemo(function () {
        var thumbnailSize = { width: 40, height: 23 };
        return variants.length > 1
            ? variants.map(function (variant) { return ({
                sku: variant.sku,
                image: getVariantImages(variant, locale, staticsUrl, thumbnailSize, false, isBynderImagesEnabled)[0],
            }); })
            : [];
    }, [variants, staticsUrl, locale, isBynderImagesEnabled]);
    var isInsuranceReimbursable = Boolean(activeVariant.isInsuranceReimbursable);
    return {
        productType: productType,
        variantInfo: variantInfo,
        variantUrl: variantUrl,
        promotionLabel: promotionLabel,
        variantImages: variantImages,
        otherVariants: otherVariants,
        isInsuranceReimbursable: isInsuranceReimbursable,
    };
}

var CommerceToolsProductBlock = function (_a) {
    var product = _a.product, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, onClick = _a.onClick, onImpression = _a.onImpression, className = _a.className, reimbursableLogos = _a.reimbursableLogos;
    var _b = __read(React.useState(product.masterVariant.sku || ''), 2), activeSku = _b[0], setActiveSku = _b[1];
    var _c = useWasSeenByUser(), wasSeen = _c.wasSeen, ref = _c.ref;
    var handleVariantChange = React.useCallback(function (sku) {
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(function () {
        if (wasSeen && onImpression)
            onImpression();
    }, [wasSeen]);
    var _d = useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl), productType = _d.productType, variantInfo = _d.variantInfo, variantUrl = _d.variantUrl, variantImages = _d.variantImages, otherVariants = _d.otherVariants, promotionLabel = _d.promotionLabel, isInsuranceReimbursable = _d.isInsuranceReimbursable;
    if (!variantInfo || !variantUrl) {
        console.error('CommerceToolsProductBlock: missing critical info required for rendering', {
            variantInfo: variantInfo,
            variantUrl: variantUrl,
        });
        return null;
    }
    return (React.createElement(ProductBlock, __assign$1({ ref: ref, className: className, url: variantUrl, images: variantImages, variants: otherVariants || [], promotionLabel: promotionLabel, productType: productType, activeSku: activeSku, reimbursableLogos: reimbursableLogos, onVariantChange: handleVariantChange, onClick: onClick, isInsuranceReimbursable: isInsuranceReimbursable }, variantInfo)));
};

var pushPowerSelectionEvent = function (event, eventLabel) {
    DataLayer.pushEvent({
        event: event,
        eventAction: 'plp select lens power',
        eventLabel: eventLabel,
    });
};

var AlgoliaProductBlock = function (_a) {
    var product = _a.product, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, additionalUrlParams = _a.additionalUrlParams, onClick = _a.onClick, onImpression = _a.onImpression, className = _a.className, reimbursableLogos = _a.reimbursableLogos;
    var _b = __read(React.useState(product.masterVariant.sku || ''), 2), activeSku = _b[0], setActiveSku = _b[1];
    var _c = useWasSeenByUser(), wasSeen = _c.wasSeen, ref = _c.ref;
    var handleVariantChange = React.useCallback(function (sku) {
        var _a, _b;
        if (CommerceToolsApi.isReadyReaders((_b = (_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '')) {
            var selectedVariant = product.variants.find(function (variant) { return variant.sku === sku; });
            var selectedPower = selectedVariant && getAttrValue(selectedVariant, 'power');
            var eventLabel = selectedPower && sku + " | " + selectedPower;
            eventLabel ? pushPowerSelectionEvent('readyreaders', eventLabel) : null;
        }
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(function () {
        if (wasSeen && onImpression)
            onImpression();
    }, [wasSeen]);
    // TODO: in the near future, we want to start stripping the data models we use in algolia (ProductProjectionLight)
    //  to make the records much smaller and improve performance. Then we can start splitting stuff from the CT data resolver.
    var _d = useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl, additionalUrlParams), productType = _d.productType, variantInfo = _d.variantInfo, variantUrl = _d.variantUrl, variantImages = _d.variantImages, otherVariants = _d.otherVariants, promotionLabel = _d.promotionLabel, isInsuranceReimbursable = _d.isInsuranceReimbursable;
    var isReimbursableFiltered = (additionalUrlParams === null || additionalUrlParams === void 0 ? void 0 : additionalUrlParams.isInsuranceReimbursable) === 'true';
    if (!variantInfo || !variantUrl) {
        console.error('AlgoliaProductBlock: missing critical info required for rendering', {
            variantInfo: variantInfo,
            variantUrl: variantUrl,
        });
        return null;
    }
    return (React.createElement(ProductBlock, __assign$1({ ref: ref, productType: productType, className: className, url: variantUrl, images: variantImages, variants: otherVariants || [], promotionLabel: promotionLabel, activeSku: activeSku, onVariantChange: handleVariantChange, onClick: onClick, reimbursableLogos: reimbursableLogos, isInsuranceReimbursable: isInsuranceReimbursable, isReimbursableFiltered: isReimbursableFiltered, offering: product.offering }, variantInfo)));
};

function useGetProductsBySku(skus, limit) {
    var productsUrl = useApiConfig().productsUrl;
    var _a = __read(React.useState({
        products: [],
        isLoading: true,
        error: null,
    }), 2), state = _a[0], setState = _a[1];
    React.useEffect(function () {
        var isCancelled = false;
        function loadProducts() {
            return __awaiter(this, void 0, void 0, function () {
                var products, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchProducts(productsUrl, skus, limit)];
                        case 1:
                            products = _a.sent();
                            if (products && !isCancelled) {
                                setState(__assign$1(__assign$1({}, state), { products: products, isLoading: false }));
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error(error_1);
                            if (!isCancelled) {
                                setState(__assign$1(__assign$1({}, state), { error: error_1, isLoading: false }));
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        (skus === null || skus === void 0 ? void 0 : skus.length) && loadProducts();
        return function () {
            isCancelled = true;
        };
    }, [productsUrl, skus]);
    return state;
}
function fetchProducts(apiUrl, skus, limit) {
    if (skus === void 0) { skus = []; }
    return __awaiter(this, void 0, void 0, function () {
        var skusFilter, filters, expand, results, sortedProducts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!skus.length) {
                        return [2 /*return*/, []];
                    }
                    skusFilter = skus
                        .filter(function (s) { return !!s.length; })
                        .map(function (sku) { return "\"" + sku + "\""; })
                        .join(',');
                    filters = ["variants.sku:" + skusFilter];
                    expand = [
                        'productType',
                        'masterVariant.prices[*].discounted.discount',
                        'variants[*].prices[*].discounted.discount',
                    ];
                    return [4 /*yield*/, Products.query(apiUrl, { filters: filters, expand: expand })];
                case 1:
                    results = (_a.sent()).results;
                    sortedProducts = sortProducts(skus, results);
                    return [2 /*return*/, limit ? sortedProducts.slice(0, limit) : sortedProducts];
            }
        });
    });
}
// The Product service currently doesn't have a way to return the products in the same order
// as the SKUs array is provided, so we have to manually sort the products based on the SKU array.
function sortProducts(skus, products) {
    if (products === void 0) { products = []; }
    return __spreadArray$1([], __read(products)).sort(function (productA, productB) {
        var indexA = skus.findIndex(function (sku) {
            return __spreadArray$1([productA.masterVariant], __read(productA.variants)).find(function (v) { return v.sku === sku; });
        });
        var indexB = skus.findIndex(function (sku) {
            return __spreadArray$1([productB.masterVariant], __read(productB.variants)).find(function (v) { return v.sku === sku; });
        });
        return indexA - indexB;
    });
}

var ProductBlocksContainer = function (_a) {
    var _b = _a.skus, skus = _b === void 0 ? [] : _b, limit = _a.limit, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, className = _a.className, reimbursableLogos = _a.reimbursableLogos;
    var _c = useGetProductsBySku(skus, limit), products = _c.products, isLoading = _c.isLoading;
    var classNames = classnames('product-blocks-container', {
        className: className,
        loading: isLoading,
    });
    var productBlockProps = React.useMemo(function () { return ({
        staticsUrl: staticsUrl,
        formatProductUrl: formatProductUrl,
        reimbursableLogos: reimbursableLogos,
        showVariants: true,
    }); }, [staticsUrl, formatProductUrl]);
    return (React.createElement("div", { className: classNames }, isLoading ? (React.createElement(Loader, null)) : (products.map(function (product) { return (React.createElement(CommerceToolsProductBlock, __assign$1({ key: product.id, product: product }, productBlockProps))); }))));
};

var updateActiveVariant = actions$1.action('UPDATE_ACTIVE_VARIANT', actions$1.payload());

var actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    updateActiveVariant: updateActiveVariant
});

var initialState$2 = {
    activeSku: '',
};
var productDetailContextReducer = reducer$9(initialState$2, actions$1.on(updateActiveVariant, function (state, action) { return (__assign$1(__assign$1({}, state), { activeSku: action.payload.sku })); }));

var ProductDetailContext = React.createContext({});
var useProductDetailContext = function () { return React.useContext(ProductDetailContext); };
var ProductDetailProvider = function (_a) {
    var children = _a.children, product = _a.product, locale = _a.locale, sku = _a.sku, productType = _a.productType, staticsUrl = _a.staticsUrl, isPrescriptionGlassesConfiguratorValidationStepEnabled = _a.isPrescriptionGlassesConfiguratorValidationStepEnabled, renderAddToCartButton = _a.renderAddToCartButton, useAddToCart = _a.useAddToCart, reimbursableLogos = _a.reimbursableLogos, rest = __rest(_a, ["children", "product", "locale", "sku", "productType", "staticsUrl", "isPrescriptionGlassesConfiguratorValidationStepEnabled", "renderAddToCartButton", "useAddToCart", "reimbursableLogos"]);
    var _b = useFeatureToggles(), isCartV2Enabled = _b.isCartV2Enabled, isBynderImagesEnabled = _b.isBynderImagesEnabled;
    var _c = __read(React.useState(false), 2), isAddToCartNotificationShown = _c[0], setIsAddToCartNotificationShown = _c[1];
    var _d = __read(React.useReducer(productDetailContextReducer, __assign$1(__assign$1({}, initialState$2), { activeSku: sku })), 2), state = _d[0], dispatch = _d[1];
    var handleNotification = React.useCallback(function (show) {
        setIsAddToCartNotificationShown(show);
    }, []);
    var activeVariant = React.useMemo(function () {
        return getVariantInfo$1(product, productType, locale, state.activeSku, staticsUrl, isBynderImagesEnabled);
    }, [staticsUrl, locale, product, productType, state.activeSku, isBynderImagesEnabled]);
    var value = __assign$1(__assign$1(__assign$1({}, state), { activeVariant: activeVariant, dispatch: dispatch, product: product, productType: productType, staticsUrl: staticsUrl, isPrescriptionGlassesConfiguratorValidationStepEnabled: isPrescriptionGlassesConfiguratorValidationStepEnabled, renderAddToCartButton: renderAddToCartButton, useAddToCart: useAddToCart, isAddToCartNotificationShown: isCartV2Enabled ? false : isAddToCartNotificationShown, setIsAddToCartNotificationShown: isCartV2Enabled ? function () { return null; } : handleNotification, reimbursableLogos: reimbursableLogos }), rest);
    return React.createElement(ProductDetailContext.Provider, { value: value }, children);
};

var attributes = {
    addition: undefined,
    axis: undefined,
    baseCurve: undefined,
    color: undefined,
    cylinder: undefined,
    diameter: undefined,
    power: undefined,
};
var initialState$1 = {
    left: attributes,
    right: attributes,
};
var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'set': {
            var _c = action.payload, key = _c.key, value = _c.value;
            return __assign$1(__assign$1({}, state), (_a = {}, _a[key] = __assign$1(__assign$1({}, state[key]), value), _a));
        }
        case 'clear': {
            var key = action.payload;
            if (key) {
                return __assign$1(__assign$1({}, state), (_b = {}, _b[key] = initialState$1[key], _b));
            }
            return initialState$1;
        }
        default:
            return state;
    }
};
var useAttributes = function () {
    var _a = __read(React__default.useReducer(reducer, initialState$1), 2), attributes = _a[0], dispatch = _a[1];
    var setAttribute = React__default.useCallback(function (eyeSide, attribute, value) {
        var _a;
        return dispatch({
            type: 'set',
            payload: {
                key: eyeSide,
                value: (_a = {}, _a[attribute] = value, _a),
            },
        });
    }, []);
    var reset = React__default.useCallback(function () {
        return dispatch({
            type: 'clear',
        });
    }, []);
    var clearEyeSide = React__default.useCallback(function (eyeSide) {
        return dispatch({
            type: 'clear',
            payload: eyeSide,
        });
    }, []);
    var actions = React__default.useMemo(function () { return ({
        clearEyeSide: clearEyeSide,
        reset: reset,
        setAttribute: setAttribute,
    }); }, []);
    return React__default.useMemo(function () { return [attributes, actions]; }, [actions, attributes]);
};

var useFetchBundle = function (bundleSku) {
    var productsUrl = useApiConfig().productsUrl;
    var params = React__default.useMemo(function () {
        return bundleSku
            ? {
                sku: bundleSku,
            }
            : null;
    }, [bundleSku]);
    var bundleRequestOptions = React__default.useMemo(function () { return ({ skip: !params }); }, [params]);
    var _a = __read(useApiClient(Products.getContactLensBundles, bundleRequestOptions, productsUrl, params), 2), data = _a[1];
    return data;
};

var upperFirst = function (value) {
    return value[0].toUpperCase() + value.slice(1);
};
var defaultLineItems = {
    leftLensSku: '',
    leftLensName: '',
    rightLensSku: '',
    rightLensName: '',
};
var convertAttributesToLineItems = function (_a) {
    var attributesState = _a.attributesState, bundleSku = _a.bundleSku, name = _a.name, sku = _a.sku, solutionSku = _a.solutionSku, solutionName = _a.solutionName;
    var productType = 'contact-lens-bundle';
    var eyeSides = Object.keys(attributesState);
    var eyeAttributes = eyeSides.reduce(function (result, eyeSide) {
        var _a;
        var lensAttributes = attributesState[eyeSide];
        var attributeKeys = Object.keys(lensAttributes);
        var lineItems = attributeKeys.reduce(function (eyeSideResult, attribute) {
            var _a;
            var lensAttributeName = eyeSide + "Lens" + upperFirst(attribute);
            var lensAttributeValue = lensAttributes[attribute];
            if (lensAttributeValue === undefined) {
                return eyeSideResult;
            }
            // Some values can be "- 5.25", parseFloat needs "-5.25"
            var cleanValue = lensAttributeValue.replace(/\s+/g, '');
            return __assign$1(__assign$1({}, eyeSideResult), (_a = {}, _a[lensAttributeName] = parseFloat(cleanValue), _a));
        }, {});
        return __assign$1(__assign$1(__assign$1({}, result), lineItems), (_a = {}, _a[eyeSide + "LensSku"] = sku, _a[eyeSide + "LensName"] = name, _a));
    }, defaultLineItems);
    // Remove undefined or empty string values
    var customAttributes = Object.entries(__assign$1(__assign$1({}, eyeAttributes), { solutionSku: solutionSku, solutionName: solutionName, type: productType })).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return value == null || value === '' ? result : __assign$1(__assign$1({}, result), (_b = {}, _b[key] = value, _b));
    }, {});
    return [{ sku: bundleSku, customAttributes: customAttributes }];
};

var LensBundleContext = React.createContext(null);
var LensBundleProvider = function (_a) {
    var subscriptionProductSKU = _a.subscriptionProductSKU, children = _a.children;
    var data = useFetchBundle(subscriptionProductSKU);
    var locale = useIntl().locale;
    var bundle = data && data.results[0];
    var solutions = data && data.solutions;
    // Bridge between current lenses logic and bundle logic
    var _b = __read(useAttributes(), 2), attributesState = _b[0], attributeActions = _b[1];
    // When the solution changes, the requested sku is updated
    var _c = __read(React.useState(''), 2), bundleSku = _c[0], setBundleSku = _c[1];
    // This sets the initial selected sku
    React.useEffect(function () {
        if (bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku) {
            setBundleSku(bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku);
        }
        else {
            console.error('LensBundleProvider: Missing contact lens bundle product');
        }
    }, [bundle]);
    var solution = React.useMemo(function () {
        return solutions === null || solutions === void 0 ? void 0 : solutions.find(function (solution) { return solution.bundleSku === bundleSku; });
    }, [bundleSku, solutions]);
    // Based on the selected solution a price is calculated for each month
    var pricePerMonth = React.useMemo(function () {
        return solution && solution.bundlePrice[0].value;
    }, [solution]);
    var lensSku = React.useMemo(function () {
        var _a, _b, _c, _d;
        if (bundle) {
            var productReference = (_b = (_a = bundle.masterVariant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (attribute) { return attribute.name === 'bundleProduct1'; })) === null || _b === void 0 ? void 0 : _b.value;
            var lensMasterData = (_d = (_c = productReference === null || productReference === void 0 ? void 0 : productReference.obj) === null || _c === void 0 ? void 0 : _c.masterData) === null || _d === void 0 ? void 0 : _d.current;
            var sku = lensMasterData === null || lensMasterData === void 0 ? void 0 : lensMasterData.masterVariant.sku;
            return sku;
        }
    }, [bundle]);
    var lineItems = React.useMemo(function () {
        return convertAttributesToLineItems({
            bundleSku: bundleSku,
            name: (bundle === null || bundle === void 0 ? void 0 : bundle.name) ? getLocalizedValue(bundle === null || bundle === void 0 ? void 0 : bundle.name, locale) : '',
            sku: lensSku,
            attributesState: attributesState,
            solutionName: (solution === null || solution === void 0 ? void 0 : solution.name) ? getLocalizedValue(solution === null || solution === void 0 ? void 0 : solution.name, locale) : undefined,
            solutionSku: solution === null || solution === void 0 ? void 0 : solution.sku,
        });
    }, [bundleSku, bundle, lensSku, attributesState, solution, locale]);
    var context = React.useMemo(function () { return ({
        bundleSku: bundleSku,
        pricePerMonth: pricePerMonth,
        attributes: {
            state: attributesState,
            actions: attributeActions,
        },
        lineItems: lineItems,
        solutions: {
            onSolutionChange: function (sku, onChanged) {
                setBundleSku(sku);
                onChanged && onChanged();
            },
            activeSolution: solution,
            items: (data === null || data === void 0 ? void 0 : data.solutions) || [],
        },
    }); }, [attributesState, lineItems, bundle, bundleSku]);
    return React.createElement(LensBundleContext.Provider, { value: context }, children);
};
var useLensBundle = function () {
    var context = React.useContext(LensBundleContext);
    if (context === null) {
        throw new Error('Missing contact lens bundle provider. Make sure the page is wrapped with the LensBundleProvider');
    }
    return context;
};

/**
 * Creates alt text for product images
 */
function createAltText(product, productType, locale, label) {
    var brand = getAttrValue(product.masterVariant, 'brand') || '';
    var name = getLocalizedValue(product.name, locale) || '';
    var frameColor = getJoinedLocalizedAttrValues(product.masterVariant, 'frameColor', locale) || '';
    var lensColor = getJoinedLocalizedAttrValues(product.masterVariant, 'lensColor', locale) || '';
    if (CommerceToolsApi.isSunglasses(productType)) {
        var colors = !lensColor ? "" + frameColor : "" + frameColor + (lensColor && "/" + lensColor);
        return label + " " + brand + " " + name + " " + colors;
    }
    if (CommerceToolsApi.isFrames(productType) || CommerceToolsApi.isReadyReaders(productType)) {
        return label + " " + brand + " " + name + " " + frameColor;
    }
    if (CommerceToolsApi.isSolutions(productType) || CommerceToolsApi.isLenses(productType)) {
        return label + " " + name;
    }
    return '';
}

var pushImageGalleryItemExpandedEvent = function (isExpanded) {
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel: isExpanded ? 'show more' : 'show less',
    });
};
var pushImageGalleryOpenEvent = function (altText, index, sku) {
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'open',
        eventLabel: sku + " - " + altText + " - " + index,
    });
};
var pushImageGalleryZoomEvent = function (altText, sku) {
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'zoom',
        eventLabel: sku + " - " + altText,
    });
};
var pushImageGalleryItemClickEvent = function (index, sku, thumbnail) {
    var eventLabel = thumbnail.vto
        ? sku + " - vto allow"
        : sku + " - " + thumbnail.altText + " - " + index;
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel: eventLabel,
    });
};

var dittoSDKVersion = '5.0.1';
function loadDitto(sdkUrl) {
    return (window.Ditto ||
        new Promise(function (resolve, reject) {
            return loadScript(sdkUrl, function (err) { return (err ? reject(err) : resolve(window.Ditto)); });
        }));
}
var dittoLocalesMap = {
    'nl-BE': 'nl-nl',
    'fr-BE': 'fr-fr',
    'en-IE': 'en-gb',
    'en-IO': 'pt-pt',
};
var getDittoLocale = function (locale) {
    var dittoLocale = locale.toLowerCase();
    if (locale in dittoLocalesMap) {
        dittoLocale = dittoLocalesMap[locale];
    }
    return dittoLocale;
};
function createVtoServerConfig(publicRuntimeDittoConfig, locale) {
    var apiUrl = publicRuntimeDittoConfig.apiUrl, partnerId = publicRuntimeDittoConfig.partnerId, sdkUrl = publicRuntimeDittoConfig.sdkUrl, accessKey = publicRuntimeDittoConfig.accessKey, signatureRoute = publicRuntimeDittoConfig.signatureRoute;
    var dittoLocale = getDittoLocale(locale);
    var composedSdkUrl = sdkUrl + "/default/" + dittoSDKVersion + "/" + dittoLocale + "/api.js";
    return {
        apiUrl: apiUrl,
        sdkUrl: composedSdkUrl,
        accessKey: accessKey,
        partnerId: partnerId,
        signatureRoute: signatureRoute,
    };
}
var vtoEvents = {
    'vto.view': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Available',
            eventLabel: "Product " + sku + " - Available",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'vto available',
                    id: '000',
                },
            },
        });
    },
    'vto.creation.view.intro': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Intro",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'introduction',
                    id: '100',
                },
            },
        });
    },
    'vto.creation.view.camera': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Allow camera",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'allow camera',
                    id: '200',
                },
            },
        });
    },
    'vto.creation.view.creation': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Creation",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'creation',
                    id: '300',
                },
            },
        });
    },
    'vto.creation.view.record': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Record",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'record',
                    id: '400',
                },
            },
        });
    },
    'vto.creation.view.save': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Save",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'save',
                    id: '500',
                },
            },
        });
    },
    'vto.creation.success': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Complete",
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'complete',
                    id: '600',
                },
            },
        });
    },
    'vto.creation.error': function (_a) {
        var sku = _a.sku, status = _a.status, description = _a.description;
        return ({
            eventAction: 'Failure',
            eventLabel: "Product " + sku + " - Creation: error " + status + ", " + (description || ''),
            VTO: {
                configFlow: {
                    action: 'error',
                    name: status == 'CAMERA_BLOCKED' ? 'camera access' : 'creation failed',
                },
            },
        });
    },
    'vto.tryon.open': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Open',
            eventLabel: "Product " + sku,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'open vto',
                },
            },
        });
    },
    'vto.tryon.retake': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Retake',
            eventLabel: "Product " + sku,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'retake vto',
                },
            },
        });
    },
    'vto.tryon.delete': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Delete',
            eventLabel: "Product " + sku,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'delete vto',
                },
            },
        });
    },
    'vto.close': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Close',
            eventLabel: "Product " + sku,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'close vto',
                },
            },
        });
    },
};
var vtoEvent = function (key, args) {
    if (!vtoEvents[key]) {
        console.warn("cannot send event '" + key + "', key does not exist");
        return;
    }
    var _a = vtoEvents[key](args), eventAction = _a.eventAction, eventLabel = _a.eventLabel, VTO = _a.VTO;
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'VTOevent',
            eventCategory: 'Virtual Try-On',
            eventAction: eventAction,
            eventLabel: eventLabel,
            VTO: VTO,
        });
    }
};

var VtoConfig = React.createContext({
    isEnabled: false,
    isActive: false,
    setActive: function () { return null; },
});
var useVtoConfig = function () { return React.useContext(VtoConfig); };

var TryOnButton = function () {
    var _a = useVtoConfig(), isEnabled = _a.isEnabled, isActive = _a.isActive, setActive = _a.setActive;
    var getLabel = useIntl().getLabel;
    var isPhone = MediaQuery.useIsPhone();
    var buttonSize = isPhone ? 'small' : 'medium';
    var onClick = function () { return setActive(true); };
    if (!isEnabled || isActive)
        return null;
    return (React.createElement(Button, { caption: getLabel('vto.callToAction'), variant: "outline", icon: "try-on", color: "primary", size: buttonSize, onClick: onClick }));
};

/*
  This component should be loaded as soon as the user
  starts a VtoCreation process. This process will happen mostly in
  a modal.
*/
var VtoCreationStep;
(function (VtoCreationStep) {
    VtoCreationStep[VtoCreationStep["INTRO"] = 0] = "INTRO";
    VtoCreationStep[VtoCreationStep["CREATION"] = 1] = "CREATION";
})(VtoCreationStep || (VtoCreationStep = {}));
var CreateDitto = function (_a) {
    var onCreate = _a.onCreate, onCancel = _a.onCancel, onError = _a.onError, skipIntro = _a.skipIntro, sku = _a.sku, vtoBanner = _a.vtoBanner;
    var vtoConfig = useVtoConfig();
    var intl = useIntl();
    var _b = __read(React.useState(false), 2), hasAgreed = _b[0], setAgreement = _b[1];
    var _c = __read(React.useState(skipIntro ? VtoCreationStep.CREATION : VtoCreationStep.INTRO), 2), activeStep = _c[0], setActiveStep = _c[1];
    var _d = __read(React.useState(false), 2), showErrorMessage = _d[0], setShowErrorMessage = _d[1];
    var _e = __read(React.useState(null), 2), errorCode = _e[0], setErrorCode = _e[1];
    var imgUrl = vtoBanner === null || vtoBanner === void 0 ? void 0 : vtoBanner.image.url;
    React.useEffect(function () {
        switch (activeStep) {
            case VtoCreationStep.INTRO:
                return vtoEvent('vto.creation.view.intro', { sku: sku });
            case VtoCreationStep.CREATION:
                return vtoEvent('vto.creation.view.creation', { sku: sku });
        }
    }, [activeStep]);
    React.useEffect(function () {
        var isCanceled = false;
        if (!vtoConfig.isEnabled || activeStep !== VtoCreationStep.CREATION) {
            return;
        }
        var instance;
        Promise.all([loadDitto(vtoConfig.sdkUrl), vtoConfig.getSignature(vtoConfig.partnerId)])
            .then(function (_a) {
            var _b = __read(_a, 2), ditto = _b[0], clientSignature = _b[1];
            if (!isCanceled) {
                instance = new ditto.Scan({
                    tryOnServer: vtoConfig.apiUrl,
                    domSelector: '.vto-create-ditto__target',
                    accessKey: vtoConfig.accessKey,
                    partnerSignature: clientSignature,
                    partnerId: vtoConfig.partnerId,
                    font: 'nunitosans',
                }, {
                    success: function (response) {
                        vtoEvent('vto.creation.success', { sku: sku });
                        onCreate(response.scanId);
                    },
                    close: onCancel,
                    progress: function (_a) {
                        var status = _a.status;
                        switch (status) {
                            case 'INIT_CAMERA':
                                vtoEvent('vto.creation.view.camera', { sku: sku });
                                break;
                            case 'READY':
                                vtoEvent('vto.creation.view.creation', { sku: sku });
                                break;
                            case 'RECORD':
                                vtoEvent('vto.creation.view.record', { sku: sku });
                                break;
                            case 'UPLOAD_STARTED':
                                vtoEvent('vto.creation.view.save', { sku: sku });
                                break;
                        }
                    },
                    failure: function (_a) {
                        var status = _a.status, description = _a.description;
                        setErrorCode(status);
                        vtoEvent('vto.creation.error', { sku: sku, status: status, description: description });
                    },
                });
            }
        })
            .catch(onError);
        return function () {
            isCanceled = true;
            instance && instance.destroy();
        };
    }, [activeStep]);
    var onButtonClick = function () {
        if (hasAgreed) {
            return setActiveStep(VtoCreationStep.CREATION);
        }
        setShowErrorMessage(true);
    };
    return (React.createElement(Modal, { activeTrap: !skipIntro, isOpen: true, className: classnames('vto-create-ditto__modal', {
            'vto-create-ditto__modal--image': imgUrl,
        }), showIcon: activeStep === VtoCreationStep.CREATION && errorCode !== 'CAMERA_ACCESS_DENIED'
            ? false
            : true, onModalClose: onCancel },
        React.createElement(LockBodyScroll, null),
        React.createElement("div", { className: "vto-create-ditto" },
            activeStep === VtoCreationStep.INTRO && renderPrivacy(),
            activeStep === VtoCreationStep.CREATION && errorCode !== 'CAMERA_ACCESS_DENIED' && (React.createElement("div", { className: "vto-create-ditto__target" })),
            errorCode && errorCode === 'CAMERA_ACCESS_DENIED' && (React.createElement("div", { className: "vto-create-ditto__error-message" }, intl.getLabel('vto.errors.cameraAccessDenied'))))));
    function renderPrivacy() {
        return (React.createElement(React.Fragment, null,
            imgUrl && (React.createElement("div", { className: "vto-create-ditto__aside", style: { backgroundImage: "url(" + imgUrl + ")" } })),
            React.createElement("div", { className: classnames('vto-create-ditto__main', {
                    'vto-create-ditto__main--with-error': showErrorMessage && !hasAgreed,
                }) },
                React.createElement("div", { className: "vto-create-ditto__titles" },
                    React.createElement(Heading, { variant: "small", className: "vto-create-ditto__title" }, intl.getLabel('vto.title')),
                    React.createElement(Heading, { variant: "smallest", className: "vto-create-ditto__subtitle" }, intl.getLabel('vto.subtitle'))),
                React.createElement(List, { className: "vto-create-ditto__usps", items: [
                        intl.getLabel('vto.step.1'),
                        intl.getLabel('vto.step.2'),
                        intl.getLabel('vto.step.3'),
                        intl.getLabel('vto.step.4'),
                    ], numerical: true }),
                React.createElement(Text, { className: "vto-create-ditto__description", color: "text-secondary", variant: "caption" }, intl.getLabel('vto.description')),
                React.createElement("label", { className: "vto-create-ditto__opt-in" },
                    React.createElement(Checkbox, { className: classnames({
                            'vto-create-ditto__opt-in--red': showErrorMessage && !hasAgreed,
                        }), onChange: function () { return setAgreement(!hasAgreed); }, checked: hasAgreed, value: "vto-create-ditto", "data-t": "vto-create-ditto-checkbox" }),
                    "\u00A0 ",
                    intl.getFormattedLabel('vto.optIn', { parseHTML: true })),
                showErrorMessage && !hasAgreed && (React.createElement("div", { className: "vto-create-ditto__error" },
                    React.createElement(Icon, { className: "vto-create-ditto__icon", height: 16, name: "alert-circle", width: 16 }),
                    React.createElement(Text, { className: "vto-create-ditto__error-text", color: "text-secondary", variant: "caption" }, intl.getLabel('vto.errors.terms')))),
                React.createElement(Button, { caption: intl.getLabel('vto.actions.start'), onClick: onButtonClick, "data-t": "vto-create-ditto-button" }))));
    }
};

var ViewDitto = function (_a) {
    var sku = _a.sku, dittoId = _a.dittoId, onError = _a.onError, onDelete = _a.onDelete, onRetake = _a.onRetake;
    var vtoConfig = useVtoConfig();
    React.useEffect(function () {
        if (!vtoConfig.isEnabled || !dittoId) {
            return;
        }
        var instance;
        Promise.all([loadDitto(vtoConfig.sdkUrl), vtoConfig.getSignature(dittoId)])
            .then(function (_a) {
            var _b = __read(_a, 2), ditto = _b[0], signature = _b[1];
            var isStatusSuccess = false;
            instance = new ditto.Overlay({
                accessKey: vtoConfig.accessKey,
                domSelector: '.vto-view-ditto__target',
                font: 'nunitosans',
                glassesId: sku,
                overlaySignature: signature,
                partnerId: vtoConfig.partnerId,
                scanId: dittoId,
                tryOnServer: vtoConfig.apiUrl,
            }, {
                success: function () {
                    isStatusSuccess = true;
                },
                failure: function () {
                    if (!isStatusSuccess) {
                        vtoEvent('vto.creation.error', { sku: sku });
                        onRetake();
                    }
                },
            });
        })
            .catch(onError);
        return function () {
            instance && instance.destroy();
        };
    }, [dittoId, vtoConfig, sku]);
    return (React.createElement("div", { className: "vto-view-ditto" },
        React.createElement("div", { className: "vto-view-ditto__target" }),
        React.createElement("div", { className: "vto-view-ditto__actions" },
            React.createElement(RoundedButton, { variant: "solid", size: "small", className: "vto-view-ditto__action", onClick: function () {
                    vtoEvent('vto.tryon.retake', { sku: sku });
                    onRetake();
                }, "data-t": "vto-view-ditto-retake" },
                React.createElement(Icon, { name: "pencil" })),
            React.createElement(RoundedButton, { variant: "solid", size: "small", className: "vto-view-ditto__action", onClick: function () {
                    vtoEvent('vto.tryon.delete', { sku: sku });
                    onDelete();
                }, "data-t": "vto-view-ditto-delete" },
                React.createElement(Icon, { name: "trash" })))));
};

function useDittoId(onDeleteCallback) {
    var _this = this;
    var vtoConfig = useVtoConfig();
    var _a = __read(useState(false), 2), shouldSkipDeleteCallback = _a[0], setSkipDeleteCallback = _a[1];
    var _b = __read(useLocalStorage('vto.dittoId', undefined, function (value) { return value === undefined; }), 2), dittoId = _b[0], setDittoId = _b[1];
    var deleteDittoId = React__default.useCallback(function (skipDeleteCallback) {
        if (skipDeleteCallback === void 0) { skipDeleteCallback = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var url, headers, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setSkipDeleteCallback(skipDeleteCallback);
                        if (!vtoConfig.isEnabled) {
                            return [2 /*return*/];
                        }
                        if (!dittoId) return [3 /*break*/, 3];
                        setDittoId(undefined);
                        url = vtoConfig.apiUrl + ("/api/1.3/dittos/" + dittoId);
                        _b = {
                            'X-Ditto-Access-Key-Id': vtoConfig.accessKey
                        };
                        _a = 'X-Ditto-Signature';
                        return [4 /*yield*/, vtoConfig.getSignature(dittoId)];
                    case 1:
                        headers = (_b[_a] = _c.sent(),
                            _b);
                        return [4 /*yield*/, fetch(url, { headers: headers, method: 'delete' })];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [dittoId]);
    var idRef = React__default.useRef();
    React__default.useEffect(function () {
        if (!shouldSkipDeleteCallback &&
            onDeleteCallback &&
            dittoId === undefined &&
            (idRef === null || idRef === void 0 ? void 0 : idRef.current) !== undefined) {
            onDeleteCallback();
        }
        idRef.current = dittoId;
    }, [dittoId]);
    return { dittoId: dittoId, setDittoId: setDittoId, deleteDittoId: deleteDittoId };
}

var VirtualTryOn = function (_a) {
    var onClose = _a.onClose, sku = _a.sku, vtoBanner = _a.vtoBanner;
    var _b = __read(React.useState(false), 2), skipIntro = _b[0], setSkipIntro = _b[1];
    var _c = useDittoId(onClose), dittoId = _c.dittoId, setDittoId = _c.setDittoId, deleteDittoId = _c.deleteDittoId;
    React.useEffect(function () {
        vtoEvent('vto.tryon.open', { sku: sku });
        return function () { return vtoEvent('vto.close', { sku: sku }); };
    }, []);
    return dittoId ? (React.createElement(ViewDitto, { dittoId: dittoId, onDelete: handleDelete, onError: handleError, onRetake: handleRetake, sku: sku })) : (React.createElement(CreateDitto, { onCreate: setDittoId, onCancel: onClose, onError: handleError, skipIntro: skipIntro, vtoBanner: vtoBanner, sku: sku }));
    function handleRetake() {
        deleteDittoId(true);
        setSkipIntro(true);
    }
    function handleDelete() {
        deleteDittoId();
    }
    function handleError() {
        onClose();
        // @TODO implement error logging
        toast.failed('vto.errors.connection');
    }
};

var VtoConfigProvider = function (_a) {
    var enabled = _a.enabled, config = _a.config, children = _a.children;
    var locale = useIntl().locale;
    var _b = __read(React.useState(false), 2), isActive = _b[0], setActive = _b[1];
    var configValue = React.useMemo(function () {
        if (enabled && config) {
            var serverConfig_1 = createVtoServerConfig(config, locale);
            var getSignature = function (message) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetch(serverConfig_1.signatureRoute + "?message=" + message)
                            .then(function (response) { return response.json(); })
                            .then(function (_a) {
                            var signature = _a.signature;
                            return signature;
                        })];
                });
            }); };
            return __assign$1(__assign$1({}, serverConfig_1), { getSignature: getSignature, isEnabled: true });
        }
        return { isEnabled: false };
    }, [config, enabled, locale]);
    var value = __assign$1(__assign$1({}, configValue), { isActive: isActive, setActive: setActive });
    return React.createElement(VtoConfig.Provider, { value: value }, children);
};

var HorizontalImageSlider = function (_a) {
    var activeImage = _a.activeImage, images = _a.images, onClick = _a.onClick;
    return (React.createElement("div", { className: "horizontal-image-slider" }, images.map(function (image) { return (React.createElement("button", { type: "button", onClick: function () { return onClick(image); }, key: image.label + "-thumb", className: classnames('horizontal-image-slider__button', {
            'horizontal-image-slider__button--active': (activeImage === null || activeImage === void 0 ? void 0 : activeImage.label) === image.label,
            'horizontal-image-slider__button--highlighted': image.highlighted,
            'horizontal-image-slider__button--vto': image.vto,
        }) },
        React.createElement("div", { className: "aspect-wrapper" },
            React.createElement("picture", { className: "horizontal-image-slider__picture" },
                React.createElement("source", { srcSet: image.thumbnailUrl, media: "(max-width: 1024px)" }),
                React.createElement("img", { src: image.url, className: "horizontal-image-slider__image", alt: image.altText })),
            image.vto && (React.createElement("div", { className: "horizontal-image-slider-try-on-overlay" },
                React.createElement(Icon, { className: "horizontal-image-slider-try-on-overlay__icon", name: "try-on" })))))); })));
};

var useImageLoaded = function (ref) {
    var _a = __read(React__default.useState(false), 2), loaded = _a[0], setLoaded = _a[1];
    var onLoad = function () {
        setLoaded(true);
    };
    React__default.useEffect(function () {
        var _a;
        if (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.complete) && ref.current.naturalWidth !== 0) {
            onLoad();
        }
    }, [ref]);
    return [loaded, onLoad];
};

var ImageZoom = function (_a) {
    var _b;
    var children = _a.children, onZoom = _a.onZoom;
    var ref = React__default.useRef(null);
    var _c = __read(React__default.useState(false), 2), zooming = _c[0], setZooming = _c[1];
    var handleMouseMove = function (e) {
        if (e.target instanceof Element) {
            var _a = e.target.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
            var x = Math.round(((e.clientX - left) / width) * 100);
            var y = Math.round(((e.clientY - top_1) / height) * 100);
            // We update the styles using a ref to directly manipulate the DOM
            // This way we we don't have to change state for every mouse movement, which would cause a lot of rerenders
            if (ref.current) {
                ref.current.style.transformOrigin = x + "% " + y + "%";
            }
        }
    };
    var resetZoom = function () {
        setZooming(false);
        if (ref.current) {
            ref.current.style.transformOrigin = "0% 0%";
        }
    };
    var enableZoom = function () {
        setZooming(true);
        onZoom();
    };
    var transformOrigin = ((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.style.transformOrigin) || '0% 0%';
    return (React__default.createElement("div", { onMouseEnter: enableZoom, onMouseLeave: resetZoom, onMouseMove: handleMouseMove, className: classnames('image-zoom', { 'image-zoom--hover': zooming }), "data-t": "image-zoom" },
        React__default.createElement("div", { className: "image-zoom__img", "data-t": "zoom__image", style: { transformOrigin: transformOrigin }, ref: ref }, children)));
};

/**
 * Image sizes below are as defined for the Image Gallery in ZeroHeight.
 * https://zeroheight.com/9qvxm097c/p/476c37-product-image-gallery/b/40f911
 */
var defaultImageSizes$1 = {
    M: 768,
    L: 601,
    XL: 877,
};
function zoomHandler(altText, sku) {
    var hasFired = false;
    return function () {
        if (!hasFired) {
            hasFired = true;
            pushImageGalleryZoomEvent(altText, sku);
        }
    };
}
var ProductImage = React.forwardRef(function (_a, ref) {
    var altText = _a.altText, children = _a.children, className = _a.className, imageParams = _a.imageParams, imageSizes = _a.imageSizes, imageUrl = _a.imageUrl, onClick = _a.onClick, _b = _a.showImage, showImage = _b === void 0 ? true : _b, _c = _a.sku, sku = _c === void 0 ? '' : _c, _d = _a.zoom, zoom = _d === void 0 ? false : _d;
    var imageRef = React.useRef(null);
    var _e = __read(useImageLoaded(imageRef), 2), loaded = _e[0], onLoad = _e[1];
    var imgSizes = zoom && imageSizes ? imageSizes : defaultImageSizes$1;
    var srcSet = createImageSrcSet(imageUrl, imgSizes, imageParams);
    var sizes = createImageSizes(imgSizes);
    var image = (React.createElement("img", { ref: imageRef, width: "100%", src: imageUrl, srcSet: srcSet, sizes: sizes, alt: altText, onLoad: onLoad, className: classnames('product-image__img', className) }));
    // We don't want to enable the zoom functionality for specific images due to a low resolution.
    var ImageWrapper = function () {
        return zoom ? React.createElement(ImageZoom, { onZoom: zoomHandler(altText, sku) }, image) : React.createElement(React.Fragment, null, image);
    };
    /**
     * Please note:
     * noscript is used to make sure a reference to the image will be available to google in the document, for SEO purposes, even if the image isn't loaded.
     * For this reason need we handle the showing/not showing of the image in this component.
     */
    var content = function () { return (React.createElement(React.Fragment, null,
        !loaded && (React.createElement(React.Fragment, null,
            React.createElement(SkeletonLoader, null,
                React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "210" },
                    React.createElement("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" }))),
            React.createElement("noscript", null,
                React.createElement("img", { src: imageUrl, alt: altText })))),
        showImage && React.createElement(ImageWrapper, null),
        children)); };
    if (onClick) {
        return (React.createElement("button", { ref: ref, onClick: onClick, className: "product-image" }, content()));
    }
    else
        return React.createElement("div", { className: "product-image" }, content());
});

var VtoBanner = function (_a) {
    var onClick = _a.onClick, vtoBanner = _a.vtoBanner, productImageProps = __rest(_a, ["onClick", "vtoBanner"]);
    var getLabel = useIntl().getLabel;
    return (React.createElement("div", { className: "vto-banner" },
        React.createElement(ProductImage, __assign$1({}, productImageProps),
            React.createElement("div", { className: "vto-banner__overlay" },
                React.createElement(Heading, { component: "h4", variant: "smallest", className: "vto-banner__title" }, vtoBanner.title),
                vtoBanner.description && (React.createElement(Text, { variant: "body", className: "vto-banner__sub" }, vtoBanner.description)),
                React.createElement(Button, { caption: getLabel('vto.callToAction'), variant: "outline", icon: "try-on", color: "primary", size: "small", className: "vto-banner__button", onClick: onClick })))));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
var roundNumber = function (num, decimal) {
    return Number(num.toFixed(decimal));
};
var checkIsNumber = function (num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var handleCallback = function (context, event, callback) {
    if (callback && typeof callback === "function") {
        callback(context, event);
    }
};
var easeOut = function (t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
var linear = function (t) {
    return t;
};
var easeInQuad = function (t) {
    return t * t;
};
var easeOutQuad = function (t) {
    return t * (2 - t);
};
var easeInOutQuad = function (t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
var easeInCubic = function (t) {
    return t * t * t;
};
var easeOutCubic = function (t) {
    return --t * t * t + 1;
};
var easeInOutCubic = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
var easeInQuart = function (t) {
    return t * t * t * t;
};
var easeOutQuart = function (t) {
    return 1 - --t * t * t * t;
};
var easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
var easeInQuint = function (t) {
    return t * t * t * t * t;
};
var easeOutQuint = function (t) {
    return 1 + --t * t * t * t * t;
};
var easeInOutQuint = function (t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var animations = {
    easeOut: easeOut,
    linear: linear,
    easeInQuad: easeInQuad,
    easeOutQuad: easeOutQuad,
    easeInOutQuad: easeInOutQuad,
    easeInCubic: easeInCubic,
    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
};
var handleCancelAnimationFrame = function (animation) {
    if (typeof animation === "number") {
        cancelAnimationFrame(animation);
    }
};
var handleCancelAnimation = function (contextInstance) {
    if (!contextInstance.mounted)
        return;
    handleCancelAnimationFrame(contextInstance.animation);
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted)
        return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    handleCancelAnimation(contextInstance);
    contextInstance.animation = function () {
        if (!contextInstance.mounted) {
            return handleCancelAnimationFrame(contextInstance.animation);
        }
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        }
        else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid)
        return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) {
        setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    }
    else {
        handleSetupAnimation(contextInstance, animationName, animationTime, function (step) {
            var newScale = scale + scaleDiff * step;
            var newPositionX = positionX + positionXDiff * step;
            var newPositionY = positionY + positionYDiff * step;
            setTransformState(newScale, newPositionX, newPositionY);
        });
    }
}
function isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (isNaN(scale) || isNaN(positionX) || isNaN(positionY)) {
        return false;
    }
    return true;
}
function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight,
    };
}
var getBounds = function (wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth
        ? diffWidth * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight
        ? diffHeight * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return { minPositionX: minPositionX, maxPositionX: maxPositionX, minPositionY: minPositionY, maxPositionY: maxPositionY };
};
var calculateBounds = function (contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) {
        throw new Error("Components are not mounted");
    }
    var _a = getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
var handleCalculateBounds = function (contextInstance, newScale) {
    var bounds = calculateBounds(contextInstance, newScale);
    contextInstance.bounds = bounds;
    return bounds;
};
function getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return { x: x, y: y };
}
var boundLimiter = function (value, minBound, maxBound, isActive) {
    if (!isActive)
        return roundNumber(value, 2);
    if (value < minBound)
        return roundNumber(minBound, 2);
    if (value > maxBound)
        return roundNumber(maxBound, 2);
    return roundNumber(value, 2);
};
function handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return { x: positionX, y: positionY };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    var newPositions = getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!isNaN(maxScale) && zoom >= maxScale)
        return maxScale;
    if (!isNaN(minScale) && zoom <= minScaleWithPadding)
        return minScaleWithPadding;
    return zoom;
}
var isPanningStartAllowed = function (contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPanningAllowed = function (contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed)
        return false;
    return true;
};
var handlePanningSetup = function (contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = { x: x - positionX, y: y - positionY };
};
var handleTouchPanningSetup = function (contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = { x: x - positionX, y: y - positionY };
    }
};
function handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds)
        return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX
        ? wrapperComponent.offsetWidth
        : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY
        ? wrapperComponent.offsetHeight
        : contextInstance.setup.minPositionY || 0;
    var _d = handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY,
    };
}
function handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var hasPositionXChanged = newPositionX !== positionX;
    var hasPositionYChanged = newPositionY !== positionY;
    var hasNewPosition = !hasPositionXChanged || !hasPositionYChanged;
    if (!wrapperComponent || hasNewPosition || !bounds) {
        return;
    }
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var getPanningClientPosition = function (contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) {
        return { x: positionX, y: positionY };
    }
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return { x: newPositionX, y: newPositionY };
};
var getPaddingValue = function (contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale;
    if (size > 0 && scale >= minScale) {
        return size;
    }
    return 0;
};
var isVelocityCalculationAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    return true;
};
var isVelocityAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    if (!velocity || !bounds)
        return false;
    return true;
};
function getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) {
        return animationTime * velocity * sensitivity;
    }
    return animationTime;
}
function getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget)
                return maxTarget;
            if (calculatedPosition < maxPosition)
                return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget)
                return minTarget;
            if (calculatedPosition > minPosition)
                return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked)
        return startPosition;
    return boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) {
        return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    }
    return defaultMultiplier;
}
function handleCalculateVelocity(contextInstance, position) {
    var isAllowed = isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) {
        return;
    }
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = { velocityX: velocityX, velocityY: velocityY, total: velocity };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) {
        return;
    }
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var paddingX = (paddingValueX * wrapperComponent.offsetWidth) / 100;
    var paddingY = (paddingValueY * wrapperComponent.offsetHeight) / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function (step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) {
            contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
        }
    });
}
function handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    handleCancelAnimation(contextInstance);
    handleCalculateBounds(contextInstance, scale);
    if (event.touches) {
        handleTouchPanningSetup(contextInstance, event);
    }
    else {
        handlePanningSetup(contextInstance, event);
    }
}
function handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords)
        return;
    var _b = getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    handleCalculateVelocity(contextInstance, { x: x, y: y });
    handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) {
            handleVelocityPanning(contextInstance);
        }
        else {
            handleAlignToBounds(contextInstance);
        }
    }
}
function handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || (!sizeX && !sizeY);
    if (isDisabled)
        return;
    var targetState = handlePanToBounds(contextInstance);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}
function handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) {
        handleAlignToBounds(contextInstance);
    }
    if (isDisabled || !wrapperComponent || !contextInstance.mounted)
        return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}
function handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var _b = handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return { scale: newScale, positionX: x, positionY: y };
}
var initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0,
};
var contextInitialState = __assign(__assign({}, initialState), { setComponents: function () { return undefined; }, contextInstance: null });
var initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    wheel: {
        step: 0.2,
        disabled: false,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: [],
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        activationKeys: [],
        excluded: [],
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: [],
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: [],
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut",
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut",
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true,
    },
};
var createState = function (props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : initialState.positionY,
    };
};
var createSetup = function (props) {
    var newSetup = __assign({}, initialSetup);
    Object.keys(props).forEach(function (key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call(initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) {
                newSetup[key] = __assign(__assign({}, initialSetup[key]), props[key]);
            }
            else if (isArray) {
                newSetup[key] = __spreadArray(__spreadArray([], initialSetup[key]), props[key]);
            }
            else {
                newSetup[key] = props[key];
            }
        }
    });
    return newSetup;
};
var handleCalculateButtonZoom = function (contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale * Math.exp(delta * step);
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
function resetTransformations(contextInstance, animationTime, animationType) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return;
    var newBounds = calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y,
    };
    if (scale === initialTransformation.scale &&
        positionX === initialTransformation.positionX &&
        positionY === initialTransformation.positionY) {
        return;
    }
    animate(contextInstance, newState, animationTime, animationType);
}
function calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent)
        return initialState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = getOffset(node);
    var nodeLeft = nodeRect.x;
    var nodeTop = nodeRect.y;
    var nodeWidth = node.offsetWidth;
    var nodeHeight = node.offsetHeight;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = calculateBounds(contextInstance, newScale);
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return { positionX: x, positionY: y, scale: newScale };
}
function getOffset(element) {
    var el = element;
    var offsetLeft = 0;
    var offsetTop = 0;
    while (el) {
        offsetLeft += el.offsetLeft;
        offsetTop += el.offsetTop;
        el = el.offsetParent;
    }
    return {
        x: offsetLeft,
        y: offsetTop,
    };
}
function isValidZoomNode(node) {
    if (!node) {
        console.error("Zoom node not found");
        return false;
    }
    else if ((node === null || node === void 0 ? void 0 : node.offsetWidth) === undefined ||
        (node === null || node === void 0 ? void 0 : node.offsetHeight) === undefined) {
        console.error("Zoom node is not valid - it must contain offsetWidth and offsetHeight");
        return false;
    }
    return true;
}
var zoomIn = function (contextInstance) { return function (step, animationTime, animationType) {
    if (step === void 0) { step = 0.5; }
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
}; };
var zoomOut = function (contextInstance) { return function (step, animationTime, animationType) {
    if (step === void 0) { step = 0.5; }
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
}; };
var setTransform = function (contextInstance) { return function (newPositionX, newPositionY, newScale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 300; }
    if (animationType === void 0) { animationType = "easeOut"; }
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var disabled = contextInstance.setup.disabled;
    if (disabled || !wrapperComponent || !contentComponent)
        return;
    var targetState = {
        positionX: isNaN(newPositionX) ? positionX : newPositionX,
        positionY: isNaN(newPositionY) ? positionY : newPositionY,
        scale: isNaN(newScale) ? scale : newScale,
    };
    animate(contextInstance, targetState, animationTime, animationType);
}; };
var resetTransform = function (contextInstance) { return function (animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 200; }
    if (animationType === void 0) { animationType = "easeOut"; }
    resetTransformations(contextInstance, animationTime, animationType);
}; };
var centerView = function (contextInstance) { return function (scale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 200; }
    if (animationType === void 0) { animationType = "easeOut"; }
    var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    if (wrapperComponent && contentComponent) {
        var targetState = getCenterPosition(scale || transformState.scale, wrapperComponent, contentComponent);
        animate(contextInstance, targetState, animationTime, animationType);
    }
}; };
var zoomToElement = function (contextInstance) { return function (node, scale, animationTime, animationType) {
    if (animationTime === void 0) { animationTime = 600; }
    if (animationType === void 0) { animationType = "easeOut"; }
    handleCancelAnimation(contextInstance);
    var wrapperComponent = contextInstance.wrapperComponent;
    var target = typeof node === "string" ? document.getElementById(node) : node;
    if (wrapperComponent &&
        isValidZoomNode(target) &&
        target &&
        wrapperComponent.contains(target)) {
        var targetState = calculateZoomToNode(contextInstance, target, scale);
        animate(contextInstance, targetState, animationTime, animationType);
    }
}; };
var getContext = function (contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState,
        zoomIn: zoomIn(contextInstance),
        zoomOut: zoomOut(contextInstance),
        setTransform: setTransform(contextInstance),
        resetTransform: resetTransform(contextInstance),
        centerView: centerView(contextInstance),
        zoomToElement: zoomToElement(contextInstance),
    };
};
var passiveSupported = false;
function makePassiveEventOption() {
    try {
        var options = {
            get passive() {
                passiveSupported = true;
                return false;
            },
        };
        return options;
    }
    catch (err) {
        passiveSupported = false;
        return passiveSupported;
    }
}
var isExcludedNode = function (node, excluded) {
    var targetTagName = node.tagName.toUpperCase();
    var isExcludedTag = excluded.find(function (tag) { return tag.toUpperCase() === targetTagName; });
    if (isExcludedTag)
        return true;
    var isExcludedClassName = excluded.find(function (className) {
        return node.classList.contains(className);
    });
    if (isExcludedClassName)
        return true;
    return false;
};
var cancelTimeout = function (timeout) {
    if (timeout) {
        clearTimeout(timeout);
    }
};
var getTransformStyles = function (x, y, scale) {
    return "translate3d(" + x + "px, " + y + "px, 0) scale(" + scale + ")";
};
var getCenterPosition = function (scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY,
    };
};
var isWheelAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed)
        return false;
    if (wheelDisabled && !event.ctrlKey)
        return false;
    if (touchPadDisabled && event.ctrlKey)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
function getDelta(event, customDelta) {
    var deltaY = event ? (event.deltaY < 0 ? 1 : -1) : 0;
    var delta = checkIsNumber(customDelta, deltaY);
    return delta;
}
function getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    }
    else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (isNaN(mouseX) || isNaN(mouseY))
        console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY,
    };
}
var handleCalculateWheelZoom = function (contextInstance, delta, step, disablePadding, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale + delta * (scale - scale * step) * step;
    if (getTarget)
        return targetScale;
    var paddingEnabled = disablePadding ? false : !disabled;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled);
    return newScale;
};
var handleWheelZoomStop = function (contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent)
        return false;
    if (scale < maxScale || scale > minScale)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY)
        return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    return false;
};
var isPinchStartAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPinchAllowed = function (contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed)
        return false;
    return true;
};
var calculateTouchMidPoint = function (event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale,
    };
};
var getTouchDistance = function (event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) +
        Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var calculatePinchZoom = function (contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) {
        throw new Error("Pinch touches distance was not provided");
    }
    if (currentDistance < 0) {
        return contextInstance.transformState.scale;
    }
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled);
};
var wheelStopEventTime = 160;
var wheelAnimationTime = 100;
var handleWheelStart = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        handleCancelAnimation(contextInstance);
        handleCallback(getContext(contextInstance), event, onWheelStart);
        handleCallback(getContext(contextInstance), event, onZoomStart);
    }
};
var handleWheelZoom = function (contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step;
    if (!contentComponent) {
        throw new Error("Component not mounted");
    }
    event.preventDefault();
    event.stopPropagation();
    var delta = getDelta(event, null);
    var newScale = handleCalculateWheelZoom(contextInstance, delta, step, !event.ctrlKey);
    if (scale === newScale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    handleCallback(getContext(contextInstance), event, onWheel);
    handleCallback(getContext(contextInstance), event, onZoom);
};
var handleWheelStop = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function () {
        if (!contextInstance.mounted)
            return;
        handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, wheelAnimationTime);
    var hasStoppedZooming = handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function () {
            if (!contextInstance.mounted)
                return;
            contextInstance.wheelStopEventTimer = null;
            handleCallback(getContext(contextInstance), event, onWheelStop);
            handleCallback(getContext(contextInstance), event, onZoomStop);
        }, wheelStopEventTime);
    }
};
var handlePinchStart = function (contextInstance, event) {
    var distance = getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    handleCancelAnimation(contextInstance);
};
var handlePinchZoom = function (contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    if (pinchStartDistance === null || !contentComponent)
        return;
    var midPoint = calculateTouchMidPoint(event, scale, contentComponent);
    if (!isFinite(midPoint.x) || !isFinite(midPoint.y))
        return;
    var currentDistance = getTouchDistance(event);
    var newScale = calculatePinchZoom(contextInstance, currentDistance);
    if (newScale === scale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    contextInstance.setTransformState(newScale, x, y);
};
var handlePinchStop = function (contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
function handleDoubleClick(contextInstance, event) {
    var _a = contextInstance.setup.doubleClick, disabled = _a.disabled, mode = _a.mode, step = _a.step, animationTime = _a.animationTime, animationType = _a.animationType;
    if (disabled)
        return;
    if (mode === "reset") {
        return resetTransformations(contextInstance, animationTime, animationType);
    }
    var scale = contextInstance.transformState.scale;
    var contentComponent = contextInstance.contentComponent;
    if (!contentComponent)
        return console.error("No ContentComponent found");
    var delta = mode === "zoomOut" ? -1 : 1;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var targetState = handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
var isDoubleClickAllowed = function (contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    if (!isAllowed)
        return false;
    return true;
};
var Context = React__default.createContext(contextInitialState);
var TransformContext =  (function (_super) {
    __extends(TransformContext, _super);
    function TransformContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mounted = true;
        _this.transformState = createState(_this.props);
        _this.setup = createSetup(_this.props);
        _this.wrapperComponent = null;
        _this.contentComponent = null;
        _this.isInitialized = false;
        _this.bounds = null;
        _this.previousWheelEvent = null;
        _this.wheelStopEventTimer = null;
        _this.wheelAnimationTimer = null;
        _this.isPanning = false;
        _this.startCoords = null;
        _this.lastTouch = null;
        _this.distance = null;
        _this.lastDistance = null;
        _this.pinchStartDistance = null;
        _this.pinchStartScale = null;
        _this.pinchMidpoint = null;
        _this.velocity = null;
        _this.velocityTime = null;
        _this.lastMousePosition = null;
        _this.animate = false;
        _this.animation = null;
        _this.maxBounds = null;
        _this.pressedKeys = {};
        _this.handleInitializeWrapperEvents = function (wrapper) {
            var passive = makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        _this.handleInitialize = function () {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.forceUpdate();
            if (centerOnInit) {
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 50);
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 100);
                setTimeout(function () {
                    if (_this.mounted) {
                        _this.setCenter();
                    }
                }, 200);
            }
        };
        _this.onWheelZoom = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isWheelAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed)
                return;
            handleWheelStart(_this, event);
            handleWheelZoom(_this, event);
            handleWheelStop(_this, event);
        };
        _this.onPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handleCancelAnimation(_this);
            handlePanningStart(_this, event);
            handleCallback(getContext(_this), event, onPanningStart);
        };
        _this.onPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled)
                return;
            var isAllowed = isPanningAllowed(_this);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePanning(_this, event.clientX, event.clientY);
            handleCallback(getContext(_this), event, onPanning);
        };
        _this.onPanningStop = function (event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                handlePanningEnd(_this);
                handleCallback(getContext(_this), event, onPanningStop);
            }
        };
        _this.onPinchStart = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled)
                return;
            var isAllowed = isPinchStartAllowed(_this, event);
            if (!isAllowed)
                return;
            handlePinchStart(_this, event);
            handleCancelAnimation(_this);
            handleCallback(getContext(_this), event, onPinchingStart);
            handleCallback(getContext(_this), event, onZoomStart);
        };
        _this.onPinch = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled)
                return;
            var isAllowed = isPinchAllowed(_this);
            if (!isAllowed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePinchZoom(_this, event);
            handleCallback(getContext(_this), event, onPinching);
            handleCallback(getContext(_this), event, onZoom);
        };
        _this.onPinchStop = function (event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                handlePinchStop(_this);
                handleCallback(getContext(_this), event, onPinchingStop);
                handleCallback(getContext(_this), event, onZoomStop);
            }
        };
        _this.onTouchPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) {
                _this.onDoubleClick(event);
            }
            else {
                _this.lastTouch = +new Date();
                handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    handleCancelAnimation(_this);
                    handlePanningStart(_this, event);
                    handleCallback(getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) {
                    _this.onPinchStart(event);
                }
            }
        };
        _this.onTouchPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled)
                    return;
                var isAllowed = isPanningAllowed(_this);
                if (!isAllowed)
                    return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                handlePanning(_this, touch.clientX, touch.clientY);
                handleCallback(getContext(_this), event, onPanning);
            }
            else if (event.touches.length > 1) {
                _this.onPinch(event);
            }
        };
        _this.onTouchPanningStop = function (event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        _this.onDoubleClick = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isDoubleClickAllowed(_this, event);
            if (!isAllowed)
                return;
            handleDoubleClick(_this, event);
        };
        _this.clearPanning = function (event) {
            if (_this.isPanning) {
                _this.onPanningStop(event);
            }
        };
        _this.setKeyPressed = function (e) {
            _this.pressedKeys[e.key] = true;
        };
        _this.setKeyUnPressed = function (e) {
            _this.pressedKeys[e.key] = false;
        };
        _this.isPressingKeys = function (keys) {
            if (!keys.length) {
                return true;
            }
            return Boolean(keys.find(function (key) { return _this.pressedKeys[key]; }));
        };
        _this.setComponents = function (wrapperComponent, contentComponent) {
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize();
            _this.handleRef();
            _this.isInitialized = true;
            handleCallback(getContext(_this), undefined, _this.props.onInit);
        };
        _this.setTransformState = function (scale, positionX, positionY) {
            if (!isNaN(scale) && !isNaN(positionX) && !isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
            }
            else {
                console.error("Detected NaN set state values");
            }
        };
        _this.setCenter = function () {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = getCenterPosition(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        _this.applyTransformation = function () {
            if (!_this.mounted || !_this.contentComponent)
                return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = getTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
            _this.handleRef();
        };
        _this.handleRef = function () {
            _this.props.setRef(getContext(_this));
        };
        return _this;
    }
    TransformContext.prototype.componentDidMount = function () {
        var passive = makePassiveEventOption();
        window.addEventListener("mousedown", this.onPanningStart, passive);
        window.addEventListener("mousemove", this.onPanning, passive);
        window.addEventListener("mouseup", this.onPanningStop, passive);
        document.addEventListener("mouseleave", this.clearPanning, passive);
        window.addEventListener("keyup", this.setKeyUnPressed, passive);
        window.addEventListener("keydown", this.setKeyPressed, passive);
        this.handleRef();
    };
    TransformContext.prototype.componentWillUnmount = function () {
        var passive = makePassiveEventOption();
        window.removeEventListener("mousedown", this.onPanningStart, passive);
        window.removeEventListener("mousemove", this.onPanning, passive);
        window.removeEventListener("mouseup", this.onPanningStop, passive);
        window.removeEventListener("keyup", this.setKeyUnPressed, passive);
        window.removeEventListener("keydown", this.setKeyPressed, passive);
        handleCancelAnimation(this);
    };
    TransformContext.prototype.componentDidUpdate = function (oldProps) {
        if (oldProps !== this.props) {
            handleCalculateBounds(this, this.transformState.scale);
            this.setup = createSetup(this.props);
        }
    };
    TransformContext.prototype.render = function () {
        var value = getContext(this);
        var children = this.props.children;
        var content = typeof children === "function" ? children(value) : children;
        return (React__default.createElement(Context.Provider, { value: __assign(__assign({}, this.transformState), { setComponents: this.setComponents, contextInstance: this }) }, content));
    };
    return TransformContext;
}(Component));
var TransformWrapper = React__default.forwardRef(function (props, ref) {
    var _a = useState(null), innerRef = _a[0], setRef = _a[1];
    useImperativeHandle(ref, function () { return innerRef; }, [innerRef]);
    return React__default.createElement(TransformContext, __assign({}, props, { setRef: setRef }));
});
function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".transform-component-module_wrapper__1_Fgj {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__2jYgh {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__2jYgh img {\n  pointer-events: none;\n}\n";
var styles = {"wrapper":"transform-component-module_wrapper__1_Fgj","content":"transform-component-module_content__2jYgh"};
styleInject(css_248z);
var TransformComponent = function (_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle;
    var setComponents = useContext(Context).setComponents;
    var wrapperRef = useRef(null);
    var contentRef = useRef(null);
    useEffect(function () {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && setComponents) {
            setComponents(wrapper, content);
        }
    }, []);
    return (React__default.createElement("div", { ref: wrapperRef, className: "react-transform-wrapper " + styles.wrapper + " " + wrapperClass, style: wrapperStyle },
        React__default.createElement("div", { ref: contentRef, className: "react-transform-component " + styles.content + " " + contentClass, style: contentStyle }, children)));
};

var useImageSlider = function (totalImages, _a) {
    var _b = _a.elementIdentifierString, elementIdentifierString = _b === void 0 ? 'scroller' : _b, _c = _a.initialIndex, initialIndex = _c === void 0 ? 0 : _c;
    var _d = __read(React__default.useState(initialIndex || 0), 2), activeIndex = _d[0], setActiveIndex = _d[1];
    var interruptSwitchEffect = React__default.useRef(false);
    var setSlide = React__default.useCallback(function (index) {
        if (index !== activeIndex) {
            setActiveIndex(index);
        }
    }, [activeIndex]);
    var prevSlide = React__default.useCallback(function () {
        setActiveIndex(function (index) { return (index !== 0 ? index - 1 : 0); });
    }, []);
    var nextSlide = React__default.useCallback(function () {
        setActiveIndex(function (index) { return (index !== totalImages - 1 ? index + 1 : totalImages - 1); });
    }, [totalImages]);
    React__default.useEffect(function () {
        setActiveIndex(initialIndex || 0);
    }, [initialIndex]);
    React__default.useEffect(function () {
        function handleKeyDownEvent(event) {
            switch (event.key) {
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    prevSlide();
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    nextSlide();
                    break;
            }
        }
        var target = document;
        if (target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return function () { return target.removeEventListener('keydown', handleKeyDownEvent, false); };
        }
    }, [nextSlide, prevSlide]);
    var handleInView = React__default.useCallback(function (inView, index) {
        if (inView && index !== activeIndex) {
            setSlide(index);
            interruptSwitchEffect.current = true;
        }
    }, [activeIndex, setSlide]);
    React__default.useEffect(function () {
        var _a;
        if (!interruptSwitchEffect.current) {
            (_a = document === null || document === void 0 ? void 0 : document.getElementById(elementIdentifierString + "-" + activeIndex)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                block: 'nearest',
            });
        }
        else {
            interruptSwitchEffect.current = false;
        }
    }, [activeIndex]);
    var onFirstSlide = activeIndex < 1;
    var onLastSlide = activeIndex >= totalImages - 1;
    return {
        setSlide: setSlide,
        handleInView: handleInView,
        prevSlide: prevSlide,
        nextSlide: nextSlide,
        onFirstSlide: onFirstSlide,
        onLastSlide: onLastSlide,
        activeIndex: activeIndex,
        interruptSwitchEffect: interruptSwitchEffect,
    };
};

var defaultImageSizes = {
    S: 768,
    M: 768,
    L: 1024,
    XL: 1440,
};
var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return condition ? wrapper(children) : children;
};
var ZoomModal = function (_a) {
    var isOpen = _a.isOpen, images = _a.images, onClose = _a.onClose, openingIndex = _a.openingIndex;
    var getLabel = useIntl().getLabel;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var extendedImages = React.useMemo(function () {
        return images
            .map(function (image) { return (__assign$1(__assign$1({}, image), { srcSet: createImageSrcSet(image.url, defaultImageSizes), sizes: createImageSizes(defaultImageSizes) })); })
            .filter(function (image) { return !image.vto; });
    }, [images]);
    var _b = useImageSlider(extendedImages.length, {
        initialIndex: openingIndex || 0,
        elementIdentifierString: 'zoom-modal__image-slide',
    }), setSlide = _b.setSlide, prevSlide = _b.prevSlide, nextSlide = _b.nextSlide, handleInView = _b.handleInView, onFirstSlide = _b.onFirstSlide, onLastSlide = _b.onLastSlide, activeIndex = _b.activeIndex, interruptSwitchEffect = _b.interruptSwitchEffect;
    var handlePrevClick = React.useCallback(function (event) {
        event.preventDefault();
        prevSlide();
    }, [prevSlide]);
    var handleNextClick = React.useCallback(function (event) {
        event.preventDefault();
        nextSlide();
    }, [nextSlide]);
    var handleClose = React.useCallback(function () {
        interruptSwitchEffect.current = true;
        setTimeout(function () { return (interruptSwitchEffect.current = false); }, 200);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    return (React.createElement(Modal, { isOpen: isOpen, showIcon: true, isFullScreen: true, onModalClose: handleClose, useScrollLock: true, className: "zoom-modal" },
        React.createElement("div", { className: "zoom-modal__image-container" },
            React.createElement("div", { className: "zoom-modal__image-wrapper" },
                React.createElement(ConditionalWrapper, { condition: isSmallScreen, wrapper: function (children) { return (React.createElement(TransformWrapper, { panning: {
                            disabled: true,
                        } }, children)); } }, extendedImages.map(function (image, index) { return (React.createElement(InView, { key: image.label, threshold: 0.8, onChange: function (inView) { return handleInView(inView, index); } }, function (_a) {
                    var ref = _a.ref;
                    return isSmallScreen ? (React.createElement(TransformComponent, { wrapperClass: "zoom-modal__zoom-wrapper" },
                        React.createElement("picture", { ref: ref, "data-index": index, id: "zoom-modal__image-slide-" + index, className: "zoom-modal__picture" },
                            React.createElement("img", { src: image.url, className: "zoom-modal__image", srcSet: image.srcSet, sizes: image.sizes, alt: image.altText })))) : (React.createElement("picture", { ref: ref, "data-index": index, id: "zoom-modal__image-slide-" + index, className: "zoom-modal__picture" },
                        React.createElement("img", { src: image.url, className: "zoom-modal__image", srcSet: image.srcSet, sizes: image.sizes, alt: image.altText })));
                })); })))),
        React.createElement("div", { className: "zoom-modal__buttons" },
            React.createElement(IconButton, { className: classnames('zoom-modal__chevron', {
                    disabled: onFirstSlide,
                }), disabled: onFirstSlide, onClick: handlePrevClick, "aria-label": getLabel('common.actions.previous') },
                React.createElement(Icon, { name: "chevron-left" })),
            React.createElement(IconButton, { className: classnames('zoom-modal__chevron', {
                    disabled: onLastSlide,
                }), disabled: onLastSlide, onClick: handleNextClick, "aria-label": getLabel('common.actions.next') },
                React.createElement(Icon, { name: "chevron-right" }))),
        React.createElement("div", { className: "zoom-modal__navigator", "data-t": "zoom-modal__navigator" }, extendedImages.map(function (image, index) { return (React.createElement("button", { key: image.label, "data-t": "zoom-modal__navigator-" + index, className: classnames('zoom-modal__navigator-button', {
                _is_active: index === activeIndex,
            }), onClick: function () { return setSlide(index); } })); }))));
};

var ProductImageGallery = function (_a) {
    var initialImages = _a.initialImages, expandableImages = _a.expandableImages, showMoreLabel = _a.showMoreLabel, showLessLabel = _a.showLessLabel, handleGalleryExpansion = _a.handleGalleryExpansion, handleImageInteraction = _a.handleImageInteraction, isImageVisible = _a.isImageVisible, setVtoActive = _a.setVtoActive, vtoActive = _a.vtoActive, zoomModalOpenIndex = _a.zoomModalOpenIndex, buttonClickedForZoomRef = _a.buttonClickedForZoomRef, vtoBanner = _a.vtoBanner, sku = _a.sku, imageSizes = _a.imageSizes;
    if (!initialImages || initialImages.length === 0) {
        return null;
    }
    var handleImageClick = function (index, altText) {
        handleImageInteraction(index);
        // push dataLayer event only for the first image
        if (sku && index === 0) {
            pushImageGalleryOpenEvent(altText, index, sku);
        }
    };
    return (React.createElement("section", { "data-t": "product-image-gallery", className: classnames('product-image-gallery', {
            'product-image-gallery--full-width': initialImages.length <= 2,
        }) },
        React.createElement("div", { className: "product-image-gallery__images" }, initialImages.map(function (image, index) { return (React.createElement("div", { key: image.label, className: classnames('product-image-gallery__image', {
                'product-image-gallery__image--highlighted': image.highlighted,
            }) },
            image.vto && !vtoActive && vtoBanner && (React.createElement(VtoBanner, { vtoBanner: vtoBanner, altText: image.altText, imageUrl: image.url, onClick: function () { return setVtoActive(true); } })),
            image.vto && vtoActive && !!sku && (React.createElement("div", { className: "product-image-gallery__vto product-image" },
                React.createElement(VirtualTryOn, { sku: sku, onClose: function () { return setVtoActive(false); }, vtoBanner: vtoBanner }))),
            !image.vto && (React.createElement(ProductImage, { ref: index === zoomModalOpenIndex ? buttonClickedForZoomRef : null, onClick: function () { return handleImageClick(index, image.altText); }, altText: image.altText, imageUrl: image.url, zoom: image.zoom, imageSizes: imageSizes, sku: sku })))); })),
        !!expandableImages.length && (React.createElement(Expander, { className: "product-image-gallery__expanded-images", showMoreLabel: showMoreLabel, showLessLabel: showLessLabel, id: "gallery-expander", onExpandCallback: handleGalleryExpansion }, expandableImages.map(function (image, index) { return (React.createElement("div", { key: image.label, className: classnames('product-image-gallery__expanded-image', {
                'product-image-gallery__image--highlighted': image.highlighted,
            }) },
            !!image.vto && vtoBanner && (React.createElement(VtoBanner, { vtoBanner: vtoBanner, altText: image.altText, imageUrl: image.url, onClick: function () { return setVtoActive(true); }, showImage: isImageVisible })),
            !image.vto && (React.createElement(ProductImage, { ref: index + initialImages.length === zoomModalOpenIndex
                    ? buttonClickedForZoomRef
                    : null, onClick: function () { return handleImageClick(index + initialImages.length, image.altText); }, altText: image.altText, imageUrl: image.url, showImage: isImageVisible, imageSizes: imageSizes, zoom: image.zoom, sku: sku })))); }))),
        React.createElement(ZoomModal, { isOpen: zoomModalOpenIndex !== null, openingIndex: zoomModalOpenIndex, onClose: function () { return handleImageInteraction(null); }, images: __spreadArray$1(__spreadArray$1([], __read(initialImages)), __read(expandableImages)) })));
};

var ProductImageGalleryMobile = function (_a) {
    var images = _a.images, imageParams = _a.imageParams, setVtoActive = _a.setVtoActive, vtoActive = _a.vtoActive, sku = _a.sku, vtoBanner = _a.vtoBanner, handleImageInteraction = _a.handleImageInteraction, zoomModalOpenIndex = _a.zoomModalOpenIndex;
    var _b = useImageSlider(images.length, {
        elementIdentifierString: 'mobile__image-scroll-item',
    }), setSlide = _b.setSlide, activeIndex = _b.activeIndex, handleInView = _b.handleInView;
    var activeImage = images[activeIndex];
    // when vto is activated make sure the gallery switches to the vto slide
    React.useEffect(function () {
        if (vtoActive && !activeImage.vto) {
            setSlide(images.findIndex(function (image) { return image.vto; }));
        }
    }, [images, vtoActive]);
    var handleThumbnailClick = React.useCallback(function (thumbnail) {
        var activeImage = images.findIndex(function (image) { return image.label === thumbnail.label; });
        setSlide(activeImage);
        sku && pushImageGalleryItemClickEvent(activeImage, sku, thumbnail);
    }, [images, setSlide]);
    if (!Boolean(images.length)) {
        return null;
    }
    return (React.createElement("section", { className: "product-image-gallery-mobile" },
        React.createElement("div", { className: "product-image-gallery-mobile__images" },
            React.createElement("div", { className: "product-image-gallery-mobile__wrapper" },
                React.createElement("div", { className: "product-image-gallery-mobile__image-scroller" }, images.map(function (image, index) { return (React.createElement(InView, { key: image.label, threshold: 0.8, onChange: function (inView) { return handleInView(inView, index); } }, function (_a) {
                    var ref = _a.ref;
                    return (React.createElement("div", { ref: ref, id: "mobile__image-scroll-item-" + index, className: "product-image-gallery-mobile__image-scroller-item" },
                        image.vto && !vtoActive && vtoBanner && (React.createElement(VtoBanner, { altText: image.altText, imageUrl: image.url, imageParams: imageParams, vtoBanner: vtoBanner, onClick: function () { return setVtoActive(true); } })),
                        image.vto && vtoActive && !!sku && (React.createElement(VirtualTryOn, { sku: sku, vtoBanner: vtoBanner, onClose: function () { return setVtoActive(false); } })),
                        !image.vto && (React.createElement(ProductImage, { altText: image.altText, imageUrl: image.url, imageParams: imageParams, onClick: function () { return handleImageInteraction(index); } }))));
                })); }))),
            images.length > 1 && (React.createElement("div", { className: "product-image-gallery-mobile__thumbnails", "data-t": "image-gallery-mobile__thumbnails" },
                React.createElement(HorizontalImageSlider, { images: images, onClick: handleThumbnailClick, activeImage: activeImage })))),
        React.createElement(ZoomModal, { isOpen: zoomModalOpenIndex !== null, openingIndex: activeIndex, onClose: function () { return handleImageInteraction(null); }, images: images })));
};

var ProductImageGalleryMobileContainer = function (_a) {
    var images = _a.images, imageParams = _a.imageParams, product = _a.product, vtoBanner = _a.vtoBanner, handleImageInteraction = _a.handleImageInteraction, zoomModalOpenIndex = _a.zoomModalOpenIndex;
    var _b = useVtoConfig(), vtoActive = _b.isActive, setVtoActive = _b.setActive;
    return (React.createElement(ProductImageGalleryMobile, { images: images, setVtoActive: setVtoActive, vtoActive: vtoActive, sku: product.sku, imageParams: imageParams, vtoBanner: vtoBanner, handleImageInteraction: handleImageInteraction, zoomModalOpenIndex: zoomModalOpenIndex }));
};

var defaultImageParams = { fit: 'fill', format: 'png' };
var highlightedPackshots = new Set([
    'On_Model_Female01',
    'On_Model_Female02',
    'On_Model_Female03',
    'On_Model_Male01',
    'On_Model_Male02',
    'On_Model_Male03',
]);
var desktopImageSizes = {
    M: 768,
    L: 1024,
    XL: 1440,
};
var ProductImageGalleryContainer = function (_a) {
    var _b = _a.packshotTypes, packshotTypes = _b === void 0 ? [] : _b, product = _a.product, vtoBanner = _a.vtoBanner, activeVariant = _a.activeVariant;
    var productType = useProductDetailContext().productType;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var _c = useIntl(), getLabel = _c.getLabel, locale = _c.locale;
    var _d = __read(React.useState(false), 2), isImageVisible = _d[0], setImageVisible = _d[1];
    var _e = __read(React.useState(null), 2), zoomMobileOpenIndex = _e[0], setZoomMobileOpenIndex = _e[1];
    var _f = useVtoConfig(), isEnabled = _f.isEnabled, vtoActive = _f.isActive, setVtoActive = _f.setActive;
    var buttonClickedForZoomRef = React.useRef(null);
    var _g = __read(React.useState(false), 2), isExpanded = _g[0], setIsExpanded = _g[1];
    var activeVariantProduct = getActiveVariant$1(product, activeVariant.sku);
    var handleGalleryExpansion = React.useCallback(function (expanded) {
        if (!isImageVisible && expanded) {
            setImageVisible(true);
        }
        setIsExpanded(expanded);
    }, [isImageVisible]);
    React.useEffect(function () {
        if (isImageVisible) {
            pushImageGalleryItemExpandedEvent(isExpanded);
        }
    }, [isImageVisible, isExpanded]);
    var handleImageInteraction = React.useCallback(function (index) {
        var _a;
        if (index === null)
            (_a = buttonClickedForZoomRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setZoomMobileOpenIndex(index);
    }, []);
    var _h = React.useMemo(function () {
        var _a;
        // Use placeholder if there are no images
        var variantImages = ((_a = activeVariant.images) === null || _a === void 0 ? void 0 : _a.length) > 0 ? activeVariant.images : [placeholderImage];
        var enhancedImages = variantImages.map(function (image) { return (__assign$1(__assign$1({}, image), { thumbnailUrl: createImageUrl(image.url, __assign$1(__assign$1({}, defaultImageParams), { width: 224 })), altText: createAltText(product, productType, locale, image.label), highlighted: highlightedPackshots.has(image.label), zoom: !highlightedPackshots.has(image.label) })); });
        var vtoImg = vtoBanner
            ? {
                url: vtoBanner.image.url,
                dimensions: { w: vtoBanner.image.original.width, h: vtoBanner.image.original.height },
                thumbnailUrl: createImageUrl(vtoBanner.image.url, __assign$1(__assign$1({}, defaultImageParams), { width: 112, height: 63, fit: 'cover' })),
                altText: vtoBanner.image.description || vtoBanner.title,
                highlighted: false,
                zoom: false,
                label: 'vto',
                vto: true,
            }
            : __assign$1(__assign$1({}, enhancedImages[0]), { label: 'vto', zoom: false, vto: true });
        if (vtoActive && !isSmallScreen && activeVariantProduct.vtoEnabled) {
            enhancedImages.unshift(vtoImg);
        }
        else if (vtoActive && activeVariantProduct.vtoEnabled) {
            enhancedImages.push(vtoImg);
        }
        else if (vtoBanner && isEnabled && activeVariantProduct.vtoEnabled) {
            enhancedImages.push(vtoImg);
        }
        /**
         * In order to correctly follow the design we need to decide how many images we will initially render on load.
         * If there is a highlightedPackshot we have more space to render an extra image.
         *
         * This follows the following logic:
         * 1. If there are no highlightedPackshots: render 3 images.
         * 2. If only the first image is a highlightedPackshot: render 3 images.
         * 3. If the second OR third image is a highlightedPackshot: render 4 images.
         * 4. If the second AND third images are highlightedPackshots: render 3 images.
         */
        var initialImageSize = enhancedImages.slice(1, 3).filter(function (image) { return image.highlighted === true; }).length === 1 ? 4 : 3;
        var initialImages = enhancedImages.slice(0, initialImageSize);
        var expandableImages = enhancedImages.slice(initialImageSize);
        return {
            initialImages: initialImages,
            expandableImages: expandableImages,
            enhancedImages: enhancedImages,
        };
    }, [
        activeVariant.images,
        packshotTypes,
        vtoBanner,
        vtoActive,
        isSmallScreen,
        isEnabled,
        product,
        productType,
        locale,
        activeVariantProduct,
    ]), initialImages = _h.initialImages, expandableImages = _h.expandableImages, enhancedImages = _h.enhancedImages;
    useEffect(function () {
        if (!activeVariantProduct.vtoEnabled)
            setVtoActive(false);
    }, [activeVariantProduct.vtoEnabled, setVtoActive]);
    useEffect(function () {
        if (product.masterVariant.sku && product.masterVariant.vtoEnabled)
            vtoEvent('vto.view', { sku: product.masterVariant.sku });
    }, []);
    return (React.createElement(React.Fragment, null, isSmallScreen ? (React.createElement(ProductImageGalleryMobileContainer, { images: enhancedImages, product: activeVariantProduct, imageParams: defaultImageParams, vtoBanner: vtoBanner, handleImageInteraction: handleImageInteraction, zoomModalOpenIndex: zoomMobileOpenIndex })) : (React.createElement(ProductImageGallery, { initialImages: initialImages, expandableImages: expandableImages, showMoreLabel: getLabel('products.imageGallery.showMore'), showLessLabel: getLabel('products.imageGallery.showLess'), isImageVisible: isImageVisible, handleGalleryExpansion: handleGalleryExpansion, handleImageInteraction: handleImageInteraction, setVtoActive: setVtoActive, sku: activeVariantProduct.sku, vtoActive: vtoActive, vtoBanner: vtoBanner, zoomModalOpenIndex: zoomMobileOpenIndex, imageSizes: desktopImageSizes, buttonClickedForZoomRef: buttonClickedForZoomRef }))));
};

/**
 * Please note that the first step cannot be a skippable step
 */
var stepSequence$1 = [
    'lensType',
    'prescription',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn',
];
/**
 * @experiment rx_configuration_sequence_experiment
 * the alternative sequence is used for A/B testing
 * this can be removed after the experiment is over
 */
var stepSequenceAlternative = [
    'lensType',
    'lensPackage',
    'lensAddOn',
    'prescription',
    'prescriptionValidation',
];

var PriceTagOrIncluded = function (props) {
    var _a = useIntl(), getLabel = _a.getLabel, hasLabel = _a.hasLabel;
    var originalPrice = props.originalPrice, discountedPrice = props.discountedPrice, discountText = props.discountText, className = props.className;
    if (originalPrice === 0) {
        var labelKey = 'products.glasses.configurator.priceIsZero';
        return hasLabel(labelKey) ? React.createElement("span", { className: className }, getLabel(labelKey)) : null;
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return React.createElement("span", { className: className }, discountText);
    }
    return React.createElement(PriceTag, __assign$1({}, props));
};

var ImageSection = function (_a) {
    var image = _a.image, alt = _a.alt, className = _a.className;
    if ('dimensions' in image) {
        var url = image.url, label = image.label, dimensions = image.dimensions;
        return (React.createElement("img", { src: url, alt: label ? label : alt, height: dimensions.h, width: dimensions.w, className: className }));
    }
    else {
        var description = image.description, original = image.original;
        return (React.createElement("img", { src: original.url, alt: description ? description : alt, height: original.height, width: original.width, className: className }));
    }
};
var RadioCardBody = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.alignment, alignment = _b === void 0 ? 'top' : _b, title = _a.title, description = _a.description, tag = _a.tag, image = _a.image, icon = _a.icon, imageClassName = _a.imageClassName, price = _a.price, discountText = _a.discountText, priceComment = _a.priceComment, _c = _a.withDivider, withDivider = _c === void 0 ? false : _c;
    return (React.createElement("div", { "data-t": "radio-card-body", className: classnames('radio-card-body', className) },
        tag && React.createElement("em", { className: "radio-card-body__tag" }, tag),
        !tag && (React.createElement("div", { className: "radio-card-body__tag radio-card-body__tag--hidden", "aria-hidden": "true" }, "\u00A0")),
        React.createElement("div", { className: classnames('radio-card-body__content', "radio-card-body__content--align-" + alignment) },
            image && !icon && (React.createElement(ImageSection, { image: image, alt: title, className: classnames('radio-card-body__image', imageClassName) })),
            icon && !image && (React.createElement("div", { className: "radio-card-body__icon" },
                React.createElement(Icon, { name: icon }))),
            React.createElement(Heading, { className: "radio-card-body__header", component: "h3", variant: "smallest" }, title),
            description && (React.createElement(Text, { className: "radio-card-body__description", variant: "caption-head" }, description)),
            children),
        withDivider && React.createElement(Hr, null),
        price && (React.createElement("div", { className: "radio-card-body__price-wrapper" },
            React.createElement(PriceTagOrIncluded, __assign$1({}, price, { discountText: discountText })))),
        priceComment && (React.createElement(Text, { className: "radio-card-body__price-comment", variant: "caption" }, priceComment))));
};

var RadioCard = function (_a) {
    var className = _a.className, isChecked = _a.isChecked, name = _a.name, value = _a.value, id = _a.id, onChange = _a.onChange, rest = __rest(_a, ["className", "isChecked", "name", "value", "id", "onChange"]);
    var handleChange = React.useCallback(function (e) { return onChange(e.currentTarget.value); }, [onChange]);
    return (React.createElement(RadioButton, { name: name, className: classnames('radio-card', className), id: id, isChecked: isChecked, position: "bottom", onChange: handleChange, value: value, "data-t": rest['data-t'] },
        React.createElement(RadioCardBody, __assign$1({}, rest))));
};

var SingleItemRadioCard = function (_a) {
    var cardClassName = _a.cardClassName, rest = __rest(_a, ["cardClassName"]);
    return (React.createElement(Card, { className: cardClassName },
        React.createElement(RadioCardBody, __assign$1({}, rest))));
};

var RadioCardWithVariants = function (_a) {
    var name = _a.name, variants = _a.variants, selectedVariantSku = _a.selectedVariantSku, onChange = _a.onChange, className = _a.className, rest = __rest(_a, ["name", "variants", "selectedVariantSku", "onChange", "className"]);
    var containsSelectedAddOn = variants.some(function (a) { return a.sku === selectedVariantSku; });
    var handleChange = React.useCallback(function (e) { return onChange(e.currentTarget.value); }, [onChange]);
    return (React.createElement(Card, { "data-t": rest['data-t'], className: classnames('radio-card-with-variants', className, {
            'radio-card-with-variants--active': containsSelectedAddOn,
        }) },
        React.createElement(RadioCardBody, { title: rest.title, description: rest.description, image: rest.image, imageClassName: rest.imageClassName, tag: rest.tag, price: rest.price, discountText: rest.discountText }, variants.map(function (v) {
            var _a;
            var isChecked = v.sku === selectedVariantSku;
            return (React.createElement(RadioButton, { key: v.sku, name: name, variant: "plain", position: "left", value: v.sku, isChecked: isChecked, onChange: handleChange, className: "radio-card-with-variants__variant-item" },
                React.createElement("img", { alt: "", src: (_a = v.image) === null || _a === void 0 ? void 0 : _a.url, className: "radio-card-with-variants__variant-item-image" }),
                React.createElement("span", { className: "radio-card-with-variants__variant-item-label" }, v.title)));
        }))));
};

var BundleProductRadioCard = function (_a) {
    var _b;
    _a.children; var className = _a.className, id = _a.id, productInfo = _a.productInfo, selectedVariantSku = _a.selectedVariantSku, showPriceAsZero = _a.showPriceAsZero, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "id", "productInfo", "selectedVariantSku", "showPriceAsZero", "value", "onChange"]);
    var handleChange = React.useCallback(function () { return onChange(productInfo); }, [onChange, productInfo]);
    var description = productInfo.description, image = productInfo.image, price = productInfo.price, title = productInfo.title, discountText = productInfo.discountText;
    var getLabel = useIntl().getLabel;
    var handleVariantChange = React.useCallback(function (sku) {
        var _a;
        var addOn = (_a = productInfo.variants) === null || _a === void 0 ? void 0 : _a.find(function (v) { return v.sku === sku; });
        addOn && onChange(addOn);
    }, [productInfo.variants, onChange]);
    var zeroPriceLabel = showPriceAsZero
        ? undefined
        : getLabel('products.glasses.configurator.priceIsZero');
    var sharedProps = {
        className: classnames('bundle-product-radio-card', className),
        alignment: 'bottom',
        title: title,
        description: description,
        image: image,
        imageClassName: 'bundle-product-radio-card__image',
        price: price,
        zeroPriceLabel: zeroPriceLabel,
        discountText: discountText,
        'data-t': rest['data-t'],
    };
    if ((_b = productInfo.variants) === null || _b === void 0 ? void 0 : _b.length) {
        return (React.createElement(RadioCardWithVariants, __assign$1({}, sharedProps, { variants: productInfo.variants, selectedVariantSku: selectedVariantSku, onChange: handleVariantChange })));
    }
    var isChecked = selectedVariantSku === productInfo.sku;
    // Check if this is the dummy lens add-on and if it's checked
    if (selectedVariantSku === undefined && productInfo.sku === '') {
        isChecked = true;
    }
    return (React.createElement(RadioCard, __assign$1({}, sharedProps, { id: id !== null && id !== void 0 ? id : value + "-radio", isChecked: isChecked, value: value, onChange: handleChange })));
};

var StepWrapper = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React__default.createElement("div", { "data-t": rest['data-t'], className: classnames('prescription-glasses-step', className) }, children));
};

function usePrescriptionTypes() {
    var _a = useFeatureToggles(), isPrescriptionFileEnabled = _a.isPrescriptionFileEnabled, featureConfigs = _a.featureConfigs;
    var prescriptionTypesOrder = useProductDetailContext().prescriptionTypesOrder;
    var allTypes = [
        'EmailPrescription',
        'ExistingCustomer',
        'NewPrescription',
        'PrescriptionFile',
    ];
    // checking environment variables
    var envTypes = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.prescriptionTypesOrder;
    if (envTypes && envTypes.every(function (type) { return allTypes.includes(type); })) {
        return __spreadArray$1([], __read(envTypes));
    }
    // checking ordered types passed in from the product-detail.tsx file
    if (prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder.length) {
        // if this item exists
        return __spreadArray$1([], __read(prescriptionTypesOrder));
    }
    // default behavior
    var finalTypes = ['NewPrescription', 'ExistingCustomer'];
    if (isPrescriptionFileEnabled) {
        finalTypes.push('EmailPrescription');
    }
    return finalTypes;
}

var RxGlassesConfiguratorContext = React.createContext({});
var useRxGlassesConfiguratorContext = function () { return React.useContext(RxGlassesConfiguratorContext); };
var RxGlassesConfiguratorProvider = function (_a) {
    var children = _a.children, opticianForm = _a.opticianForm, configuratorDocument = _a.configuratorDocument, frame = _a.frame, frameSku = _a.frameSku, formatProductUrl = _a.formatProductUrl, id = _a.id;
    var isExtraValidationStepEnabled = useFeatureToggles().isPrescriptionGlassesConfiguratorValidationStepEnabled;
    var prescriptionTypesOrder = usePrescriptionTypes();
    var value = {
        opticianForm: opticianForm,
        configuratorDocument: configuratorDocument,
        isExtraValidationStepEnabled: isExtraValidationStepEnabled,
        id: id,
    };
    var dispatch = useDispatch();
    React.useEffect(function () {
        dispatch(startPrescriptionGlassesConfiguration({
            frame: frame,
            frameSku: frameSku,
            formatProductUrl: formatProductUrl,
            isExtraValidationStepEnabled: isExtraValidationStepEnabled,
            prescriptionTypesOrder: prescriptionTypesOrder,
        }));
    }, [dispatch]);
    return (React.createElement(RxGlassesConfiguratorContext.Provider, { value: value }, children));
};

/*
 * This component is used to show the "No Add-ons" option in the frontend.
 * No value is returned when it is selected, and nothing is returned to the BE when the user proceeds to checkout.
 */
var DummyLensAddOn = function (_a) {
    _a.children; var className = _a.className, selectedLensAddOnSku = _a.selectedLensAddOnSku, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "selectedLensAddOnSku", "onChange"]);
    var handleChange = React.useCallback(function () { return onChange(); }, [onChange]);
    var _b = useIntl(), getLabel = _b.getLabel, currency = _b.currency;
    var configuratorDocument = useRxGlassesConfiguratorContext().configuratorDocument;
    var noAddOnsImage = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.addOnsStep.noAddonsImage;
    var productInfo = React.useMemo(function () { return ({
        variants: [],
        isDefault: false,
        sku: '',
        title: getLabel('products.glasses.lensAddOn.noAddOn.title'),
        price: {
            originalPrice: 0,
            currency: currency,
        },
        image: noAddOnsImage,
    }); }, [noAddOnsImage, getLabel]);
    return (React.createElement(BundleProductRadioCard, { className: className, id: "dummy-add-on-radio", productInfo: productInfo, selectedVariantSku: selectedLensAddOnSku, value: "", onChange: handleChange, showPriceAsZero: true, "data-t": rest['data-t'] }));
};

var LensAddOnStep = function (_a) {
    var className = _a.className, lensAddOns = _a.lensAddOns, selectedLensAddOn = _a.selectedLensAddOn, areAddOnsOptional = _a.areAddOnsOptional, onChange = _a.onChange, onSubmit = _a.onSubmit, rest = __rest(_a, ["className", "lensAddOns", "selectedLensAddOn", "areAddOnsOptional", "onChange", "onSubmit"]);
    var selectedLensAddOnSku = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku;
    return (React.createElement(StepWrapper, { className: classnames('lens-add-on-step', className), "data-t": rest['data-t'] },
        React.createElement(ConfiguratorStepTitleAndDescription, null),
        React.createElement(StepForm, { onSubmit: onSubmit },
            React.createElement("div", { className: "lens-add-on-step__scroll-container" },
                React.createElement("div", { className: "lens-add-on-step__scroll-container__inner" },
                    React.createElement("div", { className: "lens-add-on-step__list" },
                        lensAddOns.map(function (lensAddOn) {
                            return (React.createElement(BundleProductRadioCard, { "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensAddOn.sku : undefined, className: "lens-add-on-step__list-item", productInfo: lensAddOn, selectedVariantSku: selectedLensAddOnSku, value: lensAddOn.sku, key: lensAddOn.sku, onChange: onChange }));
                        }),
                        areAddOnsOptional && (React.createElement(DummyLensAddOn, { className: "lens-add-on-step__list-item", onChange: onChange, selectedLensAddOnSku: selectedLensAddOnSku }))))))));
};

var LensAddOnStepContainer = function () {
    var dispatch = useDispatch();
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var frame = useSelector(getSelectedFrame);
    var addOns = useSelector(getAddOns);
    var selectedAddOn = useSelector(getSelectedAddOn);
    var areAddOnsOptional = useSelector(getAreAddOnsOptional);
    var onChange = React__default.useCallback(function (args) {
        if (!frame) {
            return;
        }
        if (!(args === null || args === void 0 ? void 0 : args.sku)) {
            dispatch(resetSelectedAddOn({
                frameSku: frame.sku,
                reason: 'user selection',
            }));
        }
        else {
            dispatch(selectAddOn({
                frameSku: frame.sku,
                addOnSku: args.sku,
                reason: 'user selection',
            }));
        }
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!statusSuccess(addOns)) {
        return React__default.createElement(LoaderScreen, null);
    }
    return (React__default.createElement(LensAddOnStep, { onChange: onChange, onSubmit: goToNextStep, lensAddOns: addOns.result, selectedLensAddOn: selectedAddOn, areAddOnsOptional: areAddOnsOptional }));
};

var lensAddOnStepBase = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call(selectDefaultAddOn)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    view: LensAddOnStepContainer,
};
var isSuccess$2 = function (_a) {
    var packageSku = _a.packageSku;
    return function (a) {
        return actions$1.isType(a, fetchAddOnsSuccess) && a.payload.packageSku === packageSku;
    };
};
var isFailed$2 = function (_a) {
    var packageSku = _a.packageSku;
    return function (a) {
        return actions$1.isType(a, fetchAddOnsFailed) && a.payload.packageSku === packageSku;
    };
};
function selectDefaultAddOn() {
    var selectedAddOn, frameSku, selectedPackage, addOns, lensType, _a, success, products, variants, addOnSku, variants_1, variants_1_1, variant;
    var e_1, _b;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(getSelectedAddOn)];
            case 1:
                selectedAddOn = _d.sent();
                if (!!selectedAddOn) return [3 /*break*/, 10];
                return [4 /*yield*/, select(getFrameSku)];
            case 2:
                frameSku = _d.sent();
                if (!frameSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getSelectedPackage)];
            case 3:
                selectedPackage = _d.sent();
                return [4 /*yield*/, select(getAddOns)];
            case 4:
                addOns = _d.sent();
                if (!(!statusSuccess(addOns) && !statusFailed(addOns))) return [3 /*break*/, 8];
                return [4 /*yield*/, select(getSelectedLensType)];
            case 5:
                lensType = _d.sent();
                if (!lensType) {
                    return [2 /*return*/];
                }
                if (!selectedPackage) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, race([
                        take(isSuccess$2({ packageSku: selectedPackage.sku })),
                        take(isFailed$2({ packageSku: selectedPackage.sku })),
                        delay(30000, true),
                    ])];
            case 6:
                _a = __read.apply(void 0, [_d.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 8];
                return [4 /*yield*/, select(getAddOns)];
            case 7:
                addOns = _d.sent();
                _d.label = 8;
            case 8:
                if (!statusSuccess(addOns)) return [3 /*break*/, 10];
                products = addOns.result;
                variants = products.reduce(function (acc, p) { return __spreadArray$1(__spreadArray$1(__spreadArray$1([], __read(acc)), [p]), __read((p.variants || []))); }, []);
                addOnSku = (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.areAddOnsOptional) ? '' : (_c = addOns.result[0]) === null || _c === void 0 ? void 0 : _c.sku;
                try {
                    for (variants_1 = __values(variants), variants_1_1 = variants_1.next(); !variants_1_1.done; variants_1_1 = variants_1.next()) {
                        variant = variants_1_1.value;
                        if (variant.isDefault) {
                            addOnSku = variant.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (variants_1_1 && !variants_1_1.done && (_b = variants_1.return)) _b.call(variants_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!addOnSku) return [3 /*break*/, 10];
                return [4 /*yield*/, put(selectAddOn({
                        frameSku: frameSku,
                        addOnSku: addOnSku,
                        reason: 'default selection',
                    }))];
            case 9:
                _d.sent();
                _d.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}

var LensPackage = function (_a) {
    var className = _a.className, lensPackage = _a.lensPackage, isChecked = _a.isChecked, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["className", "lensPackage", "isChecked", "value", "onChange"]);
    var getLabel = useIntl().getLabel;
    var isTabletPortrait = MediaQuery.useIsTabletPortrait();
    var handleChange = React.useCallback(function () { return onChange(lensPackage); }, [onChange, lensPackage]);
    var title = lensPackage.title, description = lensPackage.description, price = lensPackage.price, discountText = lensPackage.discountText, tag = lensPackage.tag, usps = lensPackage.usps;
    return (React.createElement(RadioCard, { "data-t": rest['data-t'], className: classnames('lens-package', className), id: value + "-radio", isChecked: isChecked, onChange: handleChange, value: value, tag: tag, title: title, description: description, price: price, discountText: discountText, zeroPriceLabel: getLabel('products.glasses.lensPackage.priceIsZero') },
        React.createElement("div", { className: "lens-package__content" },
            !!usps && !!usps.length && React.createElement(Hr, null),
            React.createElement("div", { className: "lens-package__usp-list-wrapper" },
                React.createElement(List, { icon: isTabletPortrait ? 'default' : 'checkmark-small', items: usps, renderText: function (item) { return React.createElement(Text, { variant: "caption-head" }, item); }, className: "lens-package__usp-list" })),
            React.createElement(Hr, { className: "lens-package__bottom-divider" }))));
};

var LensPackageStep = function (_a) {
    var className = _a.className, lensPackages = _a.lensPackages, selectedLensPackage = _a.selectedLensPackage, onChange = _a.onChange, onSubmit = _a.onSubmit, rest = __rest(_a, ["className", "lensPackages", "selectedLensPackage", "onChange", "onSubmit"]);
    return (React__default.createElement(StepWrapper, { className: classnames('lens-package-step', className), "data-t": rest['data-t'] },
        React__default.createElement(StepForm, { onSubmit: onSubmit },
            React__default.createElement(ConfiguratorStepTitleAndDescription, null),
            React__default.createElement("div", { className: "lens-package-step__scroll-container" },
                React__default.createElement("div", { className: "lens-package-step__scroll-container__inner" },
                    React__default.createElement("div", { className: "lens-package-step__list" }, lensPackages.map(function (lensPackage) {
                        var isChecked = (selectedLensPackage === null || selectedLensPackage === void 0 ? void 0 : selectedLensPackage.sku) === lensPackage.sku;
                        return (React__default.createElement(LensPackage, { "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensPackage.sku : undefined, isChecked: isChecked, className: "lens-package-step__list-item", lensPackage: lensPackage, value: lensPackage.sku, key: lensPackage.sku, onChange: onChange }));
                    })))))));
};

var LensPackageStepContainer = function () {
    var dispatch = useDispatch();
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var frame = useSelector(getSelectedFrame);
    var lensPackages = useSelector(getPackages);
    var selectedLensPackage = useSelector(getSelectedPackage);
    var onChange = React__default.useCallback(function (lensPackage) {
        if (!frame) {
            return;
        }
        dispatch(selectPackage({
            frameSku: frame.sku,
            packageSku: lensPackage.sku,
            reason: 'user selection',
        }));
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!statusSuccess(lensPackages)) {
        return React__default.createElement(LoaderScreen, null);
    }
    return (React__default.createElement(LensPackageStep, { selectedLensPackage: selectedLensPackage, onChange: onChange, onSubmit: goToNextStep, lensPackages: lensPackages.result }));
};

var lensPackageStepBase = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call(selectDefaultPackage)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var selectedPackage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getSelectedPackage)];
                case 1:
                    selectedPackage = _a.sent();
                    if (!selectedPackage) {
                        return [2 /*return*/, new Error("Selecting a lens-package is required")];
                    }
                    return [2 /*return*/];
            }
        });
    },
    view: LensPackageStepContainer,
};
var isSuccess$1 = function (_a) {
    var lensTypeSku = _a.lensTypeSku;
    return function (a) {
        return actions$1.isType(a, fetchPackagesSuccess) && a.payload.lensTypeSku === lensTypeSku;
    };
};
var isFailed$1 = function (_a) {
    var lensTypeSku = _a.lensTypeSku;
    return function (a) {
        return actions$1.isType(a, fetchPackagesFailed) && a.payload.lensTypeSku === lensTypeSku;
    };
};
function selectDefaultPackage() {
    var selectedPackage, frameSku, packages, lensType, _a, success, packageSku, _b, _c, product;
    var e_1, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, select(getSelectedPackage)];
            case 1:
                selectedPackage = _f.sent();
                if (!!selectedPackage) return [3 /*break*/, 10];
                return [4 /*yield*/, select(getFrameSku)];
            case 2:
                frameSku = _f.sent();
                if (!frameSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getPackages)];
            case 3:
                packages = _f.sent();
                if (!(!statusSuccess(packages) && !statusFailed(packages))) return [3 /*break*/, 7];
                return [4 /*yield*/, select(getSelectedLensType)];
            case 4:
                lensType = _f.sent();
                if (!lensType) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, race([
                        take(isSuccess$1({ lensTypeSku: lensType.sku })),
                        take(isFailed$1({ lensTypeSku: lensType.sku })),
                        delay(30000, true),
                    ])];
            case 5:
                _a = __read.apply(void 0, [_f.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 7];
                return [4 /*yield*/, select(getPackages)];
            case 6:
                packages = _f.sent();
                _f.label = 7;
            case 7:
                if (!statusSuccess(packages)) return [3 /*break*/, 9];
                packageSku = (_e = packages.result[0]) === null || _e === void 0 ? void 0 : _e.sku;
                try {
                    for (_b = __values(packages.result), _c = _b.next(); !_c.done; _c = _b.next()) {
                        product = _c.value;
                        if (product.isDefault) {
                            packageSku = product.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!packageSku) return [3 /*break*/, 9];
                return [4 /*yield*/, put(selectPackage({
                        frameSku: frameSku,
                        packageSku: packageSku,
                        reason: 'default selection',
                    }))];
            case 8:
                _f.sent();
                _f.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, call(loadMissingAddOns, selectedPackage.sku)];
            case 11:
                _f.sent();
                _f.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}

var LensTypeStep = function (_a) {
    var className = _a.className, lensTypeInfoList = _a.lensTypeInfoList, selectedLensType = _a.selectedLensType, onChange = _a.onChange, onSubmit = _a.onSubmit, rest = __rest(_a, ["className", "lensTypeInfoList", "selectedLensType", "onChange", "onSubmit"]);
    return (React.createElement(StepWrapper, { className: classnames('lens-type-step', className), "data-t": rest['data-t'] },
        React.createElement(StepForm, { onSubmit: onSubmit },
            React.createElement(ConfiguratorStepTitleAndDescription, null),
            React.createElement("div", { className: "lens-type-step__list" }, lensTypeInfoList.map(function (lensTypeInfo) { return (React.createElement(BundleProductRadioCard, { className: "lens-type-step__list-item", productInfo: lensTypeInfo, selectedVariantSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku, value: lensTypeInfo.sku, onChange: onChange, key: lensTypeInfo.sku, "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensTypeInfo.sku : undefined })); })))));
};

var LensTypeStepContainer = function () {
    var dispatch = useDispatch();
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var frame = useSelector(getSelectedFrame);
    var lensTypes = useSelector(getLensTypes);
    var selectedLensType = useSelector(getSelectedLensType);
    var onChange = React__default.useCallback(function (lensType) {
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: lensType.sku,
            reason: 'user selection',
        }));
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!statusSuccess(lensTypes)) {
        return React__default.createElement(LoaderScreen, null);
    }
    return (React__default.createElement(LensTypeStep, { onChange: onChange, onSubmit: goToNextStep, lensTypeInfoList: lensTypes.result, selectedLensType: selectedLensType }));
};

var lensTypeStepBase = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                /**
                 * Blocks the onEnter for this step, until the action has passed that
                 * prepares the RxGlasses state for this configuration.
                 */
                return [4 /*yield*/, race([take(startPrescriptionGlassesConfiguration), delay(3000)])];
                case 1:
                    /**
                     * Blocks the onEnter for this step, until the action has passed that
                     * prepares the RxGlasses state for this configuration.
                     */
                    _a.sent();
                    return [4 /*yield*/, call(selectDefaultLensType)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var lensType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getSelectedLensType)];
                case 1:
                    lensType = _a.sent();
                    if (!lensType) {
                        return [2 /*return*/, new Error("Selecting a lens-type is required")];
                    }
                    return [2 /*return*/];
            }
        });
    },
    view: LensTypeStepContainer,
};
var isSuccess = actions$1.guard(fetchLensTypesSuccess);
var isFailed = actions$1.guard(fetchLensTypesFailed);
function selectDefaultLensType() {
    var lensType, frameSku, lensTypes, _a, success, lensTypeSku, _b, _c, product;
    var e_1, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, select(getSelectedLensType)];
            case 1:
                lensType = _f.sent();
                return [4 /*yield*/, select(getFrameSku)];
            case 2:
                frameSku = _f.sent();
                if (!frameSku) {
                    console.warn("Did not find a frame SKU for this configuration. Received: " + frameSku);
                    return [2 /*return*/];
                }
                if (!!lensType) return [3 /*break*/, 9];
                return [4 /*yield*/, select(getLensTypes)];
            case 3:
                lensTypes = _f.sent();
                if (!(statusLoading(lensTypes) || statusUninit(lensTypes))) return [3 /*break*/, 6];
                return [4 /*yield*/, race([
                        take(function (a) { return isSuccess(a); }),
                        take(function (a) { return isFailed(a) && a.payload.frameSku === frameSku; }),
                        delay(30000, true),
                    ])];
            case 4:
                _a = __read.apply(void 0, [_f.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 6];
                return [4 /*yield*/, select(getLensTypes)];
            case 5:
                lensTypes = _f.sent();
                _f.label = 6;
            case 6:
                if (!statusSuccess(lensTypes)) return [3 /*break*/, 8];
                lensTypeSku = (_e = lensTypes.result[0]) === null || _e === void 0 ? void 0 : _e.sku;
                try {
                    for (_b = __values(lensTypes.result), _c = _b.next(); !_c.done; _c = _b.next()) {
                        product = _c.value;
                        if (product.isDefault) {
                            lensTypeSku = product.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!lensTypeSku) return [3 /*break*/, 8];
                return [4 /*yield*/, put(selectLensType({
                        frameSku: frameSku,
                        lensTypeSku: lensTypeSku,
                        reason: 'default selection',
                    }))];
            case 7:
                _f.sent();
                _f.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9: 
            // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
            return [4 /*yield*/, call(loadMissingPackages, lensType.sku)];
            case 10:
                // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
                _f.sent();
                _f.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}

var typeToLabelMap = {
    NewPrescription: 'products.glasses.existingCustomerRadio.isNotExisting',
    ExistingCustomer: 'products.glasses.existingCustomerRadio.isExisting',
    EmailPrescription: 'products.glasses.existingCustomerRadio.isEmailPrescription',
    PrescriptionFile: 'products.glasses.existingCustomerRadio.isPrescriptionFile',
};
function useRadioItems(scopesToCheck) {
    var prescriptionTypes = usePrescriptionTypes();
    var shouldCheckUploadConfig = prescriptionTypes.includes('PrescriptionFile');
    var _a = __read(useState([]), 2), radioItems = _a[0], setRadioItems = _a[1];
    var getLabel = useIntl().getLabel;
    var configs = useUpload().configs;
    function setOptionsWithLabel(items) {
        setRadioItems(items.map(function (key) { return ({ value: key, label: getLabel(typeToLabelMap[key]) }); }));
    }
    // if radio buttons has been set once, changing the config should not update them
    if (radioItems.length) {
        return { isWaiting: false, radioItems: radioItems };
    }
    var statuses = scopesToCheck.map(function (s) { var _a; return ((_a = configs[s]) === null || _a === void 0 ? void 0 : _a.status) || 'failed'; });
    var waitingStatuses = [LOADING, UNINIT];
    var waitForUploadConfig = waitingStatuses.some(function (s) { return statuses.includes(s); });
    // if there is no need for upload config, then ignore it
    if (!shouldCheckUploadConfig) {
        setOptionsWithLabel(prescriptionTypes);
    }
    else if (!waitForUploadConfig) {
        var finalTypes = __spreadArray$1([], __read(prescriptionTypes));
        // removing file options if config was not received
        if (statuses.some(function (s) { return s !== 'success'; })) {
            var index = finalTypes.indexOf('PrescriptionFile');
            if (index >= 0) {
                finalTypes.splice(index, 1);
            }
        }
        setOptionsWithLabel(finalTypes);
    }
    return { isWaiting: waitForUploadConfig, radioItems: radioItems };
}

var getOptions = function (values, prescriptionAttribute) {
    var formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
    return Array.from(values).reduce(function (acc, value) {
        var _a;
        var formattedValue = formatter(value);
        if (formattedValue) {
            return __assign$1(__assign$1({}, acc), (_a = {}, _a[formattedValue] = value, _a));
        }
        else {
            console.error("Error formatting prescription value " + value + " for attribute: " + prescriptionAttribute);
            return acc;
        }
    }, {});
};
var PrescriptionSelect = React.memo(function (_a) {
    var _b;
    var name = _a.name, parentId = _a.parentId, values = _a.values, selectClassName = _a.selectClassName, onChange = _a.onChange, errorMessageId = _a.errorMessageId, value = _a.value, isValid = _a.isValid, isDisabled = _a.isDisabled;
    var getLabel = useIntl().getLabel;
    var options = React.useMemo(function () { return getOptions(values, name); }, [values, name]);
    var sortOptions = React.useCallback(function (a, b) { return Number(a) - Number(b); }, []);
    var formattedValue = (_b = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && _b !== void 0 ? _b : '';
    var valueAsString = React.useMemo(function () { return ({
        value: isPrescriptionValue(value) && values.has(value) ? formattedValue : '',
    }); }, [values, value, formattedValue]);
    var _c = React.useMemo(function () { return ({
        selectId: parentId + "-" + name + "-select",
        labelId: parentId + "-" + name + "-label",
        selectName: "prescription-select-" + name,
    }); }, [parentId, name]), selectId = _c.selectId, labelId = _c.labelId, selectName = _c.selectName;
    var handleChange = React.useCallback(function (newValue) {
        onChange(name, newValue);
    }, [onChange, name]);
    var isInvalid = isValid === false;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "prescription-column__label-wrapper" },
            React.createElement("label", { id: labelId, htmlFor: selectId, className: "prescription-column__label" }, getLabel("products.glasses.prescription." + name)),
            React.createElement(Tooltip, { id: parentId + "-" + name + "-tooltip", greyedOut: isDisabled, className: "prescription-column__tooltip", message: getLabel("products.glasses.prescription." + name + ".tooltip") })),
        React.createElement(Select, { id: selectId, "aria-labelledby": labelId + " " + parentId, "aria-describedby": errorMessageId, "aria-invalid": isInvalid, className: classnames('prescription-column__select', selectClassName), options: options, sortOptionsBy: sortOptions, initialState: valueAsString, onChange: handleChange, name: selectName, "data-t": selectName, placeholder: "---" })));
});
var PrescriptionColumn = function (_a) {
    var id = _a.id, className = _a.className, hideSelectLabels = _a.hideSelectLabels, columnTitle = _a.columnTitle; _a.errorMessageId; var parameters = _a.parameters, selectedValues = _a.selectedValues, validations = _a.validations, showValidation = _a.showValidation, onAttributeChange = _a.onAttributeChange, isDisabled = _a.isDisabled, rest = __rest(_a, ["id", "className", "hideSelectLabels", "columnTitle", "errorMessageId", "parameters", "selectedValues", "validations", "showValidation", "onAttributeChange", "isDisabled"]);
    var sortedParams = sortPrescriptionParameters(parameters.map(function (p) { return p.name; }));
    return (React.createElement("fieldset", { "data-t": "prescription-column-fieldset", disabled: isDisabled, className: className },
        React.createElement("div", { "data-t": rest['data-t'], className: classnames('prescription-column', {
                'prescription-column--hide-labels': hideSelectLabels,
                'prescription-column--disabled': isDisabled,
            }) },
            React.createElement(Heading, { component: "h3", variant: "subheading2", id: id, className: "prescription-column__title" }, columnTitle),
            sortedParams.map(function (paramName, index, array) {
                var parameter = parameters.find(function (p) { return p.name === paramName; });
                if (!parameter) {
                    return;
                }
                var parameterValue = selectedValues[parameter.name];
                var isParameterValid = showValidation ? validations === null || validations === void 0 ? void 0 : validations[parameter.name] : undefined;
                return (React.createElement(PrescriptionSelect, { key: parameter.name, name: parameter.name, parentId: id, value: !isDisabled ? parameterValue : undefined, isValid: isParameterValid, isDisabled: isDisabled, values: parameter.values, onChange: onAttributeChange, selectClassName: classnames({
                        'prescription-column__select--first': index === 0,
                        'prescription-column__select--last': index === array.length - 1,
                    }) }));
            }))));
};
var PrescriptionColumn$1 = React.memo(PrescriptionColumn);

var PupillaryDistanceLink = function (_a) {
    var className = _a.className, labels = _a.labels;
    var pdLinkLabel = labels.pdLinkLabel;
    if (!pdLinkLabel) {
        return null;
    }
    return (React__default.createElement("p", { className: classnames('pupillary-distance-link', className) },
        React__default.createElement(Icon, { name: "glasses", className: "pupillary-distance-link__icon" }),
        pdLinkLabel));
};

var PupillaryDistanceLinkContainer = function (_a) {
    var className = _a.className;
    var prescriptionType = useSelector(getPrescriptionType);
    var _b = useIntl(), hasLabel = _b.hasLabel, getFormattedLabel = _b.getFormattedLabel;
    var pdLinkLabelKey = CommerceToolsApi.isPrescriptionFile(prescriptionType)
        ? 'products.glasses.prescription.form.pdMeasurementLink'
        : 'products.glasses.prescription.form.pdLink';
    var labels = React__default.useMemo(function () { return ({
        pdLinkLabel: hasLabel(pdLinkLabelKey)
            ? getFormattedLabel(pdLinkLabelKey, {
                parseLink: true,
                openLinksInNewTab: true,
            })
            : '',
    }); }, [hasLabel, getFormattedLabel]);
    return React__default.createElement(PupillaryDistanceLink, { className: className, labels: labels });
};

var PrescriptionForm = function (_a) {
    var idExtension = _a.idExtension, className = _a.className, prescription = _a.prescription, setLeftParameter = _a.setLeftParameter, setRightParameter = _a.setRightParameter, opticalParameters = _a.opticalParameters, prescriptionValidationState = _a.prescriptionValidationState, isSubmitted = _a.isSubmitted, isDisabled = _a.isDisabled, onSubmit = _a.onSubmit, rest = __rest(_a, ["idExtension", "className", "prescription", "setLeftParameter", "setRightParameter", "opticalParameters", "prescriptionValidationState", "isSubmitted", "isDisabled", "onSubmit"]);
    var getLabel = useIntl().getLabel;
    var isPhone = MediaQuery.useIsPhone();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StepForm, { className: classnames('prescription-form', className), "data-t": rest['data-t'], onSubmit: onSubmit },
            React__default.createElement(PrescriptionColumn$1, { className: "prescription-form__column", id: "right-configurator-" + idExtension, columnTitle: getLabel("products.glasses.rightEye"), parameters: opticalParameters, selectedValues: prescription.right, validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.right, showValidation: isSubmitted, onAttributeChange: setRightParameter, isDisabled: isDisabled }),
            isPhone && React__default.createElement(PupillaryDistanceLinkContainer, { className: "prescription-form__pd-link" }),
            React__default.createElement(PrescriptionColumn$1, { className: "prescription-form__column", id: "left-configurator-" + idExtension, columnTitle: getLabel("products.glasses.leftEye"), parameters: opticalParameters, selectedValues: prescription.left, validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.left, showValidation: isSubmitted, onAttributeChange: setLeftParameter, hideSelectLabels: true, isDisabled: isDisabled })),
        React__default.createElement(PupillaryDistanceLinkContainer, { className: "prescription-form__pd-link" })));
};

var PrescriptionFormContainer = function (props) {
    var dispatch = useDispatch();
    var _a = useConfiguratorContext(), goToNextStep = _a.goToNextStep, hasAttemptedNextStep = _a.hasAttemptedNextStep;
    var frame = useSelector(getSelectedFrame);
    var handleChange = React__default.useCallback(function (side) { return function (parameter, value) {
        if (!frame) {
            return;
        }
        dispatch(updatePrescriptionValue({
            side: side,
            frameSku: frame.sku,
            parameter: parameter,
            value: value,
        }));
    }; }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    var prescription = useSelector(getPrescription$2);
    var prescriptionType = useSelector(getPrescriptionType);
    var manualPrescriptionValidationState = useSelector(getManualPrescriptionValidationState);
    var isSubmitted = hasAttemptedNextStep;
    var isEnabled = !prescriptionType || CommerceToolsApi.isNewPrescription(prescriptionType);
    var handleRightChange = React__default.useCallback(handleChange('right'), [handleChange]);
    var handleLeftChange = React__default.useCallback(handleChange('left'), [handleChange]);
    if (!statusSuccess(prescription) || !frame) {
        // Loading / error states are handled further up the tree
        return null;
    }
    var _b = prescription.result, left = _b.left, right = _b.right, parameters = _b.parameters;
    var shouldDisplayValidationError = isSubmitted && isEnabled ? manualPrescriptionValidationState : undefined;
    return (React__default.createElement(PrescriptionForm, { className: "prescription-step__form", opticalParameters: parameters, prescription: { left: left, right: right }, prescriptionValidationState: shouldDisplayValidationError, idExtension: frame.sku, setLeftParameter: handleLeftChange, setRightParameter: handleRightChange, isSubmitted: isSubmitted, isDisabled: !isEnabled, onSubmit: goToNextStep }));
};

var PrescriptionUploadForm = function (_a) {
    var className = _a.className, onSubmit = _a.onSubmit, onStatusChange = _a.onStatusChange, uploadState = _a.uploadState, rest = __rest(_a, ["className", "onSubmit", "onStatusChange", "uploadState"]);
    var getLabel = useIntl().getLabel;
    var uploadLayout = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT)
        ? 'vertical'
        : 'horizontal';
    var handlePDStatusChange = React__default.useCallback(function (status) { return onStatusChange(status, PD_SCOPE); }, [onStatusChange]);
    var handleRXStatusChange = React__default.useCallback(function (status) { return onStatusChange(status, RX_SCOPE); }, [onStatusChange]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StepForm, { className: classnames('prescription-upload-form', className), "data-t": rest['data-t'], onSubmit: onSubmit },
            React__default.createElement(Upload, { variant: uploadLayout, id: "pd-upload", iconName: "upload-pd", title: getLabel('products.glasses.upload.pd.title'), "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID, onStatusChange: handlePDStatusChange, uploadStatus: uploadState[PD_SCOPE], referenceId: PD_SCOPE, scope: PD_SCOPE, className: "prescription-upload-form__uploader" }),
            React__default.createElement(Upload, { variant: uploadLayout, id: "rx-upload", iconName: "upload-prescription", title: getLabel('products.glasses.upload.rx.title'), "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID, onStatusChange: handleRXStatusChange, uploadStatus: uploadState[RX_SCOPE], referenceId: RX_SCOPE, scope: RX_SCOPE, className: "prescription-upload-form__uploader" }))));
};

var PrescriptionUploadFormContainer = function (_a) {
    var className = _a.className;
    var dispatch = useDispatch();
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var frame = useSelector(getSelectedFrame);
    var prescription = useSelector(getPrescription$2);
    var _b = useUpload(), scopes = _b.scopes, setError = _b.setError, configs = _b.configs;
    var _c = useUploadHandler({
        sharedErrorElementId: PRESCRIPTION_STEP_UPLOAD_ERROR_ID,
        configs: scopes.map(function (scope) {
            var _a;
            var ref = statusSuccess(prescription)
                ? (_a = prescription.result.uploadReferences) === null || _a === void 0 ? void 0 : _a[scope]
                : undefined;
            return {
                scope: scope,
                required: true,
                uploadStatus: ref ? Types.uploadStatusSuccess(ref) : undefined,
            };
        }),
    }), lastError = _c.lastError, state = _c.state, handlers = _c.handlers, checkMissingFiles = _c.checkMissingFiles;
    React__default.useEffect(function () {
        var _a, _b;
        if (((_a = configs[RX_SCOPE]) === null || _a === void 0 ? void 0 : _a.status) !== 'success') {
            dispatch(fileUploadResult('upload not possible - rx config'));
        }
        if (((_b = configs[PD_SCOPE]) === null || _b === void 0 ? void 0 : _b.status) !== 'success') {
            dispatch(fileUploadResult('upload not possible - pd config'));
        }
    }, [configs, dispatch]);
    React__default.useEffect(function () {
        setError(lastError);
        // Adding setError in the deps array creates an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastError]);
    var handleNextStepClick = React__default.useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        goToNextStep();
        /**
         * checkMissingFiles only updates the UI.
         * If the form is valid in state and goToNextStep is successful,
         * then it doesn't matter if checkMissingFiles runs or not
         */
        var hasMissing = checkMissingFiles();
        if (hasMissing) {
            var isPDMissing = !Types.isUploadSuccess(state[PD_SCOPE]);
            var isRXMissing = !Types.isUploadSuccess(state[RX_SCOPE]);
            if (isPDMissing && isRXMissing) {
                dispatch(fileUploadResult('files missing'));
            }
            else {
                dispatch(fileUploadResult(isRXMissing ? 'rx missing' : 'pd missing'));
            }
        }
    }, [goToNextStep, checkMissingFiles, state, dispatch]);
    var handleStatusChange = React__default.useCallback(function (callbackStatus, scope) {
        if (!frame)
            return;
        if (Types.isUploadSuccess(callbackStatus)) {
            toast.success('products.glasses.upload.success.message');
            dispatch(fileUploadResult(scope === PD_SCOPE ? 'pd success' : 'rx success'));
            dispatch(updateUploadReference({
                frameSku: frame.sku,
                scope: scope,
                uploadReference: callbackStatus.uploadReference,
            }));
        }
        /**
         * User deleted the file, so we want to remove our reference to it.
         */
        if (Types.isUploadIdleAfterFileRemove(callbackStatus)) {
            dispatch(fileUploadResult(scope === PD_SCOPE ? 'pd remove' : 'rx remove'));
            dispatch(removeUploadReference({
                frameSku: frame.sku,
                scope: scope,
            }));
        }
        /**
         * User tried to overwrite a file, but it failed. Since the user intended to overwrite the
         * existing file and we show in the UI that the upload has failed, we remove the existing file
         * reference we had to not confuse the user. Worst case scenario they re-upload their previous file.
         */
        if (Types.isUploadError(callbackStatus)) {
            dispatch(fileUploadResult(callbackStatus.error));
            dispatch(removeUploadReference({
                frameSku: frame.sku,
                scope: scope,
            }));
        }
        return handlers[scope](callbackStatus);
    }, [frame, handlers, dispatch]);
    if (!statusSuccess(prescription) || !frame) {
        // error states are handled further up the tree
        return null;
    }
    return (React__default.createElement(PrescriptionUploadForm, { className: className, onSubmit: handleNextStepClick, onStatusChange: handleStatusChange, uploadState: state }));
};

var PupillaryDistanceContent = function (_a) {
    var className = _a.className, description = _a.description, image = _a.image;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    return (React__default.createElement("section", { className: classnames('pupillary-distance-content', className) },
        image && (React__default.createElement("img", { className: "pupillary-distance-content__image", src: isSmallScreen ? image.mobileUrl : image.url, alt: image.description || '' })),
        description && (React__default.createElement("div", null,
            React__default.createElement(RichTextArea, { className: "pupillary-distance-content__description", content: description })))));
};

var PrescriptionUploadLayout = function (_a) {
    var _b;
    var _c;
    var className = _a.className;
    var isPhone = MediaQuery.useIsPhone();
    var _d = useIntl(), getLabel = _d.getLabel, getFormattedLabel = _d.getFormattedLabel;
    var configuratorDocument = useRxGlassesConfiguratorContext().configuratorDocument;
    var _e = (_c = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.prescriptionStep) !== null && _c !== void 0 ? _c : {}, description = _e.description, image = _e.image;
    var shouldShowPdContent = !!description || !!image;
    var supportedFilesLabelKey = 'products.glasses.upload.supportedFileTypes';
    var privacyPolicyLabelValue = getFormattedLabel('products.glasses.upload.privacyPolicyLink', {
        parseLink: true,
        openLinksInNewTab: true,
    });
    return (React__default.createElement("div", { className: classnames(className + "__body " + className + "__body--upload", (_b = {},
            _b[className + "__body--upload-content"] = shouldShowPdContent,
            _b)) },
        shouldShowPdContent && (React__default.createElement("div", { className: className + "__section " + className + "__pd-content" },
            React__default.createElement(PupillaryDistanceContent, { description: description, image: image }))),
        isPhone ? (React__default.createElement(React__default.Fragment, null,
            !shouldShowPdContent && (React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(PupillaryDistanceLinkContainer, { className: className + "__pd-link" }))),
            React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(PrescriptionUploadFormContainer, { className: className + "__upload-form" })),
            React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(SupportedFiles, { label: getLabel(supportedFilesLabelKey) })),
            React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(ExtraInfo, { className: className, label: privacyPolicyLabelValue })))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(PrescriptionUploadFormContainer, { className: className + "__upload-form" })),
            React__default.createElement("div", { className: className + "__section " + className + "__extra-info-wrapper" },
                React__default.createElement(ExtraInfo, { className: className, label: privacyPolicyLabelValue })),
            React__default.createElement("div", { className: className + "__section" },
                React__default.createElement(SupportedFiles, { label: getLabel(supportedFilesLabelKey) }),
                !shouldShowPdContent && React__default.createElement(PupillaryDistanceLinkContainer, { className: className + "__pd-link" }))))));
};
function ExtraInfo(_a) {
    var className = _a.className, label = _a.label;
    return (React__default.createElement("p", { className: className + "__extra-info" },
        React__default.createElement(Icon, { name: "info" }),
        React__default.createElement("span", null, label)));
}
function SupportedFiles(_a) {
    var label = _a.label;
    return React__default.createElement("p", { id: PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID }, label);
}

var PrescriptionStep = function (_a) {
    var className = _a.className, errorMessageKey = _a.errorMessageKey, frame = _a.frame, frameImage = _a.frameImage, prescriptionType = _a.prescriptionType, changePrescriptionType = _a.changePrescriptionType, radioItems = _a.radioItems, rest = __rest(_a, ["className", "errorMessageKey", "frame", "frameImage", "prescriptionType", "changePrescriptionType", "radioItems"]);
    var isPhone = MediaQuery.useIsPhone();
    var _b = useIntl(), getLabel = _b.getLabel, hasLabel = _b.hasLabel;
    var isUploadSelected = CommerceToolsApi.isPrescriptionFile(prescriptionType);
    //creates a label like 'products.glasses.newPrescriptionRadio.alert'
    var alertLabelKey = prescriptionType
        ? "products.glasses." + (prescriptionType.charAt(0).toLowerCase() + prescriptionType.substring(1)) + "Radio.alert"
        : '';
    var onRadioChange = React__default.useCallback(function (selected) {
        if (prescriptionType !== selected.value) {
            changePrescriptionType === null || changePrescriptionType === void 0 ? void 0 : changePrescriptionType(selected.value);
        }
    }, [changePrescriptionType, prescriptionType]);
    var alertRef = React__default.createRef();
    React__default.useEffect(function () {
        var _a, _b;
        if ('scrollBehavior' in document.documentElement.style) {
            (_a = alertRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        else {
            (_b = alertRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
        }
    }, [errorMessageKey]);
    return (React__default.createElement(StepWrapper, { className: classnames('prescription-step', className), "data-t": rest['data-t'] || 'prescription-step' },
        React__default.createElement(ConfiguratorStepTitleAndDescription, null),
        React__default.createElement(RadioButtons, { alignment: isPhone ? 'vertical' : 'horizontal', items: radioItems, scope: "prescription-type", onChange: onRadioChange, initialValue: prescriptionType !== null && prescriptionType !== void 0 ? prescriptionType : '', className: "prescription-step__radios" }),
        hasLabel(alertLabelKey) && (React__default.createElement(Alert, { type: "info", icon: "information-circle", title: getLabel(alertLabelKey), className: "prescription-step__alert" })),
        errorMessageKey && (React__default.createElement("div", { ref: alertRef },
            React__default.createElement(Alert, { id: isUploadSelected ? PRESCRIPTION_STEP_UPLOAD_ERROR_ID : undefined, type: "error", icon: "alert-circle", title: getLabel(errorMessageKey), className: "prescription-step__alert", notifyScreenReader: true }))),
        isUploadSelected ? (React__default.createElement(PrescriptionUploadLayout, { className: "prescription-step" })) : (React__default.createElement("div", { className: "prescription-step__body" },
            !isPhone && frameImage && (React__default.createElement("div", { className: "prescription-step__section prescription-step__image-wrapper" },
                React__default.createElement("img", { src: frameImage.url, alt: frame.title, className: "prescription-step__image" }))),
            React__default.createElement("div", { className: "prescription-step__section prescription-step__prescription-form" },
                React__default.createElement(PrescriptionFormContainer, null))))));
};

var BASIC_VALIDATION_MESSAGE = 'products.glasses.prescription.form.validationError';
var PrescriptionStepContainer = function () {
    var staticsUrl = useProductDetailContext().staticsUrl;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var hasAttemptedNextStep = useConfiguratorContext().hasAttemptedNextStep;
    var _a = useRadioItems([RX_SCOPE, PD_SCOPE]), isWaiting = _a.isWaiting, radioItems = _a.radioItems;
    var _b = __read(React__default.useState(null), 2), errorMessageKey = _b[0], setErrorMessageKey = _b[1];
    var dispatch = useDispatch();
    var frame = useSelector(getSelectedFrame);
    var frameImage = useSelector(function (s) {
        return getFrameImage(s, { width: 590, staticsUrl: staticsUrl, isBynderImagesEnabled: isBynderImagesEnabled });
    });
    var prescription = useSelector(getPrescription$2);
    var prescriptionType = useSelector(getPrescriptionType);
    var isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    var uploadError = useUpload().error;
    var handlePrescriptionTypeChange = React__default.useCallback(function (value) {
        if (!frame) {
            return;
        }
        if (CommerceToolsApi.isPrescriptionType(value)) {
            dispatch(updatePrescriptionType({
                frameSku: frame.sku,
                prescriptionType: value,
                reason: 'user selection',
            }));
        }
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    /**
     * Check if the selected radio from state is still a possible option to show
     */
    React__default.useEffect(function () {
        // checking if prescriptionType exists in options
        if (radioItems.length && !radioItems.some(function (_a) {
            var value = _a.value;
            return value === prescriptionType;
        })) {
            // reset selected item to first one
            handlePrescriptionTypeChange(radioItems[0].value);
        }
    }, [prescriptionType, radioItems]);
    /**
     * Determine what error to show, if any
     */
    React__default.useEffect(function () {
        if (isPrescriptionStepValid) {
            setErrorMessageKey(null);
            return;
        }
        // If the user hits "Next Step" without selecting a prescription Type
        if (hasAttemptedNextStep && !prescriptionType) {
            setErrorMessageKey(BASIC_VALIDATION_MESSAGE);
            return;
        }
        // If Manual prescription form is invalid
        if (hasAttemptedNextStep && CommerceToolsApi.isNewPrescription(prescriptionType)) {
            setErrorMessageKey(BASIC_VALIDATION_MESSAGE);
            return;
        }
        // If Prescription Upload is selected and invalid
        if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
            setErrorMessageKey(uploadError);
            return;
        }
        setErrorMessageKey(null);
    }, [
        prescriptionType,
        setErrorMessageKey,
        uploadError,
        hasAttemptedNextStep,
        isPrescriptionStepValid,
    ]);
    if (isWaiting || !prescription || statusUninit(prescription) || statusLoading(prescription)) {
        return React__default.createElement(Loading, null);
    }
    if (!frame || statusWarning(prescription) || statusFailed(prescription)) {
        return React__default.createElement(Failed, null);
    }
    return (React__default.createElement(PrescriptionStep, { errorMessageKey: errorMessageKey, frame: frame, frameImage: frameImage, prescriptionType: prescriptionType, changePrescriptionType: handlePrescriptionTypeChange, radioItems: radioItems }));
};
function Loading() {
    return React__default.createElement(LoaderScreen, null);
}
function Failed() {
    var getLabel = useIntl().getLabel;
    return (React__default.createElement(Alert, { type: "error", title: getLabel('products.glasses.configurator.error'), className: "prescription-step__error" }));
}

var prescriptionStepBase = {
    onNext: onNext$1,
    view: PrescriptionStepContainer,
};
function onNext$1() {
    var prescriptionType, isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getPrescriptionType)
                // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
            ];
            case 1:
                prescriptionType = _a.sent();
                // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
                if (!prescriptionType) {
                    return [2 /*return*/, new Error("Prescription type is not defined")];
                }
                // Only validate prescription if user fills in their prescription manually or with a file upload.
                if (!CommerceToolsApi.isNewPrescription(prescriptionType) &&
                    !CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsPrescriptionStepValid)];
            case 2:
                isValid = _a.sent();
                if (!isValid) {
                    return [2 /*return*/, new Error("Need valid prescription data for unknown customer")];
                }
                return [2 /*return*/];
        }
    });
}

var PrescriptionStepValidationStep = function (_a) {
    var className = _a.className, prescriptionInfoFormState = _a.prescriptionInfoFormState, showValidationError = _a.showValidationError, verificationAllowed = _a.verificationAllowed, onVerificationAllowedChange = _a.onVerificationAllowedChange, onChange = _a.onChange, onSubmit = _a.onSubmit;
    var getLabel = useIntl().getLabel;
    var placeholderLabels = {
        dayPlaceholder: getLabel('common.placeholder.day.abbr'),
        monthPlaceholder: getLabel('common.placeholder.month.abbr'),
        yearPlaceholder: getLabel('common.placeholder.year.abbr'),
    };
    var verificationCheckbox = React__default.useMemo(function () { return ({
        label: getLabel('products.glasses.validationStep.verificationAllowed.checkbox'),
        value: 'verificationAllowed',
    }); }, [getLabel]);
    var handleFormChange = React__default.useCallback(debounce(250, function (state) {
        onChange === null || onChange === void 0 ? void 0 : onChange(state.formState);
    }), [onChange]);
    var handleConsentChange = React__default.useCallback(function (selectedItems) {
        onVerificationAllowedChange === null || onVerificationAllowedChange === void 0 ? void 0 : onVerificationAllowedChange(!!selectedItems.includes(verificationCheckbox));
    }, [onVerificationAllowedChange]);
    var opticianForm = useRxGlassesConfiguratorContext().opticianForm;
    var currentYear = new Date().getFullYear();
    return (React__default.createElement(StepWrapper, { className: classnames('prescription-validation-step', className), "data-t": "prescription-validation-step" },
        React__default.createElement(ConfiguratorStepTitleAndDescription, null),
        showValidationError && (React__default.createElement(Alert, { type: "error", icon: "alert-circle", title: getLabel('products.glasses.validationStep.form.validationError'), className: "prescription-validation-step__alert" })),
        React__default.createElement(ConnectedStepForm, { className: "prescription-validation-step__form", initialFormState: prescriptionInfoFormState, onChange: handleFormChange, onSubmit: onSubmit },
            React__default.createElement(DateOfBirthSelect, __assign$1({ required: true, name: "expiryDate", label: getLabel('products.glasses.validationStep.expiryDate'), errorMessage: getLabel('products.glasses.validationStep.expiryDate.errorMessage'), validations: [Util.validations.isDate], tooltipLabel: getLabel('products.glasses.validationStep.expiryDate.tooltip'), minYear: currentYear, maxYear: currentYear + 3 }, placeholderLabels)),
            React__default.createElement(DateOfBirthSelect, __assign$1({ name: "examDate", label: getLabel('products.glasses.validationStep.examDate'), errorMessage: getLabel('products.glasses.validationStep.examDate.errorMessage'), tooltipLabel: getLabel('products.glasses.validationStep.examDate.tooltip'), validations: [Util.validations.isDate], minYear: currentYear - 4 }, placeholderLabels)),
            opticianForm && opticianForm(),
            React__default.createElement(CheckboxList, { idPrefix: "prescription_validation__", items: [verificationCheckbox], selectedItems: verificationAllowed ? [verificationCheckbox] : [], onChange: handleConsentChange, getItemIdentifier: function (item) { return item.value; }, renderItem: function (item) { return item.label; } }))));
};

var PrescriptionValidationStepContainer = function () {
    var dispatch = useDispatch();
    var _a = useConfiguratorContext(), goToNextStep = _a.goToNextStep, hasAttemptedNextStep = _a.hasAttemptedNextStep;
    var frameSku = useSelector(getFrameSku);
    var prescriptionInfoFormState = useSelector(getAdditionalPrescriptionInfoFormState);
    var isVerificationAllowed = useSelector(getVerificationAllowed);
    var handleChange = React__default.useCallback(function (formState) {
        if (!frameSku) {
            return;
        }
        dispatch(updatePrescriptionInfo({
            frameSku: frameSku,
            value: formState,
        }));
    }, [frameSku, dispatch]);
    var handleIsVerificationAllowedChange = React__default.useCallback(function (verificationAllowed) {
        if (!frameSku) {
            return;
        }
        dispatch(updateVerificationAllowed({
            frameSku: frameSku,
            value: verificationAllowed,
        }));
    }, [frameSku, dispatch]);
    return (React__default.createElement(PrescriptionStepValidationStep, { prescriptionInfoFormState: prescriptionInfoFormState, verificationAllowed: isVerificationAllowed, onVerificationAllowedChange: handleIsVerificationAllowedChange, showValidationError: hasAttemptedNextStep, onChange: handleChange, onSubmit: goToNextStep }));
};

var prescriptionValidationStepBase = {
    onNext: onNext,
    stepStatus: function (s) {
        /**
         * Page should only show when the customer chose to enter their prescription manually via our form ("NewPrescription").
         */
        var isStepEnabled = getIsExtraValidationStepEnabled(s);
        var prescriptionType = getPrescriptionType(s);
        var isNewPrescription = CommerceToolsApi.isNewPrescription(prescriptionType);
        if (!isStepEnabled) {
            return 'hidden';
        }
        return isNewPrescription ? 'active' : 'skip';
    },
    view: PrescriptionValidationStepContainer,
};
function onNext() {
    var isVerificationAllowed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getVerificationAllowed)];
            case 1:
                isVerificationAllowed = _a.sent();
                return [2 /*return*/, !isVerificationAllowed];
        }
    });
}

var stepsMap$2 = {
    lensType: __assign$1(__assign$1({}, lensTypeStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.glasses.configurator.step.lensType',
            title: 'products.glasses.lensType.title',
            description: 'products.glasses.lensType.description',
        } }),
    prescription: __assign$1(__assign$1({}, prescriptionStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.glasses.configurator.step.prescription',
            title: 'products.glasses.prescription.title',
            description: 'products.glasses.prescription.description',
        } }),
    prescriptionValidation: __assign$1(__assign$1({}, prescriptionValidationStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.glasses.configurator.step.prescriptionValidation',
            title: 'products.glasses.validationStep.title',
            description: 'products.glasses.validationStep.description',
        } }),
    lensPackage: __assign$1(__assign$1({}, lensPackageStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.glasses.configurator.step.lensPackage',
            title: 'products.glasses.lensPackage.title',
            description: 'products.glasses.lensPackage.description',
        } }),
    lensAddOn: __assign$1(__assign$1({}, lensAddOnStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.glasses.configurator.step.lensAddOn',
            title: 'products.glasses.lensAddOn.title',
            description: 'products.glasses.lensAddOn.description',
        } }),
};

var stepsMap$1 = {
    lensType: __assign$1(__assign$1({}, lensTypeStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.rxsun.configurator.step.lensType',
            title: 'products.rxsun.lensType.title',
            description: 'products.rxsun.lensType.description',
        } }),
    prescription: __assign$1(__assign$1({}, prescriptionStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.rxsun.configurator.step.prescription',
            title: 'products.rxsun.prescription.title',
            description: 'products.rxsun.prescription.description',
        } }),
    prescriptionValidation: __assign$1(__assign$1({}, prescriptionValidationStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.rxsun.configurator.step.prescriptionValidation',
            title: 'products.rxsun.validationStep.title',
            description: 'products.rxsun.validationStep.description',
        } }),
    lensPackage: __assign$1(__assign$1({}, lensPackageStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.rxsun.configurator.step.lensPackage',
            title: 'products.rxsun.lensPackage.title',
            description: 'products.rxsun.lensPackage.description',
        } }),
    lensAddOn: __assign$1(__assign$1({}, lensAddOnStepBase), { labelKeys: {
            stepIndicatorTitle: 'products.rxsun.configurator.step.lensAddOn',
            title: 'products.rxsun.lensAddOn.title',
            description: 'products.rxsun.lensAddOn.description',
        } }),
};

var FrameInformation = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, _b = _a.showImage, showImage = _b === void 0 ? true : _b, _c = _a.textOrientation, textOrientation = _c === void 0 ? 'vertical' : _c;
    return (React.createElement("div", { "data-t": "frame-information", className: "frame-information frame-information--" + textOrientation },
        showImage && imageUrl && (React.createElement("img", { src: imageUrl, alt: title + " " + subtitle, className: "frame-information__image" })),
        React.createElement("div", { className: "frame-information__text" },
            React.createElement(Heading, { variant: "subheading1", component: "h2", className: "frame-information__title" }, title),
            React.createElement("span", { className: "frame-information__subtitle" }, subtitle))));
};

var FrameInformationContainer = function (props) {
    var staticsUrl = useProductDetailContext().staticsUrl;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var frame = useSelector(getSelectedFrame);
    var image = useSelector(function (s) {
        return getFrameImage(s, { width: 100, staticsUrl: staticsUrl, isBynderImagesEnabled: isBynderImagesEnabled });
    });
    if (!frame) {
        return null;
    }
    return (React.createElement(FrameInformation, __assign$1({}, props, { title: frame.brand, subtitle: frame.code, imageUrl: image === null || image === void 0 ? void 0 : image.url })));
};

var ConfigurationSummaryDivider = function (_a) {
    var isSmallScreen = _a.isSmallScreen, className = _a.className;
    return (React.createElement("div", { className: classnames('configuration-summary-divider', className) }, isSmallScreen ? (React.createElement(Line, null)) : (React.createElement(React.Fragment, null,
        React.createElement(Line, null),
        React.createElement(Line, null),
        React.createElement(Line, null)))));
};
var Line = function () { return React.createElement(Hr, { className: "configuration-summary-divider__line" }); };

var ConfigurationSummaryRow = function (_a) {
    var label = _a.label, value = _a.value, price = _a.price, discountText = _a.discountText;
    return (React.createElement("div", { className: "configuration-summary-row", "data-t": "configuration-summary-row" },
        React.createElement("div", null,
            React.createElement("strong", { className: "configuration-summary-row__label" }, label || ''),
            React.createElement("span", { className: "configuration-summary-row__value" }, value || '')),
        typeof (price === null || price === void 0 ? void 0 : price.originalPrice) !== 'undefined' && (React.createElement(PriceTagOrIncluded, __assign$1({}, price, { discountText: discountText })))));
};

var ConfigurationSummary = function (_a) {
    var labels = _a.labels, frame = _a.frame, addOn = _a.addOn, lensType = _a.lensType, lensPackage = _a.lensPackage, bundlePrice = _a.bundlePrice, isPhone = _a.isPhone, isSmallScreen = _a.isSmallScreen, hasVisitedStepLensPackage = _a.hasVisitedStepLensPackage, hasVisitedStepAddOn = _a.hasVisitedStepAddOn;
    return (React.createElement(React.Fragment, null,
        frame && (React.createElement(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: React.createElement(FrameInformationContainer, { showImage: isPhone, textOrientation: isPhone ? 'vertical' : 'horizontal' }), price: frame.price })),
        React.createElement("div", { className: "glasses-configuration-summary", "data-t": "configuration-summary" },
            lensType && (React.createElement(React.Fragment, null,
                React.createElement(ConfigurationSummaryDivider, { isSmallScreen: isSmallScreen }),
                React.createElement(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.lensType, value: getBundleProductTitle(lensType), price: lensType.price, discountText: lensType.discountText }))),
            hasVisitedStepLensPackage && lensPackage && (React.createElement(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.lensPackage, value: lensPackage.title, price: lensPackage.price, discountText: lensPackage.discountText })),
            hasVisitedStepAddOn && addOn && (React.createElement(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.addOn, value: getBundleProductTitle(addOn), price: addOn.price, discountText: addOn.discountText })),
            React.createElement(ConfigurationSummaryDivider, { isSmallScreen: isSmallScreen }),
            React.createElement(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.totalPrice, price: bundlePrice, priceSize: "medium" }))));
};

var ConfigurationSummaryContainer = function () {
    var getLabel = useIntl().getLabel;
    var isPhone = MediaQuery.useIsPhone();
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var id = useRxGlassesConfiguratorContext().id;
    var hasVisitedStepLensPackage$1 = useSelector(function (s) {
        return hasVisitedStepLensPackage(s, { id: id });
    });
    var hasVisitedStepAddOn$1 = useSelector(function (s) {
        return hasVisitedStepAddOn(s, { id: id });
    });
    var frame = useSelector(getSelectedFrame);
    var lensType = useSelector(getSelectedLensType);
    var lensPackage = useSelector(getSelectedPackage);
    var addOn = useSelector(getSelectedAddOn);
    var bundlePrice = useSelector(function (s) { return getBundlePrice(s, { id: id }); });
    var labels = React.useMemo(function () { return ({
        lensType: getLabel('products.glasses.configurator.lensType'),
        lensPackage: getLabel('products.glasses.configurator.lensPackage'),
        addOn: getLabel('products.glasses.configurator.addOn'),
        totalPrice: getLabel('products.glasses.configurator.totalPrice'),
        zeroPrice: getLabel('products.glasses.configurator.priceIsZero'),
    }); }, [getLabel]);
    return (React.createElement(ConfigurationSummary, { frame: frame, lensType: lensType, lensPackage: lensPackage, addOn: addOn, bundlePrice: bundlePrice, labels: labels, isPhone: isPhone, isSmallScreen: isSmallScreen, hasVisitedStepLensPackage: hasVisitedStepLensPackage$1, hasVisitedStepAddOn: hasVisitedStepAddOn$1 }));
};

var SummaryTitle = function (_a) {
    var children = _a.children;
    return (React.createElement("strong", { className: "glasses-configurator-footer-prescription-column__title" }, children));
};

var Wrapper = function (_a) {
    var children = _a.children, title = _a.title;
    return (React.createElement("div", { className: "glasses-configurator-footer-prescription-column" },
        React.createElement(SummaryTitle, null, title),
        children));
};
var PrescriptionSummaryColumn = function (_a) {
    var title = _a.title, labels = _a.labels, parameters = _a.parameters, fields = _a.fields, prescriptionType = _a.prescriptionType;
    var sortedParameterNames = sortPrescriptionParameters((parameters || []).map(function (p) { return p.name; }));
    if (CommerceToolsApi.isNewPrescription(prescriptionType) && fields && parameters) {
        return (React.createElement(Wrapper, { title: title },
            React.createElement("ol", { className: "glasses-configurator-footer-prescription-column__fields" }, sortedParameterNames.map(function (name) {
                return isNumber(fields[name]) ? (React.createElement(PrescriptionColumnRow, { key: name, name: name, label: labels[name], value: fields[name] })) : null;
            }))));
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return (React.createElement(Wrapper, { title: title },
            React.createElement(Text, { variant: "body" }, labels.existingCustomer)));
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return (React.createElement(Wrapper, { title: title },
            React.createElement(Text, { variant: "body" }, labels.emailPrescription)));
    }
    return null;
};
var PrescriptionColumnRow = function (_a) {
    var _b;
    var label = _a.label, name = _a.name, value = _a.value;
    return (React.createElement("li", { className: "glasses-configurator-footer-prescription-column__row" },
        React.createElement("span", { className: "glasses-configurator-footer-prescription-column__label" }, label + " "),
        React.createElement("strong", { className: "glasses-configurator-footer-prescription-column__value" }, (_b = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && _b !== void 0 ? _b : '')));
};

var PrescriptionSummary = function (_a) {
    var parameters = _a.parameters, right = _a.right, left = _a.left, labels = _a.labels, prescriptionType = _a.prescriptionType;
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        return (React.createElement("div", { className: "glasses-configurator-footer-prescription", "data-t": "prescription-summary" },
            Object.keys(right).length > 0 && (React.createElement(PrescriptionSummaryColumn, { title: labels.rightEye, fields: right, parameters: parameters, prescriptionType: prescriptionType, labels: labels })),
            Object.keys(left).length > 0 && (React.createElement(PrescriptionSummaryColumn, { title: labels.leftEye, fields: left, parameters: parameters, prescriptionType: prescriptionType, labels: labels }))));
    }
    return (React.createElement("div", { className: "glasses-configurator-footer-prescription", "data-t": "prescription-summary" }, !CommerceToolsApi.isNewPrescription(prescriptionType) && (React.createElement(PrescriptionSummaryColumn, { title: labels.prescriptionTitle, labels: labels, prescriptionType: prescriptionType }))));
};

var PrescriptionSummaryContainer = function () {
    var getLabel = useIntl().getLabel;
    var id = useRxGlassesConfiguratorContext().id;
    var prescription = useSelector(getPrescription$2);
    var hasVisitedStepPrescription$1 = useSelector(function (s) {
        return hasVisitedStepPrescription(s, { id: id });
    });
    var prescriptionType = useSelector(getPrescriptionType);
    var labels = React.useMemo(function () {
        if (!statusSuccess(prescription)) {
            return {};
        }
        var parameters = prescription.result.parameters;
        var paramLabels = parameters.reduce(function (acc, _a) {
            var _b;
            var name = _a.name;
            return (__assign$1(__assign$1({}, acc), (_b = {}, _b[name] = getLabel("products.glasses.prescription." + name), _b)));
        }, {});
        return __assign$1(__assign$1({}, paramLabels), { rightEye: getLabel('products.glasses.rightEye'), leftEye: getLabel('products.glasses.leftEye'), prescriptionTitle: getLabel('products.glasses.configurator.footer.prescription.title'), existingCustomer: getLabel('products.glasses.configurator.footer.existingCustomer'), emailPrescription: getLabel('products.glasses.configurator.footer.emailPrescription') });
    }, [getLabel, prescription]);
    if (!hasVisitedStepPrescription$1) {
        return null;
    }
    if (statusFailed(prescription)) {
        return React.createElement("p", null, getLabel('products.glasses.prescription.loadingFailed'));
    }
    if (statusLoading(prescription)) {
        return React.createElement(Loader, null);
    }
    if (!statusSuccess(prescription)) {
        return null;
    }
    var _a = prescription.result, right = _a.right, left = _a.left, parameters = _a.parameters, uploadReferences = _a.uploadReferences;
    return (React.createElement(PrescriptionSummary, { prescriptionType: prescriptionType, parameters: parameters, right: right, left: left, labels: labels, uploadReferences: uploadReferences }));
};

var PrescriptionUploadSummary = function (_a) {
    var title = _a.title, uploadReferences = _a.uploadReferences;
    var filteredUploadedFileNames = Object.values(uploadReferences).reduce(function (m, ref) { return (!ref ? m : __spreadArray$1(__spreadArray$1([], __read(m)), [ref.fileName])); }, []);
    return (React__default.createElement("section", { className: "prescription-upload-summary" },
        React__default.createElement(SummaryTitle, null, title),
        React__default.createElement(ConfigurationSummaryDivider, { isSmallScreen: true, className: "prescription-upload-summary__divider" }),
        React__default.createElement(FilesList, { items: filteredUploadedFileNames }),
        React__default.createElement(ConfigurationSummaryDivider, { isSmallScreen: true, className: "prescription-upload-summary__divider--bottom" })));
};

var PrescriptionUploadSummaryContainer = function () {
    var getLabel = useIntl().getLabel;
    var prescription = useSelector(getPrescription$2);
    if (!statusSuccess(prescription) || !prescription.result.uploadReferences) {
        return null;
    }
    return (React__default.createElement(PrescriptionUploadSummary, { title: getLabel('products.glasses.configurator.footer.prescription.title'), uploadReferences: prescription.result.uploadReferences }));
};

var RxGlassesExpanderContent = function (_a) {
    var prescriptionType = _a.prescriptionType;
    return (React.createElement("div", { className: "rxglasses-expander-content" },
        React.createElement("div", { className: "rxglasses-expander-content__summary" },
            React.createElement(ConfigurationSummaryContainer, null)),
        React.createElement("div", { className: "rxglasses-expander-content__prescription" }, CommerceToolsApi.isPrescriptionFile(prescriptionType) ? (React.createElement(PrescriptionUploadSummaryContainer, null)) : (React.createElement(PrescriptionSummaryContainer, null)))));
};

var RxGlassesExpanderContentContainer = function () {
    var prescriptionType = useSelector(getPrescriptionType);
    return React.createElement(RxGlassesExpanderContent, { prescriptionType: prescriptionType });
};

var ConfigurationTotalPrice = function (_a) {
    var originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice, rest = __rest(_a, ["originalPrice", "discountedPrice"]);
    return (React.createElement("div", { className: "configuration-total-price-wrapper" },
        discountedPrice && discountedPrice !== originalPrice && (React.createElement(Price, __assign$1({}, rest, { type: "strikethrough", value: originalPrice, className: "configuration-total-price" }))),
        React.createElement(Price, __assign$1({}, rest, { value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : originalPrice, className: "configuration-total-price", type: discountedPrice ? 'discount' : 'default' }))));
};

var ConfigurationTotalPriceContainer$1 = function () {
    var id = useRxGlassesConfiguratorContext().id;
    var isPhone = MediaQuery.useIsPhone();
    var bundlePrice = useSelector(function (s) { return getBundlePrice(s, { id: id }); });
    if (!bundlePrice || !bundlePrice.originalPrice) {
        return null;
    }
    return React.createElement(ConfigurationTotalPrice, __assign$1({ centAmount: true, size: isPhone ? 'small' : 'large' }, bundlePrice));
};

var RxGlassesTopBar = function () {
    var isPhone = MediaQuery.useIsPhone();
    return (React.createElement("div", { className: "rxglasses-topbar" },
        !isPhone && React.createElement(FrameInformationContainer, null),
        React.createElement(ConfigurationTotalPriceContainer$1, null)));
};

var useConfiguratorStepSubmit = function (configuratorNamespace) {
    var dispatch = useDispatch();
    var lineItemToBeAdded = useSelector(getAddToCartLineItem);
    var _a = useProductDetailContext(), useAddToCart = _a.useAddToCart, setIsAddToCartNotificationShown = _a.setIsAddToCartNotificationShown;
    var onAddToCartSuccess = React__default.useCallback(function () {
        dispatch(addSuccess());
        setIsAddToCartNotificationShown(true);
    }, [dispatch, setIsAddToCartNotificationShown]);
    var onValidationError = React__default.useCallback(function (validationCodes) {
        dispatch(addFailed(new Error("Add to cart failed with following validation errors: " + validationCodes.join(', '))));
        validationCodes.forEach(function (code) { return toast.failed("cart." + code); });
    }, [dispatch]);
    var onError = React__default.useCallback(function (errorCode) {
        dispatch(addFailed(new Error("Add to cart failed with following error code: " + errorCode)));
        toast.failed("cart." + errorCode);
    }, [dispatch]);
    /**
     * Officially we are conditionally calling a hook here. In this case it's not an issue, as the hook
     * will either always be there or always be undefined. There won't be a difference between renders.
     * We're either always calling it, or always ignoring it, depending on whether CARTS_V2 is enabled.
     */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _b = __read(useAddToCart ? useAddToCart() : [undefined], 2), addToCart = _b[0], addToCartResult = _b[1];
    // This makes sure the loading state resets when the addToCart call fails
    React__default.useEffect(function () {
        if (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) {
            dispatch(addFailed(addToCartResult.error));
        }
        // Being a bit cautious about showing errors. We only dispatch error when error flips from `undefined` to error`
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeof (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) !== 'undefined']);
    useSaga(React__default.useMemo(function () {
        return function () {
            var _a, failure;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        return [4 /*yield*/, race([
                                take([
                                    addToCartFailed$1.type,
                                    addFailed.type,
                                ]),
                                take([
                                    addSuccess.type,
                                    addToCartSuccess$1.type,
                                ]),
                            ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 1]), failure = _a[0];
                        if (!failure) return [3 /*break*/, 3];
                        return [4 /*yield*/, put(Actions.finishFailed({
                                id: configuratorNamespace,
                                reason: new Error(failure.error.message),
                            }))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 0];
                    case 3: return [4 /*yield*/, put(Actions.finishSuccess({ id: configuratorNamespace }))];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 0];
                    case 5: return [2 /*return*/];
                }
            });
        };
    }, [configuratorNamespace]));
    return React__default.useCallback(function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (addToCart) {
            // if addToCart is defined, then use the carts-v2 method for adding to cart
            var draftLineItems = lineItemToBeAdded ? [lineItemToBeAdded] : [];
            dispatch(add());
            addToCart(draftLineItems, onAddToCartSuccess, onValidationError, onError);
        }
        else {
            // if addToCart is not defined, add to cart with the carts-v1 method
            dispatch(addToCart$1());
        }
    }, [addToCart, lineItemToBeAdded, dispatch, onAddToCartSuccess, onValidationError, onError]);
};

var scopes = [RX_SCOPE, PD_SCOPE];
var contentProps$1 = {
    footerTopBarContent: React.createElement(RxGlassesTopBar, null),
    footerExpanderContent: React.createElement(RxGlassesExpanderContentContainer, null),
};
var RxGlassesConfigurator = function (props) {
    var bundlePrice = useSelector(function (s) {
        return getBundlePrice(s, { id: props.id });
    });
    var prescriptionTypes = usePrescriptionTypes();
    var shouldCheckUploadConfig = prescriptionTypes.includes('PrescriptionFile');
    var variation = useExperiment('rx_configuration_sequence_experiment', usePersistentRandomId('ab_testing')).variation;
    React.useEffect(function () {
        bundlePrice && props.onPriceChange(bundlePrice);
    }, [bundlePrice, props.onPriceChange]);
    useSaga(React.useMemo(function () {
        return function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        return [4 /*yield*/, take(function (a) { return actions$1.isType(a, Actions.finishSuccess) && a.payload.id === props.id; })];
                    case 1:
                        _b.sent();
                        if (!props.onModalClose) return [3 /*break*/, 3];
                        return [4 /*yield*/, call(props.onModalClose)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!((_a = props.triggerButtonRef) === null || _a === void 0 ? void 0 : _a.current)) return [3 /*break*/, 5];
                        return [4 /*yield*/, call([props.triggerButtonRef.current, 'focus'])];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        };
    }, [props.onModalClose, props.triggerButtonRef]));
    useSaga(React.useMemo(function () {
        return function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [5 /*yield**/, __values(listenForConfigurationChanges$1(props.id))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        };
    }, [props.id]));
    var finishHandler = useConfiguratorStepSubmit(props.id);
    /**
     * If the configurator isn't open, the contents of this entire component don't need to be rendered.
     */
    if (!props.isOpen) {
        return null;
    }
    var isRxSun = props.id === 'rxSun';
    var resolvedStepSequence = isRxSun ? stepSequence$1 : stepSequence$1;
    if (variation === 'on') {
        resolvedStepSequence = isRxSun ? stepSequenceAlternative : stepSequenceAlternative;
    }
    var resolvedStepsMap = isRxSun ? stepsMap$1 : stepsMap$2;
    return (React.createElement(RxGlassesConfiguratorProvider, { frame: props.frame, frameSku: props.frameSku, formatProductUrl: props.formatProductUrl, opticianForm: props.opticianForm, configuratorDocument: props.configuratorDocument, id: props.id },
        React.createElement(UploadProvider, { scopes: scopes, shouldFetchConfigs: shouldCheckUploadConfig },
            React.createElement(Configurator, __assign$1({ id: props.id, "data-t": "glasses-configurator-modal", stepSequence: resolvedStepSequence, stepsMap: resolvedStepsMap, lastStepCTALabelKey: "products.glasses.configurator.addToCart", isOpen: props.isOpen, onModalClose: props.onModalClose, onFinish: finishHandler }, contentProps$1)))));
};

var ProductDetailDescription = function (_a) {
    var children = _a.children, description = _a.description, header = _a.header, title = _a.title, usps = _a.usps;
    return (React.createElement("section", { className: "product-detail-description", "aria-label": title },
        title && (React.createElement(Heading, { variant: "smallest", component: "h2" }, title)),
        usps,
        header && (React.createElement(Heading, { variant: "subheading1", className: "product-detail-description__subheading", component: "h3" }, header)),
        description && React.createElement(Text, { variant: "body" }, description),
        children));
};

var ProductDetailOpticsFeatures = function (_a) {
    var frame = _a.frame, antiReflex = _a.antiReflex, antiScratch = _a.antiScratch;
    return (React.createElement("ul", { className: "product-detail-optics-features" },
        !!frame && (React.createElement("li", { className: "product-detail-optics-features__feature" },
            React.createElement(Icon, { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            frame)),
        !!antiReflex && (React.createElement("li", { className: "product-detail-optics-features__feature" },
            React.createElement(Icon, { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            antiReflex)),
        antiScratch && (React.createElement("li", { className: "product-detail-optics-features__feature" },
            React.createElement(Icon, { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            antiScratch))));
};

var getAttributeFactory = function (_a) {
    var _b = _a.isLocalised, isLocalised = _b === void 0 ? false : _b;
    if (!isLocalised) {
        return getAttrValue;
    }
    return getJoinedLocalizedAttrValues;
};
/**
 *
 * Helper for converting specification data to a string format
 *
 * if a value is an array, that value has to be converted to a string of those values. ('blue'. 'red')
 * if a value is a boolean, that value has to be converted to ('yes'/'no')
 * if a value is a number, that value has to be converted to a string of that number. (preventing things like 8.5e10)
 *
 */
var getSpecificationItem = function (config, variant, getLabel, locale) {
    var getAttribute = getAttributeFactory(config);
    var attr = getAttribute(variant, config.attribute, locale);
    if (isNil(attr) || attr === '') {
        return;
    }
    var value = attr;
    if (isBoolean(attr)) {
        value = attr ? getLabel('common.yes') : getLabel('common.no');
    }
    if (isNumber(attr)) {
        value = attr.toString();
    }
    // Final check for when something unexpected happend
    if (!isString(value)) {
        console.warn("Could not render " + config.labelKey + " because the received value is a " + typeof attr + " while expecting a string");
        return;
    }
    return {
        label: getLabel(config.labelKey),
        value: value,
    };
};

var SpecificationItem = function (_a) {
    var config = _a.config, variant = _a.variant;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var item = getSpecificationItem(config, variant, getLabel, locale);
    if (!item) {
        return null;
    }
    return (React.createElement("div", { className: "product-detail-specification__item", "data-t": "specification-item", role: "presentation" },
        React.createElement("dt", { className: "product-detail-specification__item--label" }, item.label),
        React.createElement("dd", { className: "product-detail-specification__item--value" }, item.value)));
};
var SpecificationItem$1 = React.memo(SpecificationItem);

var ProductDetailSpecification = function (_a) {
    var configuration = _a.configuration, variant = _a.variant;
    var getLabel = useIntl().getLabel;
    var title = getLabel('products.detail.specifications.title');
    if (!configuration || !variant) {
        return null;
    }
    var items = configuration.map(function (config) { return (React.createElement(SpecificationItem$1, { config: config, variant: variant, key: config.labelKey })); });
    if (!items.length) {
        return null;
    }
    return (React.createElement("section", { className: "product-detail-specification", "data-t": "product-detail-specification" },
        React.createElement(Heading, { variant: "smallest", className: "product-detail-specification__title" }, title),
        React.createElement("dl", { className: "product-detail-specification__list" }, items)));
};

var ProductDetailTitle = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, href = _a.href;
    return (React.createElement("div", { className: "product-detail-title" },
        !!href ? (React.createElement("a", { href: href, className: "product-detail-title__link" },
            React.createElement("span", { className: "product-detail-title__subtitle" }, subtitle))) : (React.createElement("span", { className: "product-detail-title__subtitle" }, subtitle)),
        React.createElement(Heading, { variant: "small", component: "h1" }, title)));
};
var ProductDetailTitle$1 = React.memo(ProductDetailTitle);

var ProductDetailUspItem = function (_a) {
    var item = _a.item;
    var icon = item.icon, text = item.text;
    return (React.createElement("div", { className: "product-detail-usps__item" },
        icon && (React.createElement("span", { className: "product-detail-usps__icon" },
            React.createElement(Icon, { name: icon, width: 24, height: 24 }))),
        React.createElement("span", { className: "product-detail-usps__message" }, text)));
};

var ProductDetailUsps = function (_a) {
    var _b;
    var items = _a.items, _c = _a.layout, layout = _c === void 0 ? 'list' : _c, _d = _a.gridColumns, gridColumns = _d === void 0 ? 3 : _d, className = _a.className;
    if (gridColumns < 2 || gridColumns > 5) {
        console.warn('ProductDetailUsps only supports between 2 and 5 columns (inclusive) in grid mode');
    }
    return (React.createElement("div", { className: classnames('product-detail-usps', "product-detail-usps--layout-" + layout, className, (_b = {},
            _b["product-detail-usps--columns-" + gridColumns] = layout === 'grid',
            _b)) }, items.map(function (usp) { return (React.createElement(ProductDetailUspItem, { item: usp, key: usp.text })); })));
};

var ProductDiscountLabel = function (_a) {
    var _b;
    var title = _a.title, modifier = _a.modifier;
    return title ? (React.createElement("div", { className: classnames('product-discount-label', (_b = {},
            _b["product-discount-label--" + modifier] = !!modifier,
            _b)) },
        React.createElement("span", { className: "product-discount-label__title" }, title))) : null;
};
var ProductDiscountLabel$1 = React.memo(ProductDiscountLabel);

var ProductDetailImage = function (_a) {
    var image = _a.image, altText = _a.altText;
    var encodedImage = encodeURI(image); // Needed for url with spaces, which is not supported in srcSet
    var imgSuffix = "&fm=jpeg&auto=format";
    var sizes = "(min-width: 64em) calc(60vw - 30px), (min-width: 48em) calc(100vw - 1.5rem), 450w";
    var srcSet = encodedImage + "?w=450" + imgSuffix + " 450w, " + encodedImage + "?w=675" + imgSuffix + " 675w, " + encodedImage + "?w=1350" + imgSuffix + " 1350w";
    return (React.createElement("div", { className: "product-detail-image" },
        React.createElement(ResponsiveImage, { src: encodedImage + "?w=900" + imgSuffix, srcSet: srcSet, sizes: sizes, alt: altText })));
};

var VisualSwitcherViews;
(function (VisualSwitcherViews) {
    VisualSwitcherViews["FRONT"] = "front";
    VisualSwitcherViews["SIDE"] = "side";
    VisualSwitcherViews["VTO"] = "vto";
})(VisualSwitcherViews || (VisualSwitcherViews = {}));
var ProductVisualSwitcher = function (_a) {
    var productImages = _a.productImages, alt = _a.alt, sticker = _a.sticker, sku = _a.sku, ean = _a.ean, vtoEnabled = _a.vtoEnabled;
    var _b = __read(React.useState(VisualSwitcherViews.FRONT), 2), activeView = _b[0], setActiveView = _b[1];
    var intl = useIntl();
    var vtoId = ean || sku;
    React.useEffect(function () {
        if (!vtoEnabled && activeView === VisualSwitcherViews.VTO) {
            setActiveView(VisualSwitcherViews.FRONT);
        }
    }, [activeView, vtoEnabled]);
    var getButtonClassNames = function (angle) {
        var _a;
        var base = 'product-visuals__button';
        return classnames(base, base + "--" + angle, (_a = {},
            _a[base + "--active"] = activeView === angle,
            _a));
    };
    var getThumbnailStyle = function (url) { return ({
        backgroundImage: "url(" + url + "?w=74&h=29&fit=fill&fm=jpeg&auto=format)",
    }); };
    return (React.createElement("div", { className: "product-visuals", "data-t": "product-visual-switcher" },
        activeView !== VisualSwitcherViews.VTO && sticker,
        React.createElement("div", { className: "product-visuals__main" },
            activeView === VisualSwitcherViews.FRONT && (React.createElement(ProductDetailImage, { image: productImages[0].url, altText: alt })),
            productImages[1] && activeView === VisualSwitcherViews.SIDE && (React.createElement(ProductDetailImage, { image: productImages[1].url, altText: alt })),
            vtoEnabled && activeView === VisualSwitcherViews.VTO && (React.createElement(VirtualTryOn, { sku: vtoId, onClose: function () { return setActiveView(VisualSwitcherViews.FRONT); } }))),
        productImages[1] && (React.createElement("div", { className: "product-visuals__buttons" },
            React.createElement("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.FRONT); }, className: getButtonClassNames(VisualSwitcherViews.FRONT) },
                React.createElement("div", { className: "product-visuals__thumb", style: getThumbnailStyle(productImages[0].url) })),
            React.createElement("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.SIDE); }, className: getButtonClassNames(VisualSwitcherViews.SIDE) },
                React.createElement("div", { className: "product-visuals__thumb", style: getThumbnailStyle(productImages[1].url) })),
            vtoEnabled && (React.createElement("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.VTO); }, className: getButtonClassNames(VisualSwitcherViews.VTO) },
                React.createElement(Icon, { name: "try-on" }),
                React.createElement("span", null,
                    "\u00A0 ",
                    intl.getLabel('vto.caption'))))))));
};

function getEnPrioritizedText(text) {
    var e_1, _a;
    var locales = Object.keys(text).sort();
    try {
        for (var locales_1 = __values(locales), locales_1_1 = locales_1.next(); !locales_1_1.done; locales_1_1 = locales_1.next()) {
            var locale = locales_1_1.value;
            if (locale.toLocaleLowerCase().startsWith('en')) {
                return text[locale];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (locales_1_1 && !locales_1_1.done && (_a = locales_1.return)) _a.call(locales_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return text[locales[0]];
}

function mapOfferingToOfferingSelectionEvent(offering, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isDefaultSelection, isDefaultSelection = _c === void 0 ? false : _c;
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: isDefaultSelection ? 'view step' : 'click on button',
        eventLabel: getEnPrioritizedText(offering.title),
    };
}
function mapOfferingToAddToCartEvent(offering) {
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'add to cart',
        RxGlasses: {
            productConfig: {
                offering: getEnPrioritizedText(offering.title),
            },
        },
    };
}

var calcSumPrices = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return calcPrice(args.reduce(function (sum, n) { return sum + (n !== null && n !== void 0 ? n : 0); }, 0));
};
var parsePrice = function (price, vatRate) {
    var _a, _b;
    if (!price)
        return {
            regularPrice: null,
            discountedPrice: null,
            discountAmount: null,
            vatAmount: null,
        };
    var regularPrice = price.value.centAmount;
    var discountedPrice = (_b = (_a = price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount) !== null && _b !== void 0 ? _b : null;
    var vatAmount = (discountedPrice !== null
        ? priceVatCalc(discountedPrice, vatRate)
        : priceVatCalc(regularPrice, vatRate)).vatAmount;
    return {
        regularPrice: regularPrice,
        discountedPrice: discountedPrice,
        discountAmount: discountedPrice ? regularPrice - discountedPrice : 0,
        vatAmount: vatAmount,
    };
};
var getPrices = function (variant, vat, offering) {
    var _a;
    if (!variant) {
        console.warn('No variant data found.');
        return null;
    }
    if (typeof vat === 'undefined') {
        console.warn("No VAT amount found for variant with SKU " + variant.sku + ".");
        return null;
    }
    var pricing = ((_a = variant.prices) !== null && _a !== void 0 ? _a : []).find(function (price) { return typeof price.value.centAmount !== 'undefined'; });
    if (!pricing) {
        console.warn("Variant with SKU " + variant.sku + " doesn't have any pricing.");
        return null;
    }
    var productPricing = parsePrice(pricing, vat);
    var offeringPricing = parsePrice(offering === null || offering === void 0 ? void 0 : offering.price, vat);
    return {
        original: calcSumPrices(productPricing.regularPrice, offeringPricing.regularPrice),
        discountedPrice: productPricing.discountedPrice !== null
            ? calcSumPrices(productPricing.discountedPrice, offeringPricing.discountedPrice)
            : calcSumPrices(productPricing.regularPrice, offeringPricing.regularPrice),
        discountAmount: calcSumPrices(productPricing.discountAmount, offeringPricing.discountAmount),
        vatAmount: calcSumPrices(productPricing.vatAmount, offeringPricing.vatAmount),
    };
};
var getSharedAttributes = function (product, purchaseType, activeVariant, lineItemType, pricePerMonth, offering) {
    var name = activeVariant.name, sku = activeVariant.sku;
    var includedVatAmount = getIncludedVatAmount(product);
    var isSubscription = !!(purchaseType === DataLayer.DataLayerTypes.PurchaseType.Subscription);
    var prices = !isSubscription ? getPrices(activeVariant, includedVatAmount, offering) : null;
    var subscriptionPrice = pricePerMonth ? calcPrice(pricePerMonth) : '';
    return {
        name: name || '',
        id: sku || '',
        price: !isSubscription ? (prices === null || prices === void 0 ? void 0 : prices.discountedPrice) || '' : subscriptionPrice || '',
        dimension143: purchaseType,
        dimension144: lineItemType,
        dimension145: 'true',
        metric140: !isSubscription ? (prices === null || prices === void 0 ? void 0 : prices.original) || '' : subscriptionPrice || '',
        metric141: (prices === null || prices === void 0 ? void 0 : prices.discountAmount) || '',
        metric142: (prices === null || prices === void 0 ? void 0 : prices.vatAmount) || '',
    };
};
var getSunglassesAttributes = function (sharedAttributes, product, activeVariant, locale) { return (__assign$1(__assign$1({}, sharedAttributes), { category: DataLayer.DataLayerTypes.Category.Sunglasses, brand: activeVariant.brand || '', variant: getLocalizedAttrValue(activeVariant, 'frameShape', locale).toLowerCase(), dimension16: getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase() || '', dimension140: product.masterVariant.sku || '', dimension146: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale).toLowerCase(), dimension147: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase() })); };
var getContactLensesAttributes = function (sharedAttributes, product, activeVariant, locale) { return (__assign$1(__assign$1({}, sharedAttributes), { brand: "" + getAttrValue(activeVariant, 'brand'), category: DataLayer.DataLayerTypes.Category.ContactLenses, variant: getLocalizedAttrValue(activeVariant, 'lensType', locale), dimension140: product.masterVariant.sku || '', dimension148: getLocalizedAttrValue(activeVariant, 'replacementFrequency', locale), dimension146: getLocalizedAttrValue(activeVariant, 'material', locale).toLowerCase() })); };
var getPrescriptionGlassesAttributes = function (sharedAttributes, product, activeVariant, locale) {
    var frameMaterial = getLocalizedAttrValue(activeVariant, 'frameMaterial', locale).toLowerCase();
    var frameColor = getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase();
    var gender = getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase();
    return __assign$1(__assign$1(__assign$1(__assign$1({}, sharedAttributes), { brand: activeVariant.brand || '', dimension140: product.masterVariant.sku || '', dimension16: gender, category: DataLayer.DataLayerTypes.Category.Optical }), (frameMaterial ? { dimension146: frameMaterial } : null)), (frameColor ? { dimension147: frameColor } : null));
};
var getContactLensesBundleBeneluxAttributes = function (sharedAttributes, activeVariant, locale) { return (__assign$1(__assign$1({}, sharedAttributes), { category: DataLayer.DataLayerTypes.Category.ContactLenses, variant: getLocalizedAttrValue(activeVariant, 'lensType', locale) })); };
var getSolutionsAttributes = function (sharedAttributes, product, activeVariant) { return (__assign$1(__assign$1({}, sharedAttributes), { category: DataLayer.DataLayerTypes.Category.Solutions, brand: activeVariant.brand || '', variant: String(getAttrValue(activeVariant, 'packageOption')), dimension140: String(product.masterVariant.sku), dimension146: String(getAttrValue(activeVariant, 'solutionType')) })); };
var getReadyReadersAttributes = function (sharedAttributes, product, activeVariant, locale) { return (__assign$1(__assign$1({}, sharedAttributes), { category: DataLayer.DataLayerTypes.Category.ReadyReaders, brand: activeVariant.brand || '', variant: getLocalizedAttrValue(activeVariant, 'frameShape', locale).toLowerCase(), dimension16: getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase() || '', dimension140: product.masterVariant.sku || '', dimension146: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale).toLowerCase(), dimension147: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase() })); };
var mapProductToDataLayerProductObject = function (purchaseType, product, activeSku, locale, productType, pricePerMonth, offering) {
    var _a, _b, _c, _d, _e, _f;
    if (locale === void 0) { locale = Locales['en-GB']; }
    var activeVariant = __spreadArray$1([product.masterVariant], __read(product.variants)).find(function (variant) { return variant.sku === activeSku; }) ||
        product.masterVariant;
    var sharedAttributes = getSharedAttributes(product, purchaseType, activeVariant, productType || DataLayer.DataLayerTypes.LineItemType.Single, pricePerMonth, offering);
    if (((_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name) === 'Sunglasses') {
        return getSunglassesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((_b = product.productType.obj) === null || _b === void 0 ? void 0 : _b.name) === 'Contact-lenses') {
        return getContactLensesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((_c = product.productType.obj) === null || _c === void 0 ? void 0 : _c.name) === 'Contact-lens-bundles') {
        return getContactLensesBundleBeneluxAttributes(sharedAttributes, activeVariant, locale);
    }
    if (((_d = product.productType.obj) === null || _d === void 0 ? void 0 : _d.name) === 'Frames') {
        return getPrescriptionGlassesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((_e = product.productType.obj) === null || _e === void 0 ? void 0 : _e.name) === 'Ready-readers') {
        return getReadyReadersAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((_f = product.productType.obj) === null || _f === void 0 ? void 0 : _f.name) === 'Solutions') {
        return getSolutionsAttributes(sharedAttributes, product, activeVariant);
    }
};

var pushPdpEventToDataLayer = function (purchaseType, product, activeSku, currency, productType, pricePerMonth) {
    pushEventToDataLayer(purchaseType, product, activeSku, currency, { list: 'pdp' }, 'gvProductDetail', productType, pricePerMonth);
};
var pushEventToDataLayer = function (purchaseType, product, activeSku, currency, actionField, dataEvent, productType, pricePerMonth, eventType, offering) {
    var _a;
    var productObject = mapProductToDataLayerProductObject(purchaseType, product, activeSku, 
    // Data in the Data Layer should always be English, therefore hardcoded locale
    Locales['en-GB'], productType, pricePerMonth, offering);
    if (!productObject) {
        return;
    }
    DataLayer.pushEvent({
        event: dataEvent,
        atfEcommerce: {
            ecommerce: (_a = {
                    currencyCode: currency
                },
                _a[eventType || 'detail'] = {
                    actionField: actionField,
                    products: [productObject],
                },
                _a),
        },
    });
};
var pushTabClickEvent = function (isSubscriptionSelected) {
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on tab',
        eventLabel: isSubscriptionSelected
            ? DataLayer.DataLayerTypes.PurchaseType.Subscription
            : DataLayer.DataLayerTypes.PurchaseType.OneTime,
    });
};
var pushSubscriptionStartEvent = function (packs, packageQuantity, price, selectedVariants, usageLevel) {
    var toLens = function (lens) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            baseCurve: ((_a = lens === null || lens === void 0 ? void 0 : lens.attributes.baseCurve) === null || _a === void 0 ? void 0 : _a.toString()) || 'n/a',
            diameter: ((_b = lens === null || lens === void 0 ? void 0 : lens.attributes.diameter) === null || _b === void 0 ? void 0 : _b.toString()) || 'n/a',
            addition: ((_c = lens === null || lens === void 0 ? void 0 : lens.attributes.addition) === null || _c === void 0 ? void 0 : _c.toString()) || 'n/a',
            axis: ((_d = lens === null || lens === void 0 ? void 0 : lens.attributes.axis) === null || _d === void 0 ? void 0 : _d.toString()) || 'n/a',
            power: ((_e = lens === null || lens === void 0 ? void 0 : lens.attributes.power) === null || _e === void 0 ? void 0 : _e.toString()) || 'n/a',
            cylinder: ((_f = lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder) === null || _f === void 0 ? void 0 : _f.toString()) || 'n/a',
        });
    };
    var event = {
        event: 'ContactLensesConfigEvent',
        eventAction: 'view step',
        eventLabel: undefined,
        RxContactLenses: {
            configFlow: {
                version: '1.0',
                step: {
                    name: 'box quantity and prescription',
                    id: '100',
                },
            },
        },
        productConfig: {
            purchaseType: DataLayer.DataLayerTypes.PurchaseType.Subscription,
            price: calcPrice(price),
            box: {
                frequency: usageLevel && usageLevelToFrequency(usageLevel),
                quantity: mapBoxQuantity(packs, packageQuantity),
            },
            lens: {
                OS: selectedVariants.left && toLens(selectedVariants.left),
                OD: selectedVariants.right && toLens(selectedVariants.right),
            },
        },
    };
    DataLayer.pushEvent(event);
};
function pushOfferingSelectionEvent(offering, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isDefaultSelection, isDefaultSelection = _c === void 0 ? false : _c;
    DataLayer.pushEvent(mapOfferingToOfferingSelectionEvent(offering, { isDefaultSelection: isDefaultSelection }));
}
function pushAddToCartEvent(product, activeSku, offering, currency) {
    DataLayer.pushEvent(mapOfferingToAddToCartEvent(offering));
    // Clear the previous atfEcommerce object
    DataLayer.pushEvent({ event: '', atfEcommerce: null });
    pushEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency, {}, 'gvAddToCart', DataLayer.DataLayerTypes.LineItemType.Bundle, undefined, DataLayer.DataLayerTypes.EventType.add, offering);
}

// Re-export the viewHistory API but with the products key used in localStorage bound to it
var useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products);

var imgSuffix = '?w=64&fm=jpeg&auto=format';
function VariantPicker(_a) {
    var title = _a.title, variants = _a.variants, currentSku = _a.currentSku, currentLabel = _a.currentLabel, stockIndicator = _a.stockIndicator, onPick = _a.onPick;
    var _b = __read(React__default.useState(''), 2), queryString = _b[0], setQueryString = _b[1];
    // will pass the current queryString in the url of the variant picker
    React__default.useEffect(function () {
        setQueryString(typeof window !== 'undefined' ? window.location.search : '');
    }, []);
    if (!variants.length) {
        return null;
    }
    if (variants.length === 1) {
        return (React__default.createElement("div", { className: "variant-picker" },
            React__default.createElement("div", { className: "variant-picker__header" },
                React__default.createElement("div", { className: "variant-picker__info" }, currentLabel),
                stockIndicator)));
    }
    return (React__default.createElement("div", { className: "variant-picker" },
        React__default.createElement("div", { className: "variant-picker__header" },
            React__default.createElement("strong", null, title),
            stockIndicator),
        React__default.createElement("div", { className: "variant-picker__info" }, currentLabel),
        React__default.createElement("div", { className: "variant-picker__variants" }, variants.map(function (_a) {
            var sku = _a.sku, image = _a.image, url = _a.url;
            return (React__default.createElement("a", { href: url && "" + url + queryString, key: sku, className: classnames('variant-picker__variant', {
                    'variant-picker__variant--active': currentSku === sku,
                }), onClick: function (event) { return onPick(event, sku); }, style: { backgroundImage: "url(" + (image + imgSuffix) + ")" } }));
        }))));
}

var NonRxProductAddToCartButton = function (_a) {
    var activeSku = _a.activeSku, variantUrl = _a.variantUrl, offeringSku = _a.offeringSku, bundleLineItemSkus = _a.bundleLineItemSkus, formatProductUrl = _a.formatProductUrl, onCTAClick = _a.onCTAClick;
    var getLabel = useIntl().getLabel;
    var isCartV2Enabled = useFeatureToggles().isCartV2Enabled;
    var renderAddToCartButton = useProductDetailContext().renderAddToCartButton;
    var addToCartSharedProps = {
        caption: getLabel('products.actions.addToCart'),
        formatProductUrl: formatProductUrl,
        onClick: onCTAClick,
    };
    // Return carts-v2 button
    if (isCartV2Enabled && renderAddToCartButton) {
        var lineItemDraft = void 0;
        if (!bundleLineItemSkus || bundleLineItemSkus.length === 0) {
            // Add a Regular product to cart
            var draft = {
                sku: activeSku,
                quantity: 1,
                type: 'regular',
            };
            lineItemDraft = draft;
        }
        else {
            // Add a Non-Rx Bundle product to cart
            var skus = offeringSku ? __spreadArray$1([offeringSku], __read(bundleLineItemSkus)) : bundleLineItemSkus;
            var draft = {
                sku: activeSku,
                quantity: 1,
                type: 'non-prescription-bundle',
                bundleLineItems: skus.map(function (sku) { return ({
                    sku: sku,
                    quantity: 1,
                }); }),
            };
            lineItemDraft = draft;
        }
        return renderAddToCartButton(__assign$1(__assign$1({}, addToCartSharedProps), { onSuccess: onCTAClick, lineItemDrafts: [lineItemDraft] }));
    }
    // todo: remove this
    // Return carts-v1 button
    return (React.createElement(AddToCart, __assign$1({}, addToCartSharedProps, { lineItems: [
            {
                sku: activeSku,
                productUrl: variantUrl + "#product",
                quantity: 1,
            },
        ] })));
};

var NonRxProductCTA = function (_a) {
    var action = _a.action, addToCartConfig = _a.addToCartConfig, handleConversionEvent = _a.handleConversionEvent;
    var getLabel = useIntl().getLabel;
    var routes = useProductDetailContext().routes;
    return action === 'ADD_TO_CART' ? (
    // Add to Cart button
    React.createElement(NonRxProductAddToCartButton, __assign$1({}, addToCartConfig))) : (
    // Find a Store button
    React.createElement(Button, { onClick: handleConversionEvent, caption: getLabel('products.actions.excludedFromCheckout'), "data-t": "btn-excluded-from-checkout", href: routes.stores }));
};

var SelectionBoxRadio = function (props) {
    var classNames = getSelectionBoxStyles({
        isSelected: props.checked,
        isDisabled: props.disabled,
        className: props.className,
    });
    return React__default.createElement(Radio, __assign$1({}, props, { className: classNames }));
};

var TileLayout = function (_a) {
    var _b;
    var title = _a.title, subtitle = _a.subtitle, price = _a.price, iconName = _a.iconName, className = _a.className;
    var resolvedPriceCentAmount = ((_b = price === null || price === void 0 ? void 0 : price.discounted) === null || _b === void 0 ? void 0 : _b.value.centAmount) || (price === null || price === void 0 ? void 0 : price.value.centAmount);
    var currencyCode = price === null || price === void 0 ? void 0 : price.value.currencyCode;
    return (React__default.createElement("div", { className: classnames('tile-layout', className) },
        iconName && (React__default.createElement("div", { className: "tile-layout__aside" },
            React__default.createElement(Icon, { name: iconName, className: "tile-layout__icon" }))),
        React__default.createElement("div", { className: "tile-layout__main" },
            React__default.createElement(Text, { className: "tile-layout__title", variant: "caption-head" }, title),
            subtitle && (React__default.createElement(Text, { className: "tile-layout__subtitle", variant: "caption" }, subtitle)),
            resolvedPriceCentAmount && currencyCode && (React__default.createElement(Text, { className: "tile-layout__price", variant: "caption" },
                React__default.createElement(Price, { value: resolvedPriceCentAmount, centAmount: true, currency: currencyCode }))))));
};

var OfferingsList = function (_a) {
    var className = _a.className, offeringItems = _a.offeringItems, selectedValue = _a.selectedValue, onChange = _a.onChange;
    return (React__default.createElement("fieldset", { className: classnames('offerings-list', className) }, offeringItems.map(function (_a) {
        var title = _a.title, subtitle = _a.subTitle, price = _a.price, sku = _a.sku, icon = _a.icon;
        return (React__default.createElement(SelectionBoxRadio, { key: title, name: "offerings", value: sku, checked: selectedValue === sku, onChange: function () { return onChange(sku); } },
            React__default.createElement(TileLayout, { title: title, subtitle: subtitle, price: price, iconName: icon })));
    })));
};

function convertToLocalizedOffering(locale, offering) {
    return __assign$1(__assign$1({}, offering), { title: getLocalizedValue(offering.title, locale), subTitle: getLocalizedValue(offering.subTitle, locale) });
}
var OfferingsListContainer = function (_a) {
    var offerings = _a.offerings, onSelectionChange = _a.onSelectionChange, selectedValue = _a.selectedValue, rest = __rest(_a, ["offerings", "onSelectionChange", "selectedValue"]);
    var locale = useIntl().locale;
    var offeringItems = offerings.map(convertToLocalizedOffering.bind(null, locale));
    var handleOnChange = React__default.useCallback(function (sku) {
        var selectedOffering = offerings.find(function (offering) { return offering.sku === sku; });
        selectedOffering && onSelectionChange(selectedOffering);
    }, [offerings, onSelectionChange]);
    return (React__default.createElement(OfferingsList, __assign$1({ offeringItems: offeringItems, selectedValue: selectedValue, onChange: handleOnChange }, rest)));
};

var Panel = function (_a) {
    var title = _a.title, _b = _a.icon, icon = _b === void 0 ? 'info' : _b, className = _a.className, children = _a.children;
    if (!title || !children) {
        return null;
    }
    return (React__default.createElement("div", { className: classnames(['panel', className]) },
        React__default.createElement("div", { className: "panel__header" },
            React__default.createElement(Icon, { className: "panel__icon", name: icon }),
            React__default.createElement(Heading, { variant: "subheading1", className: "panel__title" }, title)),
        React__default.createElement("div", { className: "panel__content" }, children)));
};

var ProductDetailPrice = function (_a) {
    var originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice, currency = _a.currency, customSize = _a.customSize;
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Price, { value: originalPrice, currency: currency, size: customSize !== null && customSize !== void 0 ? customSize : 'large', type: "strikethrough", className: "product-detail__price" }),
            React__default.createElement(Price, { value: discountedPrice, currency: currency, size: customSize !== null && customSize !== void 0 ? customSize : 'large', className: "product-detail__price", type: "discount" })));
    }
    return (React__default.createElement(Price, { value: originalPrice, currency: currency, size: customSize !== null && customSize !== void 0 ? customSize : 'large', className: "product-detail__price" }));
};
var ProductDetailPrice$1 = React__default.memo(ProductDetailPrice);

var RxGlassesCTA = function (_a) {
    var action = _a.action, onClickWhenOrderable = _a.onClickWhenOrderable, buttonRef = _a.buttonRef, className = _a.className, handleConversionEvent = _a.handleConversionEvent;
    var getLabel = useIntl().getLabel;
    var routes = useProductDetailContext().routes;
    return action === 'OPEN_CONFIGURATOR' ? (
    // Open Configurator button
    React.createElement(Button, { caption: getLabel('products.actions.openConfigurator'), "data-t": "btn-open-configurator", onClick: onClickWhenOrderable, btnRef: buttonRef, className: className })) : (
    // Book Appointment button
    React.createElement(Button, { caption: getLabel('products.actions.bookAppointment'), "data-t": "btn-book-examination", href: routes['book-appointment'], className: className, onClick: handleConversionEvent }));
};

var _a$1 = __read(createSlotsContext({
    displayName: 'ProductDetailSlotsContext',
}), 2), ProductDetailSlotsProvider = _a$1[0], useProductDetailSlots = _a$1[1];

var getFramesDisplayPrice = function (variantPrice, offeringPrice, sspTotalPrice) {
    var currency = variantPrice.currency, originalVariantPrice = variantPrice.originalPrice, discountedVariantPrice = variantPrice.discountedPrice;
    if (isNumber(sspTotalPrice)) {
        var nonFrameSSPPrice = sspTotalPrice - originalVariantPrice;
        return {
            originalPrice: sspTotalPrice,
            /**
             * When the product doesn't have a discounted price, we want to keep it that way.
             * If the (total) discounted price returned from here is a number (even 0), it will
             * show up on the PDP. So we want to keep it undefined.
             */
            discountedPrice: discountedVariantPrice
                ? discountedVariantPrice + nonFrameSSPPrice
                : undefined,
            currency: currency,
        };
    }
    /**
     *
     * The offering price is added on top of the variant price
     *
     * -- No discounts --
     * originalVariantPrice: €10
     * offeringOriginalPrice: +€3
     *
     * Displayed total price:  10 + 3 = €13
     *
     *
     *  -- Only Offering with discount --
     * originalVariantPrice: €10
     * offeringOriginalPrice: +€3
     * offeringDiscountPrice: +€1
     *
     * Displayed total pre-discount price:  10 + 3 = €13
     * Displayed total discounted price:    10 + 1 = €11
     *
     *
     * -- Only Variant with discount --
     * originalVariantPrice: €10
     * discountedVariantPrice: €9
     * offeringOriginalPrice: +€3
     *
     * Displayed total pre-discount price:  10 + 3 = €13
     * Displayed total discounted price:     9 + 3 = €12
     *
     *
     * -- Variant AND Offering with discount --
     * originalVariantPrice: €10
     * discountedVariantPrice: €9
     * offeringOriginalPrice: +€3
     * offeringDiscountPrice: +€1
     *
     * Displayed total pre-discount price:  10 + 3 = €13
     * Displayed total discounted price:     9 + 1 = €10
     *
     */
    if (offeringPrice) {
        var offeringOriginalPrice = offeringPrice.value, offeringDiscount = offeringPrice.discounted;
        var offeringOriginalPriceValue = offeringOriginalPrice.centAmount;
        var displayedOriginalPrice = originalVariantPrice + offeringOriginalPriceValue;
        var displayedDiscountPrice = discountedVariantPrice;
        if (offeringDiscount) {
            var offeringDiscountPrice = offeringDiscount.value.centAmount;
            displayedDiscountPrice = discountedVariantPrice
                ? // -- Variant AND Offering with discount --
                    discountedVariantPrice + offeringDiscountPrice
                : //-- Only Offering with discount --
                    originalVariantPrice + offeringDiscountPrice;
        }
        else {
            displayedDiscountPrice = displayedDiscountPrice
                ? //-- Only Variant with discount --
                    displayedDiscountPrice + offeringOriginalPriceValue
                : //-- No discounts -- (you only get here if displayedDiscountPrice is undefined)
                    displayedDiscountPrice;
        }
        return {
            originalPrice: displayedOriginalPrice,
            discountedPrice: displayedDiscountPrice,
            currency: currency,
        };
    }
    return variantPrice;
};

var useBrandLink = function (brand) {
    var _a;
    if (typeof window === 'undefined') {
        return '';
    }
    var link = React.useMemo(function () {
        var _a;
        var sanitizedBrand = sanitizeStringForUrl(brand);
        var path = ((_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) || '';
        var parts = path.split('/').filter(function (v) { return v !== ''; });
        var isMultilingual = /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]);
        var category = isMultilingual ? parts[1] : parts[0];
        return "/" + (isMultilingual ? parts[0] + "/" : '') + category + "/" + encodeURIComponent(sanitizedBrand);
    }, [(_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname, brand]);
    return link;
};

function findOfferingByTitle(offerings, title) {
    return offerings.find(function (offering) {
        return new RegExp(title, 'i').test(Object.values(offering.title).join(','));
    });
}
function selectOffering(offerings, title) {
    return findOfferingByTitle(offerings, title) || offerings[0];
}

var Frames = function (_a) {
    var _b;
    var isPrescriptionGlassesEnabled = _a.isPrescriptionGlassesEnabled, activeSku = _a.activeSku, ean = _a.ean, addToCartRef = _a.addToCartRef, formatProductUrl = _a.formatProductUrl, handleVariantPick = _a.handleVariantPick, onCTAClick = _a.onCTAClick, onPriceChange = _a.onPriceChange, product = _a.product, productTypeUsps = _a.productTypeUsps, configuratorDocument = _a.configuratorDocument, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration, sspTotalPrice = _a.price, opticianForm = _a.opticianForm, children = _a.children, stickyTop = _a.stickyTop, isBynderImagesEnabled = _a.isBynderImagesEnabled, stockResolver = _a.stockResolver, secondaryCallToAction = _a.secondaryCallToAction, handleConversionEvent = _a.handleConversionEvent, productImageGallery = _a.productImageGallery, disclaimer = _a.disclaimer;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var _c = useIntl(), currency = _c.currency, getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel, hasLabel = _c.hasLabel, locale = _c.locale;
    var reviews = useReviewsContext();
    var productViewHistory = useProductViewHistory();
    var _d = useProductDetailContext(), reimbursableLogos = _d.reimbursableLogos, isReimbursable = _d.isReimbursable, filteredOfferings = _d.filteredOfferings;
    var brandLink = useBrandLink(variant.brand);
    var variants = React.useMemo(function () { return __spreadArray$1([product.masterVariant], __read(product.variants)); }, [product]);
    var openConfiguratorButtonRef = React.useRef(null);
    var Slots = useProductDetailSlots().Slots;
    var _e = __read(React.useState(false), 2), isConfiguratorOpen = _e[0], setIsConfiguratorOpen = _e[1];
    var offerings = React.useMemo(function () {
        if (!product.offerings)
            return [];
        // filter offerings based on the isReimbursable
        return product.offerings.filter(function (offering) {
            return isReimbursable ? offering.isInsuranceReimbursable : !offering.isInsuranceReimbursable;
        });
    }, [product.offerings, isReimbursable]);
    var _f = __read(React.useState(function () { return selectOffering(offerings, (filteredOfferings === null || filteredOfferings === void 0 ? void 0 : filteredOfferings[0]) || ''); }), 2), selectedOffering = _f[0], setSelectedOffering = _f[1];
    var _g = __read(React.useState(function () {
        return getCtaAction(variant, selectedOffering, isPrescriptionGlassesEnabled);
    }), 2), ctaAction = _g[0], setCtaAction = _g[1];
    var altTag = getProductAltTag(variant.name, variants.find(function (v) { return v.sku === activeSku; }) || variants[0], 'Frames', locale);
    var activeVariant = getActiveVariant$1(product, activeSku);
    var allowBackOrder = variant.allowBackOrder, availability = variant.availability, variantPrice = variant.price;
    var displayPrice = getFramesDisplayPrice(variantPrice, selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.price, !isPrescriptionGlassesEnabled ? sspTotalPrice : undefined);
    // Add SKU to viewed product history
    React.useEffect(function () {
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map(function (v) { return v.sku || ''; }));
        productViewHistory.add(variant.sku);
        // Adding productViewHistory to deps will cause an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variants.length, variant.sku]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(function () {
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku,
            }));
        }
    }, [activeSku, reviews, reviews.enabled]);
    React.useEffect(function () {
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [activeSku]);
    React.useEffect(function () {
        if (selectedOffering) {
            pushOfferingSelectionEvent(selectedOffering, { isDefaultSelection: true });
        }
        // this useEffect should be executed only once, so no dependency is needed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOfferingSelection = React.useCallback(function (selectedOffering) {
        setSelectedOffering(selectedOffering);
        pushOfferingSelectionEvent(selectedOffering);
        // update URL with selected offering
        var url = new URL(window.location.href);
        url.searchParams.set('offerings', getLocalizedValue(selectedOffering.title, locale));
        window.history.replaceState(null, '', url.toString());
    }, 
    // changes on any of the dependencies has no effect on this function
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var handleCtaClick = React.useCallback(function () {
        onCTAClick();
        // in case of add to cart, we need to push the event to data layer
        if (ctaAction === 'ADD_TO_CART' && selectedOffering) {
            pushAddToCartEvent(product, activeSku, selectedOffering, currency);
        }
    }, [ctaAction, onCTAClick, activeSku, selectedOffering, product, currency]);
    React.useEffect(function () {
        var activeAction = getCtaAction(variant, selectedOffering, isPrescriptionGlassesEnabled);
        setCtaAction(activeAction);
    }, [activeSku, activeVariant, isPrescriptionGlassesEnabled, selectedOffering, variant]);
    var handleConfiguratorClose = React.useCallback(function () {
        var _a;
        setIsConfiguratorOpen(false);
        (_a = openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : openConfiguratorButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [openConfiguratorButtonRef]);
    var handleConfiguratorOpen = React.useCallback(function () {
        handleConversionEvent();
        setIsConfiguratorOpen(true);
    }, []);
    var callToActionButton = CommerceToolsApi.isRegularProductAction(ctaAction) ? (React.createElement(NonRxProductCTA, { action: ctaAction, handleConversionEvent: handleConversionEvent, addToCartConfig: {
            activeSku: activeSku,
            offeringSku: selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.sku,
            bundleLineItemSkus: selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.bundledProducts,
            variantUrl: formatProductUrl({
                productType: variant.productType,
                sku: activeSku || '',
                slug: product.slug,
            }),
            formatProductUrl: formatProductUrl,
            onCTAClick: handleCtaClick,
        } })) : (React.createElement(RxGlassesCTA, { action: ctaAction, handleConversionEvent: handleConversionEvent, buttonRef: openConfiguratorButtonRef, onClickWhenOrderable: handleConfiguratorOpen }));
    return (React.createElement("div", { className: "product-detail__main product-detail__main--optical" },
        React.createElement("div", { className: "desktop-hidden product-detail__header--mobile" },
            React.createElement(ProductDetailTitle$1, { title: variant.brand + " " + variant.modelName, subtitle: variant.brand, href: brandLink }),
            isSmallScreen && (React.createElement(ReviewSnippet, { productId: product.masterVariant.sku, variantId: activeSku }))),
        React.createElement("div", { className: "product-detail__image-gallery" }, isBynderImagesEnabled ? (productImageGallery) : (React.createElement(ProductVisualSwitcher, { productImages: variant.images || [], alt: altTag, sku: activeSku, ean: ean, vtoEnabled: product.masterVariant.vtoEnabled }))),
        React.createElement("div", { className: "product-detail__description" },
            React.createElement(ProductDetailDescription, { title: getLabel('products.contactLenses.header.details'), header: variant.header, description: variant.description, usps: React.createElement(List, { icon: "checkmark", items: variant.usps }) },
                React.createElement(ProductDetailOpticsFeatures, { frame: getLabel('products.frame'), antiReflex: getLabel('products.lens.features.antiReflex'), antiScratch: getLabel('products.lens.features.antiScratch') }))),
        React.createElement("div", { className: "product-detail__specification" },
            React.createElement(ProductDetailSpecification, { configuration: specificationConfiguration, variant: activeVariant })),
        disclaimer && (React.createElement("div", { className: "product-detail__disclaimer" },
            React.createElement(Panel, { title: disclaimer.title }, disclaimer.description))),
        React.createElement("section", { className: "product-detail__aside", "aria-label": variant.brand + " " + variant.modelName },
            React.createElement(Sticky, { top: stickyTop || 0, bottomBoundary: ".product-detail", enabled: !isSmallScreen },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mobile-hidden" },
                        React.createElement(ProductDetailTitle$1, { title: variant.brand + " " + variant.modelName, subtitle: variant.brand, href: brandLink })),
                    activeVariant.isInsuranceReimbursable && (React.createElement(ProductReimbursableLogo, { logos: reimbursableLogos, variant: isReimbursable ? 'alternative' : 'default' })),
                    !!variantPrice && (React.createElement("div", { role: "group", "aria-label": getLabel('products.screenreader.priceInformation') },
                        !!(selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.bundleContentDescription) && (React.createElement("div", { className: "product-detail__offering-bundle-description" }, getLocalizedValue(selectedOffering.bundleContentDescription, locale))),
                        React.createElement("div", { className: classnames('product-detail__specification-prices', {
                                'product-detail__specification-prices--has-discount': !!variant.discountText,
                            }) },
                            React.createElement("div", { className: "product-detail__price-container" },
                                React.createElement(ProductDetailPrice, __assign$1({}, displayPrice))),
                            variant.discountText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" }))),
                        Slots.AfterPrice ? (React.createElement("div", { className: "product-detail__after-price-slot" },
                            React.createElement(Slots.AfterPrice, { price: displayPrice.discountedPrice
                                    ? displayPrice.discountedPrice
                                    : displayPrice.originalPrice, productType: variant.productType }))) : null)),
                    !isSmallScreen && (React.createElement(ReviewSnippet, { productId: product.masterVariant.sku, variantId: activeSku })),
                    hasLabel('products.frames.contents') && (React.createElement("div", { className: "product-detail__specification-contents" },
                        React.createElement("span", { className: "product-detail__specification-contents__header" }, getLabel('products.including')),
                        React.createElement("p", null, getLabel('products.frames.contents')))),
                    React.createElement(VariantPicker, { title: getFormattedLabel('products.numberOfVariants', {
                            labelData: { number: variants.length },
                        }), variants: getVariants$1(variants, staticsUrl, variant, product, formatProductUrl, isBynderImagesEnabled), currentSku: variant.sku, currentLabel: variant.frameColorLabel, onPick: handleVariantPick, stockIndicator: isPrescriptionGlassesEnabled ? (React.createElement(StockIndicator, { stockCount: (_b = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && _b !== void 0 ? _b : 0, allowBackOrder: allowBackOrder, stockResolver: stockResolver })) : undefined }),
                    React.createElement("div", { className: "product-detail__cart-details", ref: addToCartRef },
                        offerings && selectedOffering && (React.createElement(OfferingsListContainer, { selectedValue: selectedOffering.sku, offerings: offerings, onSelectionChange: handleOfferingSelection })),
                        callToActionButton,
                        secondaryCallToAction && secondaryCallToAction(variant),
                        Slots.AfterCTA ? (React.createElement(Slots.AfterCTA, { price: displayPrice.discountedPrice
                                ? displayPrice.discountedPrice
                                : displayPrice.originalPrice, productType: variant.productType })) : null,
                        activeVariant.vtoEnabled && React.createElement(TryOnButton, null),
                        isSmallScreen && showStickyButton && !!variantPrice && (React.createElement(StickyCallToAction, { button: callToActionButton, price: React.createElement(Price, { value: displayPrice.discountedPrice
                                    ? displayPrice.discountedPrice
                                    : displayPrice.originalPrice, currency: currency, centAmount: true, type: displayPrice.discountedPrice ? 'discount' : 'default' }) }))),
                    productTypeUsps && (React.createElement(React.Fragment, null,
                        React.createElement(Hr, { className: "product-detail__usp-divider" }),
                        React.createElement(ProductDetailUsps, { items: productTypeUsps })))))),
        children && React.createElement("div", { className: "product-detail__configuration" }, children),
        React.createElement(RxGlassesConfigurator, { id: "glasses", frame: product, frameSku: activeSku, isOpen: isConfiguratorOpen, triggerButtonRef: openConfiguratorButtonRef, onModalClose: handleConfiguratorClose, onPriceChange: onPriceChange, formatProductUrl: formatProductUrl, opticianForm: opticianForm, configuratorDocument: configuratorDocument })));
};
function getActiveOfferingActionObject(offering, activeSku) {
    if (!offering || !activeSku)
        return;
    if (Array.isArray(offering.actions)) {
        /**
         * 'offerings' will only be an array once we're using GraphQL to fetch the product data.
         */
        return offering === null || offering === void 0 ? void 0 : offering.actions.find(function (a) { return a.variant === activeSku; });
    }
    else {
        var action = offering.actions[activeSku];
        if (!action)
            return;
        return { variant: activeSku, action: action };
    }
}
function getCtaAction(variant, offering, isPrescriptionGlassesEnabled) {
    var fallbackAction = variant.channelAvailability === 'ONLINE' && isPrescriptionGlassesEnabled
        ? 'OPEN_CONFIGURATOR'
        : 'OPEN_CONFIGURATOR_UNAVAILABLE';
    if (!offering) {
        return fallbackAction;
    }
    if (offering && CommerceToolsApi.isDeprecatedOffering(offering)) {
        return offering.action;
    }
    var activeOffering = getActiveOfferingActionObject(offering, variant.sku);
    if (!activeOffering) {
        return fallbackAction;
    }
    return activeOffering.action;
}

/**
 * Step related selectors
 */
createSelector(stateProp, function (s) { return getClsUsps(s); });

function productIsAvailableForSubscription(product) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = product === null || product === void 0 ? void 0 : product.masterVariant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var name = _a.name;
        return name === 'isAvailableForSubscription';
    })) === null || _c === void 0 ? void 0 : _c.value);
}

// Sort rateplans by a combination of their delivery and billing frequencies
/**
 * Helper to map the enum values to numbers for easy comparison
 * use number conversion to map monthly -> 0, quarterly -> 1
 */
var toSortable = function (ratePlan) { return ({
    shipping: +(ratePlan.shippingSchedule === DeliveryFrequency$1.Quarterly),
    billing: +(ratePlan.billingPeriod === BillingFrequency$1.Quarterly),
}); };
/**
 * This sorter can be used on alist of rateplans to sort them based on
 * the delivery and billing frequencies. The delivery frequency is checked first.
 * In case of a tie, the billing frequency is checked. Sort is not stable.
 * @param a first rateplan
 * @param b second rateplan
 * @returns -1, 0 or 1 in line with requirements for JS sort implementations
 */
function sortRateplans(a, b) {
    var _c = __read([a, b].map(toSortable), 2), _a = _c[0], _b = _c[1];
    // if shipping is a tie, 0 is coerced to false and the check falls through
    // to the second part.
    return _a.shipping - _b.shipping || _a.billing - _b.billing;
}

function getNounLabel(value) {
    if (value === 1)
        return 'singular';
    else
        return 'plural';
}

function removeDuplicatesByPropertyValue(objArr, prop) {
    return objArr.filter(function (obj, pos, arr) { return arr.map(function (rp) { return rp[prop]; }).indexOf(obj[prop]) === pos; });
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * The billing frequency of the subscription
 */
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["QUARTERLY"] = "QUARTERLY";
})(BillingFrequency || (BillingFrequency = {}));
/**
 * Enum for bundle line items product types.
 */
var BundleLineItemProductType;
(function (BundleLineItemProductType) {
    BundleLineItemProductType["LENS"] = "LENS";
    BundleLineItemProductType["SOLUTION"] = "SOLUTION";
})(BundleLineItemProductType || (BundleLineItemProductType = {}));
/**
 * List of possible bundle line item types.
 */
var BundleLineItemType;
(function (BundleLineItemType) {
    BundleLineItemType["COMPOSITE"] = "COMPOSITE";
    BundleLineItemType["CONTACT_LENSES_BENELUX"] = "CONTACT_LENSES_BENELUX";
    BundleLineItemType["CONTACT_LENSES_SUBSCRIPTION"] = "CONTACT_LENSES_SUBSCRIPTION";
    BundleLineItemType["NON_PRESCRIPTION_BUNDLE"] = "NON_PRESCRIPTION_BUNDLE";
    BundleLineItemType["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
})(BundleLineItemType || (BundleLineItemType = {}));
/**
 * The type of the customer.
 */
var CartCustomerType;
(function (CartCustomerType) {
    CartCustomerType["B2B"] = "B2B";
    CartCustomerType["B2C"] = "B2C";
})(CartCustomerType || (CartCustomerType = {}));
/**
 * Channel where the cart was created/modified, one of ONLINE/STORE, default to ONLINE.
 */
var ChannelType;
(function (ChannelType) {
    ChannelType["ONLINE"] = "ONLINE";
    ChannelType["STORE"] = "STORE";
})(ChannelType || (ChannelType = {}));
/**
 * The delivery frequency of the subscription
 */
var DeliveryFrequency;
(function (DeliveryFrequency) {
    DeliveryFrequency["MONTHLY"] = "MONTHLY";
    DeliveryFrequency["QUARTERLY"] = "QUARTERLY";
})(DeliveryFrequency || (DeliveryFrequency = {}));
/**
 * List of possible eyeSide properties
 */
var EyeSide;
(function (EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
var LineItemType;
(function (LineItemType) {
    LineItemType["BUNDLE"] = "BUNDLE";
    LineItemType["CONTACTLENSES"] = "CONTACTLENSES";
    LineItemType["REGULAR"] = "REGULAR";
})(LineItemType || (LineItemType = {}));
/**
 * Contains the type of discount.
 */
var RecommendationDiscountType;
(function (RecommendationDiscountType) {
    RecommendationDiscountType["CART_DISCOUNT"] = "CART_DISCOUNT";
    RecommendationDiscountType["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
})(RecommendationDiscountType || (RecommendationDiscountType = {}));
var SanitizationAction;
(function (SanitizationAction) {
    SanitizationAction["KeepExisting"] = "KeepExisting";
    SanitizationAction["Replace"] = "Replace";
})(SanitizationAction || (SanitizationAction = {}));
var UsageLevel;
(function (UsageLevel) {
    UsageLevel["MORE_THAN_FIVE_DAYS_A_WEEK"] = "MORE_THAN_FIVE_DAYS_A_WEEK";
    UsageLevel["ONE_DAY_A_WEEK"] = "ONE_DAY_A_WEEK";
    UsageLevel["THREE_FOUR_DAYS_A_WEEK"] = "THREE_FOUR_DAYS_A_WEEK";
    UsageLevel["TWO_DAYS_A_WEEK"] = "TWO_DAYS_A_WEEK";
})(UsageLevel || (UsageLevel = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

var toRawUsageLevel = function (usageLevel) {
    return ({
        one_day_a_week: UsageLevel.ONE_DAY_A_WEEK,
        two_days_a_week: UsageLevel.TWO_DAYS_A_WEEK,
        three_four_days_a_week: UsageLevel.THREE_FOUR_DAYS_A_WEEK,
        more_than_five_days_a_week: UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK,
    }[usageLevel]);
};
var toUsageLevel = function (usageLevel) {
    var _a;
    return ((_a = {},
        _a[UsageLevel.ONE_DAY_A_WEEK] = UsageLevel$1.One,
        _a[UsageLevel.TWO_DAYS_A_WEEK] = UsageLevel$1.Two,
        _a[UsageLevel.THREE_FOUR_DAYS_A_WEEK] = UsageLevel$1.ThreeFour,
        _a[UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK] = UsageLevel$1.FivePlus,
        _a)[usageLevel]);
};
var toBillingFrequency$1 = function (raw) {
    var _a;
    return (_a = {},
        _a[BillingFrequency.MONTHLY] = BillingFrequency$1.Monthly,
        _a[BillingFrequency.QUARTERLY] = BillingFrequency$1.Quarterly,
        _a)[raw];
};
var toDeliveryFrequency$1 = function (raw) {
    var _a;
    return (_a = {},
        _a[DeliveryFrequency.MONTHLY] = DeliveryFrequency$1.Monthly,
        _a[DeliveryFrequency.QUARTERLY] = DeliveryFrequency$1.Quarterly,
        _a)[raw];
};
var toRatePlans = function (rawRatePlan) {
    if (!rawRatePlan)
        return undefined;
    return rawRatePlan.map(function (ratePlan) { return ({
        externalId: ratePlan.externalId,
        effectiveStartDate: ratePlan.effectiveStartDate,
        effectiveEndDate: ratePlan.effectiveEndDate,
        billingPeriod: toBillingFrequency$1(ratePlan.billingPeriod),
        shippingSchedule: toDeliveryFrequency$1(ratePlan.shippingSchedule),
        includedUnits: ratePlan.includedUnits,
        totalPrice: ratePlan.totalPrice,
        usageLevel: ratePlan.usageLevel ? toUsageLevel(ratePlan.usageLevel) : null,
        packageQuantity: ratePlan.variant.packageQuantity,
    }); });
};

var GET_PRODUCT_RATEPLANS = gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  query getProductRatePlansByMasterKey($productMasterKey: ID!, $usageLevel: UsageLevel) {\n    productByMasterKey(productMasterKey: $productMasterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        ratePlans(usageLevel: $usageLevel) {\n          id: externalId\n          externalId\n          effectiveStartDate\n          effectiveEndDate\n          billingPeriod\n          shippingSchedule\n          includedUnits\n          usageLevel\n          totalPrice {\n            currencyCode\n            centAmount\n          }\n          variant {\n            gan\n            packageQuantity\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getProductRatePlansByMasterKey($productMasterKey: ID!, $usageLevel: UsageLevel) {\n    productByMasterKey(productMasterKey: $productMasterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        ratePlans(usageLevel: $usageLevel) {\n          id: externalId\n          externalId\n          effectiveStartDate\n          effectiveEndDate\n          billingPeriod\n          shippingSchedule\n          includedUnits\n          usageLevel\n          totalPrice {\n            currencyCode\n            centAmount\n          }\n          variant {\n            gan\n            packageQuantity\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$3;

var useProductRateplans = function (productMasterKey, selectedUsageLevel) {
    // Usage level is null for non-dailies
    var usageLevel = selectedUsageLevel && toRawUsageLevel(selectedUsageLevel);
    var _a = __read(useLazyQuery(GET_PRODUCT_RATEPLANS), 2), getProductRatePlans = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error;
    useEffect(function () {
        if (productMasterKey) {
            getProductRatePlans({
                variables: {
                    productMasterKey: productMasterKey,
                    usageLevel: usageLevel,
                },
            });
        }
    }, [productMasterKey, getProductRatePlans, usageLevel]);
    var product = (data === null || data === void 0 ? void 0 : data.productByMasterKey) &&
        data.productByMasterKey;
    if (!product || !product.ratePlans) {
        return { data: undefined, loading: loading, error: error };
    }
    return {
        data: toRatePlans(product.ratePlans),
        loading: loading,
        error: error,
    };
};

var CardTrack = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.itemSize, itemSize = _c === void 0 ? 'large' : _c, rest = __rest(_a, ["className", "children", "itemSize"]);
    var baseClassNames = classnames('configurator-card-track', className);
    var containerClassNames = classnames('configurator-card-track__container', (_b = {},
        _b["item-size-" + itemSize] = !!itemSize,
        _b));
    return (React__default.createElement("div", { className: baseClassNames, "data-t": rest['data-t'] },
        React__default.createElement("div", { className: containerClassNames }, React__default.Children.map(children, function (child) {
            return React__default.createElement("div", { className: "card-track-item" }, child);
        }))));
};

var createSolutionProduct = function (solution, variantGroup, solutions) {
    var _a, _b, _c;
    var position = (solutions === null || solutions === void 0 ? void 0 : solutions.findIndex(function (_a) {
        var sku = _a.sku;
        return sku === solution.sku;
    })) + 1;
    var originalPrice = calcPrice(((_a = solution.price) === null || _a === void 0 ? void 0 : _a.originalPrice) || 0);
    var discountedPrice = ((_b = solution.price) === null || _b === void 0 ? void 0 : _b.discountedPrice)
        ? calcPrice(((_c = solution.price) === null || _c === void 0 ? void 0 : _c.discountedPrice) || 0)
        : '';
    return {
        name: solution.title,
        id: solution.sku,
        price: originalPrice,
        brand: variantGroup,
        category: 'Solutions',
        variant: 'Solutions',
        dimension140: solution === null || solution === void 0 ? void 0 : solution.sku,
        dimension143: 'subscription',
        dimension144: 'single',
        dimension145: 'true',
        metric140: originalPrice,
        metric141: discountedPrice,
        metric142: '0',
        list: 'cls configurator',
        position: position,
    };
};
function pushEvent$1(event, ecommerce) {
    DataLayer.pushEvent({ event: '', atfEcommerce: null });
    DataLayer.pushEvent({ event: event, atfEcommerce: { ecommerce: ecommerce } });
}
var pushSolutionClick = function (selectedSolution, variantGroup, currency, solutions) {
    if (selectedSolution.sku === NO_SOLUTION_SKU) {
        return;
    }
    var ecommerce = {
        currencyCode: currency,
        click: {
            actionField: { list: 'cls configurator' },
            products: [createSolutionProduct(selectedSolution, variantGroup, solutions)],
        },
    };
    pushEvent$1('gvProductClick', ecommerce);
};
var pushSolutionImpressions = function (solutions, variantGroup, currency) {
    var ecommerce = {
        currencyCode: currency,
        impressions: solutions
            // Slice off the "No solution" option
            .slice(1)
            .map(function (solution) { return createSolutionProduct(solution, variantGroup, solutions); }),
    };
    pushEvent$1('gvProductImpressions', ecommerce);
};
var pushClickUspBack = function () {
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'USP back (mobile)',
    });
};
var pushClickUspNext = function () {
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'USP forward (mobile)',
    });
};

var StepWithUsps = function (_a) {
    var children = _a.children, stepFormProps = __rest(_a, ["children"]);
    var usps = useSelector(getClsUsps);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(UspGroup, { items: usps, theme: "light", onPrevSlide: pushClickUspBack, onNextSlide: pushClickUspNext }),
        React__default.createElement(StepForm, __assign$1({}, stepFormProps, { className: "contact-lenses-step" }), children)));
};

var DeliveryFrequencyStep = function (_a) {
    var deliveryFrequencies = _a.deliveryFrequencies, selectedDeliveryFrequency = _a.selectedDeliveryFrequency, className = _a.className, onChange = _a.onChange, onSubmit = _a.onSubmit, rest = __rest(_a, ["deliveryFrequencies", "selectedDeliveryFrequency", "className", "onChange", "onSubmit"]);
    var handleChange = React.useCallback(function (deliveryFrequency) {
        onChange({ deliveryFrequency: deliveryFrequency });
    }, [onChange]);
    var singleDeliveryFrequency = deliveryFrequencies.length == 1 ? deliveryFrequencies[0] : null;
    var cardClassName = classnames('cls-delivery-frequency-card', className);
    return (React.createElement(StepWithUsps, { onSubmit: onSubmit, className: className, "data-t": rest['data-t'] },
        React.createElement(ConfiguratorStepTitleAndDescription, null),
        React.createElement(CardTrack, { itemSize: "large" }, singleDeliveryFrequency ? (React.createElement(SingleItemRadioCard, { cardClassName: cardClassName, className: "cls-delivery-frequency-card--single", title: singleDeliveryFrequency.title, description: singleDeliveryFrequency.description, icon: "calendar-" + singleDeliveryFrequency.deliveryFrequency })) : (deliveryFrequencies.map(function (item) { return (React.createElement(RadioCard, { key: item.deliveryFrequency, withDivider: true, className: cardClassName, id: item.deliveryFrequency + "-radio", isChecked: item.deliveryFrequency === selectedDeliveryFrequency, onChange: handleChange, value: item.deliveryFrequency, title: item.title, description: item.description, icon: "calendar-" + item.deliveryFrequency })); })))));
};

var DeliveryFrequencyStepContainer = function () {
    var dispatch = useDispatch();
    var _a = useIntl(), getLabel = _a.getLabel, getFormattedLabel = _a.getFormattedLabel;
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    var selectedDeliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    var selectedUsageLevel = useSelector(getUsageFrequency);
    var ratePlans = useSelector(getRatePlans);
    var _b = useProductRateplans(variantGroup, selectedUsageLevel), data = _b.data, loading = _b.loading, error = _b.error;
    React__default.useEffect(function () {
        if (data && !statusSuccess(ratePlans)) {
            dispatch(fetchRatePlansSuccess({ ratePlans: data }));
        }
        if (error && !statusFailed(ratePlans)) {
            dispatch(fetchRatePlansFailed({ error: error }));
        }
    }, [data, dispatch, ratePlans, error]);
    var onChange = React__default.useCallback(function (args) {
        dispatch(selectDeliveryFrequency$1({
            variantGroup: variantGroup,
            deliveryFrequency: args.deliveryFrequency,
        }));
    }, [dispatch, variantGroup]);
    if (loading) {
        return React__default.createElement(LoaderScreen, null);
    }
    if (statusFailed(ratePlans) || !data) {
        return (React__default.createElement(Alert, { type: "error", title: getLabel('products.contactLenses.subscription.steps.deliveryFrequency.error') }));
    }
    var uniqueRatePlans = removeDuplicatesByPropertyValue(data, 'shippingSchedule');
    var deliveryFrequencySelectionList = uniqueRatePlans
        .map(function (ratePlan) { return ({
        deliveryFrequency: ratePlan.shippingSchedule,
        packageQuantity: ratePlan.packageQuantity,
        title: getLabel("products.contactLenses.subscription.steps.deliveryFrequency." + ratePlan.shippingSchedule + ".title"),
        description: getFormattedLabel("products.contactLenses.subscription.steps.deliveryFrequency.description." + getNounLabel(ratePlan.includedUnits) + "Packs." + getNounLabel(ratePlan.packageQuantity) + "Lenses", {
            labelData: {
                numberOfPacks: ratePlan.includedUnits,
                numberOfLenses: ratePlan.packageQuantity,
            },
        }),
    }); })
        .sort(function (a, b) { return a.deliveryFrequency.localeCompare(b.deliveryFrequency); });
    return (React__default.createElement(DeliveryFrequencyStep, { deliveryFrequencies: deliveryFrequencySelectionList, selectedDeliveryFrequency: selectedDeliveryFrequency, onChange: onChange, onSubmit: goToNextStep }));
};

var deliveryFrequency = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call(selectDefaultDeliveryFrequency)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var deliveryFrequency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getSelectedDeliveryFrequency)];
                case 1:
                    deliveryFrequency = _a.sent();
                    if (!deliveryFrequency) {
                        return [2 /*return*/, new Error('Selecting a delivery frequency is required.')];
                    }
                    return [2 /*return*/];
            }
        });
    },
    view: DeliveryFrequencyStepContainer,
};
function selectDefaultDeliveryFrequency() {
    var selectedDeliveryFrequency, ratePlans, _a, success, variantGroup;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getSelectedDeliveryFrequency)];
            case 1:
                selectedDeliveryFrequency = _b.sent();
                if (!!selectedDeliveryFrequency) return [3 /*break*/, 9];
                return [4 /*yield*/, select(getRatePlans)];
            case 2:
                ratePlans = _b.sent();
                if (!(statusUninit(ratePlans) || statusLoading(ratePlans))) return [3 /*break*/, 5];
                return [4 /*yield*/, race([
                        take(fetchRatePlansSuccess.type),
                        take(fetchRatePlansFailed.type),
                        delay(30000, true),
                    ])];
            case 3:
                _a = __read.apply(void 0, [_b.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 5];
                return [4 /*yield*/, select(getRatePlans)];
            case 4:
                ratePlans = _b.sent();
                _b.label = 5;
            case 5:
                if (!statusSuccess(ratePlans)) return [3 /*break*/, 9];
                return [4 /*yield*/, select(getVariantGroup)
                    //Use a rateplan with monthly shipping and billing frequency by default (if possible)
                ];
            case 6:
                variantGroup = _b.sent();
                //Use a rateplan with monthly shipping and billing frequency by default (if possible)
                return [4 /*yield*/, put(selectDeliveryFrequency$1({
                        variantGroup: variantGroup,
                        deliveryFrequency: __spreadArray$1([], __read(ratePlans.result.sort(sortRateplans)))[0].shippingSchedule,
                    }))
                    // selectDeliveryFrequency triggers selectDeliveryFrequencySuccess which triggers
                    // selectRatePlan, and only after success or failed can we know for sure that the
                    // data layer event can successfully be called
                ];
            case 7:
                //Use a rateplan with monthly shipping and billing frequency by default (if possible)
                _b.sent();
                // selectDeliveryFrequency triggers selectDeliveryFrequencySuccess which triggers
                // selectRatePlan, and only after success or failed can we know for sure that the
                // data layer event can successfully be called
                return [4 /*yield*/, race([
                        take(selectRatePlanSuccess.type),
                        take(selectRatePlanFailed.type),
                        delay(30000, true),
                    ])];
            case 8:
                // selectDeliveryFrequency triggers selectDeliveryFrequencySuccess which triggers
                // selectRatePlan, and only after success or failed can we know for sure that the
                // data layer event can successfully be called
                _b.sent();
                _b.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}

var toRawBillingFrequency = function (billingFrequency) {
    var _a;
    return ((_a = {},
        _a[BillingFrequency$1.Monthly] = BillingFrequency.MONTHLY,
        _a[BillingFrequency$1.Quarterly] = BillingFrequency.QUARTERLY,
        _a)[billingFrequency]);
};
var toRawDeliveryFrequency = function (deliveryFrequency) {
    var _a;
    return ((_a = {},
        _a[DeliveryFrequency$1.Monthly] = DeliveryFrequency.MONTHLY,
        _a[DeliveryFrequency$1.Quarterly] = DeliveryFrequency.QUARTERLY,
        _a)[deliveryFrequency]);
};
var toBillingFrequency = function (raw) {
    var _a;
    var map = (_a = {},
        _a[BillingFrequency.MONTHLY] = BillingFrequency$1.Monthly,
        _a[BillingFrequency.QUARTERLY] = BillingFrequency$1.Quarterly,
        _a);
    return map[raw];
};
var toDeliveryFrequency = function (raw) {
    var _a;
    var map = (_a = {},
        _a[DeliveryFrequency.MONTHLY] = DeliveryFrequency$1.Monthly,
        _a[DeliveryFrequency.QUARTERLY] = DeliveryFrequency$1.Quarterly,
        _a);
    return map[raw];
};

var toRecommendedSolutions = function (raw) {
    var _a, _b;
    return (__assign$1(__assign$1({}, raw), { ratePlans: (_b = (_a = raw.ratePlans) === null || _a === void 0 ? void 0 : _a.map(function (rp) { return (__assign$1(__assign$1({}, rp), { billingPeriod: toBillingFrequency(rp.billingPeriod), shippingSchedule: toDeliveryFrequency(rp.shippingSchedule), packageQuantity: 0 })); })) !== null && _b !== void 0 ? _b : [] }));
};

var GET_RECOMMENDED_SOLUTIONS = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  query getRecommendedSolutionsByMasterKey(\n    $locale: Locale!\n    $masterKey: ID!\n    $billingFrequency: BillingFrequency!\n    $deliveryFrequency: DeliveryFrequency!\n  ) {\n    productByMasterKey(productMasterKey: $masterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        recommendedSolutions {\n          brand\n          name(locale: $locale)\n          description(locale: $locale)\n          ratePlans(billingFrequency: $billingFrequency, deliveryFrequency: $deliveryFrequency) {\n            id: externalId\n            externalId\n            effectiveStartDate\n            effectiveEndDate\n            billingPeriod\n            shippingSchedule\n            includedUnits\n            totalPrice {\n              currencyCode\n              centAmount\n            }\n          }\n          variants {\n            gan\n            sku\n            media {\n              images {\n                url\n                label\n                dimensions {\n                  w\n                  h\n                }\n              }\n            }\n            contactLensCareType(locale: $locale)\n            volume\n            volumeUnit\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getRecommendedSolutionsByMasterKey(\n    $locale: Locale!\n    $masterKey: ID!\n    $billingFrequency: BillingFrequency!\n    $deliveryFrequency: DeliveryFrequency!\n  ) {\n    productByMasterKey(productMasterKey: $masterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        recommendedSolutions {\n          brand\n          name(locale: $locale)\n          description(locale: $locale)\n          ratePlans(billingFrequency: $billingFrequency, deliveryFrequency: $deliveryFrequency) {\n            id: externalId\n            externalId\n            effectiveStartDate\n            effectiveEndDate\n            billingPeriod\n            shippingSchedule\n            includedUnits\n            totalPrice {\n              currencyCode\n              centAmount\n            }\n          }\n          variants {\n            gan\n            sku\n            media {\n              images {\n                url\n                label\n                dimensions {\n                  w\n                  h\n                }\n              }\n            }\n            contactLensCareType(locale: $locale)\n            volume\n            volumeUnit\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$2;

var useRecommendedSolutions = function (brandKey, billingFrequency, deliveryFrequency) {
    var locale = useIntl().locale;
    var mappedBillingFrequency = billingFrequency && toRawBillingFrequency(billingFrequency);
    var mappedDeliveryFrequency = deliveryFrequency && toRawDeliveryFrequency(deliveryFrequency);
    var _a = __read(useLazyQuery(GET_RECOMMENDED_SOLUTIONS), 2), runQuery = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error;
    useEffect(function () {
        if (brandKey && mappedBillingFrequency && mappedDeliveryFrequency) {
            runQuery({
                variables: {
                    locale: locale,
                    billingFrequency: mappedBillingFrequency,
                    deliveryFrequency: mappedDeliveryFrequency,
                    masterKey: brandKey,
                },
            });
        }
    }, [brandKey, mappedBillingFrequency, mappedDeliveryFrequency, runQuery, locale]);
    var result = useMemo(function () {
        return ((data === null || data === void 0 ? void 0 : data.productByMasterKey) &&
            data.productByMasterKey.recommendedSolutions.map(toRecommendedSolutions));
    }, [data]);
    if (!result) {
        return { data: undefined, loading: loading, error: error };
    }
    return {
        data: result,
        loading: loading,
        error: error,
    };
};

var useSolutions = function () {
    var _a = useIntl(), getLabel = _a.getLabel, currency = _a.currency;
    var dispatch = useDispatch();
    var variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    var billingFrequency = useSelector(getSelectedBillingPeriod);
    var deliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    var _b = useRecommendedSolutions(variantGroup, billingFrequency, deliveryFrequency), recommendedSolutions = _b.data, loading = _b.loading;
    var selectedSolution = useSelector(getSelectedSolution);
    var parsedSolutions = useMemo(function () {
        var noSolution = {
            sku: NO_SOLUTION_SKU,
            gan: '',
            title: getLabel('products.contactLenses.subscription.steps.solution.noSolution'),
            price: {
                currency: currency,
                originalPrice: 0,
            },
        };
        if (recommendedSolutions) {
            var parsed = recommendedSolutions
                .filter(function (solution) { var _a; return (_a = solution.ratePlans) === null || _a === void 0 ? void 0 : _a.length; })
                .map(function (solution) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var variant = solution.variants[0];
                var masterImage = (_a = solution.variants[0].media) === null || _a === void 0 ? void 0 : _a.images.find(function (image) { return image.label !== ''; });
                var totalPrice = (_b = solution.ratePlans) === null || _b === void 0 ? void 0 : _b[0].totalPrice;
                return {
                    sku: solution.variants[0].sku,
                    gan: solution.variants[0].gan,
                    image: masterImage && {
                        label: (_c = masterImage.label) !== null && _c !== void 0 ? _c : '',
                        url: "" + masterImage.url,
                        dimensions: masterImage.dimensions,
                    },
                    description: ((_d = variant.contactLensCareType) !== null && _d !== void 0 ? _d : '') + ", " + variant.volume + variant.volumeUnit,
                    title: (_e = solution.name) !== null && _e !== void 0 ? _e : '',
                    ratePlan: (_f = solution.ratePlans) === null || _f === void 0 ? void 0 : _f[0],
                    price: {
                        currency: (_g = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currencyCode) !== null && _g !== void 0 ? _g : 'EUR',
                        originalPrice: (_h = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.centAmount) !== null && _h !== void 0 ? _h : 0,
                    },
                };
            });
            parsed.unshift(noSolution);
            return parsed;
        }
        return [noSolution];
    }, [getLabel, currency, recommendedSolutions]);
    var onSolutionChange = useCallback(function (_a) {
        var solution = _a.solution;
        var selected = parsedSolutions.find(function (_a) {
            var sku = _a.sku;
            return sku === solution;
        });
        if (!selected)
            return;
        dispatch(selectSolution({
            solution: selected,
            variantGroup: variantGroup,
        }));
        // Analytics event
        pushSolutionClick(selected, variantGroup, currency, parsedSolutions);
    }, [parsedSolutions, dispatch, variantGroup, currency]);
    useEffect(function () {
        // Analytics event
        if (parsedSolutions.length > 1 && variantGroup && currency) {
            pushSolutionImpressions(parsedSolutions, variantGroup, currency);
        }
    }, [parsedSolutions, variantGroup, currency]);
    useEffect(function () {
        if (recommendedSolutions && !selectedSolution) {
            onSolutionChange({ solution: NO_SOLUTION_SKU });
        }
    }, [recommendedSolutions, onSolutionChange, selectedSolution]);
    return {
        loading: loading,
        onSolutionChange: onSolutionChange,
        recommendedSolutions: parsedSolutions,
        selectedSolution: selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.gan,
    };
};

var SolutionStep = function (_a) {
    var onSolutionChange = _a.onSolutionChange, onSubmit = _a.onSubmit, labels = _a.labels, solutions = _a.solutions, selectedSolution = _a.selectedSolution, rest = __rest(_a, ["onSolutionChange", "onSubmit", "labels", "solutions", "selectedSolution"]);
    var handleSolutionChange = React.useCallback(function (solution) {
        onSolutionChange({ solution: solution });
    }, [onSolutionChange]);
    var isSolutionNoSolutionValue = function (solution) {
        return solution.sku.startsWith('-');
    };
    var solutionRadioCardClassname = function (solution) {
        return classnames('solution-step__radio', {
            'solution-step__radio--none': solution && isSolutionNoSolutionValue(solution),
        });
    };
    var singleSolution = solutions.length == 1 ? solutions[0] : null;
    return (React.createElement(StepWithUsps, { onSubmit: onSubmit, "data-t": rest['data-t'] },
        React.createElement(ConfiguratorStepTitleAndDescription, null),
        React.createElement(CardTrack, { itemSize: "small" }, singleSolution ? (React.createElement(SingleItemRadioCard, { withDivider: !isSolutionNoSolutionValue(singleSolution), cardClassName: "solution-step__single", className: solutionRadioCardClassname(singleSolution), image: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.image, title: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.title, description: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.description, price: isSolutionNoSolutionValue(singleSolution) ? undefined : singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.price })) : (solutions.map(function (sol) {
            // master image needs to resized to properly sized Image object.
            // This is not done in the useSolution hook as more components
            // require access to this base image to do their own sizing.
            var sizedImage = sol.image
                ? __assign$1(__assign$1({}, sol.image), { url: sol.image.url + "?w=175", dimensions: {
                        w: 175,
                        h: 100,
                    } }) : undefined;
            return (React.createElement(RadioCard, { key: sol.sku, withDivider: !isSolutionNoSolutionValue(sol), className: solutionRadioCardClassname(sol), "data-t": sol.sku + "-radio", id: sol.sku, isChecked: sol.gan === selectedSolution, value: sol.sku, onChange: handleSolutionChange, image: sizedImage, title: sol === null || sol === void 0 ? void 0 : sol.title, description: sol === null || sol === void 0 ? void 0 : sol.description, price: isSolutionNoSolutionValue(sol) ? undefined : sol === null || sol === void 0 ? void 0 : sol.price, priceComment: isSolutionNoSolutionValue(sol) ? undefined : labels.priceComment }));
        })))));
};

var SolutionStepContainer = function () {
    var getLabel = useIntl().getLabel;
    var _a = useSolutions(), recommendedSolutions = _a.recommendedSolutions, loading = _a.loading, onSolutionChange = _a.onSolutionChange, selectedSolution = _a.selectedSolution;
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var labels = useMemo(function () { return ({
        priceComment: getLabel('products.contactLenses.subscription.steps.solution.text'),
    }); }, [getLabel]);
    if (loading) {
        return React__default.createElement(LoaderScreen, null);
    }
    return (React__default.createElement(SolutionStep, { labels: labels, solutions: recommendedSolutions, onSolutionChange: onSolutionChange, onSubmit: goToNextStep, selectedSolution: selectedSolution }));
};

var solution = {
    onEnter: function () {
        var solution;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getSelectedSolution)
                    // This race will force the saga to wait until the solutions are fetched and
                    // a default solution is selected, so the analytics event will fire correctly
                ];
                case 1:
                    solution = _a.sent();
                    if (!!solution) return [3 /*break*/, 3];
                    return [4 /*yield*/, race([take(selectSolution.type), delay(30000, true)])];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    },
    view: SolutionStepContainer,
    stepStatus: function (s) {
        return s.contactLensSubscription.configurator.recommendedCategoryKey === undefined
            ? 'hidden'
            : 'active';
    },
};

var SubscriptionPlanStep = function (_a) {
    var billingPeriods = _a.billingPeriods, selectedBillingPeriod = _a.selectedBillingPeriod, onBillingPeriodChange = _a.onBillingPeriodChange, selectedStartDate = _a.selectedStartDate, onStartDateChange = _a.onStartDateChange, onSubmit = _a.onSubmit, startDates = _a.startDates, labels = _a.labels, _b = _a.showDisclaimer, showDisclaimer = _b === void 0 ? false : _b, rest = __rest(_a, ["billingPeriods", "selectedBillingPeriod", "onBillingPeriodChange", "selectedStartDate", "onStartDateChange", "onSubmit", "startDates", "labels", "showDisclaimer"]);
    var handleBillingPeriodChange = React.useCallback(function (billingPeriod) {
        onBillingPeriodChange({ billingPeriod: billingPeriod });
    }, [onBillingPeriodChange]);
    var singleBillingPeriod = billingPeriods.length == 1 ? billingPeriods[0] : null;
    return (React.createElement(StepWithUsps, { onSubmit: onSubmit, className: rest.className, "data-t": rest['data-t'] },
        React.createElement(ConfiguratorStepTitleAndDescription, null),
        React.createElement(CardTrack, { itemSize: "large" }, singleBillingPeriod ? (React.createElement(SingleItemRadioCard, { withDivider: true, cardClassName: "subscription-plan-step--single", icon: "calendar-" + singleBillingPeriod.billingPeriod, title: singleBillingPeriod.title || 'NO_TITLE', description: singleBillingPeriod.description || 'NO_DESC', price: singleBillingPeriod.price })) : (billingPeriods.map(function (item) { return (React.createElement(RadioCard, { key: item.billingPeriod, withDivider: true, className: "subscription-plan-step__radio", "data-t": item.billingPeriod + "-radio", id: item.billingPeriod, isChecked: item.billingPeriod === selectedBillingPeriod, value: item.billingPeriod, onChange: handleBillingPeriodChange, icon: "calendar-" + item.billingPeriod, title: item.title || 'NO_TITLE', description: item.description || 'NO_DESC', price: item.price })); }))),
        React.createElement("div", { className: "subscription-plan-step__date-picker" },
            React.createElement(DatePicker, { onChange: onStartDateChange, label: labels.datePickerLabel, required: true, initialValue: selectedStartDate, minDate: startDates === null || startDates === void 0 ? void 0 : startDates.min, maxDate: startDates === null || startDates === void 0 ? void 0 : startDates.max, dateFormat: "d MMMM yyyy" }),
            React.createElement(Text, { variant: "caption" }, labels.datePickerText)),
        showDisclaimer && (React.createElement(Text, { variant: "caption", className: "subscription-plan-step__disclaimer" }, labels.disclaimer))));
};

var MAX_DATE_SHIFT = { period: 'month', amount: 3 };
var SubscriptionPlanStepContainer = function () {
    var dispatch = useDispatch();
    var _a = useIntl(), getLabel = _a.getLabel, getFormattedLabel = _a.getFormattedLabel;
    var goToNextStep = useConfiguratorContext().goToNextStep;
    var variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    var ratePlans = useSelector(getRatePlans);
    var selectedDeliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    var selectedBillingPeriod = useSelector(getSelectedBillingPeriod);
    var selectedStartDate = useSelector(getSelectedStartDate);
    var eyeSides = useSelector(getEyeSides);
    // min = today at midnight,
    // max = today shifted by MAX_DATE_SHIFT constant
    var startDates = React__default.useMemo(function () { return ({
        min: new Date(new Date().setHours(0, 0, 0, 0)),
        max: DateUtils.shiftDate(new Date(), MAX_DATE_SHIFT.period, MAX_DATE_SHIFT.amount),
    }); }, []);
    // show disclaimer when delivery frequency is set to quarterly,
    // but billing period set to monthly.
    // The user has to pay 3 months upfront as a one-time fee in
    // this case and we don't want to surprise them
    var shouldShowDisclaimer = React__default.useMemo(function () { return selectedDeliveryFrequency === 'quarterly' && selectedBillingPeriod === 'monthly'; }, [selectedBillingPeriod, selectedDeliveryFrequency]);
    var labels = React__default.useMemo(function () { return ({
        datePickerLabel: getLabel('products.contactLenses.subscription.steps.startDate.title'),
        datePickerText: getLabel('products.contactLenses.subscription.steps.startDate.description'),
        disclaimer: getFormattedLabel('products.contactLenses.subscription.steps.subscriptionPlan.disclaimer', { parseHTML: true }),
    }); }, [getFormattedLabel, getLabel]);
    var onBillingPeriodChange = React__default.useCallback(function (_a) {
        var billingPeriod = _a.billingPeriod;
        dispatch(selectBillingPeriod$1({
            variantGroup: variantGroup,
            billingPeriod: billingPeriod,
        }));
    }, [dispatch, variantGroup]);
    var onStartDateChange = React__default.useCallback(function (startDate) {
        if (selectedStartDate === startDate)
            return;
        dispatch(selectStartDate$2({ variantGroup: variantGroup, startDate: startDate }));
        dispatch(selectStartDate$1({ startDate: startDate }));
    }, [dispatch, variantGroup]);
    if (!statusSuccess(ratePlans)) {
        return React__default.createElement(LoaderScreen, null);
    }
    var billingPeriods = ratePlans.result
        // Only include rate plans that match the selected usage and delivery frequencies
        .filter(function (ratePlan) { return ratePlan.shippingSchedule === selectedDeliveryFrequency; })
        .map(function (ratePlan) { return ({
        billingPeriod: ratePlan.billingPeriod,
        price: {
            originalPrice: ratePlan.totalPrice.centAmount * eyeSides.length,
            currency: ratePlan.totalPrice.currencyCode,
        },
        title: getLabel("products.contactLenses.subscription.steps.subscriptionPlan." + ratePlan.billingPeriod + ".title"),
        description: getLabel("products.contactLenses.subscription.steps.subscriptionPlan." + ratePlan.billingPeriod + ".description"),
    }); })
        .sort(function (a, b) { return a.billingPeriod.localeCompare(b.billingPeriod); });
    return (React__default.createElement(SubscriptionPlanStep, { billingPeriods: billingPeriods, selectedBillingPeriod: selectedBillingPeriod, onBillingPeriodChange: onBillingPeriodChange, selectedStartDate: selectedStartDate, onStartDateChange: onStartDateChange, onSubmit: goToNextStep, startDates: startDates, labels: labels, showDisclaimer: shouldShowDisclaimer }));
};

var subscriptionPlan = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call(selectDefaultBillingPeriod)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, call(selectDefaultStartDate)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var billingPeriod, startDate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, select(getSelectedBillingPeriod)];
                case 1:
                    billingPeriod = _a.sent();
                    if (!billingPeriod) {
                        return [2 /*return*/, new Error('Selecting a billing period is required.')];
                    }
                    return [4 /*yield*/, select(getSelectedStartDate)];
                case 2:
                    startDate = _a.sent();
                    if (!startDate) {
                        return [2 /*return*/, new Error('Selecting a start date is required.')];
                    }
                    return [2 /*return*/];
            }
        });
    },
    view: SubscriptionPlanStepContainer,
};
function selectDefaultBillingPeriod() {
    var selectedBillingPeriod, ratePlans, _a, success, variantGroup, selectedDeliveryFrequency_1, filteredRatePlans;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getSelectedBillingPeriod)];
            case 1:
                selectedBillingPeriod = _c.sent();
                if (!!selectedBillingPeriod) return [3 /*break*/, 10];
                return [4 /*yield*/, select(getRatePlans)];
            case 2:
                ratePlans = _c.sent();
                if (!(statusUninit(ratePlans) || statusLoading(ratePlans))) return [3 /*break*/, 5];
                return [4 /*yield*/, race([
                        take(fetchRatePlansSuccess.type),
                        take(fetchRatePlansFailed.type),
                        delay(30000, true),
                    ])];
            case 3:
                _a = __read.apply(void 0, [_c.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 5];
                return [4 /*yield*/, select(getRatePlans)];
            case 4:
                ratePlans = _c.sent();
                _c.label = 5;
            case 5:
                if (!statusSuccess(ratePlans)) return [3 /*break*/, 10];
                return [4 /*yield*/, select(getVariantGroup)];
            case 6:
                variantGroup = _c.sent();
                return [4 /*yield*/, select(getSelectedDeliveryFrequency)];
            case 7:
                selectedDeliveryFrequency_1 = _c.sent();
                filteredRatePlans = ratePlans.result.filter(function (ratePlan) { return ratePlan.shippingSchedule === selectedDeliveryFrequency_1; });
                return [4 /*yield*/, put(selectBillingPeriod$1({
                        variantGroup: variantGroup,
                        billingPeriod: (_b = __spreadArray$1([], __read(filteredRatePlans.sort(sortRateplans)))[0]) === null || _b === void 0 ? void 0 : _b.billingPeriod,
                    }))];
            case 8:
                _c.sent();
                return [4 /*yield*/, race([
                        take(selectRatePlanSuccess.type),
                        take(selectRatePlanFailed.type),
                        delay(30000, true),
                    ])];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
function selectDefaultStartDate() {
    var selectedStartDate, variantGroup, startDate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getSelectedStartDate)];
            case 1:
                selectedStartDate = _a.sent();
                if (!!selectedStartDate) return [3 /*break*/, 5];
                return [4 /*yield*/, select(getVariantGroup)];
            case 2:
                variantGroup = _a.sent();
                startDate = new Date();
                return [4 /*yield*/, put(selectStartDate$2({
                        variantGroup: variantGroup,
                        startDate: startDate,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, race([
                        take(selectStartDateSuccess.type),
                        take(selectStartDateFailed.type),
                        delay(30000, true),
                    ])];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}

var steps = {
    deliveryFrequency: deliveryFrequency,
    solution: solution,
    subscriptionPlan: subscriptionPlan,
};
var stepSequence = ['deliveryFrequency', 'subscriptionPlan', 'solution'];
var stepsMap = {
    deliveryFrequency: __assign$1(__assign$1({}, steps.deliveryFrequency), { labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.deliveryFrequency',
            title: 'products.contactLenses.subscription.steps.deliveryFrequency.title',
            description: 'products.contactLenses.subscription.steps.deliveryFrequency.description',
        } }),
    subscriptionPlan: __assign$1(__assign$1({}, steps.subscriptionPlan), { labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.subscriptionPlan',
            title: 'products.contactLenses.subscription.steps.subscriptionPlan.title',
            description: 'products.contactLenses.subscription.steps.subscriptionPlan.description',
        } }),
    solution: __assign$1(__assign$1({}, steps.solution), { labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.solution',
            title: 'products.contactLenses.subscription.steps.solution.title',
            description: 'products.contactLenses.subscription.steps.solution.description',
        } }),
};

var ClsConfiguratorContext = React.createContext({});
var useClsConfiguratorContext = function () { return React.useContext(ClsConfiguratorContext); };
var ClsConfiguratorProvider = function (_a) {
    var children = _a.children, id = _a.id, startClsConfigurationProps = __rest(_a, ["children", "id"]);
    var value = {
        id: id,
    };
    var dispatch = useDispatch();
    React.useEffect(function () {
        dispatch(startContactLensSubscriptionConfiguration(startClsConfigurationProps));
    }, [dispatch]);
    return React.createElement(ClsConfiguratorContext.Provider, { value: value }, children);
};

var ExpanderContentItem = function (_a) {
    var _b, _c;
    var imageUrl = _a.imageUrl, includedUnits = _a.includedUnits, lenses = _a.lenses, name = _a.name, packageQuantity = _a.packageQuantity, replacementFrequency = _a.replacementFrequency, solution = _a.solution;
    var _d = useIntl(), getLabel = _d.getLabel, getFormattedLabel = _d.getFormattedLabel;
    var cylinder = getLabel("products.contactLenses.prescription.cylinder");
    var diameter = getLabel("products.contactLenses.prescription.diameter");
    var baseCurve = getLabel("products.contactLenses.prescription.baseCurve");
    var power = getLabel("products.contactLenses.prescription.power");
    var axis = getLabel("products.contactLenses.prescription.axis");
    var addition = getLabel("products.contactLenses.prescription.addition");
    var leftEye = getLabel("products.contactLenses.leftEye");
    var rightEye = getLabel("products.contactLenses.rightEye");
    var solutionRatePlan = solution === null || solution === void 0 ? void 0 : solution.ratePlan;
    var solutionRatePlanLabel = (solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.shippingSchedule) && (solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.includedUnits)
        ? getFormattedLabel("products.contactLenses.configurator.footer.solutionRatePlan." + (solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.shippingSchedule), {
            labelData: {
                includedUnits: solutionRatePlan.includedUnits,
            },
        })
        : null;
    var quantityDescription = packageQuantity &&
        includedUnits &&
        getFormattedLabel("products.contactLenses.subscription.steps.deliveryFrequency.description." + getNounLabel(includedUnits) + "Packs." + getNounLabel(packageQuantity) + "Lenses", {
            labelData: {
                numberOfPacks: includedUnits,
                numberOfLenses: packageQuantity,
            },
        });
    return (React.createElement("div", { className: "cls-configurator-footer-expander-content__products" },
        React.createElement("div", { className: "cls-configurator-footer-expander-content__product" },
            React.createElement("div", { className: "cls-configurator-footer-expander-content__product-image" },
                imageUrl ? React.createElement("img", { src: imageUrl, alt: name }) : null,
                React.createElement("div", { className: "cls-configurator-footer-expander-content__product-image__overlay" }, lenses &&
                    lenses.map(function (lens) {
                        return lens.eyeSide ? (React.createElement(EyeSideIndicator, { key: lens.sku + "-" + lens.eyeSide, className: "cls-configurator-footer-expander-content__product-image__overlay-button", side: lens.eyeSide })) : null;
                    }))),
            React.createElement("div", { className: "cls-configurator-footer-expander-content__product-info" },
                name && (React.createElement(Heading, { className: "cls-configurator-footer-expander-content__product-info-head", color: "primary", variant: "subheading1" }, name)),
                React.createElement(Text, { className: "cls-configurator-footer-expander-content__product-info-body" }, replacementFrequency),
                React.createElement(Text, { className: "cls-configurator-footer-expander-content__product-info-body" }, quantityDescription),
                lenses &&
                    lenses.map(function (lens) { return (React.createElement("div", { key: lens.eyeSide, className: "cls-configurator-footer-expander-content__product-info-details" },
                        React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-details__title" },
                            React.createElement(Text, { variant: "body-head" }, lens.eyeSide === 'left' ? "" + leftEye : "" + rightEye)),
                        React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes" },
                            React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, diameter + ": " + (lens === null || lens === void 0 ? void 0 : lens.attributes.diameter) + " "),
                            React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, baseCurve + ":\n              " + (lens === null || lens === void 0 ? void 0 : lens.attributes.baseCurve) + " "),
                            React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, power + ": " + (lens === null || lens === void 0 ? void 0 : lens.attributes.power) + " "),
                            (lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder) && (React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, cylinder + ": " + (lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder) + " ")),
                            (lens === null || lens === void 0 ? void 0 : lens.attributes.axis) && (React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, axis + ": " + (lens === null || lens === void 0 ? void 0 : lens.attributes.axis) + " ")),
                            (lens === null || lens === void 0 ? void 0 : lens.attributes.addition) && (React.createElement("span", { className: "cls-configurator-footer-expander-content__product-info-attributes__detail" }, addition + ": " + (lens === null || lens === void 0 ? void 0 : lens.attributes.addition) + " "))))); }))),
        solution && (solution === null || solution === void 0 ? void 0 : solution.sku) !== NO_SOLUTION_SKU ? (React.createElement("div", { className: "cls-configurator-footer-expander-content__product" },
            React.createElement("div", { className: "cls-configurator-footer-expander-content__product-image" }, ((_b = solution.image) === null || _b === void 0 ? void 0 : _b.url) && (React.createElement("img", { src: ((_c = solution.image) === null || _c === void 0 ? void 0 : _c.url) + "?w=100&fm=jpeg&auto=format", alt: solution.title }))),
            React.createElement("div", { className: "cls-configurator-footer-expander-content__product-info" },
                React.createElement(Heading, { className: "cls-configurator-footer-expander-content__product-info-head", color: "primary", variant: "subheading1" }, solution.title),
                React.createElement(Text, { className: "cls-configurator-footer-expander-content__product-info-body" }, solutionRatePlanLabel),
                React.createElement(Text, { className: "cls-configurator-footer-expander-content__product-info-body" }, solution.description)))) : null));
};

var ADDED_DAYS = 7;
var useFooter = function () {
    var _a = useIntl(), locale = _a.locale, getLabel = _a.getLabel;
    var configurator = selectors;
    var staticsUrl = useProductDetailContext().staticsUrl;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var id = useClsConfiguratorContext().id;
    var billingPeriod = useSelector(configurator.getSelectedBillingPeriod);
    var eyeSides = useSelector(configurator.getEyeSides);
    var currentStep = useSelector(function (s) {
        return Selectors.getCurrentStep(s, { id: id });
    });
    var startDate = useSelector(configurator.getSelectedStartDate);
    var lensVariants = useSelector(configurator.getLensVariants);
    var product = useSelector(configurator.getProduct);
    var ratePlans = useSelector(configurator.getSelectedRatePlan);
    var selectedDeliveryFrequency = useSelector(configurator.getSelectedDeliveryFrequency);
    var totalPrice = useSelector(function (s) {
        return configurator.getConfigurationTotalPrice(s, { id: id });
    });
    var solution = useSelector(configurator.getSelectedSolution);
    var total = getLabel("products.contactLenseBundles.price.total");
    var deliveryFrequencyLabel = getLabel("cart.delivery");
    var deliveryEstimate = getLabel("products.contactLenses.subscription.steps.deliveryEstimate");
    var subscriptionPlan = getLabel("products.contactLenses.configurator.step.subscriptionPlan");
    var startDateLabel = getLabel("products.contactLenses.subscription.steps.startDate");
    var everyMonth = getLabel('products.contactLenses.subscription.steps.deliveryFrequency.monthly.title').toLowerCase();
    var everyQuarter = getLabel('products.contactLenses.subscription.steps.deliveryFrequency.quarterly.title').toLowerCase();
    var deliveryDate = startDate && DateUtils.shiftDate(new Date(startDate), 'day', ADDED_DAYS);
    var name = product && getLocalizedValue(product.name, locale);
    var sku = (product === null || product === void 0 ? void 0 : product.masterVariant.sku) || '';
    var image = product && getProductImageData(product, sku, 100, staticsUrl, isBynderImagesEnabled);
    var replacementFrequency = product && getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale);
    var packageQuantity = ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.packageQuantity;
    var includedUnits = ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.includedUnits;
    var lenses = Object.values(lensVariants).filter(function (variant) { return eyeSides.includes(variant.eyeSide); });
    return {
        billingPeriod: billingPeriod,
        currentStep: currentStep,
        deliveryDate: deliveryDate,
        deliveryEstimate: deliveryEstimate,
        deliveryFrequencyLabel: deliveryFrequencyLabel,
        everyMonth: everyMonth,
        everyQuarter: everyQuarter,
        image: image,
        includedUnits: includedUnits,
        lenses: lenses,
        locale: locale,
        name: name,
        packageQuantity: packageQuantity,
        replacementFrequency: replacementFrequency,
        selectedDeliveryFrequency: selectedDeliveryFrequency,
        startDate: startDate,
        startDateLabel: startDateLabel,
        subscriptionPlan: subscriptionPlan,
        total: total,
        totalPrice: totalPrice,
        solution: solution,
    };
};

var FREQUENCY_STEP = 'deliveryFrequency';
var BILLING_MONTHLY = 'monthly';
var ExpanderContent = function () {
    var _a = useFooter(), billingPeriod = _a.billingPeriod, currentStep = _a.currentStep, deliveryDate = _a.deliveryDate, deliveryEstimate = _a.deliveryEstimate, deliveryFrequencyLabel = _a.deliveryFrequencyLabel, everyMonth = _a.everyMonth, everyQuarter = _a.everyQuarter, image = _a.image, includedUnits = _a.includedUnits, lenses = _a.lenses, locale = _a.locale, name = _a.name, packageQuantity = _a.packageQuantity, replacementFrequency = _a.replacementFrequency, solution = _a.solution, selectedDeliveryFrequency = _a.selectedDeliveryFrequency, startDate = _a.startDate, startDateLabel = _a.startDateLabel, subscriptionPlan = _a.subscriptionPlan, total = _a.total, totalPrice = _a.totalPrice;
    if (!totalPrice) {
        return null;
    }
    if (!includedUnits || !packageQuantity) {
        return (React.createElement("div", { className: "cls-configurator-footer-expander-content__loader" },
            React.createElement(Loader, null)));
    }
    return (React.createElement("section", { className: "cls-configurator-footer-expander-content" },
        React.createElement(ExpanderContentItem, { imageUrl: image === null || image === void 0 ? void 0 : image.url, includedUnits: includedUnits, lenses: lenses, name: name, packageQuantity: packageQuantity, replacementFrequency: replacementFrequency, solution: solution }),
        React.createElement("div", { className: "cls-configurator-footer-expander-content__subscription" },
            React.createElement("p", { className: "cls-configurator-footer-expander-content__subscription__title" }, subscriptionPlan),
            (currentStep === null || currentStep === void 0 ? void 0 : currentStep.name) !== FREQUENCY_STEP && (React.createElement("div", null,
                React.createElement(Alert, { "data-t": "delivery-alert", icon: "delivery" }, deliveryEstimate + " ",
                    React.createElement(DateTime, { locale: locale, dateTime: deliveryDate ? deliveryDate : '' })),
                React.createElement("div", { className: "cls-configurator-footer-expander-content__subscription-info" },
                    React.createElement("span", null, startDateLabel + ": "),
                    React.createElement(DateTime, { locale: locale, dateTime: startDate ? startDate : '' })))),
            React.createElement("div", { className: "cls-configurator-footer-expander-content__subscription-info" },
                React.createElement("span", null, deliveryFrequencyLabel + ": "),
                React.createElement("span", { className: "cls-configurator-footer-expander-content__subscription-info__delivery" }, selectedDeliveryFrequency)),
            (currentStep === null || currentStep === void 0 ? void 0 : currentStep.name) !== FREQUENCY_STEP && (React.createElement("div", { className: "cls-configurator-footer-expander-content__subscription-info" },
                React.createElement("span", null, total + ": "),
                React.createElement("span", { className: "cls-configurator-footer-expander-content__subscription-info__amount" },
                    React.createElement(Price, { "data-t": "total-price", className: "cls-configurator-footer-expander-content__subscription-info__amount-total", currency: totalPrice.currency, value: totalPrice.originalPrice }),
                    billingPeriod === BILLING_MONTHLY ? everyMonth : everyQuarter))))));
};

var ConfigurationTotalPriceContainer = function () {
    var isPhone = MediaQuery.useIsPhone();
    var id = useClsConfiguratorContext().id;
    var totalPrice = useSelector(function (s) {
        return getConfigurationTotalPrice(s, { id: id });
    });
    if (!totalPrice) {
        return null;
    }
    return React.createElement(ConfigurationTotalPrice, __assign$1({ centAmount: true, size: isPhone ? 'small' : 'large' }, totalPrice));
};

var SubscriptionInformation = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, _b = _a.showImage, showImage = _b === void 0 ? true : _b, // TODO replace with icon when we have multiple subscription items
    _c = _a.textOrientation, // TODO replace with icon when we have multiple subscription items
    textOrientation = _c === void 0 ? 'vertical' : _c;
    return (React.createElement("div", { "data-t": "subscription-information", className: "subscription-information subscription-information--" + textOrientation },
        showImage && imageUrl && (React.createElement("img", { src: imageUrl, alt: title, className: "subscription-information__image" })),
        React.createElement("div", { className: "subscription-information__text" },
            React.createElement(Heading, { variant: "subheading1", className: "subscription-information__title" }, title),
            React.createElement("span", { className: "frame-information__subtitle" }, subtitle))));
};

var SubscriptionInformationContainer = function (props) {
    var locale = useIntl().locale;
    var staticsUrl = useProductDetailContext().staticsUrl;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var product = useSelector(getProduct);
    if (!product) {
        return null;
    }
    var brand = getLocalizedValue(product.name, locale);
    var replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale);
    var image = getProductImageData(product, product.masterVariant.sku, 100, staticsUrl, isBynderImagesEnabled);
    return (React.createElement(SubscriptionInformation, __assign$1({}, props, { title: brand, subtitle: replacementFrequency, imageUrl: image === null || image === void 0 ? void 0 : image.url })));
};

var TopBar = function () { return (React.createElement("div", { className: "cls-configurator-footer-topbar" },
    React.createElement("div", { className: "cls-configurator-footer-topbar__aside" },
        React.createElement(SubscriptionInformationContainer, null)),
    React.createElement("div", { className: "cls-configurator-footer-topbar__main" },
        React.createElement(ConfigurationTotalPriceContainer, null)))); };

var _a;
var errorCodePrefix = 'validations';
var errorLabelMap = (_a = {},
    _a[errorCodePrefix + ".maxVariantsPerProductTypeQuantityExceeded"] = LABEL_PREFIX + ".subscriptionLimitCart",
    _a);
var mapErrorLabels = function (errorLabels) {
    // only map error labels with validation prefixes
    var validationErrorLabels = errorLabels.filter(function (code) { return code.includes(errorCodePrefix); });
    // cart prefix is used here because error labels from cart do not come back with the cart prefix
    var mappedErrorLabels = validationErrorLabels.map(function (label) { var _a; return (_a = errorLabelMap[label]) !== null && _a !== void 0 ? _a : "cart." + label; });
    return mappedErrorLabels;
};

var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["EnableCartsV2"] = "Feature CARTS_V2 is not enabled";
    ErrorMessage["Generic"] = "Add to cart failed";
    ErrorMessage["InsufficientData"] = "Insufficient data to create cart";
    ErrorMessage["ValidationError"] = "Failed to validate cart";
})(ErrorMessage || (ErrorMessage = {}));
var useCreateCartCallback = function (configuratorId) {
    var dispatch = useDispatch();
    var useAddToCart = useProductDetailContext().useAddToCart;
    var lineItemDraft = useSelector(getLineItemDraft);
    var isEvent = function (arg) { return Boolean(arg === null || arg === void 0 ? void 0 : arg.preventDefault); };
    var handleError = React__default.useCallback(function (errorMessage, errorLabels) {
        if (errorLabels === null || errorLabels === void 0 ? void 0 : errorLabels.length) {
            errorLabels.forEach(function (label) { return toast.failed(label); });
        }
        else {
            toast.failed(LABEL_PREFIX + ".addToCartFailed");
        }
        dispatch(addToCartFailed(new Error(errorMessage)));
    }, [dispatch]);
    var onSuccess = React__default.useCallback(function () {
        dispatch(addToCartSuccess());
    }, [dispatch]);
    var onValidationError = React__default.useCallback(function (codes) {
        var errorMessage = ErrorMessage.ValidationError + ": " + codes.join(', ');
        var errorLabels = mapErrorLabels(codes);
        return handleError(errorMessage, errorLabels);
    }, [handleError]);
    var onError = React__default.useCallback(function (code) { return handleError(ErrorMessage.Generic + ": " + code); }, [handleError]);
    /**
     * Officially we are conditionally calling a hook here. In this case it's not an issue, as the hook
     * will either always be there or always be undefined. There won't be a difference between renders.
     * We're either always calling it, or always ignoring it, depending on whether CARTS_V2 is enabled.
     */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = __read(useAddToCart ? useAddToCart() : [undefined], 1), addToCart$1 = _a[0];
    useSaga(React__default.useMemo(function () {
        return function () {
            var _a, failure;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        return [4 /*yield*/, race([
                                take(addToCartFailed.type),
                                take(addToCartSuccess.type),
                            ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 1]), failure = _a[0];
                        if (!failure) return [3 /*break*/, 3];
                        return [4 /*yield*/, put(Actions.finishFailed({
                                id: configuratorId,
                                reason: new Error(failure.error.message),
                            }))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 0];
                    case 3: return [4 /*yield*/, put(Actions.finishSuccess({ id: configuratorId }))];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 0];
                    case 5: return [2 /*return*/];
                }
            });
        };
    }, [configuratorId]));
    return React__default.useCallback(function (arg) {
        if (isEvent(arg))
            arg.preventDefault();
        dispatch(addToCart());
        if (lineItemDraft === null)
            return handleError(ErrorMessage.InsufficientData);
        if (!addToCart$1)
            return handleError(ErrorMessage.EnableCartsV2);
        addToCart$1([lineItemDraft], onSuccess, onValidationError, onError);
    }, [dispatch, addToCart$1, lineItemDraft, handleError, onSuccess, onValidationError, onError]);
};

var contentProps = {
    footerTopBarContent: React__default.createElement(TopBar, null),
    footerExpanderContent: React__default.createElement(ExpanderContent, null),
};
var ClsConfigurator = function (_a) {
    var isOpen = _a.isOpen, onModalClose = _a.onModalClose, triggerButtonRef = _a.triggerButtonRef, clsProviderProps = __rest(_a, ["isOpen", "onModalClose", "triggerButtonRef"]);
    useSaga(React__default.useMemo(function () {
        return function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, take([
                                function (a) { return actions$1.isType(a, Actions.finishSuccess) && a.payload.id === CONFIGURATOR_ID; },
                            ])];
                    case 1:
                        _a.sent();
                        if (!onModalClose) return [3 /*break*/, 3];
                        return [4 /*yield*/, call(onModalClose)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(triggerButtonRef === null || triggerButtonRef === void 0 ? void 0 : triggerButtonRef.current)) return [3 /*break*/, 5];
                        return [4 /*yield*/, call([triggerButtonRef.current, 'focus'])];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        };
    }, [onModalClose, triggerButtonRef]));
    useSaga(React__default.useMemo(function () {
        return function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, listenForConfigurationChanges(CONFIGURATOR_ID)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        };
    }, []));
    var finishHandler = useCreateCartCallback(CONFIGURATOR_ID);
    if (!isOpen) {
        return null;
    }
    return (React__default.createElement(ClsConfiguratorProvider, __assign$1({ id: CONFIGURATOR_ID }, clsProviderProps),
        React__default.createElement(Configurator, __assign$1({ id: CONFIGURATOR_ID, "data-t": "cls-configurator-modal", stepSequence: stepSequence, stepsMap: stepsMap, lastStepCTALabelKey: "products.contactLenses.configurator.footer.addToCart", isOpen: isOpen, onModalClose: onModalClose, onFinish: finishHandler }, contentProps))));
};

var useCartSolutionChange = function (lineItems) {
    var dispatch = useDispatch();
    var cart = useSelector(ReduxDataSource.Selectors.getCartResult);
    return React.useCallback(function () {
        if (cart) {
            // When a solution changes we need to remove the old lens bundle and add a new one.
            var existingLensBundles = cart.lineItems.reduce(function (result, lineItem) {
                var _a;
                if (((_a = lineItem.productType.obj) === null || _a === void 0 ? void 0 : _a.name) === 'Contact-lens-bundles') {
                    return __spreadArray$1(__spreadArray$1([], __read(result)), [lineItem]);
                }
                return result;
            }, []);
            var removeActions = existingLensBundles.map(function (lineItem) { return ({
                action: 'removeLineItem',
                lineItemId: lineItem.id,
            }); });
            var addActions = lineItems.map(function (_a) {
                var sku = _a.sku, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b, customAttributes = _a.customAttributes;
                var type = customAttributes.type, custom = __rest(customAttributes, ["type"]);
                return {
                    action: 'addLineItem',
                    sku: sku,
                    quantity: quantity,
                    custom: {
                        type: {
                            key: type,
                        },
                        fields: custom,
                    },
                };
            });
            var actions = __spreadArray$1(__spreadArray$1([], __read(removeActions)), __read(addActions));
            // TODO: handleSDActions as updateCart does not have that working yet.
            dispatch(ReduxDataSource.Actions.updateCart({ actions: actions }));
        }
    }, [cart, lineItems]);
};

var SubscriptionSolution = function (_a) {
    var isChecked = _a.isChecked, onChange = _a.onChange, solution = _a.solution, title = _a.title;
    var bundleSku = solution.bundleSku, bundlePrice = solution.bundlePrice;
    return (React__default.createElement(RadioButton, { isChecked: isChecked, onChange: onChange, position: "bottom", value: bundleSku, className: classnames('subscription-solution', {
            'subscription-solution--empty': !solution.description && !solution.imageUrl,
        }) },
        React__default.createElement("div", { className: "subscription-solution__container" },
            solution.imageUrl && (React__default.createElement("div", { className: "subscription-solution__image-holder" },
                React__default.createElement("img", { className: "subscription-solution__image", src: solution.imageUrl, alt: title }))),
            React__default.createElement(Heading, { variant: "small", className: "subscription-solution__title", "data-t": "subscription-solution-title" }, title),
            bundlePrice[0].value && (React__default.createElement("span", { className: "subscription-solution__price" },
                React__default.createElement(Price, { value: bundlePrice[0].value.centAmount, currency: bundlePrice[0].value.currencyCode }))))));
};

var SubscriptionSolutionContainer = function (_a) {
    var onChange = _a.onChange, isChecked = _a.isChecked, solution = _a.solution;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var solutionProduct = React__default.useMemo(function () {
        var _a;
        var imageUrl = isBynderImagesEnabled
            ? getFrontImage((_a = solution.media) === null || _a === void 0 ? void 0 : _a.images).url + "?w=300&auto=format"
            : solution.imageUrl;
        return __assign$1(__assign$1({}, solution), { imageUrl: imageUrl });
    }, [solution, isBynderImagesEnabled]);
    var title = solutionProduct.name
        ? getLocalizedValue(solutionProduct.name, locale)
        : getLabel('products.contactLenses.solutions.missing');
    return (React__default.createElement(SubscriptionSolution, { isChecked: isChecked, onChange: onChange, solution: solutionProduct, title: title }));
};

var SubscriptionSolutionPicker = function (_a) {
    var labels = _a.labels, onChange = _a.onChange, selectedSolution = _a.selectedSolution, solutions = _a.solutions;
    return (React__default.createElement("div", { className: "subscription-solution-picker" },
        React__default.createElement(Heading, { variant: "subheading1", className: "subscription-solution-picker__title" }, labels.title),
        React__default.createElement("div", { className: "subscription-solution-picker__list" },
            React__default.createElement(React__default.Fragment, null, solutions.map(function (solution) { return (React__default.createElement("div", { className: "subscription-solution-picker__item", key: solution.bundleSku },
                React__default.createElement(SubscriptionSolutionContainer, { onChange: onChange, isChecked: selectedSolution ? solution.bundleSku === selectedSolution.bundleSku : false, solution: solution }))); }))),
        selectedSolution && (React__default.createElement("p", { className: "subscription-solution-picker__description" }, labels.description))));
};

var SubscriptionSolutionPickerContainer = function () {
    var _a = useIntl(), getLabel = _a.getLabel, locale = _a.locale;
    var _b = useLensBundle(), lineItems = _b.lineItems, _c = _b.solutions, items = _c.items, onSolutionChange = _c.onSolutionChange, activeSolution = _c.activeSolution;
    var _d = __read(React__default.useState(false), 2), shouldUpdateCart = _d[0], setShouldUpdateCart = _d[1];
    var handleCartSolutionChange = useCartSolutionChange(lineItems);
    var labels = React__default.useMemo(function () { return ({
        title: getLabel('products.contactLenses.solutions.title'),
        description: (activeSolution === null || activeSolution === void 0 ? void 0 : activeSolution.description) && getLocalizedValue(activeSolution.description, locale),
    }); }, []);
    React__default.useEffect(function () {
        if (shouldUpdateCart) {
            handleCartSolutionChange();
            setShouldUpdateCart(false);
        }
    }, [shouldUpdateCart]);
    var handleChange = React__default.useCallback(function (event) {
        onSolutionChange(event.currentTarget.value, function () { return setShouldUpdateCart(true); });
    }, [items, handleCartSolutionChange]);
    if (!activeSolution) {
        return null;
    }
    return (React__default.createElement(SubscriptionSolutionPicker, { onChange: handleChange, selectedSolution: activeSolution, solutions: items, labels: labels }));
};

function createSubscriptionPriceSpecification(activeVariant, pricePerMonth) {
    var currency = pricePerMonth.currencyCode;
    var subscriptionPriceSpecification = {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: calcPrice(pricePerMonth.centAmount),
        priceCurrency: currency,
        valueAddedTaxIncluded: true,
    };
    return subscriptionPriceSpecification;
}
var createViewProductEvent = function (_a) {
    var _b, _c;
    var product = _a.product, activeSKU = _a.activeSKU, staticsUrl = _a.staticsUrl, url = _a.url, locale = _a.locale, isSubscriptionSelected = _a.isSubscriptionSelected, pricePerMonth = _a.pricePerMonth, extra = _a.extra, isBynderImagesEnabled = _a.isBynderImagesEnabled;
    var activeVariant = __spreadArray$1([product.masterVariant], __read(product.variants)).find(function (variant) { return variant.sku === activeSKU; }) ||
        product.masterVariant;
    var subscriptionProductSku = (_c = (_b = activeVariant.attributes) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var name = _a.name;
        return name === 'subscriptionProductSKU';
    })) === null || _c === void 0 ? void 0 : _c.value;
    var vat = getNestedProperty(product, 'taxCategory.obj.rates', []).find(function (rate) { return rate.includedInPrice; });
    var offers = [
        {
            '@type': 'Offer',
            priceSpecification: isSubscriptionSelected && pricePerMonth
                ? createSubscriptionPriceSpecification(activeVariant, pricePerMonth)
                : createPriceSpecification(activeVariant, vat.amount),
        },
    ];
    var _d = parseProductData(product, activeVariant, staticsUrl, locale, isBynderImagesEnabled), name = _d.name, image = _d.image, description = _d.description, brand = _d.brand, category = _d.category, sku = _d.sku;
    var action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: 'product_detail',
        // The object currently has the same structure as what is sent by the `Product` SD component.
        object: __assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ '@type': 'Product', '@id': url + "#product", url: url, sku: isSubscriptionSelected ? subscriptionProductSku : sku, skuMaster: product.masterVariant.sku, purchaseModel: isSubscriptionSelected ? 'subscription' : 'single purchase', image: image, name: (name && String(name)) || sku }, optionalKey('description', description)), optionalKey('brand', brand)), optionalKey('category', category)), optionalKey('offers', offers)), extra),
    };
    return action;
};
var viewProductSdEvent = function (params) {
    var action = createViewProductEvent(params);
    pushSdAction(action);
};

var ConfiguratorButton = function (_a) {
    var calculatedPrice = _a.calculatedPrice, calculatedDiscountPrice = _a.calculatedDiscountPrice, isPrescriptionEnabled = _a.isPrescriptionEnabled, hasLenses = _a.hasLenses, btnRef = _a.btnRef, onClick = _a.onClick;
    var _b = useIntl(), getLabel = _b.getLabel, currency = _b.currency;
    var caption = (React.createElement(React.Fragment, null,
        React.createElement(Text, { component: "span", variant: "body" }, getLabel('products.actions.openContactLensSubscriptionConfigurator')),
        isPrescriptionEnabled && hasLenses && (React.createElement(Text, { component: "span", variant: "body", className: "product-detail__add-to-cart" },
            React.createElement(Price, { value: calculatedDiscountPrice || calculatedPrice, currency: currency, centAmount: true }),
            ' ',
            getLabel('common.frequency.perMonth')))));
    return (React.createElement(Button, { size: "large", caption: caption, "data-t": "btn-open-cls-configurator", onClick: onClick, btnRef: btnRef }));
};

var CTAButton$1 = function (_a) {
    var onPrescriptionClick = _a.onPrescriptionClick, handleMiniCartChange = _a.handleMiniCartChange, isPrescriptionEnabled = _a.isPrescriptionEnabled, isSubscription = _a.isSubscription, calculatedDiscountPrice = _a.calculatedDiscountPrice, calculatedPrice = _a.calculatedPrice, lineItemsForCart = _a.lineItemsForCart, excludedFromCheckout = _a.excludedFromCheckout, hasLenses = _a.hasLenses, onClick = _a.onClick, pricePerMonth = _a.pricePerMonth, renderAddToCartButton = _a.renderAddToCartButton, handleConversionEvent = _a.handleConversionEvent;
    var _b = useIntl(), getLabel = _b.getLabel, currency = _b.currency;
    var routes = useProductDetailContext().routes;
    var storesRoute = routes.stores;
    var addToCartCallback = React.useCallback(function () {
        handleMiniCartChange && handleMiniCartChange();
        onClick && onClick();
    }, [handleMiniCartChange, onClick]);
    var isPhone = MediaQuery.useIsPhone();
    var buttonSize = isPhone ? 'small' : 'medium';
    /*
     * If subscription product and configuration is valid, show button with monthly costs that triggers the MiniCart
     * */
    if (isSubscription && hasLenses) {
        var addToCartSharedProps = {
            'data-t': 'btn-subscription',
            caption: (React.createElement(React.Fragment, null,
                React.createElement(Text, { component: "span", variant: "body" }, getLabel('products.actions.addToCart')),
                pricePerMonth && (React.createElement(Text, { component: "span", variant: "body", className: "product-detail__add-to-cart" },
                    '(',
                    React.createElement(Price, { value: pricePerMonth.centAmount, currency: currency, centAmount: true }),
                    ' / ',
                    getLabel('common.frequency.perMonth'),
                    ')')))),
        };
        var addToCartPropsV1 = __assign$1(__assign$1({}, addToCartSharedProps), { onClick: addToCartCallback, lineItems: lineItemsForCart });
        var addToCartPropsV2 = __assign$1(__assign$1({}, addToCartSharedProps), { onSuccess: addToCartCallback, lineItemDrafts: lineItemsForCart.map(function (_a) {
                var sku = _a.sku, quantity = _a.quantity, custom = _a.custom, customAttributes = _a.customAttributes;
                return ({
                    sku: sku,
                    quantity: quantity,
                    type: 'contact-lenses-bundle-benelux',
                    typeDetails: __assign$1(__assign$1({}, custom), customAttributes),
                });
            }) });
        return renderAddToCartButton ? (renderAddToCartButton(addToCartPropsV2)) : (React.createElement(AddToCart, __assign$1({}, addToCartPropsV1)));
    }
    if (isPrescriptionEnabled && hasLenses) {
        var addToCartSharedProps = {
            caption: (React.createElement(React.Fragment, null,
                React.createElement(Text, { component: "span", variant: "body" }, getLabel('products.actions.addToCart')),
                React.createElement(Text, { component: "span", variant: "body", className: "product-detail__add-to-cart" },
                    React.createElement(Price, { value: calculatedDiscountPrice ? calculatedDiscountPrice : calculatedPrice, currency: currency, centAmount: true })))),
        };
        var addToCartPropsV1 = __assign$1(__assign$1({}, addToCartSharedProps), { onClick: addToCartCallback, lineItems: lineItemsForCart });
        var addToCartPropsV2 = __assign$1(__assign$1({}, addToCartSharedProps), { onSuccess: addToCartCallback, lineItemDrafts: lineItemsForCart.map(function (_a) {
                var sku = _a.sku, quantity = _a.quantity, custom = _a.custom, customAttributes = _a.customAttributes;
                return ({
                    sku: sku,
                    quantity: quantity,
                    type: 'contact-lenses',
                    typeDetails: __assign$1(__assign$1({}, custom), customAttributes),
                });
            }) });
        return renderAddToCartButton ? (renderAddToCartButton(addToCartPropsV2)) : (React.createElement(AddToCart, __assign$1({}, addToCartPropsV1)));
    }
    if (excludedFromCheckout) {
        return (React.createElement(Button, { size: buttonSize, caption: getLabel('products.actions.excludedFromCheckout'), "data-t": "btn-excluded-from-checkout", href: storesRoute, onClick: handleConversionEvent }));
    }
    if (!isPrescriptionEnabled) {
        return (React.createElement(Button, { size: buttonSize, caption: getLabel('products.actions.bookAppointment'), href: storesRoute, "data-t": "btn-book-appointment", onClick: handleConversionEvent }));
    }
    return (React.createElement(Button, { size: buttonSize, className: "add-to-cart", caption: getLabel('products.actions.addToCart'), "data-t": "btn-enter-prescription", onClick: onPrescriptionClick }));
};

/**
 * From the API returned solution data, create objects that can be processed
 * by the CrossSellBlock
 */
var parseCTSolutionData = function (solutions, locale, staticsUrl, getLabel, isBynderImagesEnabled) {
    if (!solutions || solutions.length === 0) {
        return [];
    }
    return solutions.reduce(function (storedSolutions, solution, index) {
        var _a;
        var masterVariant = solution.masterVariant, name = solution.name;
        var price = getPrice$1(masterVariant);
        if (price === undefined || index > 3) {
            return storedSolutions;
        }
        var title = getLocalizedValue(name, locale);
        var SKU = masterVariant.sku ? masterVariant.sku : '';
        var imageUrl = (_a = getFullImageUrls(masterVariant, staticsUrl, isBynderImagesEnabled)[0]) === null || _a === void 0 ? void 0 : _a.url;
        var solutionType = getAttrValue(masterVariant, 'solutionType');
        var volume = getAttrValue(masterVariant, 'volume');
        var subTitle;
        if (solutionType && volume) {
            subTitle = solutionType + ", " + volume + getLabel('products.unit.metric.liter.milli.abbr');
        }
        var product = {
            title: title,
            subTitle: subTitle,
            imageUrl: imageUrl,
            SKU: SKU,
            price: price,
            quantity: 0,
        };
        storedSolutions.push(product);
        return storedSolutions;
    }, []);
};

var CrossSellItem = function (_a) {
    var imageUrl = _a.imageUrl, onUpdate = _a.onUpdate, price = _a.price, quantity = _a.quantity, SKU = _a.SKU, subTitle = _a.subTitle, title = _a.title, intl = _a.intl, maxQuantity = _a.maxQuantity;
    var increaseQuantity = React.useCallback(function () {
        onUpdate('increment', SKU);
    }, [onUpdate, SKU]);
    var decreaseQuantity = React.useCallback(function () {
        onUpdate('decrement', SKU);
    }, [onUpdate, SKU]);
    return (React.createElement("div", { className: classnames('cross-sell-item', {
            _is_active: quantity > 0,
        }) },
        React.createElement("div", { className: "cross-sell-item__image-holder" },
            React.createElement("img", { className: "cross-sell-item__image", src: imageUrl + "?w=300&auto=format", alt: title })),
        React.createElement("div", { className: "cross-sell-item__title" },
            React.createElement(Heading, { variant: "small", className: "cross-sell-item__title-heading" }, title)),
        subTitle ? React.createElement("span", { className: "cross-sell-item__subtitle" }, subTitle) : null,
        price && (React.createElement(PriceTag, { className: "cross-sell-item__price", currency: intl.currency, discountedPrice: price.discountedPrice, originalPrice: price.originalPrice })),
        React.createElement("div", { className: "cross-sell-item__quantity-selector" },
            React.createElement(QuantitySelector, { maximumQuantity: maxQuantity, quantity: quantity, minimumQuantity: 0, onDecreaseQuantity: decreaseQuantity, onIncreaseQuantity: increaseQuantity }))));
};
var CrossSellItem$1 = withIntl(CrossSellItem);

var CrossSellBlock = function (_a) {
    var onUpdateItem = _a.onUpdateItem, products = _a.products, maxQuantity = _a.maxQuantity;
    var crossSellItems = products &&
        products.map(function (_a) {
            var imageUrl = _a.imageUrl, price = _a.price, quantity = _a.quantity, SKU = _a.SKU, subTitle = _a.subTitle, title = _a.title;
            return (React.createElement(CrossSellItem$1, { imageUrl: imageUrl, key: SKU, onUpdate: onUpdateItem, price: price, quantity: quantity, SKU: SKU, subTitle: subTitle, title: title, maxQuantity: maxQuantity }));
        });
    return React.createElement("div", { className: "cross-sell" }, crossSellItems);
};

var Solutions$1 = function (_a) {
    var labels = _a.labels, onUpdateItem = _a.onUpdateItem, solutions = _a.solutions, maxQuantity = _a.maxQuantity;
    return (React.createElement("div", { className: "solutions" },
        React.createElement(Heading, { variant: "subheading1", className: "solutions__title" }, labels.title),
        labels.disclaimer && !!solutions.length && React.createElement(Alert, { type: "info" }, labels.disclaimer),
        React.createElement(CrossSellBlock, { onUpdateItem: onUpdateItem, products: solutions, maxQuantity: maxQuantity })));
};

var SolutionsContainer$1 = function (_a) {
    var recommendedCategoryKey = _a.recommendedCategoryKey, staticsUrl = _a.staticsUrl, maxQuantity = _a.maxQuantity;
    var _b = useIntl(), currency = _b.currency, country = _b.country, getLabel = _b.getLabel, locale = _b.locale;
    var productsUrl = useApiConfig().productsUrl;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var _c = __read(React.useState([]), 2), solutions = _c[0], setSolutions = _c[1];
    var dispatch = useDispatch();
    var cart = useSelector(ReduxDataSource.Selectors.getCartResult);
    /**
     * Load solutions for a given category key.
     * Parse the results and store it in the state
     */
    React.useEffect(function () {
        var fetchSolutions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Products.query(productsUrl, {
                                categoryType: recommendedCategoryKey,
                            })];
                    case 1:
                        results = (_a.sent()).results;
                        data = parseCTSolutionData(results, locale, staticsUrl, getLabel, isBynderImagesEnabled);
                        setSolutions(data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Error fetching solutions " + e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchSolutions();
    }, [productsUrl, recommendedCategoryKey]);
    var handleSolutionChange = React.useCallback(function (action, SKU) {
        var _a;
        var lineItem = (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lineItem) { return lineItem.variant.sku === SKU; });
        var incrementAllowed = isNumber(maxQuantity) && lineItem ? lineItem.quantity <= maxQuantity : true;
        var decrementAllowed = !!lineItem && lineItem.quantity > 0;
        if (action === 'increment' && incrementAllowed) {
            dispatch(ReduxDataSource.Actions.addToCart({
                currency: currency,
                country: country,
                locale: locale,
                lineItems: [{ sku: SKU, quantity: 1 }],
            }));
        }
        if (action === 'decrement' && lineItem && decrementAllowed) {
            if (lineItem.quantity === 1) {
                dispatch(ReduxDataSource.Actions.removeLineItems({
                    lineItems: [lineItem],
                }));
            }
            else {
                dispatch(ReduxDataSource.Actions.changeQuantity({
                    lineItem: lineItem,
                    newQuantity: lineItem.quantity - 1,
                }));
            }
        }
        if (incrementAllowed || decrementAllowed) {
            setSolutions(function (prevState) {
                var newSolutions = prevState.map(function (solution) {
                    return solution.SKU === SKU
                        ? __assign$1(__assign$1({}, solution), { quantity: Math.max(0, (solution.quantity || 0) + (action === 'increment' ? 1 : -1)) }) : solution;
                });
                return newSolutions;
            });
        }
    }, [cart, currency, country, locale, maxQuantity, dispatch]);
    var labels = React.useMemo(function () { return ({
        title: getLabel('products.contactLenses.solutions.title'),
        disclaimer: getLabel('products.solutions.disclaimer', {
            hideLabelKey: true,
        }),
    }); }, [getLabel]);
    if (solutions.length === 0) {
        return null;
    }
    var solutionsWithQuantity = solutions.map(function (solution) {
        var _a;
        var lineItem = (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lineItem) { return lineItem.variant.sku === solution.SKU; });
        var quantity = lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity;
        if (isNumber(quantity) && solution.quantity !== quantity) {
            return __assign$1(__assign$1({}, solution), { quantity: quantity });
        }
        return solution;
    });
    return (React.createElement(Solutions$1, { onUpdateItem: handleSolutionChange, labels: labels, solutions: solutionsWithQuantity, maxQuantity: maxQuantity }));
};

var calculatePrescription = function (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionValid) {
    if (!config || !Object.keys(config).length || !config.packPrice) {
        return {
            selectedProducts: [],
            packageQuantity: 0,
            totalDiscount: undefined,
            totalPrice: 0,
            totalSubscriptionPrice: 0,
        };
    }
    var leftEyeBoxSKU = config.leftEyeBoxSKU, leftEyeChecked = config.leftEyeChecked, leftEyeBoxQuantity = config.leftEyeBoxQuantity, leftEyeBoxAvailableQuantity = config.leftEyeBoxAvailableQuantity, rightEyeBoxSKU = config.rightEyeBoxSKU, rightEyeChecked = config.rightEyeChecked, rightEyeBoxQuantity = config.rightEyeBoxQuantity, rightEyeBoxAvailableQuantity = config.rightEyeBoxAvailableQuantity, hasHardQuantityLimit = config.hasHardQuantityLimit, subscriptionPrice = config.subscriptionPrice, centAmount = config.packPrice.value.centAmount, prescriptionInfo = config.prescriptionInfo;
    var hasDiscount = !!config.packPrice.discounted &&
        !!config.packPrice.discounted.value &&
        !!config.packPrice.discounted.value.centAmount;
    var discountedPackPrice = config.packPrice.discounted;
    var discountedCentAmount = discountedPackPrice && discountedPackPrice.value.centAmount;
    var selectedProducts = [];
    var calculatedPrices = [];
    var calculatedDiscountedPrices = [];
    if (isPrescriptionValid &&
        leftEyeBoxQuantity &&
        (leftEyeBoxAvailableQuantity || !hasHardQuantityLimit) &&
        leftEyeChecked &&
        leftEyeBoxSKU) {
        var totalPriceLeft = leftEyeBoxQuantity * centAmount;
        var leftLensSKU = {
            sku: leftEyeBoxSKU,
            quantity: leftEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'left',
            },
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            var prescriptionExpiryDate = prescriptionInfo.prescriptionExpiryDate, prescriptionExamDate = prescriptionInfo.prescriptionExamDate, externalOptician = prescriptionInfo.externalOptician, internalOptician = prescriptionInfo.internalOptician;
            leftLensSKU.customAttributes = __assign$1(__assign$1({}, leftLensSKU.customAttributes), { prescriptionExpiryDate: prescriptionExpiryDate, prescriptionExamDate: prescriptionExamDate, externalOptician: externalOptician, internalOptician: internalOptician });
        }
        selectedProducts.push(leftLensSKU);
        calculatedPrices.push(totalPriceLeft);
        if (hasDiscount) {
            var totalDiscountLeft = totalPriceLeft - discountedCentAmount * leftEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountLeft);
        }
    }
    if (isPrescriptionValid &&
        rightEyeBoxQuantity &&
        (rightEyeBoxAvailableQuantity || !hasHardQuantityLimit) &&
        rightEyeChecked &&
        rightEyeBoxSKU) {
        var totalPriceRight = rightEyeBoxQuantity * centAmount;
        var rightLensSKU = {
            sku: rightEyeBoxSKU,
            quantity: rightEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'right',
            },
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            var prescriptionExpiryDate = prescriptionInfo.prescriptionExpiryDate, prescriptionExamDate = prescriptionInfo.prescriptionExamDate, externalOptician = prescriptionInfo.externalOptician, internalOptician = prescriptionInfo.internalOptician;
            rightLensSKU.customAttributes = __assign$1(__assign$1({}, rightLensSKU.customAttributes), { prescriptionExpiryDate: prescriptionExpiryDate, prescriptionExamDate: prescriptionExamDate, externalOptician: externalOptician, internalOptician: internalOptician });
        }
        selectedProducts.push(rightLensSKU);
        calculatedPrices.push(totalPriceRight);
        if (hasDiscount) {
            var totalDiscountRight = totalPriceRight - discountedCentAmount * rightEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountRight);
        }
    }
    var calculatedPrice = calculatedPrices.reduce(function (a, b) { return a + b; }, 0);
    var totalDiscount = calculatedDiscountedPrices.reduce(function (a, b) { return a + b; }, 0);
    var calculatedDiscountPrice = totalDiscount && calculatedPrice - totalDiscount;
    // selectedProducts is eye side lenses i.e. max is two.
    // Hence multiplying the subscripton price for one eye.
    var totalSubscriptionPrice = (subscriptionPrice !== null && subscriptionPrice !== void 0 ? subscriptionPrice : 0) * selectedProducts.length;
    var packageQuantity = (config && config.packSize) || variant.packageQuantity;
    var lineItemsForCart = selectedProducts.map(function (product) {
        var productType = 'Contact-lenses';
        var newProduct = __assign$1({}, product);
        if (product.customAttributes && product.customAttributes.eyeSide) {
            var variantUrl = formatProductUrl({
                productType: productType,
                sku: product.sku,
                slug: slug,
            });
            newProduct.productUrl = variantUrl + "#product";
        }
        return newProduct;
    });
    return {
        selectedProducts: lineItemsForCart,
        totalPrice: calculatedPrice,
        totalSubscriptionPrice: totalSubscriptionPrice,
        totalDiscount: calculatedDiscountPrice,
        packageQuantity: packageQuantity,
    };
};

/**
 * Returns the product and lens features from a given variant
 */
var getContactLensFeatures = function (variant, getLabel) {
    var productFeatures = [
        {
            labelKey: 'products.contactLenses.materialType',
            attribute: 'materialType',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.lensType',
            attribute: 'lensType',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.material',
            attribute: 'material',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.waterContent',
            attribute: 'waterContent',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.features.uv',
            attribute: 'features.uv',
            isLocalised: true,
        },
    ];
    var hydration = {
        label: getLabel('products.contactLenses.features.hydration'),
        variantHasAttribute: (function () { return !!variant.features.hydration; })(),
    };
    var softness = {
        label: getLabel('products.contactLenses.features.softness'),
        variantHasAttribute: (function () { return !!variant.features.softness; })(),
    };
    var breathability = {
        label: getLabel('products.contactLenses.features.breathability'),
        variantHasAttribute: (function () { return !!variant.features.breathability; })(),
    };
    var fatigue = {
        label: getLabel('products.contactLenses.features.eyeFatigue'),
        variantHasAttribute: (function () { return !!variant.features.fatigue; })(),
    };
    var uv = {
        label: getLabel('products.contactLenses.features.uv'),
        variantHasAttribute: (function () { return !!variant.features.uv; })(),
    };
    var basics = {
        label: getLabel('products.contactLenses.features.basics'),
        variantHasAttribute: (function () { return !!variant.features.basics; })(),
    };
    var lensFeatures = {
        hydration: hydration,
        softness: softness,
        breathability: breathability,
        fatigue: fatigue,
        uv: uv,
        basics: basics,
    };
    return {
        productFeatures: productFeatures,
        lensFeatures: lensFeatures,
    };
};

var getAvailability = function (config) {
    if (!config.selectedVariants) {
        return { selectedVariantsData: [], availability: [] };
    }
    var selectedVariantsData = Object.values(config.selectedVariants);
    var availability = selectedVariantsData.map(function (variant) {
        if (variant &&
            variant.availability &&
            ((config.leftEyeChecked && variant.sku === config.leftEyeBoxSKU) ||
                (config.rightEyeChecked && variant.sku === config.rightEyeBoxSKU))) {
            return variant.availability;
        }
        return undefined;
    });
    return {
        selectedVariantsData: selectedVariantsData,
        availability: availability,
    };
};

/**
 * returns the validity for the configurator and the prescription info section
 */
var validateConfigurator = function (config, isPrescriptionInfoEnabled) {
    var _a;
    var leftEyeValid = config.leftEyeChecked ? !!config.leftEyeBoxSKU : true;
    var rightEyeValid = config.rightEyeChecked ? !!config.rightEyeBoxSKU : true;
    var isConfiguratorValid = leftEyeValid && rightEyeValid;
    var isPrescriptionInfoValid = isPrescriptionInfoEnabled
        ? ((_a = config === null || config === void 0 ? void 0 : config.prescriptionInfo) === null || _a === void 0 ? void 0 : _a.valid) || false
        : true;
    return {
        isConfiguratorValid: isConfiguratorValid,
        isPrescriptionInfoValid: isPrescriptionInfoValid,
    };
};

/**
 * Calls the different helper functions in order to retrieve the complete state
 * needed for the Lenses component
 */
var getPrescriptionState = function (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug) {
    var _a = getAvailability(config), availability = _a.availability, selectedVariantsData = _a.selectedVariantsData;
    var formErrorState = validateConfigurator(config, isPrescriptionInfoEnabled);
    var isPrescriptionInfoValid = formErrorState.isPrescriptionInfoValid, isConfiguratorValid = formErrorState.isConfiguratorValid;
    var prescriptionResult = calculatePrescription(config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionInfoValid && isConfiguratorValid);
    return {
        availability: availability,
        formErrorState: formErrorState,
        prescriptionResult: prescriptionResult,
        selectedVariantsData: selectedVariantsData,
    };
};

var useLenses = function (_a) {
    var _b;
    var product = _a.product, isPrescriptionEnabled = _a.isPrescriptionEnabled, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, variant = _a.variant, formatProductUrl = _a.formatProductUrl;
    var packageQuantity = Number(getAttrValue(product.masterVariant, 'packageQuantity'));
    /**
     * Stores the pack price, this updates when a different pack size is selected
     */
    var _c = __read(React.useState((_b = product.masterVariant.prices) === null || _b === void 0 ? void 0 : _b[0]), 2), packPrice = _c[0], setPackPrice = _c[1];
    var _d = __read(React.useState(), 2), subscriptionPrice = _d[0], setSubscriptionPrice = _d[1];
    /**
     * Stores the pack price, usage frequency and subscription pack size when a
     * different pack size is selected. These values are passed into the contact
     * lens configurator.
     */
    var _e = __read(React.useState({ eyeSides: [] }), 2), subscriptionConfiguratorInput = _e[0], setSubscriptionConfiguratorInput = _e[1];
    /**
     * Selected prescription state which keeps track of the selected lenses
     * and the corresponding prices
     */
    var _f = __read(React.useState({
        packageQuantity: packageQuantity,
        selectedProducts: [],
        totalPrice: 0,
        totalSubscriptionPrice: 0,
        totalDiscount: undefined,
    }), 2), lensesState = _f[0], setLensesState = _f[1];
    /**
     * Keeps track of the availability and the selected lenses,
     * these are used in the DeliveryIndicator
     */
    var _g = __read(React.useState([]), 2), availability = _g[0], setAvailability = _g[1];
    var _h = __read(React.useState([]), 2), selectedLensVariants = _h[0], setSelectedLensVariants = _h[1];
    /**
     * Keeps track of the error states for the configurator and prescriptionInfo,
     * the error count is used for re-rendering the error Alert components
     */
    var _j = __read(React.useState({
        errorCount: 0,
        showError: false,
        isConfiguratorValid: false,
        isPrescriptionInfoValid: !isPrescriptionEnabled,
    }), 2), formValidations = _j[0], setFormValidations = _j[1];
    /**
     * Keeps track of the when to show the MiniCart
     */
    var _k = __read(React.useState(false), 2), showMiniCart = _k[0], setShowMiniCart = _k[1];
    /**
     * Click handler assigned to the enter prescription button
     * Clicking this button always means the user has not filled in
     * the requested forms completely.
     */
    var handlePrescriptionClick = React.useCallback(function () {
        setFormValidations(__assign$1(__assign$1({}, formValidations), { showError: true, errorCount: formValidations.errorCount + 1 }));
    }, [formValidations]);
    /**
     * Contact lens configurator callback
     * This will derive the different states based on the form
     */
    var handleFormChange = React.useCallback(function (config) {
        var _a = getPrescriptionState(config, !!isPrescriptionInfoEnabled, variant, formatProductUrl, product.slug), prescriptionResult = _a.prescriptionResult, availability = _a.availability, formErrorState = _a.formErrorState, selectedVariantsData = _a.selectedVariantsData;
        var eyeSides = [
            {
                side: 'left',
                checked: config.leftEyeChecked,
            },
            {
                side: 'right',
                checked: config.rightEyeChecked,
            },
        ]
            .filter(function (eyeSide) { return eyeSide.checked; })
            .map(function (eyeSide) { return eyeSide.side; });
        setPackPrice(config.packPrice);
        setSubscriptionPrice(config.subscriptionPrice);
        setLensesState(prescriptionResult);
        setAvailability(availability);
        setSelectedLensVariants(selectedVariantsData);
        setFormValidations(__assign$1(__assign$1(__assign$1({}, formValidations), formErrorState), { showError: false }));
        setSubscriptionConfiguratorInput({
            packSize: config.subscriptionPackSize,
            usageFrequency: config.dailiesUsageLevel,
            eyeSides: eyeSides,
        });
    }, [formValidations, formatProductUrl, isPrescriptionInfoEnabled, product, variant]);
    /**
     * MiniCart change handler, will fire when user proceeds to purchase lenses
     */
    var handleMiniCartChange = React.useCallback(function () {
        setShowMiniCart(function (showMiniCart) {
            return !showMiniCart;
        });
    }, []);
    var priceTotals = React.useMemo(function () { return ({
        calculatedPrice: lensesState.totalPrice,
        calculatedDiscountPrice: lensesState.totalDiscount,
        selectedProducts: lensesState.selectedProducts,
        subscriptionCalculatedPrice: lensesState.totalSubscriptionPrice,
    }); }, [lensesState]);
    var state = React.useMemo(function () { return ({
        availability: availability,
        hasLenses: !!lensesState.selectedProducts.length,
        formValidations: formValidations,
        packPrice: packPrice,
        subscriptionPrice: subscriptionPrice,
        subscriptionConfiguratorInput: subscriptionConfiguratorInput,
        priceTotals: priceTotals,
        selectedLensVariants: selectedLensVariants,
        showMiniCart: showMiniCart,
    }); }, [
        availability,
        lensesState,
        formValidations,
        packPrice,
        subscriptionPrice,
        subscriptionConfiguratorInput,
        priceTotals,
        selectedLensVariants,
        showMiniCart,
    ]);
    var handles = React.useMemo(function () { return ({
        handleFormChange: handleFormChange,
        handleMiniCartChange: handleMiniCartChange,
        handlePrescriptionClick: handlePrescriptionClick,
    }); }, []);
    return React.useMemo(function () { return [state, handles]; }, [handles, state]);
};

var ContactLensesConfigEvent = 'ContactLensesConfigEvent';
var pushSelectBoxQuantity = function (totalPrice, frequency, quantity) {
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select box quantity',
        eventLabel: undefined,
        RxContactLenses: {
            productConfig: {
                price: "" + totalPrice.centAmount / 100,
                box: {
                    frequency: frequency,
                    quantity: quantity,
                },
            },
        },
    });
};
var pushSubscriptionBoxSizeChange = function (ratePlan) {
    pushSelectBoxQuantity(ratePlan.totalPrice, ratePlan.usageLevel || '', "" + ratePlan.packageQuantity);
};
var pushPrescriptionChange = function (attribute, value, side) {
    var _a, _b;
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select rx attribute',
        eventLabel: attribute + " " + side,
        RxContactLenses: {
            productConfig: {
                lens: (_a = {},
                    _a[side === 'left' ? 'OS' : 'OD'] = (_b = {},
                        _b[attribute] = value,
                        _b),
                    _a),
            },
        },
    });
};

var GridNavigationDirection;
(function (GridNavigationDirection) {
    GridNavigationDirection["UP"] = "up";
    GridNavigationDirection["DOWN"] = "down";
    GridNavigationDirection["LEFT"] = "left";
    GridNavigationDirection["RIGHT"] = "right";
})(GridNavigationDirection || (GridNavigationDirection = {}));
function useGridNavigation(isActive, grid, targetElement, close) {
    React.useEffect(function () {
        function handleKeyDownEvent(event) {
            switch (event.key) {
                case 'Down':
                case 'ArrowDown':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.DOWN });
                    break;
                case 'Up':
                case 'ArrowUp':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.UP });
                    break;
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.LEFT });
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.RIGHT });
                    break;
                case 'Esc':
                case 'Escape':
                    close();
                    break;
            }
        }
        var target = targetElement.current;
        if (isActive && target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return function () { return target.removeEventListener('keydown', handleKeyDownEvent, false); };
        }
    }, [isActive, targetElement.current]);
    var _a = __read(React.useReducer(navigationReducer, {
        colIndex: 0,
        rowIndex: 0,
        grid: grid,
    }), 2), state = _a[0], dispatch = _a[1];
    function setState(rowIndex, colIndex) {
        dispatch({ type: 'SET', payload: { rowIndex: rowIndex, colIndex: colIndex } });
    }
    return [{ colIndex: state.colIndex, rowIndex: state.rowIndex }, setState];
}
function navigationReducer(state, action) {
    switch (action.type) {
        case GridNavigationDirection.UP: {
            var rowIndex = state.rowIndex - 1;
            if (rowIndex < 0) {
                return state;
            }
            return __assign$1(__assign$1({}, state), { rowIndex: rowIndex });
        }
        case GridNavigationDirection.DOWN: {
            var rowIndex = state.rowIndex + 1;
            if (rowIndex >= state.grid[state.colIndex]) {
                return state;
            }
            return __assign$1(__assign$1({}, state), { rowIndex: rowIndex });
        }
        case GridNavigationDirection.LEFT: {
            var colIndex = state.colIndex - 1;
            if (colIndex < 0) {
                return state;
            }
            var newState = __assign$1(__assign$1({}, state), { colIndex: colIndex });
            if (state.rowIndex >= state.grid[colIndex]) {
                newState.rowIndex = state.grid[colIndex] - 1;
            }
            return newState;
        }
        case GridNavigationDirection.RIGHT: {
            var colIndex = state.colIndex + 1;
            if (colIndex >= state.grid.length) {
                return state;
            }
            var newState = __assign$1(__assign$1({}, state), { colIndex: colIndex });
            if (state.rowIndex >= state.grid[colIndex]) {
                newState.rowIndex = state.grid[colIndex] - 1;
            }
            return newState;
        }
        case 'SET': {
            var _a = action.payload, colIndex = _a.colIndex, rowIndex = _a.rowIndex;
            if (colIndex >= state.grid.length || rowIndex >= state.grid[colIndex]) {
                return state;
            }
            return __assign$1(__assign$1({}, state), action.payload);
        }
        default: {
            throw new Error();
        }
    }
}

var PrescriptionDropdown = function (_a) {
    var allOptions = _a.allOptions, onChange = _a.onChange, disabled = _a.disabled, leftColumnOptions = _a.leftColumnOptions, name = _a.name, placeholder = _a.placeholder, rightColumnOptions = _a.rightColumnOptions, className = _a.className;
    var isDisabled = disabled || allOptions.length <= 1;
    var grid = [];
    if (leftColumnOptions.length > 0) {
        grid.push(leftColumnOptions.length);
    }
    if (rightColumnOptions.length > 0) {
        grid.push(rightColumnOptions.length);
    }
    var rowCount = grid.reduce(function (prev, curr) { return (prev > curr ? prev : curr); }, 0);
    var dropdownRef = React.useRef(null);
    var gridRef = React.useRef(null);
    var _b = __read(React.useState(placeholder || ''), 2), value = _b[0], setValue = _b[1];
    var _c = __read(React.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read(useGridNavigation(isOpen, grid, dropdownRef, function () {
        return setIsOpen(false);
    }), 2), _e = _d[0], rowIndex = _e.rowIndex, colIndex = _e.colIndex, setGridFocus = _d[1];
    useOnClickOutside(dropdownRef, function () { return setIsOpen(false); });
    /**
     * Effect that adds focus to a selected element,
     * Focus is changed after navigating with the keyboard controls,
     * on mouse hover or whenever the drodpown is opened
     */
    React.useEffect(function () {
        var elementRef = gridRef && gridRef.current;
        var selectedRow = elementRef && elementRef.querySelector(".prescription-dropdown__grid-row-" + rowIndex);
        var cellIndex = grid.length === 1 ? (leftColumnOptions.length > 0 ? 0 : 1) : colIndex;
        var selectedChild = selectedRow && selectedRow.childNodes[cellIndex];
        if (selectedRow && selectedChild) {
            selectedChild.focus();
        }
    }, [rowIndex, colIndex, isOpen, grid, leftColumnOptions]);
    /**
     * When only one option is given,
     * pre-select it
     */
    React.useEffect(function () {
        if (allOptions.length === 1) {
            selectOption(allOptions[0], 0, 0);
        }
    }, [allOptions.length]);
    var dropdownClass = classnames('prescription-dropdown', className, {
        'prescription-dropdown--disabled': isDisabled,
    });
    var columnHeaderClass = classnames('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-header', 'prescription-dropdown__grid-cell--disabled');
    var buttonWithDropdownClass = classnames('prescription-dropdown__button', {
        'prescription-dropdown__button--disabled': isDisabled,
    });
    return (React.createElement("div", { className: dropdownClass, ref: dropdownRef },
        React.createElement(ButtonWithDropdown, { isActive: isOpen, label: renderLabel(value || placeholder), isFullWidth: true, title: name, onClick: function () { return !isDisabled && setIsOpen(!isOpen); }, className: buttonWithDropdownClass },
            React.createElement("div", { className: "prescription-dropdown__container" },
                React.createElement("div", { role: "grid", className: "prescription-dropdown__grid", "aria-label": name, ref: gridRef },
                    React.createElement("div", { className: "prescription-dropdown__grid-row", role: "row" },
                        leftColumnOptions.length > 0 && (React.createElement("div", { "aria-label": "-", role: "columnheader", className: columnHeaderClass },
                            React.createElement(Icon, { name: "minus", className: "prescription-dropdown__icon" }))),
                        rightColumnOptions.length > 0 && (React.createElement("div", { "aria-label": "+", role: "columnheader", className: columnHeaderClass },
                            React.createElement(Icon, { name: "plus", className: "prescription-dropdown__icon" })))),
                    renderGrid())))));
    function renderGrid() {
        var rows = [];
        for (var i = 0; i < rowCount; i++) {
            var left = leftColumnOptions[i];
            var right = rightColumnOptions[i];
            var row = (React.createElement("div", { className: "prescription-dropdown__grid-row prescription-dropdown__grid-row-" + i, role: "row", key: i },
                left ? renderCell(left, i, 0) : renderEmptyCell(),
                right ? renderCell(right, i, 1) : renderEmptyCell()));
            rows.push(row);
        }
        return rows;
    }
    function renderEmptyCell() {
        var emptyCellClass = classnames('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-cell--disabled');
        return React.createElement("div", { role: "gridcell", className: emptyCellClass });
    }
    function renderCell(option, rowIndex, colIndex) {
        if (rowIndex === void 0) { rowIndex = 0; }
        if (colIndex === void 0) { colIndex = 0; }
        var gridCellClass = classnames('prescription-dropdown__grid-cell', {
            'prescription-dropdown__grid-cell--single-column': grid.length === 1,
        });
        return (React.createElement("button", { role: "gridcell", className: gridCellClass, onClick: function () { return selectOption(option, rowIndex, colIndex); }, onMouseEnter: function () { return setGridFocus(rowIndex, colIndex); } }, option.value));
    }
    function selectOption(option, rowIndex, colIndex) {
        setValue(option.value);
        setGridFocus(rowIndex, colIndex);
        setIsOpen(false);
        var validatedSelection = __assign$1(__assign$1({}, option), { isValid: option.value !== '' });
        onChange && onChange(validatedSelection);
    }
    function renderLabel(value) {
        if (!value) {
            return null;
        }
        var valueClass = classnames('prescription-dropdown__value', {
            'prescription-dropdown__value--invalid': !value || value === placeholder,
            'prescription-dropdown__value--disabled': allOptions.length <= 1,
        });
        return (React.createElement("span", { className: "prescription-dropdown__button-label" },
            React.createElement("span", { className: valueClass, "data-t": "prescription-dropdown-value" }, value)));
    }
};

var SelectQuantity = function (_a) {
    var id = _a.id, isDisabled = _a.isDisabled, maximumQuantity = _a.maximumQuantity, onChange = _a.onChange, packSize = _a.packSize, quantity = _a.quantity, showLabel = _a.showLabel;
    var getLabel = useIntl().getLabel;
    // helper to create the label options for the select box
    var createSelectOption = function (boxAmount, packSize) {
        var label = packSize * boxAmount + " " + getLabel('products.unit.contactLenses', {
            defaultValue: 'lenses',
        });
        return boxAmount + " (" + label + ")";
    };
    // create an array of length by maxmimumQuantity, fill it with options based on the index count
    var options = React__default.useMemo(function () {
        return Array(maximumQuantity)
            .fill(0)
            .reduce(function (options, _, index) {
            var boxAmount = index + 1;
            var name = createSelectOption(boxAmount, packSize);
            options[name] = boxAmount;
            return options;
        }, {});
    }, [maximumQuantity, packSize]);
    // prefill the selectbox if we have a quantity higher than 0.
    var optionKeys = Object.keys(options);
    var initialSelection = quantity !== 0 ? { value: optionKeys[quantity - 1] } : { value: optionKeys[0] };
    return (React__default.createElement("div", { className: "select-quantity" },
        showLabel && (React__default.createElement("label", { className: "select-quantity__label", htmlFor: id }, getLabel('products.contactLenses.quantitySelect.label', {
            defaultValue: 'Number of boxes',
        }))),
        React__default.createElement(Select, { id: id, name: "quantity-selector", className: "select-quantity__select", options: options, initialState: initialSelection, disabled: isDisabled, onChange: onChange, "data-t": "select-quantity" })));
};

var MAX_QUANTITY_LIMIT = 99;
var Prescription = /** @class */ (function (_super) {
    __extends$1(Prescription, _super);
    function Prescription() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeFilters: {},
            attributes: {},
            allowBackOrder: _this.props.allowBackOrder,
        };
        _this.getInitialFilters = function (filterAttributes) {
            var e_1, _a;
            var initialFilters = {};
            try {
                for (var _b = __values(Object.keys(filterAttributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var attribute = _c.value;
                    var currentAttribute = Array.from(filterAttributes[attribute].values);
                    if (currentAttribute.length === 1 && attribute !== 'packageQuantity') {
                        initialFilters[attribute] = currentAttribute[0];
                        // TODO fix the missing types in here some other time (been there for 1+ year now)
                        _this.props.handleLensBundleChange(_this.props.id, attribute, currentAttribute[0]);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return initialFilters;
        };
        _this.handleAttributeChange = function (key, value) {
            var _a, _b;
            if (value) {
                var newFilter_1 = __assign$1(__assign$1({}, _this.state.activeFilters), (_a = {}, _a[key] = value, _a));
                var attribute = _this.state.attributes[key];
                if (!attribute) {
                    return;
                }
                attribute.selected = value;
                _this.setState({
                    activeFilters: newFilter_1,
                    attributes: __assign$1(__assign$1({}, _this.state.attributes), (_b = {}, _b[key] = attribute, _b)),
                }, function () {
                    key !== 'packageQuantity' && _this.props.handleLensBundleChange(_this.props.id, key, value);
                    // Omit packageQuantity just like it is removed from filter.
                    var length = Object.keys(_this.state.attributes).length;
                    var attributeLength = _this.state.attributes.packageQuantity ? length - 1 : length;
                    if (Object.keys(newFilter_1).length === attributeLength) {
                        _this.getSkuByAttributes(newFilter_1);
                    }
                });
                pushPrescriptionChange(key, value, _this.props.id);
            }
            else {
                _this.setFoundProduct(undefined);
            }
        };
        _this.setFoundProduct = function (product) {
            _this.setState({
                foundProduct: product,
                allowBackOrder: product && typeof product.attributes.allowBackOrder === 'boolean'
                    ? product.attributes.allowBackOrder
                    : _this.props.allowBackOrder,
            });
            _this.props.onFoundProduct(product);
        };
        _this.getSkuByAttributes = function (filters) {
            var enrichedFilters = __assign$1(__assign$1({}, filters), { packageQuantity: _this.props.packSize });
            var foundProduct = _this.props.products.find(function (_a) {
                var e_2, _b;
                var attributes = _a.attributes;
                var valid = true;
                try {
                    for (var _c = __values(Object.keys(enrichedFilters)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var filter = _d.value;
                        var value = enrichedFilters[filter];
                        valid = filter in attributes && attributes[filter] === value;
                        if (!valid) {
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return valid;
            });
            if (foundProduct) {
                _this.setFoundProduct(foundProduct);
            }
            else {
                toast.failed("products.contactLenses.prescription.alert." + _this.props.id + "Eye");
            }
        };
        _this.getSortedArrayFromSet = function (set, _locale) {
            if (_locale === void 0) { _locale = undefined; }
            return Array.from(set)
                .sort(function (a, b) { return a.localeCompare(b, _locale, { numeric: true }); })
                .map(function (item) { return ({ label: item.toString(), value: item }); });
        };
        _this.getFilterOptions = function (options) {
            if (options === void 0) { options = []; }
            var arr = options instanceof Set ? _this.getSortedArrayFromSet(options) : options;
            return arr.reduce(function (prev, curr) {
                prev[curr.label] = curr.value;
                return prev;
            }, {});
        };
        _this.getQuantitySelectorMaximumQuantity = function () {
            var _a = _this.props, availableQuantity = _a.availableQuantity, maxOrderableQuantity = _a.maxOrderableQuantity;
            var allowBackOrder = _this.state.allowBackOrder;
            if (!allowBackOrder) {
                if (maxOrderableQuantity && availableQuantity) {
                    return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
                }
                if (availableQuantity !== undefined) {
                    return availableQuantity;
                }
            }
            if (maxOrderableQuantity) {
                return maxOrderableQuantity;
            }
            return MAX_QUANTITY_LIMIT;
        };
        _this.formatPowerValues = function (values) {
            return _this.getSortedArrayFromSet(values)
                .map(function (_a) {
                var value = _a.value;
                return ({ label: value, value: value });
            })
                .sort(function (a, b) { return powerToFloat(a) - powerToFloat(b); });
        };
        _this.renderToolTip = function (type) {
            var _a = _this.props, intl = _a.intl, currentBreakpoint = _a.currentBreakpoint, id = _a.id;
            /**
             * Decide if we have to show labels or not,
             *  - On mobile we always want to show the labels including the tooltip
             *  - On tablet landscape and up we want the dashed tooltip,
             *    which includes the label, but only for the Prescription for the right eye-side
             */
            var isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
                currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
            var showTooltip = isMobile || id === 'right';
            return (React.createElement(React.Fragment, null,
                isMobile && (React.createElement("span", { className: "prescription__input-label" }, intl.getLabel("products.contactLenses.prescription." + type))),
                showTooltip && (React.createElement(Tooltip, { dashed: !isMobile, className: "prescription__input-tooltip", id: type, label: intl.getLabel("products.contactLenses.prescription." + type), message: intl.getLabel("products.contactLenses.prescription." + type + ".tooltip") }))));
        };
        _this.sortPowerOptions = function (a, b) {
            return powerValueToFloat(a) - powerValueToFloat(b);
        };
        _this.renderReadOnly = function (key, value) { return [
            false,
            React.createElement("div", { className: "prescription__readonly-input-wrapper", key: key, "data-t": "prescription-" + key },
                _this.renderToolTip(key),
                React.createElement("span", { className: "prescription__readonly" }, value)),
        ]; };
        _this.renderSelectElement = function (key) {
            var _a;
            var _b = _this.props, attributes = _b.attributes, intl = _b.intl, isActive = _b.isActive, hasError = _b.hasError;
            var _c = _this.state, activeFilters = _c.activeFilters, foundProduct = _c.foundProduct;
            var attibuteValues = (_a = attributes[key]) === null || _a === void 0 ? void 0 : _a.values;
            var filter = activeFilters[key];
            var initialState = filter ? { value: filter } : _this.getInitialState(attibuteValues);
            var onlyOneOptionAvailble = (attibuteValues === null || attibuteValues === void 0 ? void 0 : attibuteValues.size) === 1 && initialState;
            var selectElementClass = classnames('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive,
            });
            if (onlyOneOptionAvailble && initialState) {
                return _this.renderReadOnly(key, initialState.value);
            }
            return [
                true,
                React.createElement("div", { className: "prescription__input-wrapper", key: key },
                    _this.renderToolTip(key),
                    React.createElement(Select, { id: key, className: selectElementClass, name: intl.getLabel("products.contactLenses.prescription." + key), options: _this.getFilterOptions(attibuteValues), sortOptionsBy: key === 'power' ? _this.sortPowerOptions : undefined, initialState: initialState, placeholder: "---", onChange: function (value) { return _this.handleAttributeChange(key, value); }, disabled: !isActive, "data-t": "prescription-" + key })),
            ];
        };
        _this.renderPowerSelector = function (isMobile) {
            var _a = _this.props, attributes = _a.attributes, intl = _a.intl, isActive = _a.isActive, hasError = _a.hasError;
            var _b = _this.state, activeFilters = _b.activeFilters, foundProduct = _b.foundProduct;
            var allOptions = attributes.power ? _this.formatPowerValues(attributes.power.values) : [];
            var positiveOptions = allOptions.filter(function (power) { return powerToFloat(power) >= 0; });
            var negativeOptions = allOptions.filter(function (power) { return powerToFloat(power) <= 0; });
            negativeOptions.reverse(); // 🙈 mutation; reversed for the UI (eg render 0 - -5 instead of -5 - 0)
            var onlyOneOptionAvailble = allOptions.length <= 1;
            var selectElementClass = classnames('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive,
            });
            // value to set within PrescriptionDropdown via placeholder prop when selected
            // needed because of the isMobile render check below
            var initialValue = (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.power) || '---';
            if (onlyOneOptionAvailble) {
                return _this.renderReadOnly('power', initialValue);
            }
            return !isMobile
                ? [
                    true,
                    React.createElement("div", { key: "power", className: "prescription__input-wrapper prescription__power-dropdown" },
                        _this.renderToolTip('power'),
                        React.createElement(PrescriptionDropdown, { name: intl.getLabel('products.contactLenses.prescription.power'), className: selectElementClass, allOptions: allOptions, leftColumnOptions: negativeOptions, rightColumnOptions: positiveOptions, placeholder: initialValue, onChange: function (_a) {
                                var value = _a.value;
                                return _this.handleAttributeChange('power', value);
                            }, disabled: !isActive, "data-t": "prescription-power" })),
                ]
                : _this.renderSelectElement('power');
        };
        return _this;
    }
    Prescription.prototype.componentDidMount = function () {
        var _a = this.props, attributes = _a.attributes, products = _a.products;
        var initialFilters = this.getInitialFilters(attributes);
        this.setState({
            activeFilters: initialFilters,
            attributes: attributes,
        });
        if (products.length === 1) {
            this.getSkuByAttributes(initialFilters);
        }
    };
    Prescription.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (this.props.isSubscriptionSelected &&
            prevProps.isSubscriptionSelected !== this.props.isSubscriptionSelected) {
            // Reset back to 1 as quantity should not be updated in subscription lenses
            this.props.onQuantityChange(1);
            this.props.onSelection(true);
        }
        if (((_a = this.props.products) === null || _a === void 0 ? void 0 : _a.length) === 1 && ((_b = prevProps === null || prevProps === void 0 ? void 0 : prevProps.products) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            var initialFilters = this.state.activeFilters;
            if (!initialFilters || !Object.keys(initialFilters).length) {
                initialFilters = this.getInitialFilters(this.props.attributes);
            }
            this.getSkuByAttributes(initialFilters);
        }
    };
    /**
     * This method checks if there is only one option available.
     * If this is the case, return only this value.
     * This will make sure the select boxes are prefilled with the only available option.
     */
    Prescription.prototype.getInitialState = function (options) {
        if (!options) {
            return undefined;
        }
        if (options instanceof Set && options.size === 1) {
            var value = options.values().next().value;
            return {
                value: value,
            };
        }
        if (Array.isArray(options) && options.length === 1) {
            var value = options[0].value;
            return {
                value: value,
            };
        }
        return { value: '' };
    };
    Prescription.prototype.renderStockIndicator = function () {
        var _a = this.props, availableQuantity = _a.availableQuantity, isStockEnabled = _a.isStockEnabled;
        if (!isStockEnabled || !this.state.foundProduct) {
            return null;
        }
        return (React.createElement(StockIndicator, { stockCount: availableQuantity, allowBackOrder: this.state.allowBackOrder }));
    };
    Prescription.prototype.render = function () {
        var _this = this;
        var _a = this.props, isActive = _a.isActive, availableQuantity = _a.availableQuantity, id = _a.id, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl, quantity = _a.quantity, className = _a.className, isSubscriptionSelected = _a.isSubscriptionSelected, isAvailableForSubscription = _a.isAvailableForSubscription;
        var _b = this.state, foundProduct = _b.foundProduct, allowBackOrder = _b.allowBackOrder, attributes = _b.attributes;
        var contentLabel = id === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye';
        var isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
        var checkboxClass = classnames('prescription__checkbox', {
            'prescription__checkbox--indented': id === 'right' && !isMobile,
            'prescription__checkbox--selectable': !isSubscriptionSelected || isAvailableForSubscription,
        });
        var checkboxLabelClass = classnames('prescription__checkbox-label', {
            'prescription__checkbox-label--indented': !isSubscriptionSelected || isAvailableForSubscription,
        });
        var stockIndicatorClass = classnames('prescription__stock-indicator', {
            'prescription__stock-indicator--indented': id === 'right' && !isMobile,
        });
        // Render selector elements
        var selectors = [
            attributes.color && this.renderSelectElement('color'),
            attributes.power && this.renderPowerSelector(isMobile),
            attributes.baseCurve && this.renderSelectElement('baseCurve'),
            attributes.diameter && this.renderSelectElement('diameter'),
            attributes.axis && this.renderSelectElement('axis'),
            attributes.addition && this.renderSelectElement('addition'),
            attributes.cylinder && this.renderSelectElement('cylinder'),
        ].filter(Boolean);
        // Group selectors in blocks of dropdowns an read-only elements for styling
        var groupedSelectors = [];
        var lastItem;
        selectors.forEach(function (item) {
            var lastIndex = groupedSelectors.length - 1;
            if (lastItem && item && lastItem[0] === item[0]) {
                groupedSelectors[lastIndex].push(item[1]);
            }
            else if (item) {
                groupedSelectors.push([item[1]]);
            }
            lastItem = item;
        });
        return (React.createElement("div", { className: "prescription " + className, "data-t": this.props['data-t'] },
            React.createElement("label", { className: checkboxClass },
                (!isSubscriptionSelected || isAvailableForSubscription) && (React.createElement(Checkbox, { value: id, checked: isActive, onChange: function (event) {
                        _this.props.onSelection(event.checked);
                    }, "data-t": "prescription-checkbox" })),
                React.createElement("span", { className: checkboxLabelClass }, intl.getLabel("products." + contentLabel))),
            groupedSelectors.map(function (group, i) {
                return (React.createElement("div", { key: i, className: "prescription__selectors" }, group));
            }),
            !isSubscriptionSelected && (React.createElement(SelectQuantity, { maximumQuantity: this.getQuantitySelectorMaximumQuantity(), id: "prescription-quantity-selector-" + id, onChange: this.props.onQuantityChange, showLabel: id === 'right' || isMobile, packSize: this.props.packSize, quantity: quantity, isDisabled: Boolean(!isActive ||
                    (foundProduct &&
                        !foundProduct.attributes.allowBackOrder &&
                        !allowBackOrder &&
                        !availableQuantity)) })),
            (!isSubscriptionSelected || !isAvailableForSubscription) && (React.createElement("div", { className: stockIndicatorClass }, this.renderStockIndicator()))));
    };
    Prescription.defaultProps = {
        allowBackOrder: true,
        isActive: true,
    };
    return Prescription;
}(React.Component));
var Prescription$1 = withIntl(MediaQuery.WithBreakpoints(Prescription));
function powerToFloat(power) {
    return powerValueToFloat(power === null || power === void 0 ? void 0 : power.value);
}
function powerValueToFloat(powerValue) {
    return parseFloat(powerValue.replace(/[^\d.+-]/g, ''));
}

var PrescriptionContainer = function (props) {
    var actions = useLensBundle().attributes.actions;
    // Use void function to scope logic to only lens bundle enabled products
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var handleLensBundleChange = props.hasSubscriptions ? actions.setAttribute : function () { };
    // Preliminary sorting of selected packSize
    var products = React__default.useMemo(function () { return props.products.filter(function (product) { return product.attributes.packageQuantity === props.packSize; }); }, [props.products, props.packSize]);
    return (React__default.createElement(Prescription$1, __assign$1({}, props, { products: products, handleLensBundleChange: handleLensBundleChange })));
};

/**
 * A customer's optician can either be internal or extrnal.
 * Internal = the OpCo of which the site is being visited (e.g. Vision express)
 * External = any other Optician that does eye tests (the user will have to specifiy the opticians information)
 */
var OpticianType;
(function (OpticianType) {
    OpticianType["Internal"] = "internal";
    OpticianType["External"] = "external";
})(OpticianType || (OpticianType = {}));
var Optician = function (_a) {
    var selectedStore = _a.selectedStore, onStoreChange = _a.onStoreChange, selectedOpticianType = _a.selectedOpticianType, onOpticianTypeChange = _a.onOpticianTypeChange, OpticianForm = _a.opticianForm;
    var getLabel = useIntl().getLabel;
    var radioOptions = React__default.useMemo(function () { return [
        {
            value: OpticianType.Internal,
            label: getLabel('products.contactLens.info.optician.internal'),
        },
        {
            value: OpticianType.External,
            label: getLabel('products.contactLens.info.optician.external'),
        },
    ]; }, [getLabel]);
    var handleRadiosChange = React__default.useCallback(function (_a) {
        var value = _a.value;
        onOpticianTypeChange(value);
    }, [onOpticianTypeChange]);
    return (React__default.createElement("div", { className: "prescription-info-optician" },
        React__default.createElement("span", { className: "prescription-info-optician__label" },
            getLabel('products.contactLens.info.optician.label'),
            React__default.createElement(Tooltip, { message: getLabel('products.contactLens.info.optician.hint'), id: "validation-optician-tooltip" })),
        React__default.createElement(RadioButtons, { formName: "optician-type", scope: "opticianType", alignment: "vertical", onChange: handleRadiosChange, initialValue: selectedOpticianType, items: radioOptions }),
        selectedOpticianType === OpticianType.Internal && (React__default.createElement("div", { className: "prescription-info-optician__store-finder" },
            React__default.createElement(PreferredStoreFinder, { selected: selectedStore, onStoreSelect: onStoreChange }))),
        selectedOpticianType === OpticianType.External && (React__default.createElement("div", { className: "prescription-info-optician__store-form" }, OpticianForm))));
};

var createExternalOpticianInfo = function (formState) {
    var obj = Object.entries(formState).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], field = _c[1];
        return (__assign$1(__assign$1({}, acc), (_b = {}, _b[key] = field ? field.value : '', _b)));
    }, {});
    return JSON.stringify(obj);
};
var isInfoValid = function (state, opticianType, isPrescriptionExtraInfoEnabled) {
    if (isPrescriptionExtraInfoEnabled === void 0) { isPrescriptionExtraInfoEnabled = true; }
    var prescriptionExpiryDate = state.prescriptionExpiryDate, externalOptician = state.externalOptician, internalOptician = state.internalOptician, consent = state.consent;
    // when isPrescriptionExtraInfoEnabled is false, having consent is enough to continue
    if (!isPrescriptionExtraInfoEnabled && consent) {
        return true;
    }
    if (!prescriptionExpiryDate || !consent) {
        return false;
    }
    if (opticianType === OpticianType.Internal && !internalOptician) {
        return false;
    }
    if (opticianType === OpticianType.External && !externalOptician) {
        return false;
    }
    return true;
};
var onlyHistory = function () {
    return Util.createMaxDate(new Date(), 0);
};
var getMaxExpiryDate = function () {
    var maxYears = 5;
    var date = new Date();
    date.setFullYear(date.getFullYear() + maxYears);
    return date;
};
var PrescriptionInfo = function (_a) {
    var onChange = _a.onChange, opticianForm = _a.opticianForm, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'MMMM d, yyyy' : _b, _c = _a.isPrescriptionExtraInfoEnabled, isPrescriptionExtraInfoEnabled = _c === void 0 ? true : _c, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent;
    var getLabel = useIntl().getLabel;
    var _d = __read(React__default.useState(), 2), examDate = _d[0], setExamDate = _d[1];
    var _e = __read(React__default.useState(), 2), expiryDate = _e[0], setExpiryDate = _e[1];
    var _f = __read(React__default.useState(OpticianType.Internal), 2), opticianType = _f[0], setOpticianType = _f[1];
    var _g = __read(React__default.useState(), 2), selectedStore = _g[0], setSelectedStore = _g[1];
    var _h = __read(React__default.useState(), 2), opticianInfo = _h[0], setOpticanInfo = _h[1];
    var _j = __read(React__default.useState(false), 2), consent = _j[0], setConsent = _j[1];
    var handleExamDateChange = React__default.useCallback(function (date) {
        setExamDate(date);
    }, []);
    var handleExpiryDateChange = React__default.useCallback(function (date) {
        setExpiryDate(date);
    }, []);
    var handleOpticianTypeChange = React__default.useCallback(function (type) {
        setOpticianType(type);
    }, []);
    var handleStoreChange = React__default.useCallback(function (store) {
        setSelectedStore(store);
    }, []);
    var handleOpticianFormChange = React__default.useCallback(function (form) {
        if (form.formValid) {
            setOpticanInfo(form.formState);
        }
    }, []);
    var handleConsentChange = React__default.useCallback(function (_a) {
        var checked = _a.checked;
        setConsent(checked);
    }, []);
    var state = React__default.useMemo(function () { return (__assign$1(__assign$1({ prescriptionExamDate: examDate && examDate.toISOString(), prescriptionExpiryDate: expiryDate && expiryDate.toISOString() }, (opticianType === OpticianType.Internal
        ? { internalOptician: selectedStore && selectedStore.code.toString() }
        : {
            externalOptician: opticianInfo && createExternalOpticianInfo(opticianInfo),
        })), { consent: consent })); }, [examDate, expiryDate, opticianType, opticianInfo, consent, selectedStore]);
    React__default.useEffect(function () {
        if (onChange) {
            onChange(__assign$1(__assign$1({}, state), { valid: isInfoValid(state, opticianType, isPrescriptionExtraInfoEnabled) }));
        }
    }, [onChange, state, opticianType]);
    var OpticianForm = (React__default.createElement(Form, { name: "opticianForm", "data-t": "optician-form", className: "prescription-info-optician__form", initialFormState: opticianInfo, onChange: handleOpticianFormChange }, opticianForm && opticianForm()));
    return (React__default.createElement("div", { className: "prescription-info" },
        React__default.createElement(Heading, { className: "prescription-info__heading", variant: "smallest" }, getLabel('products.contactLenses.info.title')),
        React__default.createElement(RequiredFieldsLabel, null),
        prescriptionInfoAdditionalContent,
        isPrescriptionExtraInfoEnabled && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: "prescription-info__dates" },
                React__default.createElement(DatePicker, { label: getLabel('products.contactLenses.info.eyeTestDate.label'), placeholder: getLabel('common.selectDate'), optionalText: getLabel('checkout.form.field.optional'), initialValue: examDate, onChange: handleExamDateChange, required: false, maxDate: onlyHistory(), dateFormat: dateFormat }),
                React__default.createElement(DatePicker, { label: getLabel('products.contactLenses.info.expiryDate.label'), tooltip: getLabel('products.contactLenses.info.expiryDate.hint'), errorMessage: getLabel('products.contactLenses.info.expiryDate.errorMessage'), placeholder: getLabel('common.selectDate'), initialValue: expiryDate, onChange: handleExpiryDateChange, maxDate: getMaxExpiryDate(), dateFormat: dateFormat })),
            React__default.createElement(Optician, { opticianForm: OpticianForm, selectedStore: selectedStore, onStoreChange: handleStoreChange, selectedOpticianType: opticianType, onOpticianTypeChange: handleOpticianTypeChange }))),
        React__default.createElement("div", { className: "prescription-info__consent" },
            React__default.createElement("label", { className: "prescription-info__checkbox-label" },
                React__default.createElement(Checkbox, { className: "prescription-info__checkbox", id: "prescription-info-consent", value: "prescription-info-consent", checked: consent, onChange: handleConsentChange }),
                React__default.createElement("span", { className: "prescription-info__checkbox-label-text" }, getLabel('products.contactLenses.info.consent'))))));
};

var MonthlyPrice = function (_a) {
    var currency = _a.currency, price = _a.price, labels = _a.labels;
    return (React__default.createElement("div", { className: "contact-lens-configurator__monthly-price" },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Price, { value: price.centAmount, currency: currency, className: "contact-lens-configurator__pack-size-price" }),
            ' / ',
            React__default.createElement(Text, { variant: "caption", component: "span" }, labels.perMonth))));
};

var MonthlyPriceContainer = function () {
    var _a = useIntl(), currency = _a.currency, getLabel = _a.getLabel;
    var pricePerMonth = useLensBundle().pricePerMonth;
    var labels = React__default.useMemo(function () { return ({
        perMonth: getLabel('common.frequency.perMonth'),
    }); }, [getLabel]);
    if (!pricePerMonth) {
        return null;
    }
    return React__default.createElement(MonthlyPrice, { currency: currency, labels: labels, price: pricePerMonth });
};

var ProductDetailUnitInfo = function (_a) {
    var amount = _a.amount, valueUnits = _a.valueUnits, perBox = _a.perBox, _b = _a["data-t"], dataT = _b === void 0 ? 'product-detail-unit-info' : _b;
    return (React.createElement("span", { className: "product-detail-unit-info", "data-t": dataT },
        React.createElement("span", { className: "product-detail-unit-info__amount" },
            amount,
            " ",
            amount > 1 ? valueUnits.plural : valueUnits.singular),
        React.createElement("span", { className: "product-detail-unit-info__unit" },
            " ",
            perBox,
            " ")));
};

var QuantityItem = function (_a) {
    var className = _a.className, label = _a.label, subtext = _a.subtext, aside = _a.aside;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: className + "__quantity" },
            React__default.createElement("span", { className: className + "__amount" }, label),
            subtext && React__default.createElement("span", { className: className + "__subtext" }, subtext)),
        aside && React__default.createElement("span", { className: className + "__aside" }, aside)));
};

var QuantityContainer = function (_a) {
    var items = _a.items, selected = _a.selected, itemView = _a.itemView, handleClick = _a.handleClick;
    var Component = itemView || QuantityItem;
    return (React__default.createElement("div", { className: "quantity-container" }, items.map(function (item) { return (React__default.createElement("button", { key: item.value, className: classnames('quantity-container__item', {
            _is_selected: selected.value === item.value,
        }), onClick: function () { return handleClick(item); }, "data-t": item.label },
        React__default.createElement(Component, { className: "quantity-container", label: item.label, subtext: item.subtext, aside: item.aside }))); })));
};

var PackageQuantityItem = function (_a) {
    var label = _a.label, subtext = _a.subtext, aside = _a.aside, className = _a.className;
    return (React.createElement("div", { className: className + "__content" },
        React.createElement("div", { className: className + "__quantity" },
            React.createElement("span", { className: className + "__amount" }, label),
            subtext && React.createElement("span", { className: className + "__subtext" }, subtext)),
        aside && React.createElement("span", { className: className + "__aside" }, aside)));
};

var getSelectedItem = function (items, selectedSize) {
    var item = items.find(function (_a) {
        var value = _a.value;
        return value === selectedSize;
    });
    return item || items[0] || { value: '', label: '' };
};
var PackageQuantityDropdown = function (_a) {
    var label = _a.label, title = _a.title, items = _a.items, selectedSize = _a.selectedSize, itemView = _a.itemView, onChange = _a.onChange, _b = _a["data-t"], dataT = _b === void 0 ? 'package-quantity-dropdown' : _b;
    var _c = __read(React.useState(function () {
        return getSelectedItem(items, selectedSize);
    }), 2), selected = _c[0], setSelected = _c[1];
    var _d = __read(React.useState(false), 2), isOpen = _d[0], setIsOpen = _d[1];
    var dropdownRef = React.useRef(null);
    useOnClickOutside(dropdownRef, function () { return setIsOpen(false); });
    var buttonLabel = React.useMemo(function () {
        var Component = itemView || PackageQuantityItem;
        return React.createElement(Component, __assign$1({ className: "package-quantity-dropdown" }, selected));
    }, [selected, itemView]);
    var handleSelect = React.useCallback(function (option) {
        setSelected(option);
        setIsOpen(false);
        onChange(option);
    }, []);
    var handleClick = React.useCallback(function () {
        setIsOpen(function (isOpen) { return !isOpen; });
    }, []);
    React.useEffect(function () {
        setSelected(getSelectedItem(items, selectedSize));
    }, [setSelected, items, selectedSize]);
    return (React.createElement("div", { className: "package-quantity-dropdown", ref: dropdownRef, "data-t": dataT },
        Boolean(label) && React.createElement("div", { className: "package-quantity-dropdown__label" }, label),
        React.createElement(ButtonWithDropdown, { title: title, label: buttonLabel, className: "package-quantity-dropdown__button", onClick: handleClick, isActive: isOpen, isFullWidth: true },
            React.createElement(QuantityContainer, { itemView: itemView, items: items, handleClick: handleSelect, selected: selected }))));
};

var joinExistingStrings = function (strings, separator) {
    return strings.filter(function (value) { return !!value; }).join(separator || '');
};

var PackageQuantity = function (_a) {
    var _b = _a["data-t"], dataT = _b === void 0 ? 'package-quantity' : _b, className = _a.className, packageQuantities = _a.packageQuantities, item = _a.item, dropdown = _a.dropdown;
    return (React__default.createElement("div", { className: classnames(['contact-lens-configurator__package-quantity', className]), "data-t": dataT }, packageQuantities.length === 1 ? item : dropdown));
};

var LabelPosition;
(function (LabelPosition) {
    LabelPosition["Left"] = "left";
    LabelPosition["Right"] = "right";
})(LabelPosition || (LabelPosition = {}));
var PriceAside = function (_a) {
    var value = _a.value, currency = _a.currency, discountValue = _a.discountValue, asideLabel = _a.asideLabel, _b = _a.asideLabelPosition, asideLabelPosition = _b === void 0 ? LabelPosition.Right : _b;
    if (!value)
        return null;
    var isZeroPercentDiscount = value === discountValue;
    return (React.createElement(React.Fragment, null,
        asideLabel && asideLabelPosition === LabelPosition.Left && (React.createElement("span", { className: "contact-lens-configurator__reminder" },
            asideLabel,
            " ")),
        React.createElement(Price, { value: value, currency: currency, className: classnames('contact-lens-configurator__pack-size-price', {
                'contact-lens-configurator__pack-size-price--original': discountValue && !isZeroPercentDiscount,
            }) }),
        discountValue && !isZeroPercentDiscount && (React.createElement(Price, { value: discountValue, currency: currency, className: "contact-lens-configurator__pack-size-price contact-lens-configurator__pack-size-price--discounted" })),
        asideLabel && asideLabelPosition === LabelPosition.Right && (React.createElement("span", { className: "contact-lens-configurator__reminder" },
            " ",
            asideLabel))));
};

var usePackageQuantity = function (packageTypes, mapper) {
    var _a = useIntl(), currency = _a.currency, getLabel = _a.getLabel, hasLabel = _a.hasLabel;
    var labels = React.useMemo(function () { return ({
        lenses: getLabel('products.unit.contactLenses'),
        lens: getLabel('products.unit.contactLens'),
        box: getLabel('products.unit.contactLensBox'),
        boxes: getLabel('products.unit.contactLensBoxes'),
        perEye: hasLabel('products.perEye') ? getLabel('products.perEye') : '',
        perBoxLabel: getLabel('products.perBox'),
        perMonth: getLabel('common.frequency.perMonth'),
    }); }, [getLabel, hasLabel]);
    var packageQuantities = React.useMemo(function () {
        return packageTypes.map(function (pack) { return mapper(pack, labels, currency); });
    }, [packageTypes, mapper, labels, currency]);
    return {
        labels: labels,
        packageQuantities: packageQuantities,
    };
};

var PackageQuantityContainer$1 = function (_a) {
    var onChange = _a.onChange, packageTypes = _a.packageTypes, selectedSize = _a.selectedSize;
    var getLabel = useIntl().getLabel;
    var mapper = function (pack, labels, currency) {
        var _a;
        var price = pack.price;
        var value = pack.packageQuantity.toString();
        return {
            label: value + " " + labels.lenses,
            value: value,
            subtext: joinExistingStrings([labels.perBoxLabel, labels.perEye], ', '),
            aside: (React__default.createElement(PriceAside, { value: price.value.centAmount, currency: currency, discountValue: (_a = price === null || price === void 0 ? void 0 : price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount, asideLabel: labels.perEye })),
        };
    };
    var packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    var _b = usePackageQuantity(packageTypes, mapper), labels = _b.labels, packageQuantities = _b.packageQuantities;
    return (React__default.createElement(PackageQuantity, { packageQuantities: packageQuantities, item: React__default.createElement(ProductDetailUnitInfo, { amount: +packageQuantities[0].value, valueUnits: {
                singular: labels.lens,
                plural: labels.lenses,
            }, perBox: packageQuantities[0].subtext }), dropdown: React__default.createElement(PackageQuantityDropdown, { label: packageQuantityLabel, title: packageQuantities[0].value, items: packageQuantities, selectedSize: selectedSize, onChange: onChange }) }));
};

var PackageQuantityContainer = function (_a) {
    var handlePackSizeChange = _a.handlePackSizeChange, selectedSize = _a.selectedSize, packageTypes = _a.packageTypes;
    var getLabel = useIntl().getLabel;
    var mapper = function (pack, labels, currency) {
        var price = pack.totalPrice;
        var value = pack.packageQuantity.toString();
        return {
            label: value + " " + labels.lenses,
            value: value,
            subtext: joinExistingStrings([labels.perBoxLabel, labels.perEye], ', '),
            aside: (React.createElement(PriceAside, { value: price.centAmount, currency: currency, asideLabel: joinExistingStrings([labels.perMonth, labels.perEye], ', ') })),
        };
    };
    var packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    var packageQuantities = usePackageQuantity(packageTypes, mapper).packageQuantities;
    var handleChange = React.useCallback(function (_a) {
        var value = _a.value;
        handlePackSizeChange(+value || 0);
    }, [handlePackSizeChange]);
    if (packageQuantities.length === 0) {
        return null;
    }
    return (React.createElement(PackageQuantity, { packageQuantities: packageQuantities, item: React.createElement(PackageQuantityItem, { className: "package-quantity-dropdown", label: packageQuantities[0].label, subtext: packageQuantities[0].subtext, aside: packageQuantities[0].aside }), dropdown: React.createElement(PackageQuantityDropdown, { label: packageQuantityLabel, title: packageQuantities[0].value, items: packageQuantities, selectedSize: "" + selectedSize, onChange: handleChange }) }));
};

var DailyPackageQuantityItem = function (_a) {
    var label = _a.label, subtext = _a.subtext, aside = _a.aside;
    return (React__default.createElement("div", { "data-t": "daily-package-quantity-item", className: "daily-package-quantity-item" },
        React__default.createElement("div", { className: "daily-package-quantity-item__label" }, label),
        React__default.createElement("div", null,
            React__default.createElement("div", { className: "daily-package-quantity-item__subtext" }, subtext),
            React__default.createElement("div", { className: "daily-package-quantity-item__aside" }, aside))));
};

var DailyPackageQuantityContainer = function (_a) {
    var handlePackSizeChange = _a.handlePackSizeChange, selectedSize = _a.selectedSize, packageTypes = _a.packageTypes, _b = _a.noLabel, noLabel = _b === void 0 ? false : _b, _c = _a.noPrice, noPrice = _c === void 0 ? false : _c;
    var getLabel = useIntl().getLabel;
    var mapper = function (pack, labels, currency) {
        var totalPrice = pack.totalPrice, usageLevel = pack.usageLevel;
        var value = usageLevel || '';
        return {
            value: value,
            label: getLabel("products.contactLenses.usageLevel." + value),
            subtext: noPrice ? null : (React.createElement(PriceAside, { value: totalPrice.centAmount, currency: currency, asideLabel: getLabel('common.startingAt'), asideLabelPosition: LabelPosition.Left })),
            aside: noPrice ? null : joinExistingStrings([labels.perMonth, labels.perEye], ', '),
        };
    };
    var packageQuantityLabel = getLabel('products.contactLenses.usageLevel.question');
    var packageQuantities = usePackageQuantity(packageTypes, mapper).packageQuantities;
    var handleChange = React.useCallback(function (_a) {
        var value = _a.value;
        handlePackSizeChange(value);
    }, [handlePackSizeChange]);
    if (packageQuantities.length === 0) {
        return null;
    }
    return (React.createElement(PackageQuantity, { className: "contact-lens-configurator__package-quantity--daily", packageQuantities: packageQuantities, item: React.createElement(DailyPackageQuantityItem, { className: "package-quantity-dropdown", label: packageQuantities[0].label, subtext: packageQuantities[0].subtext, aside: packageQuantities[0].aside }), dropdown: React.createElement(PackageQuantityDropdown, { label: noLabel ? '' : packageQuantityLabel, title: packageQuantities[0].value, items: packageQuantities, itemView: DailyPackageQuantityItem, selectedSize: "" + selectedSize, onChange: handleChange }) }));
};

var getPriceForPack = function (packSize, packageTypes) {
    var matchedVariant = packageTypes.find(function (packageType) { return packageType.packageQuantity === packSize; });
    // not using multiple prices for now
    return matchedVariant && matchedVariant.price;
};

var ConfigureContactLenses$1 = /** @class */ (function (_super) {
    __extends$1(ConfigureContactLenses, _super);
    function ConfigureContactLenses() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedVariants: {},
            leftEyeChecked: true,
            leftEyeBoxQuantity: 1,
            prescriptionModalOpen: false,
            rightEyeChecked: true,
            rightEyeBoxQuantity: 1,
            packSize: 0,
        };
        _this.setInitialPackSize = function (_a, rateplan) {
            var packageQuantity = _a.packageQuantity;
            packageQuantity && _this.handlePackSizeChange(packageQuantity);
            if (rateplan === null || rateplan === void 0 ? void 0 : rateplan.usageLevel) {
                _this.handleUsageLevelChange(rateplan.usageLevel);
            }
            else {
                (rateplan === null || rateplan === void 0 ? void 0 : rateplan.packageQuantity) && _this.handleSubscriptionPackSizeChange(rateplan.packageQuantity);
            }
        };
        _this.handleChange = function (key, value) {
            var handleFormChange = _this.props.handleFormChange;
            _this.setState(function (prevState) {
                var _a;
                return (__assign$1(__assign$1({}, prevState), (_a = {}, _a[key] = value, _a)));
            }, function () { return handleFormChange && handleFormChange(_this.state); });
        };
        _this.handleLeftEyeChecked = _this.handleChange.bind(_this, 'leftEyeChecked');
        _this.handleRightEyeChecked = _this.handleChange.bind(_this, 'rightEyeChecked');
        _this.handleLeftEyeQuantity = _this.handleChange.bind(_this, 'leftEyeBoxQuantity');
        _this.handleRightEyeQuantity = _this.handleChange.bind(_this, 'rightEyeBoxQuantity');
        _this.handleSubscriptionPriceChange = _this.handleChange.bind(_this, 'subscriptionPrice');
        _this.handlePackSizeChange = function (packSize) {
            var _a;
            var newPackSize;
            switch (typeof packSize) {
                case 'string':
                    newPackSize = parseInt(packSize);
                    break;
                case 'number':
                    newPackSize = packSize;
                    break;
                case 'object':
                    newPackSize = +packSize.value;
                    break;
            }
            _this.setState({
                packPrice: getPriceForPack(newPackSize, _this.props.packageTypes),
            }, function () { return _this.handleChange('packSize', newPackSize); });
            _this.state.packPrice &&
                pushSelectBoxQuantity((_a = _this.state.packPrice) === null || _a === void 0 ? void 0 : _a.value, _this.state.dailiesUsageLevel, "" + _this.state.packSize);
        };
        _this.handleSubscriptionPackSizeChange = function (packSize) {
            var ratePlan = _this.props.ratePlans.find(function (_a) {
                var packageQuantity = _a.packageQuantity;
                return packageQuantity === +packSize;
            });
            var subscriptionPrice = (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.totalPrice.centAmount) || 0;
            // Check for existing packSize in the state, so we don't push on the initial page load
            if (ratePlan && _this.state.packSize) {
                pushSubscriptionBoxSizeChange(ratePlan);
            }
            _this.setState({
                subscriptionPrice: subscriptionPrice,
            }, function () { return _this.handleChange('subscriptionPackSize', packSize); });
        };
        _this.handleUsageLevelChange = function (selectedUsageLevel) {
            var ratePlan = _this.props.ratePlans.find(function (_a) {
                var usageLevel = _a.usageLevel;
                return usageLevel === selectedUsageLevel;
            });
            var subscriptionPrice = (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.totalPrice.centAmount) || 0;
            _this.setState({
                subscriptionPrice: subscriptionPrice,
            }, function () { return _this.handleChange('dailiesUsageLevel', selectedUsageLevel); });
            ratePlan && pushSubscriptionBoxSizeChange(ratePlan);
        };
        _this.handleProductSelection = function (side, product) {
            var _a;
            _this.setState({
                selectedVariants: __assign$1(__assign$1({}, _this.state.selectedVariants), (_a = {}, _a[side] = product, _a)),
            });
            var skuKey = side === 'left' ? 'leftEyeBoxSKU' : 'rightEyeBoxSKU';
            var SKU = product && product.sku;
            _this.handleChange(skuKey, SKU);
            var availableQuantityKey = side === 'left' ? 'leftEyeBoxAvailableQuantity' : 'rightEyeBoxAvailableQuantity';
            var availableQuantity = product && Helpers.getAvailableQuantity(product.availability);
            _this.handleChange(availableQuantityKey, availableQuantity);
        };
        _this.handleLeftEyeProductSelection = _this.handleProductSelection.bind(_this, 'left');
        _this.handleRightEyeProductSelection = _this.handleProductSelection.bind(_this, 'right');
        _this.setScroll = function () {
            var body = document && document.body;
            if (body) {
                _this.state.prescriptionModalOpen && !body.classList.contains('body--no-scroll')
                    ? body.classList.add('body--no-scroll')
                    : body.classList.remove('body--no-scroll');
            }
        };
        _this.onPrescriptionModalOpen = function (event) {
            event.preventDefault();
            _this.setState({ prescriptionModalOpen: true }, function () {
                _this.setScroll();
            });
        };
        _this.onPrescriptionModalClose = function () {
            _this.setState({ prescriptionModalOpen: false }, function () {
                _this.setScroll();
            });
        };
        _this.handlePrescriptionInfoChange = function (prescriptionState) {
            _this.handleChange('prescriptionInfo', prescriptionState);
        };
        return _this;
    }
    ConfigureContactLenses.prototype.componentDidMount = function () {
        this.setInitialPackSize(this.props.packageTypes[0], this.props.ratePlans[0]);
    };
    // @TODO remove this when we rewrite this component to functional
    ConfigureContactLenses.prototype.UNSAFE_componentWillReceiveProps = function (nextProps, nextContext) {
        if (this.props.isSubscriptionSelected === false &&
            nextProps.isSubscriptionSelected &&
            nextProps.ratePlans.length &&
            this.state.packSize) {
            pushSubscriptionStartEvent(this.props.ratePlans[0].includedUnits, this.state.packSize, this.props.ratePlans[0].totalPrice.centAmount, this.state.selectedVariants, this.state.dailiesUsageLevel);
        }
    };
    ConfigureContactLenses.prototype.showErrorAlert = function () {
        var _a = this.props, intl = _a.intl, formValidations = _a.formValidations;
        return (React.createElement(ScrollIntoView, { key: formValidations.errorCount },
            React.createElement(Alert, { type: "error", icon: "alert-circle" }, intl.getFormattedLabel('products.contactLenses.prescription.text', {
                parseLink: true,
            }))));
    };
    ConfigureContactLenses.prototype.render = function () {
        var _a = this.props, attributes = _a.attributes, prescriptionModalContent = _a.prescriptionModalContent, intl = _a.intl, isStockEnabled = _a.isStockEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, allowBackOrder = _a.allowBackOrder, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, isPrescriptionExtraInfoEnabled = _a.isPrescriptionExtraInfoEnabled, opticianForm = _a.opticianForm, dateFormat = _a.dateFormat, formValidations = _a.formValidations, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent, variantData = _a.variantData, packageTypes = _a.packageTypes, isAvailableForSubscription = _a.isAvailableForSubscription, isDaily = _a.isDaily, isSubscriptionSelected = _a.isSubscriptionSelected, promotionalText = _a.promotionalText, hasSubscriptions = _a.hasSubscriptions, ratePlans = _a.ratePlans;
        var _b = this.state, leftEyeChecked = _b.leftEyeChecked, leftEyeBoxQuantity = _b.leftEyeBoxQuantity, leftEyeBoxAvailableQuantity = _b.leftEyeBoxAvailableQuantity, rightEyeChecked = _b.rightEyeChecked, rightEyeBoxQuantity = _b.rightEyeBoxQuantity, rightEyeBoxAvailableQuantity = _b.rightEyeBoxAvailableQuantity, packSize = _b.packSize, prescriptionModalOpen = _b.prescriptionModalOpen;
        return (React.createElement("div", { className: "contact-lens-configurator" },
            React.createElement(React.Fragment, null,
                promotionalText && React.createElement(Text, { variant: "body" }, promotionalText),
                isSubscriptionSelected ? (isAvailableForSubscription ? (isDaily ? (React.createElement(DailyPackageQuantityContainer, { packageTypes: ratePlans, selectedSize: this.state.dailiesUsageLevel, handlePackSizeChange: this.handleUsageLevelChange })) : (React.createElement(PackageQuantityContainer, { packageTypes: ratePlans, selectedSize: "" + this.state.subscriptionPackSize, handlePackSizeChange: this.handleSubscriptionPackSizeChange }))) : (React.createElement(MonthlyPriceContainer, null))) : (React.createElement(PackageQuantityContainer$1, { onChange: this.handlePackSizeChange, selectedSize: "" + this.state.packSize, packageTypes: packageTypes })),
                React.createElement("div", { className: "contact-lens-configurator__error-message" }, formValidations.showError &&
                    !formValidations.isConfiguratorValid &&
                    this.showErrorAlert()),
                React.createElement("div", { className: "contact-lens-configurator__prescription" },
                    React.createElement(PrescriptionContainer, { isSubscriptionSelected: isSubscriptionSelected, hasSubscriptions: hasSubscriptions, isStockEnabled: isStockEnabled, isActive: rightEyeChecked, id: "right", onSelection: this.handleRightEyeChecked, isAvailableForSubscription: isAvailableForSubscription, quantity: rightEyeBoxQuantity, availableQuantity: rightEyeBoxAvailableQuantity, attributes: attributes, products: variantData, packSize: packSize, onFoundProduct: this.handleRightEyeProductSelection, onQuantityChange: this.handleRightEyeQuantity, "data-t": "prescription-right-eye", maxOrderableQuantity: maxOrderableQuantity, allowBackOrder: allowBackOrder, className: "contact-lens-configurator__prescription-right", hasError: formValidations.showError }),
                    React.createElement(PrescriptionContainer, { isSubscriptionSelected: isSubscriptionSelected, hasSubscriptions: hasSubscriptions, isStockEnabled: isStockEnabled, isActive: leftEyeChecked, id: "left", onSelection: this.handleLeftEyeChecked, isAvailableForSubscription: isAvailableForSubscription, quantity: leftEyeBoxQuantity, availableQuantity: leftEyeBoxAvailableQuantity, attributes: attributes, products: variantData, packSize: packSize, onFoundProduct: this.handleLeftEyeProductSelection, onQuantityChange: this.handleLeftEyeQuantity, "data-t": "prescription-left-eye", maxOrderableQuantity: maxOrderableQuantity, allowBackOrder: allowBackOrder, className: "contact-lens-configurator__prescription-left", hasError: formValidations.showError })),
                prescriptionModalContent && (React.createElement(React.Fragment, null,
                    React.createElement("button", { className: "contact-lens-configurator__prescription-link", onClick: this.onPrescriptionModalOpen }, intl.getLabel('products.contactLenses.prescription.link')),
                    prescriptionModalOpen && (React.createElement(Modal, { showIcon: true, isOpen: prescriptionModalOpen, onModalClose: this.onPrescriptionModalClose },
                        React.createElement("div", { className: "contact-lens-configurator__prescription-modal" },
                            React.createElement(RichTextArea, { content: prescriptionModalContent })))))),
                isPrescriptionInfoEnabled && (React.createElement(React.Fragment, null,
                    formValidations.showError &&
                        !formValidations.isPrescriptionInfoValid &&
                        (formValidations.isConfiguratorValid ? (React.createElement(ScrollIntoView, { key: formValidations.errorCount },
                            React.createElement(Alert, { icon: "info", message: intl.getLabel('products.contactLens.info.invalidMessage') }))) : (React.createElement(Alert, { icon: "info", message: intl.getLabel('products.contactLens.info.invalidMessage') }))),
                    React.createElement(PrescriptionInfo, { opticianForm: opticianForm, dateFormat: dateFormat, onChange: this.handlePrescriptionInfoChange, isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled, prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent }))))));
    };
    return ConfigureContactLenses;
}(React.Component));
var ConfigureContactLenses$2 = withIntl(ConfigureContactLenses$1);

var getSortedPackageTypes = function (masterPackageType, packageTypes) {
    // Put the master package type first,
    // this will guarantee the default selected
    var newPackageTypes = __spreadArray$1([masterPackageType], __read(packageTypes));
    // remove duplicates
    return newPackageTypes.reduce(function (prev, curr) {
        var duplicate = prev.some(function (packageType) { return packageType.packageQuantity === curr.packageQuantity; });
        if (!duplicate) {
            prev.push(curr);
        }
        return prev;
    }, []);
};

// only dailies should have a usageLevel attribute present
var isRateplansDaily = function (ratePlans) {
    return !ratePlans.length ? false : ratePlans.every(function (_a) {
        var usageLevel = _a.usageLevel;
        return !!usageLevel;
    });
};

var GET_DISTINCT_RATEPLANS_BY_USAGE_LEVEL = gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  query getDistinctRatePlansByMasterKey($productMasterKey: ID!) {\n    productByMasterKey(productMasterKey: $productMasterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        ratePlansDistinctByUsageLevel {\n          id: externalId\n          externalId\n          effectiveStartDate\n          effectiveEndDate\n          billingPeriod\n          shippingSchedule\n          includedUnits\n          usageLevel\n          totalPrice(normalize: PER_MONTH) {\n            currencyCode\n            centAmount\n          }\n          variant {\n            gan\n            packageQuantity\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getDistinctRatePlansByMasterKey($productMasterKey: ID!) {\n    productByMasterKey(productMasterKey: $productMasterKey) {\n      ... on ContactLensProduct {\n        productMasterKey\n        ratePlansDistinctByUsageLevel {\n          id: externalId\n          externalId\n          effectiveStartDate\n          effectiveEndDate\n          billingPeriod\n          shippingSchedule\n          includedUnits\n          usageLevel\n          totalPrice(normalize: PER_MONTH) {\n            currencyCode\n            centAmount\n          }\n          variant {\n            gan\n            packageQuantity\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$1;

var useDistinctRateplans = (function (masterKey, returnWithoutFetch) {
    var _a, _b;
    // HOTFIX: return early without fetch if flag is enabled
    // This circumvents the rateplan query being called on pdp
    // of products without cls enabled. Remove once cls is on production.
    if (returnWithoutFetch) {
        return { data: [], loading: false };
    }
    var _c = useQuery(GET_DISTINCT_RATEPLANS_BY_USAGE_LEVEL, {
        variables: {
            productMasterKey: masterKey,
        },
    }), data = _c.data, loading = _c.loading, error = _c.error;
    // spread to avoid mutating original array
    var byUsageLevel = (_b = (_a = data === null || data === void 0 ? void 0 : data.productByMasterKey) === null || _a === void 0 ? void 0 : _a.ratePlansDistinctByUsageLevel) !== null && _b !== void 0 ? _b : [];
    var ratePlans = __spreadArray$1([], __read(byUsageLevel)).sort(function (a, b) {
        var _a;
        if (a.usageLevel && b.usageLevel) {
            var levels = (_a = {},
                _a[UsageLevel.ONE_DAY_A_WEEK] = 1,
                _a[UsageLevel.TWO_DAYS_A_WEEK] = 2,
                _a[UsageLevel.THREE_FOUR_DAYS_A_WEEK] = 3,
                _a[UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK] = 4,
                _a);
            return levels[a.usageLevel] - levels[b.usageLevel];
        }
        return a.variant.packageQuantity - b.variant.packageQuantity;
    });
    return { data: toRatePlans(ratePlans !== null && ratePlans !== void 0 ? ratePlans : null) || [], loading: loading, error: error };
});

var allowedAttributes = [
    'addition',
    'axis',
    'baseCurve',
    'color',
    'cylinder',
    'diameter',
    'power',
    'packageQuantity',
];
var ConfigureContactLensesContainer = function (props) {
    var _a = __read(React.useState({}), 2), attributes = _a[0], setAttributes = _a[1];
    var _b = __read(React.useState(true), 2), isLoading = _b[0], setIsLoading = _b[1];
    var _c = __read(React.useState([]), 2), packageTypes = _c[0], setPackageTypes = _c[1];
    var _d = __read(React.useState([]), 2), variantData = _d[0], setVariantData = _d[1];
    // HOTFIX to only fetch data if product has subscriptions enabled
    // remove second param once cls is running on production
    var _e = useDistinctRateplans(props.variantGroup, !props.isAvailableForSubscription), ratePlans = _e.data, ratePlansLoading = _e.loading;
    React.useEffect(function () {
        var getLensData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var productsUrl, lensData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productsUrl = props.apiConfig.productsUrl;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Products.getContactLenses(productsUrl, {
                                variantGroup: props.variantGroup,
                            })];
                    case 2:
                        lensData = _a.sent();
                        return [2 /*return*/, parseLensData(lensData)];
                    case 3:
                        err_1 = _a.sent();
                        console.warn('No variant data provided', err_1);
                        setIsLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        getLensData();
    }, []);
    var parseLensData = function (lensData) {
        var availableAttributes = {};
        var contactLensesVariants = lensData.contactLensesVariants, masterPackageType = lensData.masterPackageType, packageTypes = lensData.packageTypes;
        contactLensesVariants.forEach(function (_a) {
            var e_1, _b;
            var attributes = _a.attributes;
            try {
                for (var _c = __values(Object.keys(attributes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var key = _d.value;
                    if (allowedAttributes.includes(key)) {
                        var value = attributes[key];
                        if (!availableAttributes[key]) {
                            availableAttributes[key] = {
                                selected: '',
                                values: new Set(),
                            };
                        }
                        availableAttributes[key].values.add(value);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        setAttributes(availableAttributes);
        setPackageTypes(getSortedPackageTypes(masterPackageType, packageTypes));
        setVariantData(contactLensesVariants);
        setIsLoading(false);
    };
    return isLoading || ratePlansLoading ? (React.createElement(Loader, { className: "contact-lens-configurator__loader" })) : (React.createElement(ConfigureContactLenses$2, __assign$1({}, props, { attributes: attributes, packageTypes: packageTypes, variantData: variantData, ratePlans: ratePlans, isDaily: isRateplansDaily(ratePlans) })));
};
var ConfigureContactLenses = withApiConfig(ConfigureContactLensesContainer);

var ProductDetailLensesFeatures = function (_a) {
    var hydration = _a.hydration, softness = _a.softness, breathability = _a.breathability, fatigue = _a.fatigue, basics = _a.basics, uv = _a.uv, color = _a.color;
    if (!hydration && !softness && !breathability && !fatigue && !basics && !uv && !color) {
        return null;
    }
    return (React.createElement("ul", { className: "product-detail-lenses-features" },
        basics && basics.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--basics" },
            React.createElement(FeatureIcon, { name: "basics", color: color, size: 38 }),
            basics.label)),
        hydration && hydration.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--hydration" },
            React.createElement(FeatureIcon, { name: "hydratation", color: color, size: 38 }),
            hydration.label)),
        softness && softness.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--softness" },
            React.createElement(FeatureIcon, { name: "softness", color: color, size: 38 }),
            softness.label)),
        breathability && breathability.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--breathability" },
            React.createElement(FeatureIcon, { name: "breathability", color: color, size: 38 }),
            breathability.label)),
        fatigue && fatigue.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--fatigue" },
            React.createElement(FeatureIcon, { name: "fatigue", color: color, size: 38 }),
            fatigue.label)),
        uv && uv.variantHasAttribute && (React.createElement("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--uv" },
            React.createElement(FeatureIcon, { name: "uv", color: color, size: 38 }),
            uv.label))));
};

var Description$1 = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, labels = _a.labels, lensFeatures = _a.lensFeatures, productFeatures = _a.productFeatures, specificationVariant = _a.specificationVariant;
    return (React.createElement(ProductDetailDescription, { title: labels.title, header: labels.header, description: labels.description },
        React.createElement(ProductDetailLensesFeatures, __assign$1({ color: colorFeatureIcons }, lensFeatures)),
        React.createElement(ProductDetailSpecification, { configuration: productFeatures, variant: specificationVariant })));
};

var DescriptionContainer = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, specificationVariant = _a.specificationVariant, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration;
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        description: variant.description,
        header: variant.header,
        title: getLabel('products.contactLenses.header.details'),
    }); }, [getLabel, variant]);
    var _b = React.useMemo(function () { return getContactLensFeatures(variant, getLabel); }, [getLabel, variant]), productFeatures = _b.productFeatures, lensFeatures = _b.lensFeatures;
    return (React.createElement(Description$1, { colorFeatureIcons: colorFeatureIcons, labels: labels, lensFeatures: lensFeatures, productFeatures: specificationConfiguration || productFeatures, specificationVariant: specificationVariant }));
};

var SubscriptionOffer = function (_a) {
    var className = _a.className, clsUsps = _a.clsUsps;
    var getLabel = useIntl().getLabel;
    var label = getLabel('products.contactLenses.subscriptionOffer.label');
    var tooltipLabel = getLabel('products.contactLenses.subscriptionOffer.tooltip');
    if (!label) {
        return null;
    }
    return (React.createElement("div", { className: classnames(['subscription-offer', className]) },
        React.createElement("label", { className: "subscription-offer__label" },
            React.createElement("span", null, label),
            tooltipLabel && React.createElement(Tooltip, { id: "subscription-offer_tooltip", message: tooltipLabel })),
        clsUsps && (React.createElement("div", { className: "subscription-offer__usps" },
            React.createElement(ProductDetailUsps, { items: clsUsps, layout: "grid" })))));
};

var Lenses = function (_a) {
    var _b, _c;
    var addToCartRef = _a.addToCartRef, contactLensesConfiguratorConfig = _a.contactLensesConfiguratorConfig, ctaButton = _a.ctaButton, currency = _a.currency, deliveryIndicatorConfig = _a.deliveryIndicatorConfig, descriptionConfig = _a.descriptionConfig, _d = _a.hasSubscriptions, hasSubscriptions = _d === void 0 ? false : _d, isSmallScreen = _a.isSmallScreen, labels = _a.labels, packPrice = _a.packPrice, subscriptionPrice = _a.subscriptionPrice, productImageAlt = _a.productImageAlt, productTypeUsps = _a.productTypeUsps, clsUsps = _a.clsUsps, showStickyButton = _a.showStickyButton, stickerText = _a.stickerText, stickyTop = _a.stickyTop, variant = _a.variant, variantGroup = _a.variantGroup, activeTabIndex = _a.activeTabIndex, setActiveTabIndex = _a.setActiveTabIndex, isSubscriptionSelected = _a.isSubscriptionSelected, isAvailableForSubscription = _a.isAvailableForSubscription, productImageGallery = _a.productImageGallery, _e = _a.clsConfigurator, clsConfigurator = _e === void 0 ? null : _e, disclaimer = _a.disclaimer, calculatedPrice = _a.calculatedPrice, calculatedDiscountPrice = _a.calculatedDiscountPrice;
    var _f = useFeatureToggles(), isBynderImagesEnabled = _f.isBynderImagesEnabled, isDeliveryFullDateEnabled = _f.isDeliveryFullDateEnabled;
    var getLabel = useIntl().getLabel;
    var packPriceDiscount = (_b = packPrice === null || packPrice === void 0 ? void 0 : packPrice.discounted) === null || _b === void 0 ? void 0 : _b.value.centAmount;
    var hasPackPriceDiscount = typeof packPriceDiscount === 'number';
    var Slots = useProductDetailSlots().Slots;
    return (React.createElement("div", { className: "product-detail__main product-detail-lenses" },
        isSmallScreen && (React.createElement("div", { className: "product-detail__header--mobile" },
            React.createElement(ProductDetailTitle$1, { title: variant.brand, subtitle: variant.replacementFrequency }),
            React.createElement(ReviewSnippet, { productId: variantGroup }))),
        React.createElement("div", { className: "product-detail__image-gallery" }, isBynderImagesEnabled ? (productImageGallery) : (React.createElement(ProductVisualSwitcher, { productImages: variant.images, alt: productImageAlt, sticker: stickerText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText ? variant.discountText : stickerText, modifier: "product-detail" })) }))),
        React.createElement("section", { className: "product-detail__aside product-detail-lenses__aside", "aria-label": variant.brand + " " + variant.replacementFrequency },
            React.createElement(Sticky, { top: stickyTop || 0, bottomBoundary: ".product-detail-lenses", enabled: !isSmallScreen },
                React.createElement(React.Fragment, null,
                    !isSmallScreen && (React.createElement(ProductDetailTitle$1, { title: variant.brand, subtitle: variant.replacementFrequency })),
                    packPrice && !isSubscriptionSelected && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classnames('product-detail__specification-prices', {
                                'product-detail__specification-prices--has-discount': hasPackPriceDiscount,
                            }), role: "group", "aria-label": getLabel('products.screenreader.priceInformation') },
                            React.createElement("div", { className: "product-detail__price-container" },
                                React.createElement(ProductDetailPrice, { originalPrice: packPrice.value.centAmount, currency: currency, discountedPrice: packPriceDiscount })),
                            variant.discountText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" }))),
                        Slots.AfterPrice ? (React.createElement("div", { className: "product-detail__after-price-slot" },
                            React.createElement(Slots.AfterPrice, { price: packPrice.value.centAmount, productType: variant.productType }))) : null)),
                    subscriptionPrice && isSubscriptionSelected && (React.createElement("div", { className: classnames('product-detail__specification-prices', {
                            'product-detail__specification-prices--has-discount': false, // NYI: subscription discounts
                        }) },
                        React.createElement("div", { className: "product-detail__price-container" },
                            React.createElement(ProductDetailPrice, { originalPrice: subscriptionPrice, currency: currency })))),
                    !isSmallScreen && React.createElement(ReviewSnippet, { productId: variantGroup }),
                    isSubscriptionSelected && isAvailableForSubscription && (React.createElement(React.Fragment, null,
                        React.createElement(Hr, { className: "product-detail__usp-divider" }),
                        React.createElement(SubscriptionOffer, { clsUsps: clsUsps }))),
                    (hasSubscriptions || isAvailableForSubscription) && (React.createElement(Tabs, { onChange: setActiveTabIndex, activeTabIndex: activeTabIndex, variant: "secondary" },
                        React.createElement(Tab, { label: labels.oneTimeTitle }),
                        React.createElement(Tab, { label: labels.subscriptionTitle }))),
                    React.createElement("div", { className: "product-detail__configuration product-detail-lenses__configuration" },
                        React.createElement(ConfigureContactLenses, __assign$1({}, contactLensesConfiguratorConfig, { isSubscriptionSelected: isSubscriptionSelected, isAvailableForSubscription: isAvailableForSubscription, hasSubscriptions: hasSubscriptions, variantGroup: variantGroup }))),
                    React.createElement("div", { className: "product-detail__cart-details", ref: addToCartRef },
                        isDeliveryFullDateEnabled && !isSubscriptionSelected && (React.createElement("div", { className: "product-detail__cart-details__delivery-indicator" },
                            React.createElement(DeliveryIndicator, __assign$1({}, deliveryIndicatorConfig, { view: "text" })))),
                        ctaButton,
                        Slots.AfterCTA ? (React.createElement(Slots.AfterCTA, { price: calculatedDiscountPrice || calculatedPrice, productType: variant.productType })) : null,
                        isSmallScreen &&
                            showStickyButton &&
                            !!variant.price &&
                            (isSubscriptionSelected && !isAvailableForSubscription ? (React.createElement(StickyCallToAction, { button: ctaButton })) : (React.createElement(StickyCallToAction, { button: ctaButton, price: React.createElement(Price, { value: (_c = (packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount)) !== null && _c !== void 0 ? _c : 0, currency: currency, centAmount: true, type: packPriceDiscount ? 'discount' : 'default' }), perBox: labels.perBox })))),
                    React.createElement(Hr, { className: "product-detail__usp-divider" }),
                    !isSubscriptionSelected && !isDeliveryFullDateEnabled && (React.createElement(DeliveryIndicator, __assign$1({}, deliveryIndicatorConfig, { view: "icon" }))),
                    productTypeUsps && React.createElement(ProductDetailUsps, { items: productTypeUsps })))),
        React.createElement("div", { className: "product-detail-lenses__description" },
            React.createElement(DescriptionContainer, __assign$1({}, descriptionConfig, { variant: variant }))),
        disclaimer && (React.createElement("div", { className: "product-detail__disclaimer product-detail-lenses__disclaimer" },
            React.createElement(Panel, { title: disclaimer.title }, disclaimer.description))),
        clsConfigurator));
};

var LensesContainer = function (_a) {
    var activeSku = _a.activeSku, addToCartRef = _a.addToCartRef, allowBackOrder = _a.allowBackOrder, colorFeatureIcons = _a.colorFeatureIcons, clsUsps = _a.clsUsps, dateFormat = _a.dateFormat, deliveryResolverFactory = _a.deliveryResolverFactory, formatProductUrl = _a.formatProductUrl, isContactLensStockEnabled = _a.isContactLensStockEnabled, isPrescriptionEnabled = _a.isPrescriptionEnabled, _b = _a.isPrescriptionExtraInfoEnabled, isPrescriptionExtraInfoEnabled = _b === void 0 ? true : _b, _c = _a.isPrescriptionInfoEnabled, isPrescriptionInfoEnabled = _c === void 0 ? false : _c, isSolutionsEnabled = _a.isSolutionsEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, onCTAClick = _a.onCTAClick, onPriceChange = _a.onPriceChange, opticianForm = _a.opticianForm, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent, prescriptionModalContent = _a.prescriptionModalContent, product = _a.product, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, stickerText = _a.stickerText, stickyTop = _a.stickyTop, variant = _a.variant, hasSubscriptions = _a.hasSubscriptions, specificationConfiguration = _a.specificationConfiguration, renderAddToCartButton = _a.renderAddToCartButton, handleConversionEvent = _a.handleConversionEvent, productImageGallery = _a.productImageGallery, disclaimer = _a.disclaimer;
    var excludedFromCheckout = variant.excludedFromCheckout, promotionalText = variant.promotionalText;
    var masterVariant = product.masterVariant;
    var _d = useIntl(), currency = _d.currency, getLabel = _d.getLabel, locale = _d.locale;
    var routes = useProductDetailContext().routes;
    var isDeliveryFullDateEnabled = useFeatureToggles().isDeliveryFullDateEnabled;
    var dispatch = useDispatch();
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var _e = useFeatureToggles(), isCartV2Enabled = _e.isCartV2Enabled, isBynderImagesEnabled = _e.isBynderImagesEnabled;
    var productViewHistory = useProductViewHistory();
    var _f = __read(React.useState(0), 2), activeTabIndex = _f[0], setActiveTabIndex = _f[1];
    var _g = __read(React.useState(false), 2), isConfiguratorOpen = _g[0], setIsConfiguratorOpen = _g[1];
    var productCatKey = getAttrValue(masterVariant, 'recommendedProductCatKey');
    var recommendedCategoryKey = isString(productCatKey) ? productCatKey : undefined;
    var variantGroup = String(getAttrValue(masterVariant, 'brandKey'));
    /**
     * "Old" way of handling subscriptions, currently in use by the BeNe opco's.
     */
    var isSubscriptionSelected = activeTabIndex === 1;
    /**
     * Enables the new subscription configurator based on a boolean variant attribute.
     */
    var isAvailableForSubscription = productIsAvailableForSubscription(product);
    var _h = __read(useLenses({
        product: product,
        isPrescriptionEnabled: isPrescriptionEnabled,
        isPrescriptionInfoEnabled: isPrescriptionInfoEnabled,
        variant: variant,
        formatProductUrl: formatProductUrl,
    }), 2), lensState = _h[0], lensActions = _h[1];
    var _j = useLensBundle(), bundleLineItems = _j.lineItems, pricePerMonth = _j.pricePerMonth;
    var lineItemsForCart = isSubscriptionSelected
        ? bundleLineItems
        : lensState.priceTotals.selectedProducts;
    /**
     * Add SKU to view history
     * Only adds the masterProduct so we don't get duplicates
     */
    React.useEffect(function () {
        if (Boolean(getAttrValue(masterVariant, 'masterProduct')) && masterVariant.sku) {
            productViewHistory.add(masterVariant.sku);
        }
    }, []);
    /**
     * Callback to update the AddToCartNotification in ProductDetail
     * should execute when either the solutions or the lenses update
     */
    React.useEffect(function () {
        onPriceChange(lensState.priceTotals);
    }, [onPriceChange, lensState.priceTotals]);
    /**
     * Triggers the product_detail SD action when the user clicks on the subscription tab
     */
    React.useEffect(function () {
        viewProductSdEvent({
            product: product,
            activeSKU: variant.sku,
            staticsUrl: staticsUrl,
            url: "" + window.location + formatProductUrl({
                productType: 'Contact-lenses',
                slug: product.slug,
            }),
            locale: locale,
            isSubscriptionSelected: isSubscriptionSelected,
            pricePerMonth: pricePerMonth,
            isBynderImagesEnabled: isBynderImagesEnabled,
        });
        var purchaseType = isSubscriptionSelected
            ? DataLayer.DataLayerTypes.PurchaseType.Subscription
            : DataLayer.DataLayerTypes.PurchaseType.OneTime;
        var productType = isSubscriptionSelected
            ? DataLayer.DataLayerTypes.LineItemType.Bundle
            : DataLayer.DataLayerTypes.LineItemType.Single;
        pushPdpEventToDataLayer(purchaseType, product, variant.sku, currency, productType, lensState.subscriptionPrice);
    }, [activeTabIndex]); // eslint-disable-line react-hooks/exhaustive-deps
    var setActiveTab = function (index) {
        pushTabClickEvent(!isSubscriptionSelected);
        setActiveTabIndex(index);
    };
    var openConfiguratorButtonRef = React.useRef(null);
    var handleConfiguratorOpen = React.useCallback(function () {
        if (lensState.formValidations.isConfiguratorValid) {
            handleConversionEvent();
            setIsConfiguratorOpen(true);
        }
        else {
            lensActions.handlePrescriptionClick(); // Show the alert
        }
    }, [lensActions, lensState, dispatch]);
    var handleConfiguratorClose = React.useCallback(function () {
        var _a;
        setIsConfiguratorOpen(false);
        (_a = openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : openConfiguratorButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        dispatch(resetConfigurationState());
    }, [openConfiguratorButtonRef, dispatch]);
    var getSelectedLensVariants = React.useMemo(function () {
        var isLensVariant = function (variant) { return !!variant; };
        var selectedVariants = lensState.selectedLensVariants.filter(isLensVariant);
        // When both eye sides have the same variant, find will return the same eye side for both of the sides. Through the
        // use of a check for identical variants, we can ensure no duplicate `ContactLensVariantWithEyeSide` will end up in
        // the return value.
        var areEyeSideVariantsIdentical = selectedVariants.length === 2 && selectedVariants[0].sku === selectedVariants[1].sku;
        var getEyeSideForVariant = function (variant) {
            var _a, _b;
            return (_b = (_a = lensState.priceTotals.selectedProducts.find(function (_a) {
                var sku = _a.sku;
                return sku === (variant === null || variant === void 0 ? void 0 : variant.sku);
            })) === null || _a === void 0 ? void 0 : _a.customAttributes) === null || _b === void 0 ? void 0 : _b.eyeSide;
        };
        var getEyeSideForIdenticalVariant = function (_variant, index) { return (index === 0 ? 'left' : 'right'); };
        return __assign$1({}, selectedVariants.map(function (variant, index) { return (__assign$1(__assign$1({}, variant), { eyeSide: areEyeSideVariantsIdentical
                ? getEyeSideForIdenticalVariant(variant, index)
                : getEyeSideForVariant(variant) })); }));
    }, [lensState]);
    var clsConfigurator = (React.createElement(ClsConfigurator, { formatProductUrl: formatProductUrl, input: lensState.subscriptionConfiguratorInput, isOpen: isConfiguratorOpen, lensVariants: getSelectedLensVariants, product: product, staticsUrl: staticsUrl, variantGroup: variantGroup, onModalClose: handleConfiguratorClose, recommendedCategoryKey: recommendedCategoryKey, triggerButtonRef: openConfiguratorButtonRef, clsUsps: clsUsps }));
    var ctaButton = isAvailableForSubscription && activeTabIndex === 1 ? (React.createElement(ConfiguratorButton, { onClick: handleConfiguratorOpen, btnRef: openConfiguratorButtonRef, calculatedPrice: lensState.priceTotals.subscriptionCalculatedPrice, isPrescriptionEnabled: isPrescriptionEnabled, hasLenses: lensState.hasLenses })) : (React.createElement(CTAButton$1, { calculatedDiscountPrice: lensState.priceTotals.calculatedDiscountPrice, calculatedPrice: lensState.priceTotals.calculatedPrice, lineItemsForCart: lineItemsForCart, excludedFromCheckout: excludedFromCheckout, isPrescriptionEnabled: isPrescriptionEnabled, isSubscription: isSubscriptionSelected, hasLenses: lensState.hasLenses, onPrescriptionClick: lensActions.handlePrescriptionClick, handleMiniCartChange: lensActions.handleMiniCartChange, onClick: onCTAClick, pricePerMonth: pricePerMonth, renderAddToCartButton: renderAddToCartButton, handleConversionEvent: handleConversionEvent }));
    var solutionsConfig = isSolutionsEnabled && recommendedCategoryKey
        ? {
            recommendedCategoryKey: recommendedCategoryKey,
            maxQuantity: maxOrderableQuantity,
        }
        : undefined;
    var contactLensesConfiguratorConfig = {
        allowBackOrder: allowBackOrder,
        dateFormat: dateFormat,
        formValidations: lensState.formValidations,
        handleFormChange: lensActions.handleFormChange,
        isStockEnabled: isContactLensStockEnabled,
        isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled,
        isPrescriptionInfoEnabled: isPrescriptionInfoEnabled,
        maxOrderableQuantity: maxOrderableQuantity,
        opticianForm: opticianForm,
        prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent,
        prescriptionModalContent: prescriptionModalContent,
        promotionalText: promotionalText,
        hasSubscriptions: hasSubscriptions,
    };
    var deliveryIndicatorConfig = {
        fallbackLabel: getLabel('products.deliveryIndicator.selectPrescription'),
        className: 'product-detail__delivery-indicator',
    };
    if (isDeliveryFullDateEnabled) {
        deliveryIndicatorConfig = __assign$1(__assign$1({}, deliveryIndicatorConfig), { items: lineItemsForCart.map(function (item) { return ({
                sku: item.sku,
                quantity: item.quantity || 1,
            }); }) });
    }
    else {
        deliveryIndicatorConfig = __assign$1(__assign$1({}, deliveryIndicatorConfig), { 
            // TODO: Add availability info when bundles have that
            availability: !isSubscriptionSelected ? lensState.availability : [undefined], deliveryResolver: deliveryResolverFactory && deliveryResolverFactory(lensState.selectedLensVariants) });
    }
    var descriptionConfig = {
        colorFeatureIcons: colorFeatureIcons,
        specificationVariant: getActiveVariant$1(product, activeSku),
        specificationConfiguration: specificationConfiguration,
    };
    var labels = {
        perBox: getLabel('products.perBox'),
        perMonth: getLabel('common.frequency.perMonth'),
        descriptionTitle: getLabel('products.contactLenses.header.details'),
        subscriptionTitle: getLabel('products.contactLenses.subscription.title'),
        oneTimeTitle: getLabel('products.contactLenses.oneTime.title'),
    };
    var subscriptionPriceObject = {
        originalPrice: (pricePerMonth && pricePerMonth.centAmount) || 0,
        currency: currency,
    };
    var oneTimePurchasePriceObject = {
        originalPrice: lensState.priceTotals.calculatedPrice,
        discountedPrice: isNumber(lensState.priceTotals.calculatedDiscountPrice) &&
            lensState.priceTotals.calculatedDiscountPrice > 0
            ? lensState.priceTotals.calculatedDiscountPrice
            : undefined,
        currency: currency,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Lenses, { addToCartRef: addToCartRef, clsUsps: clsUsps, contactLensesConfiguratorConfig: contactLensesConfiguratorConfig, ctaButton: ctaButton, currency: currency, deliveryIndicatorConfig: deliveryIndicatorConfig, descriptionConfig: descriptionConfig, formatProductUrl: formatProductUrl, hasSubscriptions: hasSubscriptions, isSmallScreen: isSmallScreen, labels: labels, packPrice: lensState.packPrice, subscriptionPrice: lensState.subscriptionPrice, productImageAlt: getLocalizedValue(product.name, locale), productTypeUsps: productTypeUsps, showStickyButton: showStickyButton, staticsUrl: staticsUrl, stickerText: stickerText, stickyTop: stickyTop, variant: variant, variantGroup: variantGroup, activeTabIndex: activeTabIndex, setActiveTabIndex: setActiveTab, isSubscriptionSelected: isSubscriptionSelected, isAvailableForSubscription: isAvailableForSubscription, productImageGallery: productImageGallery, clsConfigurator: clsConfigurator, disclaimer: disclaimer, calculatedPrice: lensState.priceTotals.calculatedPrice, calculatedDiscountPrice: lensState.priceTotals.calculatedDiscountPrice }),
        !isCartV2Enabled ? (React.createElement(MiniCart, { open: lensState.showMiniCart, product: {
                title: variant.brand,
                body: variant.replacementFrequency,
                price: isSubscriptionSelected ? subscriptionPriceObject : oneTimePurchasePriceObject,
                imageUrl: variant.images[0].url + "?w=450",
            }, onClose: lensActions.handleMiniCartChange, onToCart: routes.cart, onToCheckout: routes.checkout },
            isSubscriptionSelected && React.createElement(SubscriptionSolutionPickerContainer, null),
            !isSubscriptionSelected && solutionsConfig && (React.createElement(SolutionsContainer$1, __assign$1({}, solutionsConfig, { staticsUrl: staticsUrl }))))) : null));
};

var isPowerAttribute = function (attr) {
    return attr.name === 'power';
};
var findPowerAttribute = function (variant) { var _a; return (_a = variant === null || variant === void 0 ? void 0 : variant.attributes) === null || _a === void 0 ? void 0 : _a.find(isPowerAttribute); };
var mappedDropdownItems = function (variants) {
    return variants.reduce(function (acc, curr) {
        var _a, _b, _c;
        return (findPowerAttribute(curr)
            ? acc.push({ value: (_a = curr.sku) !== null && _a !== void 0 ? _a : '', label: (_c = (_b = findPowerAttribute(curr)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '' })
            : null,
            acc);
    }, []);
};
var sortedDropdownItems = function (mappedItems) {
    return mappedItems.sort(function (a, b) { return +a.value - +b.value; });
};
var PowerSelector = function (_a) {
    var _b;
    var activeSku = _a.activeSku, handleVariantPick = _a.handleVariantPick, variants = _a.variants;
    var items = React.useMemo(function () { return mappedDropdownItems(variants); }, [variants]);
    var sortedItems = React.useMemo(function () { return sortedDropdownItems(items); }, [items]);
    var selectedSize = (_b = items.find(function (item) { return item.value === activeSku; })) === null || _b === void 0 ? void 0 : _b.value;
    return (React.createElement(PackageQuantityDropdown, { title: "ready-readers-power-selector", onChange: function (selectedVariant) {
            return handleVariantPick(selectedVariant.label, undefined, selectedVariant.value);
        }, selectedSize: selectedSize, items: sortedItems }));
};

var getFeatures$1 = function (getLabel, variant) { return ({
    blueFilter: {
        label: getLabel('products.readyreaders.features.blueFilter'),
        hasAttribute: Boolean(variant.features.blueFilter),
    },
    isOfferedWithPrescriptions: {
        label: getLabel('products.readyreaders.features.isOfferedWithPrescriptions'),
        hasAttribute: Boolean(variant.features.isOfferedWithPrescriptions),
    },
}); };
var ReadyReadersFeatures = function (_a) {
    var variant = _a.variant, labels = _a.labels;
    var getLabel = useIntl().getLabel;
    var featureList = getFeatures$1(getLabel, variant);
    var featureListItems = Object.keys(featureList).map(function (feature) {
        return featureList[feature].hasAttribute && (React__default.createElement("li", { className: "ready-readers-features__feature", key: feature, role: "listitem" },
            React__default.createElement(FeatureIcon, { name: feature, color: 'grey', size: 38 }),
            featureList[feature].label));
    });
    if (featureListItems.filter(Boolean).length === 0) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { variant: "smallest", component: "h2" }, labels.informationBlockHeader),
        React__default.createElement("ul", { className: "ready-readers-features", role: "list", "aria-label": "features" }, featureListItems)));
};

var ReadyReaders = function (_a) {
    var activeSku = _a.activeSku, activeVariant = _a.activeVariant, addToCartRef = _a.addToCartRef, brandLink = _a.brandLink, currency = _a.currency, formatProductUrl = _a.formatProductUrl, handleConversionEvent = _a.handleConversionEvent, handleVariantPick = _a.handleVariantPick, isBynderImagesEnabled = _a.isBynderImagesEnabled, isMobile = _a.isMobile, isOrderable = _a.isOrderable, labels = _a.labels, onCTAClick = _a.onCTAClick, product = _a.product, productImageAlt = _a.productImageAlt, productImageGallery = _a.productImageGallery, productTypeUsps = _a.productTypeUsps, specificationConfiguration = _a.specificationConfiguration, stickyTop = _a.stickyTop, stockCount = _a.stockCount, stockResolver = _a.stockResolver, variant = _a.variant, variants = _a.variants;
    var channelAvailability = variant.channelAvailability;
    return (React.createElement("div", { className: "product-detail__main product-detail-ready-readers" },
        isMobile && (React.createElement("div", { className: "product-detail__header--mobile" },
            React.createElement(ProductDetailTitle$1, { title: variant.brand, subtitle: variant.modelName, href: brandLink }),
            React.createElement(ReviewSnippet, { productId: variant.sku }))),
        React.createElement("div", { className: "product-detail__image-gallery" }, isBynderImagesEnabled ? (productImageGallery) : (React.createElement(ProductVisualSwitcher, { productImages: variant.images, alt: productImageAlt }))),
        React.createElement("aside", { className: "product-detail__aside" },
            React.createElement(Sticky, { top: stickyTop || 0, bottomBoundary: ".product-detail", enabled: !isMobile },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mobile-hidden" },
                        React.createElement(ProductDetailTitle$1, { title: variant.brand, subtitle: variant.modelName, href: brandLink })),
                    !!variant.price && (React.createElement("div", { className: classnames('product-detail__specification-prices', {
                            'product-detail__specification-prices--has-discount': !!variant.discountText,
                        }) },
                        React.createElement("div", { className: "product-detail__price-container" },
                            React.createElement(ProductDetailPrice, { originalPrice: variant.price.originalPrice, discountedPrice: variant.price.discountedPrice, currency: currency })),
                        variant.discountText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" })))),
                    !isMobile && React.createElement(ReviewSnippet, { productId: variant.sku }),
                    React.createElement("div", { className: "product-detail-ready-readers__power_selector" },
                        React.createElement("div", { className: "product-detail-ready-readers__label" },
                            labels.power,
                            React.createElement(StockIndicator, { stockCount: stockCount, stockResolver: stockResolver, allowBackOrder: isOrderable })),
                        React.createElement(PowerSelector, { handleVariantPick: handleVariantPick, variants: variants, activeSku: activeSku })),
                    React.createElement("div", { className: "product-detail__cart-details" },
                        React.createElement("div", { ref: addToCartRef },
                            React.createElement(NonRxProductCTA, { action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE', handleConversionEvent: handleConversionEvent, addToCartConfig: {
                                    activeSku: activeSku,
                                    variantUrl: formatProductUrl({
                                        productType: variant.productType,
                                        sku: activeSku || '',
                                        slug: product.slug,
                                    }),
                                    formatProductUrl: formatProductUrl,
                                    onCTAClick: onCTAClick,
                                } })),
                        productTypeUsps && (React.createElement(React.Fragment, null,
                            React.createElement(Hr, { className: "product-detail__usp-divider" }),
                            React.createElement(ProductDetailUsps, { items: productTypeUsps }))))))),
        React.createElement("section", { className: "product-detail-ready-readers__description", "aria-label": "product-information-block", "data-t": "ready-readers-description" },
            React.createElement(ReadyReadersFeatures, { variant: variant, labels: labels }),
            React.createElement(ProductDetailSpecification, { configuration: specificationConfiguration, variant: activeVariant })),
        React.createElement("div", { className: "product-detail__disclaimer" })));
};

var ReadyReadersContainer = function (_a) {
    var _b, _c;
    var activeSku = _a.activeSku, addToCartRef = _a.addToCartRef, formatProductUrl = _a.formatProductUrl, handleConversionEvent = _a.handleConversionEvent, onVariantPick = _a.handleVariantPick, onCTAClick = _a.onCTAClick, product = _a.product, productImageGallery = _a.productImageGallery, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, specificationConfiguration = _a.specificationConfiguration, stickyTop = _a.stickyTop, stockResolver = _a.stockResolver, variant = _a.variant;
    var _d = useIntl(), currency = _d.currency, getLabel = _d.getLabel, locale = _d.locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var brandLink = useBrandLink(variant.brand);
    var isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var activeVariant = getActiveVariant$1(product, activeSku);
    var productImageAlt = getLocalizedValue(product.name, locale);
    var stockCount = (_c = (_b = variant.availability) === null || _b === void 0 ? void 0 : _b.availableQuantity) !== null && _c !== void 0 ? _c : 0;
    var isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    var variants = React.useMemo(function () { return __spreadArray$1([product.masterVariant], __read(product.variants)); }, [
        product.masterVariant,
        product.variants,
    ]);
    var handleVariantPick = React.useCallback(function (selectedSize) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        onVariantPick.apply(void 0, __spreadArray$1([], __read(args)));
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedSize,
        });
    }, [onVariantPick]);
    var labels = React.useMemo(function () { return ({
        informationBlockHeader: getLabel('products.readyreaders.informationBlockHeader'),
        power: getLabel('products.readyreaders.power'),
    }); }, [getLabel]);
    React.useEffect(function () {
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [activeSku]);
    return (React.createElement(ReadyReaders, { activeSku: activeSku, activeVariant: activeVariant, addToCartRef: addToCartRef, brandLink: brandLink, currency: currency, formatProductUrl: formatProductUrl, handleConversionEvent: handleConversionEvent, handleVariantPick: handleVariantPick, isBynderImagesEnabled: isBynderImagesEnabled, isMobile: isMobile, isOrderable: isOrderable, labels: labels, onCTAClick: onCTAClick, product: product, productImageAlt: productImageAlt, productImageGallery: productImageGallery, productTypeUsps: productTypeUsps, showStickyButton: showStickyButton, specificationConfiguration: specificationConfiguration, stickyTop: stickyTop, stockCount: stockCount, stockResolver: stockResolver, variant: variant, variants: variants }));
};

var CTAButton = function (_a) {
    var isOrderable = _a.isOrderable, renderAddToCartButton = _a.renderAddToCartButton, calculatedPrice = _a.calculatedPrice, currency = _a.currency, activeSku = _a.activeSku, selectedQuantity = _a.selectedQuantity, addToCartCallback = _a.addToCartCallback;
    var getLabel = useIntl().getLabel;
    var routes = useProductDetailContext().routes;
    var caption = (React.createElement(Text, { component: "span", variant: "body" }, getLabel('products.solutions.addToBasket') + " ",
        isNumber(calculatedPrice) && calculatedPrice > 0 && (React.createElement(Price, { value: calculatedPrice, currency: currency }))));
    var addToCartProps = {
        caption: caption,
        onSuccess: addToCartCallback,
        lineItemDrafts: [{ sku: activeSku, quantity: selectedQuantity !== null && selectedQuantity !== void 0 ? selectedQuantity : 1, type: 'regular' }],
    };
    return isOrderable && renderAddToCartButton ? (renderAddToCartButton(addToCartProps)) : (React.createElement(Button, { caption: getLabel('products.actions.excludedFromCheckout'), href: routes.stores }));
};

var getPackageObject = function (variant) {
    var _a, _b;
    var price = getPrice$1(variant);
    return {
        label: String(getAttrValue(variant, 'packageOption')),
        value: String(variant.sku),
        subtext: '',
        aside: (React__default.createElement(ProductDetailPrice$1, { originalPrice: (_a = price === null || price === void 0 ? void 0 : price.originalPrice) !== null && _a !== void 0 ? _a : 0, discountedPrice: (_b = price === null || price === void 0 ? void 0 : price.discountedPrice) !== null && _b !== void 0 ? _b : 0, currency: price === null || price === void 0 ? void 0 : price.currency, customSize: "small" })),
    };
};
var PackageSelector = function (_a) {
    var label = _a.label, handleVariantPick = _a.handleVariantPick, variants = _a.variants, selectedPackage = _a.selectedPackage;
    var packageItems = React__default.useMemo(function () { return variants.map(getPackageObject); }, [variants]);
    var handlePackSizeChange = React__default.useCallback(function (packageOption, event) {
        handleVariantPick(event, packageOption.value, packageOption.label);
    }, [handleVariantPick]);
    return (React__default.createElement(PackageQuantityDropdown, { onChange: handlePackSizeChange, title: packageItems[0].value, label: label, items: packageItems, selectedSize: selectedPackage }));
};

var CHANGE_SOLUTION_VOLUME_OR_VARIANT = 'click_solution_pdp';
var EventAction;
(function (EventAction) {
    EventAction["SelectVolume"] = "select solutions volume";
    EventAction["QuantityIncrease"] = "solutions quantity increase";
    EventAction["QuantityDecrease"] = "solutions quantity decrease";
})(EventAction || (EventAction = {}));
var triggerDataLayerEvent$1 = function (eventAction, eventLabel) {
    DataLayer.pushEvent({
        event: CHANGE_SOLUTION_VOLUME_OR_VARIANT,
        eventAction: eventAction,
        eventLabel: eventLabel,
    });
};

var getSolutionsFeatures = function (variant, getLabel) {
    var productFeatures = [
        {
            labelKey: 'products.solutions.lensTypeTarget',
            attribute: 'lensTypeTarget',
            isLocalised: true,
        },
        {
            labelKey: 'products.solutions.caseIncluded',
            attribute: 'caseIncluded',
        },
        {
            labelKey: 'products.solutions.minimumCycleTime',
            attribute: 'minimumCycleTime',
            isLocalised: true,
        },
        {
            labelKey: 'products.solutions.preservativeFree',
            attribute: 'preservativeFree',
        },
        {
            labelKey: 'products.solutions.maxTimeFrameInLensCase',
            attribute: 'maxTimeFrameInLensCase',
            isLocalised: true,
        },
        {
            labelKey: 'products.solutions.expirationAfterOpening',
            attribute: 'expirationAfterOpening',
            isLocalised: true,
        },
    ];
    var disinfect = {
        label: getLabel('products.solutions.features.cbDisinfect'),
        variantHasAttribute: !!variant.features.disinfect,
    };
    var hydration = {
        label: getLabel('products.solutions.features.cbHydration'),
        variantHasAttribute: !!variant.features.hydration,
    };
    var comfort = {
        label: getLabel('products.solutions.features.cbComfort'),
        variantHasAttribute: !!variant.features.comfort,
    };
    var cleaning = {
        label: getLabel('products.solutions.features.cbCleaning'),
        variantHasAttribute: !!variant.features.cleaning,
    };
    var sensitivity = {
        label: getLabel('products.solutions.features.cbSensitivity'),
        variantHasAttribute: !!variant.features.sensitivity,
    };
    var rinsing = {
        label: getLabel('products.solutions.features.cbRinsing'),
        variantHasAttribute: !!variant.features.rinsing,
    };
    var solutionsFeatures = {
        disinfect: disinfect,
        hydration: hydration,
        comfort: comfort,
        cleaning: cleaning,
        sensitivity: sensitivity,
        rinsing: rinsing,
    };
    return {
        productFeatures: productFeatures,
        solutionsFeatures: solutionsFeatures,
    };
};

var getFeatures = Object.keys;
var SolutionsFeatures = function (props) {
    if (Object.values(props).every(function (feature) { return !feature.variantHasAttribute; })) {
        return null;
    }
    return (React__default.createElement("ul", { className: "product-detail-solutions-features" }, getFeatures(props).map(function (feature, i) {
        var _a;
        return (((_a = props[feature]) === null || _a === void 0 ? void 0 : _a.variantHasAttribute) && (React__default.createElement("li", { className: "product-detail-solutions-features__feature product-detail-solutions-features__feature--basics", key: feature },
            React__default.createElement(FeatureIcon, { name: feature, color: 'grey', size: 38 }),
            props[feature].label)));
    })));
};

var SolutionsProductDetails = function (props) {
    if (Object.values(props).every(function (productDetails) { return productDetails === ''; })) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { variant: "subheading1" }, props.headerTitle),
        React__default.createElement("ul", null, Object.keys(props)
            .filter(function (el) { return el !== 'headerTitle'; })
            .map(function (key) { return (props[key] ? React__default.createElement("li", { key: key }, props[key]) : null); }))));
};

var Description = function (_a) {
    var variant = _a.variant, specificationVariant = _a.specificationVariant, specificationConfiguration = _a.specificationConfiguration;
    var getLabel = useIntl().getLabel;
    var labels = React__default.useMemo(function () { return ({
        description: variant.description,
        header: variant.header || 'Product Header',
        title: getLabel('products.solutions.header.details') || 'Product Details',
        targetUsers: variant.targetUsers,
        convenience: variant.convenience,
        keyInstructions: variant.keyInstructions,
        disclaimer: getLabel('products.solutions.features.disclaimer'),
    }); }, [getLabel, variant]);
    var _b = React__default.useMemo(function () { return getSolutionsFeatures(variant, getLabel); }, [getLabel, variant]), productFeatures = _b.productFeatures, solutionsFeatures = _b.solutionsFeatures;
    return (React__default.createElement(ProductDetailDescription, { title: labels.header, description: labels.description },
        React__default.createElement(SolutionsFeatures, __assign$1({}, solutionsFeatures)),
        React__default.createElement(SolutionsProductDetails, { targetUsers: labels.targetUsers, convenience: labels.convenience, keyInstructions: labels.keyInstructions, headerTitle: labels.title }),
        React__default.createElement(ProductDetailSpecification, { configuration: specificationConfiguration || productFeatures, variant: specificationVariant }),
        labels.disclaimer));
};

var Solutions = function (_a) {
    var _b;
    var addToCartRef = _a.addToCartRef, availableQuantity = _a.availableQuantity, ctaButton = _a.ctaButton, stickyTop = _a.stickyTop, currency = _a.currency, brandLink = _a.brandLink, isSmallScreen = _a.isSmallScreen, labels = _a.labels, showStickyButton = _a.showStickyButton, productTypeUsps = _a.productTypeUsps, variant = _a.variant, brandModel = _a.brandModel, descriptionConfig = _a.descriptionConfig, productImageAlt = _a.productImageAlt, stockResolver = _a.stockResolver, packageSelector = _a.packageSelector, selectedQuantity = _a.selectedQuantity, onDecreaseQuantity = _a.onDecreaseQuantity, onIncreaseQuantity = _a.onIncreaseQuantity, isOrderable = _a.isOrderable, maxOrderableQuantity = _a.maxOrderableQuantity, productImageGallery = _a.productImageGallery, disclaimer = _a.disclaimer, quantity = _a.quantity, calculatedTotalPrice = _a.calculatedTotalPrice;
    var _c = useFeatureToggles(), isBynderImagesEnabled = _c.isBynderImagesEnabled, isDeliveryFullDateEnabled = _c.isDeliveryFullDateEnabled;
    var getLabel = useIntl().getLabel;
    var Slots = useProductDetailSlots().Slots;
    return (React.createElement("div", { className: "product-detail__main product-detail-solutions" },
        isSmallScreen && (React.createElement("div", { className: "product-detail__header--mobile" },
            React.createElement(ProductDetailTitle$1, { title: variant.modelName + " " + brandModel, subtitle: variant.modelName, href: brandLink }),
            React.createElement(ReviewSnippet, { productId: variant.sku }))),
        React.createElement("div", { className: "product-detail__image-gallery" }, isBynderImagesEnabled ? (productImageGallery) : (React.createElement(ProductVisualSwitcher, { productImages: variant.images, alt: productImageAlt }))),
        React.createElement("section", { className: "product-detail__aside", "aria-label": variant.modelName + " " + variant.modelName },
            React.createElement(Sticky, { top: stickyTop || 0, bottomBoundary: ".product-detail", enabled: !isSmallScreen },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mobile-hidden" },
                        React.createElement(ProductDetailTitle$1, { title: variant.modelName + " " + brandModel, subtitle: variant.modelName, href: brandLink })),
                    !!variant.price && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classnames('product-detail__specification-prices', {
                                'product-detail__specification-prices--has-discount': !!variant.discountText,
                            }), role: "group", "aria-label": getLabel('products.screenreader.priceInformation') },
                            React.createElement("div", { className: "product-detail__price-container" },
                                React.createElement(ProductDetailPrice, { originalPrice: variant.price.originalPrice, discountedPrice: variant.price.discountedPrice, currency: currency })),
                            variant.discountText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" }))),
                        Slots.AfterPrice ? (React.createElement("div", { className: "product-detail__after-price-slot" },
                            React.createElement(Slots.AfterPrice, { price: variant.price.discountedPrice || variant.price.originalPrice, productType: variant.productType }))) : null)),
                    !isSmallScreen && React.createElement(ReviewSnippet, { productId: variant.sku }),
                    packageSelector,
                    React.createElement("div", { className: "product-detail-solutions__quantity-picker" },
                        React.createElement("div", { className: "product-detail-solutions__quantity-picker__label" }, labels.selectAmount),
                        React.createElement("div", { className: "product-detail-solutions__quantity-picker__wrapper" },
                            React.createElement(QuantitySelector, { quantity: selectedQuantity || 1, minimumQuantity: 1, maximumQuantity: maxOrderableQuantity, onDecreaseQuantity: onDecreaseQuantity, onIncreaseQuantity: onIncreaseQuantity, isDisabled: !isOrderable }),
                            React.createElement(StockIndicator, { stockCount: availableQuantity, stockResolver: stockResolver, allowBackOrder: isOrderable }))),
                    React.createElement("div", { className: "product-detail__cart-details" },
                        isDeliveryFullDateEnabled && (React.createElement("div", { className: "product-detail__cart-details__delivery-indicator" },
                            React.createElement(DeliveryIndicator, { view: "text", items: [{ sku: variant.sku, quantity: quantity }] }))),
                        React.createElement("div", { ref: addToCartRef }, ctaButton),
                        Slots.AfterCTA ? (React.createElement(Slots.AfterCTA, { price: calculatedTotalPrice !== null && calculatedTotalPrice !== void 0 ? calculatedTotalPrice : undefined, productType: variant.productType })) : null),
                    isSmallScreen && showStickyButton && variant.price && (React.createElement(StickyCallToAction, { button: ctaButton, price: React.createElement(Price, { value: (_b = variant.price.discountedPrice) !== null && _b !== void 0 ? _b : variant.price.originalPrice, currency: currency, centAmount: true }) })),
                    productTypeUsps && (React.createElement(React.Fragment, null,
                        React.createElement(Hr, { className: "product-detail__usp-divider" }),
                        React.createElement(ProductDetailUsps, { items: productTypeUsps })))))),
        React.createElement("div", { className: "product-detail-solutions__description" },
            React.createElement(Description, __assign$1({}, descriptionConfig, { variant: variant }))),
        disclaimer && (React.createElement("div", { className: "product-detail__disclaimer product-detail-lenses__disclaimer" },
            React.createElement(Panel, { title: disclaimer.title }, disclaimer.description)))));
};

var SolutionsContainer = function (_a) {
    var _b, _c;
    var activeSku = _a.activeSku, addToCartRef = _a.addToCartRef, stockResolver = _a.stockResolver, productTypeUsps = _a.productTypeUsps, stickyTop = _a.stickyTop, variant = _a.variant, product = _a.product, showStickyButton = _a.showStickyButton, specificationConfiguration = _a.specificationConfiguration, handleVariantPick = _a.handleVariantPick, renderAddToCartButton = _a.renderAddToCartButton, maxOrderableQuantity = _a.maxOrderableQuantity, onCTAClick = _a.onCTAClick, productImageGallery = _a.productImageGallery, disclaimer = _a.disclaimer;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var _d = useIntl(), currency = _d.currency, locale = _d.locale, getLabel = _d.getLabel;
    var availability = variant.availability;
    var variants = React.useMemo(function () { return __spreadArray$1([product.masterVariant], __read(product.variants)); }, [
        product.masterVariant,
        product.variants,
    ]);
    var productViewHistory = useProductViewHistory();
    React.useEffect(function () {
        productViewHistory.remove(variants.map(function (v) { return v.sku || ''; }));
        productViewHistory.add(variant.sku);
        // Adding productViewHistory to deps will cause an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variants, variant.sku]);
    var reviews = useReviewsContext();
    React.useEffect(function () {
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku,
            }));
        }
    }, [activeSku, reviews]);
    React.useEffect(function () {
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [activeSku]);
    var _e = __read(React.useState(1), 2), selectedQuantity = _e[0], setSelectedQuantity = _e[1];
    var availableQuantity = (_b = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && _b !== void 0 ? _b : 0;
    var maxOrderableQuantityCalculated = maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : 5;
    var isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    var onIncreaseQuantity = React.useCallback(function () { return (setSelectedQuantity(function (prevSelectedQuantity) { return prevSelectedQuantity + 1; }),
        triggerDataLayerEvent$1(EventAction.QuantityIncrease)); }, []);
    var onDecreaseQuantity = React.useCallback(function () { return (setSelectedQuantity(function (prevSelectedQuantity) { return prevSelectedQuantity - 1; }),
        triggerDataLayerEvent$1(EventAction.QuantityDecrease)); }, []);
    var brandLink = useBrandLink(variant.brand);
    var brandModel = variant.contactLensCareType + " " + variant.packageOption;
    var labels = {
        selectAmount: getLabel('products.solutions.selectAmount'),
        selectVolume: getLabel('products.solutions.selectVolume'),
    };
    var descriptionConfig = {
        specificationVariant: getActiveVariant$1(product, activeSku),
        specificationConfiguration: specificationConfiguration,
    };
    var calculatedTotalPrice = selectedQuantity > 1
        ? selectedQuantity * ((_c = variant.price.discountedPrice) !== null && _c !== void 0 ? _c : variant.price.originalPrice)
        : null;
    var ctaButton = (React.createElement(CTAButton, { isOrderable: isOrderable, renderAddToCartButton: renderAddToCartButton, activeSku: activeSku, calculatedPrice: calculatedTotalPrice, currency: currency, selectedQuantity: selectedQuantity, addToCartCallback: onCTAClick }));
    var packageSelector = React.useMemo(function () {
        var handleVariantPickAndEvent = function (event, sku, pickedSolutionsVolume) {
            handleVariantPick(event, sku);
            triggerDataLayerEvent$1(EventAction.SelectVolume, pickedSolutionsVolume);
        };
        return variants.length > 1 ? (React.createElement(PackageSelector, { variants: variants, label: labels.selectVolume, selectedPackage: activeSku, handleVariantPick: handleVariantPickAndEvent })) : null;
    }, [activeSku, labels.selectVolume, handleVariantPick, variants]);
    return (React.createElement(Solutions, { addToCartRef: addToCartRef, availableQuantity: availableQuantity, brandLink: brandLink, brandModel: brandModel, currency: currency, ctaButton: ctaButton, isSmallScreen: isSmallScreen, labels: labels, productTypeUsps: productTypeUsps, showStickyButton: showStickyButton, stickyTop: stickyTop, variant: variant, descriptionConfig: descriptionConfig, productImageAlt: getLocalizedValue(product.name, locale), stockResolver: stockResolver, packageSelector: packageSelector, selectedQuantity: selectedQuantity, onDecreaseQuantity: onDecreaseQuantity, onIncreaseQuantity: onIncreaseQuantity, isOrderable: isOrderable, maxOrderableQuantity: maxOrderableQuantityCalculated, productImageGallery: productImageGallery, disclaimer: disclaimer, quantity: selectedQuantity, calculatedTotalPrice: calculatedTotalPrice }));
};

var isEnabled = function (item) {
    if (typeof item.value === 'string') {
        return parseInt(item.value, 10) > 0;
    }
    return !!item.value;
};
var ProductDetailFeatures = function (_a) {
    var uvCategory = _a.uvCategory, polarised = _a.polarised, glazable = _a.glazable;
    return (React.createElement("ul", { className: "product-detail-features" },
        isEnabled(uvCategory) && (React.createElement("li", { className: "product-detail-features__feature product-detail-features__feature--uv" },
            React.createElement(FeatureIcon, { name: "uv", color: "orange", size: 38 }),
            uvCategory.label)),
        isEnabled(polarised) && (React.createElement("li", { className: "product-detail-features__feature product-detail-features__feature--polarised" },
            React.createElement(FeatureIcon, { name: "polarized", color: "orange", size: 38 }),
            polarised.label)),
        isEnabled(glazable) && (React.createElement("li", { className: "product-detail-features__feature product-detail-features__feature--glazable" },
            React.createElement(FeatureIcon, { name: "reading", color: "orange", size: 38 }),
            glazable.label))));
};

var PrescriptionAvailabilityIndicator = function (_a) {
    var className = _a.className;
    var getLabel = useIntl().getLabel;
    return (React.createElement(Label, { type: "neutral", className: classnames('prescription-availability-indicator', className) },
        React.createElement(Icon, { name: "store-eye-test", className: "prescription-availability-indicator__icon" }),
        React.createElement(Text, { variant: "body-head" }, getLabel('products.prescriptionAvailable'))));
};

var SunglassesRxableSelect = function (_a) {
    var className = _a.className, items = _a.items, selectedValue = _a.selectedValue, onChange = _a.onChange;
    return (React__default.createElement("fieldset", { className: classnames('sunglasses-rxable-select', className) }, items.map(function (_a) {
        var value = _a.value, label = _a.label, iconName = _a.iconName;
        return (React__default.createElement(SelectionBoxRadio, { key: value, name: "sunglasses-rxable-select", value: value, checked: selectedValue === value, onChange: function () { return onChange(value); }, "data-t": value },
            React__default.createElement(TileLayout, { title: label, iconName: iconName })));
    })));
};

var WITH_RX$1 = 'with-rx';
var WITHOUT_RX$1 = 'without-rx';

var SunglassesRxableSelectContainer = function (props) {
    var getLabel = useIntl().getLabel;
    var radioButtonItems = React__default.useMemo(function () { return [
        {
            value: WITHOUT_RX$1,
            label: getLabel('products.selectRxAble.withoutRx'),
            iconName: 'sunglasses',
        },
        {
            value: WITH_RX$1,
            label: getLabel('products.selectRxAble.withRx'),
            iconName: 'store-eye-test',
        },
    ]; }, [getLabel]);
    return React__default.createElement(SunglassesRxableSelect, __assign$1({ items: radioButtonItems }, props));
};

var RX_SUN_CONFIG_EVENT = 'RxSunConfigEvent';
var triggerDataLayerEvent = function (eventAction, options) {
    var isWithRx = options.isWithRx;
    DataLayer.pushEvent({
        event: RX_SUN_CONFIG_EVENT,
        eventAction: eventAction,
        eventLabel: isWithRx ? 'prescription lenses' : 'non-prescription lenses',
    });
};

var WITH_RX = 'with-rx';
var WITHOUT_RX = 'without-rx';
var isRxRadioSelection = function (value) {
    return value === WITH_RX || value === WITHOUT_RX;
};
var Sunglasses = function (_a) {
    var _b, _c, _d, _e;
    var activeSku = _a.activeSku, ean = _a.ean, addToCartRef = _a.addToCartRef, formatProductUrl = _a.formatProductUrl, handleVariantPick = _a.handleVariantPick, product = _a.product, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, stockResolver = _a.stockResolver, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration, deliveryResolver = _a.deliveryResolver, stickyTop = _a.stickyTop, onCTAClick = _a.onCTAClick, onPriceChange = _a.onPriceChange, opticianForm = _a.opticianForm, configuratorDocument = _a.configuratorDocument, secondaryCallToAction = _a.secondaryCallToAction, isBynderImagesEnabled = _a.isBynderImagesEnabled, handleConversionEvent = _a.handleConversionEvent, productImageGallery = _a.productImageGallery, disclaimer = _a.disclaimer;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var _f = useIntl(), getLabel = _f.getLabel, getFormattedLabel = _f.getFormattedLabel, currency = _f.currency, locale = _f.locale;
    var productViewHistory = useProductViewHistory();
    var reviews = useReviewsContext();
    var brandLink = useBrandLink(variant.brand);
    var _g = __read(React.useState(WITHOUT_RX), 2), selectWithRxLens = _g[0], setSelectWithRxLens = _g[1];
    var _h = __read(React.useState(false), 2), isConfiguratorOpen = _h[0], setIsConfiguratorOpen = _h[1];
    var _j = useFeatureToggles(), isCartV2Enabled = _j.isCartV2Enabled, isDeliveryFullDateEnabled = _j.isDeliveryFullDateEnabled;
    var Slots = useProductDetailSlots().Slots;
    var variants = __spreadArray$1([product.masterVariant], __read(product.variants));
    var allowBackOrder = variant.allowBackOrder, availability = variant.availability, channelAvailability = variant.channelAvailability, excludedFromCheckout = variant.excludedFromCheckout, price = variant.price, features = variant.features, isOfferedWithPrescriptions = variant.isOfferedWithPrescriptions;
    // Add SKU to viewed product history
    React.useEffect(function () {
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map(function (v) { return v.sku || ''; }));
        productViewHistory.add(variant.sku);
    }, [variants.length, variant.sku]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(function () {
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku,
            }));
        }
    }, [activeSku, reviews.enabled]);
    React.useEffect(function () {
        triggerDataLayerEvent('view step', { isWithRx: selectWithRxLens === WITH_RX });
        // Deps intentionally left empty. This effect should only run once.
    }, []);
    React.useEffect(function () {
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [activeSku]);
    var shouldShowRxRadios = isCartV2Enabled && isOfferedWithPrescriptions;
    var shouldOpenConfigurator = shouldShowRxRadios && selectWithRxLens === WITH_RX;
    var onRxRadioChange = React.useCallback(function (newSelection) {
        if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
            setSelectWithRxLens(newSelection);
            triggerDataLayerEvent('click on button', { isWithRx: newSelection === WITH_RX });
        }
    }, [selectWithRxLens]);
    /**
     * RxGlassesConfigurator utils
     */
    var openConfiguratorButtonRef = React.useRef(null);
    var handleConfiguratorClose = React.useCallback(function () {
        var _a;
        setIsConfiguratorOpen(false);
        (_a = openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : openConfiguratorButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [openConfiguratorButtonRef]);
    var handleConfiguratorOpen = React.useCallback(function () {
        handleConversionEvent();
        setIsConfiguratorOpen(true);
    }, []);
    var CTAButton = shouldOpenConfigurator ? (React.createElement(RxGlassesCTA, { action: channelAvailability === 'ONLINE' ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE', onClickWhenOrderable: handleConfiguratorOpen, buttonRef: openConfiguratorButtonRef, handleConversionEvent: handleConversionEvent })) : (React.createElement(NonRxProductCTA, { action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE', handleConversionEvent: handleConversionEvent, addToCartConfig: {
            activeSku: activeSku,
            variantUrl: formatProductUrl({
                productType: variant.productType,
                sku: activeSku || '',
                slug: product.slug,
            }),
            formatProductUrl: formatProductUrl,
            onCTAClick: onCTAClick,
        } }));
    var activeVariant = getActiveVariant$1(product, activeSku);
    return (React.createElement("div", { className: "product-detail__main product-detail__main--sunglasses" },
        React.createElement("div", { className: "desktop-hidden product-detail__header--mobile" },
            React.createElement(ProductDetailTitle$1, { title: variant.brand + " " + variant.modelName, subtitle: variant.brand, href: brandLink }),
            isSmallScreen && (React.createElement(ReviewSnippet, { productId: product.masterVariant.sku, variantId: activeSku }))),
        React.createElement("div", { className: "product-detail__image-gallery" },
            isCartV2Enabled && isOfferedWithPrescriptions && (React.createElement(PrescriptionAvailabilityIndicator, { className: "product-detail__prescription-availability-indicator" })),
            isBynderImagesEnabled ? (productImageGallery) : (React.createElement(ProductVisualSwitcher, { productImages: variant.images, alt: getProductAltTag(variant.name, variants.find(function (v) { return v.sku === activeSku; }) || variants[0], 'Sunglasses', locale), vtoEnabled: product.masterVariant.vtoEnabled, sku: activeSku, ean: ean }))),
        React.createElement("div", { className: "product-detail__description" },
            React.createElement(ProductDetailDescription, { title: getLabel('products.contactLenses.header.details'), header: variant.header, description: variant.description, usps: React.createElement(List, { icon: "checkmark", items: variant.usps }) }, (!!features.uvCategory || !!features.polarized || !!features.glazable) && (React.createElement(ProductDetailFeatures, { uvCategory: {
                    label: getLabel('products.sunglasses.features.uvCategory'),
                    value: features.uvCategory,
                }, polarised: {
                    label: getLabel('products.sunglasses.features.polarized'),
                    value: features.polarized,
                }, glazable: {
                    label: getLabel('products.sunglasses.features.glazeable'),
                    value: features.glazable,
                } })))),
        React.createElement("div", { className: "product-detail__specification" },
            React.createElement(ProductDetailSpecification, { configuration: specificationConfiguration, variant: activeVariant })),
        disclaimer && (React.createElement("div", { className: "product-detail__disclaimer" },
            React.createElement(Panel, { title: disclaimer.title }, disclaimer.description))),
        React.createElement("section", { className: "product-detail__aside", "aria-label": variant.brand + " " + variant.modelName },
            React.createElement(Sticky, { top: stickyTop || 0, bottomBoundary: '.product-detail', enabled: !isSmallScreen },
                React.createElement("div", { className: "mobile-hidden" },
                    React.createElement(ProductDetailTitle$1, { title: variant.brand + " " + variant.modelName, subtitle: variant.brand, href: brandLink })),
                React.createElement("div", { className: classnames('product-detail__specification-prices', {
                        'product-detail__specification-prices--has-discount': !!variant.discountText,
                    }), role: "group", "aria-label": getLabel('products.screenreader.priceInformation') },
                    price && (React.createElement("div", { className: "product-detail__price-container" },
                        React.createElement(ProductDetailPrice, { originalPrice: price.originalPrice, discountedPrice: price.discountedPrice, currency: currency }))),
                    variant.discountText && (React.createElement(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" }))),
                Slots.AfterPrice ? (React.createElement("div", { className: "product-detail__after-price-slot" },
                    React.createElement(Slots.AfterPrice, { price: (_b = price.discountedPrice) !== null && _b !== void 0 ? _b : price.originalPrice, productType: variant.productType }))) : null,
                !isSmallScreen && (React.createElement(ReviewSnippet, { productId: product.masterVariant.sku, variantId: activeSku })),
                React.createElement(VariantPicker, { title: getFormattedLabel('products.numberOfVariants', {
                        labelData: { number: variants.length },
                    }), variants: getVariants$1(variants, staticsUrl, variant, product, formatProductUrl, isBynderImagesEnabled), currentSku: variant.sku, currentLabel: getVariantPickerLabel(variant), onPick: handleVariantPick, stockIndicator: !excludedFromCheckout && (React.createElement(StockIndicator, { stockCount: (_c = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && _c !== void 0 ? _c : 0, allowBackOrder: allowBackOrder, stockResolver: stockResolver })) }),
                React.createElement("div", { className: "product-detail__cart-details" },
                    shouldShowRxRadios && (React.createElement(SunglassesRxableSelectContainer, { onChange: onRxRadioChange, selectedValue: selectWithRxLens })),
                    !excludedFromCheckout && isDeliveryFullDateEnabled && (React.createElement("div", { className: "product-detail__cart-details__delivery-indicator" },
                        React.createElement(DeliveryIndicator, { view: "text", items: [{ sku: activeSku, quantity: 1 }] }))),
                    React.createElement("div", { ref: addToCartRef },
                        CTAButton,
                        secondaryCallToAction && secondaryCallToAction(variant),
                        activeVariant.vtoEnabled && React.createElement(TryOnButton, null)),
                    Slots.AfterCTA ? (React.createElement(Slots.AfterCTA, { price: (_d = price.discountedPrice) !== null && _d !== void 0 ? _d : price.originalPrice, productType: variant.productType })) : null),
                isSmallScreen && showStickyButton && variant.price && (React.createElement(StickyCallToAction, { button: CTAButton, price: React.createElement(Price, { value: (_e = variant.price.discountedPrice) !== null && _e !== void 0 ? _e : variant.price.originalPrice, currency: currency, centAmount: true, type: variant.price.discountedPrice ? 'discount' : 'default' }) })),
                (!excludedFromCheckout || productTypeUsps) && (React.createElement(Hr, { className: "product-detail__usp-divider" })),
                !excludedFromCheckout && !isDeliveryFullDateEnabled && (React.createElement(DeliveryIndicator, { availability: [activeVariant.availability], deliveryResolver: deliveryResolver, view: "icon", className: "product-detail__delivery-indicator" })),
                productTypeUsps && React.createElement(ProductDetailUsps, { items: productTypeUsps }))),
        React.createElement(RxGlassesConfigurator, { id: "rxSun", frame: product, frameSku: activeSku, isOpen: isConfiguratorOpen, triggerButtonRef: openConfiguratorButtonRef, onModalClose: handleConfiguratorClose, onPriceChange: onPriceChange, formatProductUrl: formatProductUrl, opticianForm: opticianForm, configuratorDocument: configuratorDocument })));
};

var ProductDetail = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, children = _a.children, isContactLensStockEnabled = _a.isContactLensStockEnabled, isPrescriptionEnabled = _a.isPrescriptionEnabled, isPrescriptionFileEnabled = _a.isPrescriptionFileEnabled, isPrescriptionGlassesEnabled = _a.isPrescriptionGlassesEnabled, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, isPrescriptionExtraInfoEnabled = _a.isPrescriptionExtraInfoEnabled, allowBackOrder = _a.allowBackOrder, isSolutionsEnabled = _a.isSolutionsEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, deliveryResolver = _a.deliveryResolver, deliveryResolverFactory = _a.deliveryResolverFactory, prescriptionModalContent = _a.prescriptionModalContent, opticianForm = _a.opticianForm, dateFormat = _a.dateFormat, price = _a.price, productTypeUsps = _a.productTypeUsps, additionalUsps = _a.additionalUsps, configuratorDocument = _a.configuratorDocument, formatProductUrl = _a.formatProductUrl, stockResolver = _a.stockResolver, specificationConfiguration = _a.specificationConfiguration, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent, secondaryCallToAction = _a.secondaryCallToAction, packshotTypes = _a.packshotTypes, vtoBanner = _a.vtoBanner, disclaimer = _a.disclaimer;
    var _b = useProductDetailContext(), activeSku = _b.activeSku, activeVariant = _b.activeVariant, product = _b.product, productType = _b.productType, staticsUrl = _b.staticsUrl, dispatch = _b.dispatch, renderAddToCartButton = _b.renderAddToCartButton, isAddToCartNotificationShown = _b.isAddToCartNotificationShown, setIsAddToCartNotificationShown = _b.setIsAddToCartNotificationShown, routes = _b.routes;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var isPhone = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    var algoliaAnalytics = useAlgoliaAnalytics();
    var storedQueryId = (algoliaAnalytics.algoliaAnalyticsData || {}).queryId;
    var algoliaQueryId = React.useRef(storedQueryId);
    var containerRef = React.useRef(null);
    var _c = __read(useInView(), 2), ctaRef = _c[0], ctaInview = _c[1];
    var showStickyButton = isMobile && !ctaInview;
    var _d = useIntl(), getLabel = _d.getLabel, hasLabel = _d.hasLabel, locale = _d.locale, currency = _d.currency;
    var _e = __read(React.useState(0), 2), topOffset = _e[0], setTopOffset = _e[1];
    var _f = __read(React.useState(null), 2), calculatedAddToCartPrice = _f[0], setCalculatedAddToCartPrice = _f[1];
    var shouldShowAddToCartNotification = productType === 'Sunglasses' ||
        productType === 'Solutions' ||
        productType === 'Ready-readers' ||
        (productType === 'Frames' && isPrescriptionGlassesEnabled);
    var showNotificationOverlay = function () {
        if (shouldShowAddToCartNotification) {
            setIsAddToCartNotificationShown(true);
        }
    };
    var closeNotificationOverlay = function () {
        if (shouldShowAddToCartNotification) {
            setIsAddToCartNotificationShown(false);
        }
    };
    React.useEffect(function () {
        if (storedQueryId) {
            algoliaQueryId.current = storedQueryId;
        }
    }, [storedQueryId]);
    React.useEffect(function () {
        // make sure the queryId will not be used when a user doesn't click the CTA. For example: user clicks on a product suggestion and clicks the CTA there.
        algoliaQueryId.current && algoliaAnalytics.clearQueryId();
    }, [algoliaQueryId.current]);
    React.useEffect(function () {
        // set offset based on headerHeight
        setTopOffset(calculateHeaderHeight());
        window.addEventListener('cart.change', showNotificationOverlay);
        return function () {
            window.removeEventListener('cart.change', showNotificationOverlay);
        };
    }, []);
    React.useEffect(function () {
        var body = document.body;
        isAddToCartNotificationShown && !body.classList.contains('body--lock')
            ? body.classList.add('body--lock')
            : body.classList.remove('body--lock');
    }, [isAddToCartNotificationShown]);
    var ean = React.useMemo(function () {
        var ean = getAttrValue(product.masterVariant, 'supplierEAN');
        if (typeof ean === 'string') {
            return ean;
        }
        return undefined;
    }, [product]);
    var stickerText = React.useMemo(function () {
        if (CommerceToolsApi.isSunglasses(productType)) {
            return getLabel('sunglasses.sticker.text', { hideLabelKey: true });
        }
        if (CommerceToolsApi.isLenses(productType)) {
            var pricePerDay = getAttrValue(product.masterVariant, 'pricePerDay');
            var centAmount = isPlainObject(pricePerDay) ? pricePerDay.centAmount : 0;
            return pricePerDay && hasLabel('products.perDay') ? (React.createElement(React.Fragment, null,
                React.createElement(Price, { value: centAmount, className: "product-discount-label__price-per-day", currency: currency }),
                React.createElement("span", { className: "product-discount-label__price-per-day-unit" }, getLabel('products.perDay')))) : (getLabel('contactLenses.sticker.text', { hideLabelKey: true }));
        }
        return '';
    }, [productType, product]);
    var ImageGallery = React.useMemo(function () { return (React.createElement(ProductImageGalleryContainer, { activeVariant: activeVariant, product: product, packshotTypes: packshotTypes, vtoBanner: vtoBanner })); }, [activeVariant, packshotTypes, product, vtoBanner]);
    var handleVariantPick = React.useCallback(function (event, sku) {
        dispatch(updateActiveVariant({ sku: sku }));
        var newUrl = formatProductUrl({
            sku: sku,
            slug: product.slug,
            productType: productType,
        });
        // will pass the current queryString in the url of the variant picker
        var queryString = typeof window !== 'undefined' ? window.location.search : '';
        window.history.replaceState(null, product.masterVariant.brand || '', "" + newUrl + queryString);
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (event && !isModifiedClickEvent(event)) {
            event.preventDefault();
        }
    }, [product, productType, locale]);
    /**
     * This callback is used in the Prescription Glasses configurator
     * to supply the full bundle price (Frame, LensType, Package, and Add-ons)
     * to the AddToCartNotification
     */
    var handlePrescriptionGlassesPriceChange = React.useCallback(function (bundlePrice) {
        setCalculatedAddToCartPrice(bundlePrice);
    }, []);
    /**
     * This handler is called from the Lenses page whenever the
     * price changes from their prescription selection.
     * This price object is supplied to the AddToCartNotification
     */
    var handleLensPriceChange = React.useCallback(function (_a) {
        var calculatedPrice = _a.calculatedPrice, calculatedDiscountPrice = _a.calculatedDiscountPrice;
        var _b = calculatedAddToCartPrice
            ? calculatedAddToCartPrice
            : { originalPrice: 0, discountedPrice: undefined }, originalPrice = _b.originalPrice, discountedPrice = _b.discountedPrice;
        if (originalPrice !== calculatedPrice || discountedPrice !== calculatedDiscountPrice) {
            var calculatedAddToCartPrice_1 = {
                originalPrice: calculatedPrice,
                discountedPrice: calculatedDiscountPrice,
            };
            setCalculatedAddToCartPrice(calculatedAddToCartPrice_1);
        }
    }, []);
    /**
     * Sends a conversion event to Algolia
     */
    var handleConversionEvent = React.useCallback(function () {
        algoliaAnalytics.handleConversionEvent(activeSku, algoliaQueryId.current);
    }, [activeSku, algoliaAnalytics]);
    var handleCtaClick = React.useCallback(function () {
        handleConversionEvent();
        showNotificationOverlay();
    }, [handleConversionEvent, showNotificationOverlay]);
    /**
     * Calculates the right offset for the addToCart notification
     */
    var rightOffset = function () {
        var _a;
        if (!isPhone && typeof window !== 'undefined' && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth)) {
            return (window.innerWidth - containerRef.current.clientWidth) / 2;
        }
        return 0;
    };
    if (!productType || !activeVariant) {
        return null;
    }
    var commonProps = {
        activeSku: activeSku,
        ean: ean,
        addToCartRef: ctaRef,
        formatProductUrl: formatProductUrl,
        product: product,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        staticsUrl: staticsUrl,
        specificationConfiguration: specificationConfiguration,
        stickyTop: topOffset,
        onCTAClick: handleCtaClick,
        renderAddToCartButton: renderAddToCartButton,
        isBynderImagesEnabled: isBynderImagesEnabled,
        handleConversionEvent: handleConversionEvent,
        disclaimer: disclaimer,
    };
    var variantUrl = formatProductUrl({
        productType: activeVariant.productType,
        sku: activeVariant.sku,
        slug: product.slug,
    });
    var productUrl = variantUrl + "#product";
    var subscriptionProductSKU = getAttrValue(product.masterVariant, 'subscriptionProductSKU');
    return (React.createElement("div", { className: "product-detail" },
        React.createElement("div", { ref: containerRef, className: "site-container product-detail__container" }, (CommerceToolsApi.isLenses(activeVariant) && (React.createElement(LensBundleProvider, { subscriptionProductSKU: subscriptionProductSKU },
            React.createElement(LensesContainer, __assign$1({}, commonProps, { colorFeatureIcons: colorFeatureIcons, stickerText: stickerText, variant: activeVariant, isSolutionsEnabled: isSolutionsEnabled, isPrescriptionEnabled: isPrescriptionEnabled, onPriceChange: handleLensPriceChange, specificationConfiguration: specificationConfiguration, clsUsps: additionalUsps, productImageGallery: ImageGallery, 
                /**
                 * Stock configurations props
                 */
                isContactLensStockEnabled: isContactLensStockEnabled, maxOrderableQuantity: maxOrderableQuantity, deliveryResolverFactory: deliveryResolverFactory, allowBackOrder: allowBackOrder, 
                /**
                 * Prescription props
                 */
                isPrescriptionInfoEnabled: isPrescriptionInfoEnabled, prescriptionModalContent: prescriptionModalContent, opticianForm: opticianForm, dateFormat: dateFormat, isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled, prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent, hasSubscriptions: !!subscriptionProductSKU }))))) ||
            (CommerceToolsApi.isFrames(activeVariant) && (React.createElement(Frames, __assign$1({}, commonProps, { isPrescriptionGlassesEnabled: isPrescriptionGlassesEnabled, isPrescriptionFileEnabled: isPrescriptionFileEnabled, configuratorDocument: configuratorDocument, handleVariantPick: handleVariantPick, onPriceChange: handlePrescriptionGlassesPriceChange, variant: activeVariant, specificationConfiguration: specificationConfiguration, price: price, opticianForm: opticianForm, stockResolver: stockResolver, secondaryCallToAction: secondaryCallToAction, productImageGallery: ImageGallery }), children))) ||
            (CommerceToolsApi.isSunglasses(activeVariant) && (React.createElement(Sunglasses, __assign$1({}, commonProps, { handleVariantPick: handleVariantPick, onPriceChange: handlePrescriptionGlassesPriceChange, configuratorDocument: configuratorDocument, opticianForm: opticianForm, stockResolver: stockResolver, variant: activeVariant, specificationConfiguration: specificationConfiguration, deliveryResolver: deliveryResolver, secondaryCallToAction: secondaryCallToAction, productImageGallery: ImageGallery })))) ||
            (CommerceToolsApi.isSolutions(activeVariant) && (React.createElement(SolutionsContainer, __assign$1({}, commonProps, { variant: activeVariant, handleVariantPick: handleVariantPick, specificationConfiguration: specificationConfiguration, stockResolver: stockResolver, maxOrderableQuantity: maxOrderableQuantity, productImageGallery: ImageGallery })))) ||
            (CommerceToolsApi.isReadyReaders(activeVariant) && (React.createElement(ReadyReadersContainer, __assign$1({}, commonProps, { formatProductUrl: formatProductUrl, handleConversionEvent: handleConversionEvent, handleVariantPick: handleVariantPick, productImageGallery: ImageGallery, specificationConfiguration: specificationConfiguration, stockResolver: stockResolver, variant: activeVariant }))))),
        isAddToCartNotificationShown && (React.createElement("div", { className: "add-to-cart-notification-overlay", role: "button", onClick: closeNotificationOverlay, "data-t": "add-to-cart-notification-overlay" },
            React.createElement("div", { style: { top: calculateHeaderHeight(), right: rightOffset() }, className: "add-to-cart-notification-wrapper" },
                React.createElement(AddToCartNotification, { productName: activeVariant.brand, ean: activeVariant.modelName, imgUrl: activeVariant.images[0].url, price: calculatedAddToCartPrice || activeVariant.price, onClose: closeNotificationOverlay, cartRoute: routes.cart, stickerText: stickerText })))),
        React.createElement(WebPage, { url: productUrl, pageType: "ProductDetail", name: activeVariant.brand, description: activeVariant.description })));
};

function getProductSeoInfo(staticsUrl, locale, product, productTypeLabel, isBynderImagesEnabled) {
    var _a, _b, _c;
    if (!(product === null || product === void 0 ? void 0 : product.masterVariant)) {
        return {};
    }
    var title = '';
    if (product.metaTitle !== undefined) {
        title = getLocalizedValue(product.metaTitle, locale);
    }
    else {
        var productType = (_c = (_b = (_a = product.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
        title = ((productTypeLabel !== null && productTypeLabel !== void 0 ? productTypeLabel : '') + " " + getProductTitle(productType, product, product.masterVariant, locale)).trim();
    }
    var description = product.metaDescription !== undefined
        ? getLocalizedValue(product.metaDescription, locale)
        : getLocalizedAttrValue(product.masterVariant, 'description', locale);
    var imageUrl = getProductImageUrl(product, staticsUrl, isBynderImagesEnabled);
    return {
        title: title,
        description: description,
        imageUrl: imageUrl,
    };
}
function getProductImageUrl(product, staticsUrl, isBynderImagesEnabled) {
    var _a, _b, _c, _d, _e;
    if (isBynderImagesEnabled) {
        var imageUrl_1 = getFrontImage((_a = product.masterVariant.media) === null || _a === void 0 ? void 0 : _a.images).url;
        return imageUrl_1 + "?q=70&w=1200&h=630&fit=fill&fm=jpeg";
    }
    var imageUrl = (_e = (_d = (_c = (_b = product.masterVariant) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url) !== null && _e !== void 0 ? _e : '';
    return "" + staticsUrl + imageUrl + "?q=70&w=1200&h=630&fit=fill&fm=jpeg";
}

var LensPacksItem = /** @class */ (function (_super) {
    __extends$1(LensPacksItem, _super);
    function LensPacksItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function () {
            _this.props.onChange(_this.props.value);
        };
        return _this;
    }
    LensPacksItem.prototype.getDioptries = function (str) {
        return str
            .replace(/[a-zA-Z]/g, '')
            .replace(/\s+/g, '')
            .replace(/[{()}]/g, '');
    };
    LensPacksItem.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, intl = _a.intl, currentBreakpoint = _a.currentBreakpoint, price = _a.price, item = _a.item, useIncludedLensPack = _a.useIncludedLensPack;
        // TODO: type this properly without any but it's way to messy atm
        // Special instance where the enum key is needed
        var packAttribute = item.attributes.find(function (attribute) { return attribute.name === 'pack'; });
        var type = isPlainObject(packAttribute) ? packAttribute.value.key : '';
        var packName = isPlainObject(packAttribute) && getLocalizedValue(packAttribute.value, intl.locale);
        var thicknessValue = getLocalizedAttrValue(item, 'thickness', intl.locale);
        var thickness = thicknessValue.split('(')[0];
        var dioptries = this.getDioptries(thicknessValue);
        var voucher = getAttrValue(item, 'voucher');
        var voucherValue = isPlainObject(voucher) ? Number(voucher.centAmount) : 0;
        var isSelectedClass = isSelected ? '_is_selected' : '';
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return (React.createElement("label", { className: "lens-packs-accordion-item lens-packs-accordion-item--" + type + " " + isSelectedClass },
                React.createElement("div", { className: "lens-packs-accordion-item__header" },
                    React.createElement("input", { className: "lens-packs-accordion-item__radio", type: "radio", name: "ssp-lens-pack", value: type, "aria-checked": isSelected, onChange: this.handleChange }),
                    React.createElement(Heading, { variant: "smallest" }, packName)),
                React.createElement("div", { className: "lens-packs-accordion-item__body" },
                    React.createElement("ul", null, item.benefits.map(function (benefit) { return benefit.value && React.createElement("li", { key: benefit.name }, benefit.label); })),
                    React.createElement("div", { className: "lens-packs-accordion-item__price" }, item.isIncluded ? (intl.getLabel('products.included')) : (React.createElement(React.Fragment, null,
                        "+",
                        ' ',
                        React.createElement(Price, { value: price.value.centAmount, centAmount: true, currency: intl.currency })))),
                    !item.isIncluded && !!voucherValue && (React.createElement("p", { className: "lens-packs-accordion-item__voucher" },
                        intl.getLabel('products.ssp.voucher.label'),
                        React.createElement(Price, { value: voucherValue, centAmount: true, currency: intl.currency }))))));
        }
        else {
            var visualFieldValue = getLocalizedAttrValue(item, 'visualField', intl.locale);
            var higherTitle = visualFieldValue ? 'lens-packs-cell--title--with-visual-field' : '';
            return (React.createElement("label", { className: "lens-packs-column " + isSelectedClass },
                React.createElement("div", { className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--" + type },
                    React.createElement(Heading, { variant: "smallest" }, packName)),
                React.createElement("div", { className: "lens-packs-cell lens-packs-cell--title " + higherTitle },
                    React.createElement(Heading, { variant: "subheading1" }, thickness),
                    React.createElement("div", null,
                        React.createElement("small", { className: "lens-packs-cell__dioptry" },
                            "(",
                            dioptries,
                            " ",
                            intl.getLabel('products.unit.dioptries'),
                            ")")),
                    visualFieldValue && (React.createElement("small", { className: "lens-packs-cell__visual-field" }, visualFieldValue))),
                item.benefits.map(function (benefit) {
                    var checked = benefit.value ? 'check' : 'no-check';
                    return (React.createElement("div", { key: benefit.name, className: "lens-packs-cell lens-packs-cell--" + checked }));
                }),
                React.createElement("div", { className: "lens-packs-cell lens-packs-cell--footer" },
                    React.createElement("div", { className: "lens-packs-cell__price" }, useIncludedLensPack && item.isIncluded ? (intl.getLabel('products.included')) : (React.createElement("span", null,
                        useIncludedLensPack && '+ ',
                        ' ',
                        React.createElement(Price, { value: price.value.centAmount, centAmount: true, currency: intl.currency })))),
                    !item.isIncluded && !!voucherValue && (React.createElement("p", { className: "lens-packs-cell__voucher" },
                        React.createElement("small", null, intl.getLabel('products.ssp.voucher.label')),
                        React.createElement("br", null),
                        React.createElement(Price, { value: voucherValue, centAmount: true, currency: intl.currency }))),
                    React.createElement("input", { className: "lens-packs-cell__radio", type: "radio", name: "ssp-lens-pack", value: type, "aria-checked": isSelected, onChange: this.handleChange }))));
        }
    };
    return LensPacksItem;
}(React.Component));
var LensPacksItem$1 = withIntl(MediaQuery.WithBreakpoints(LensPacksItem));

var LensPacks = /** @class */ (function (_super) {
    __extends$1(LensPacks, _super);
    function LensPacks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPackChange = function (packType) {
            _this.props.onChange && _this.props.onChange(packType);
        };
        _this.renderItems = function () {
            var _a = _this.props, packs = _a.packs, selectedPack = _a.selectedPack, useIncludedLensPack = _a.useIncludedLensPack;
            return packs.map(function (pack) {
                if (!pack.packType) {
                    console.error('No packType found');
                    return;
                }
                var price = pack.prices && pack.prices.length && pack.prices[0];
                if (!price) {
                    console.error("No price found for pack with packType \"" + pack.packType + "\"");
                    return;
                }
                return (React.createElement(LensPacksItem$1, { key: pack.id, item: pack, value: pack.packType, price: price, isSelected: pack.packType === selectedPack, onChange: _this.onPackChange, useIncludedLensPack: useIncludedLensPack }));
            });
        };
        return _this;
    }
    LensPacks.prototype.render = function () {
        var _a = this.props, packs = _a.packs, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl;
        var hasBasicClass = packs.length === 6 ? 'lens-packs--has-basic' : '';
        var benefitLabels = (packs.length > 0 && packs[0].benefits.map(function (benefit) { return benefit.label; })) || [];
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT ||
            currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return (React.createElement("div", { className: "lens-packs-accordion" },
                this.renderItems(),
                intl.getLabel('products.disclaimer', { hideLabelKey: true }) !== '' && (React.createElement("div", { className: "lens-packs-accordion__disclaimer" }, intl.getLabel('products.disclaimer')))));
        }
        else {
            return (React.createElement("div", { className: "lens-packs " + hasBasicClass },
                React.createElement("label", { className: "lens-packs-column lens-packs-column--labels" },
                    React.createElement("div", { className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--empty" }),
                    React.createElement("div", { className: "lens-packs-cell lens-packs-cell--title lens-packs-cell--empty" }),
                    benefitLabels.map(function (label) {
                        return (React.createElement("div", { key: label, className: "lens-packs-cell lens-packs-cell--label" },
                            React.createElement("span", null, label)));
                    }),
                    React.createElement("div", { className: "lens-packs-cell lens-packs-cell--footer lens-packs-cell--empty" })),
                this.renderItems(),
                intl.getLabel('products.ssp.voucher.disclaimer', {
                    hideLabelKey: true,
                }) !== '' && (React.createElement("div", { className: "lens-packs__disclaimer" }, intl.getLabel('products.ssp.voucher.disclaimer')))));
        }
    };
    return LensPacks;
}(React.Component));
var LensPacks$1 = withIntl(MediaQuery.WithBreakpoints(LensPacks));

var createImpressionEvent$1 = function (product, position, location, currency) {
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: [
                    __assign$1(__assign$1({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined')), { list: location, position: position }),
                ],
            },
        },
    };
};
var createInteractionEvent = function (product, position, location, currency) {
    return {
        event: 'gvProductClick',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                click: {
                    actionField: { list: location },
                    products: [
                        __assign$1(__assign$1({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined')), { position: position }),
                    ],
                },
            },
        },
    };
};

var context = {
    trackImpression: function () { return undefined; },
    trackInteraction: function () { return undefined; },
};
var ProductPromotionEventContext = createContext(context);
var useProductPromotionEventContext = function () {
    return React.useContext(ProductPromotionEventContext);
};
var ProductPromotionEventProvider = function (_a) {
    var children = _a.children, location = _a.location;
    var currency = useIntl().currency;
    var handleImpression = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createImpressionEvent$1(product, position, location, currency));
    }, [currency, location]);
    var handleInteraction = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createInteractionEvent(product, position, location, currency));
    }, [currency, location]);
    return (React.createElement(ProductPromotionEventContext.Provider, { value: {
            trackImpression: handleImpression,
            trackInteraction: handleInteraction,
        } }, children));
};

var ProductBanner = function (_a) {
    var products = _a.products, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, className = _a.className, _b = _a.isLoading, isLoading = _b === void 0 ? true : _b, error = _a.error, dataT = _a["data-t"], reimbursableLogos = _a.reimbursableLogos, onProductInteraction = _a.onProductInteraction, onProductImpression = _a.onProductImpression;
    var isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    var isPhone = MediaQuery.useIsPhone();
    var itemsPerSlide = MediaQuery.useIsDesktop() ? 4 : 3;
    var classNames = classnames('product-banner', className);
    var getLabel = useIntl().getLabel;
    var productBlockProps = React.useMemo(function () { return ({
        staticsUrl: staticsUrl,
        formatProductUrl: formatProductUrl,
        showVariants: true,
        reimbursableLogos: reimbursableLogos,
    }); }, [staticsUrl, formatProductUrl, reimbursableLogos]);
    var renderProductBlock = React.useCallback(function (product, index) {
        return isLightProductModel(product) ? (React.createElement(AlgoliaProductBlock, __assign$1({ onClick: function () { return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index); }, onImpression: function () { return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index); }, key: product.id, product: product }, productBlockProps))) : (React.createElement(CommerceToolsProductBlock, __assign$1({ onClick: function () { return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index); }, onImpression: function () { return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index); }, key: product.id, product: product }, productBlockProps)));
    }, [onProductImpression, onProductInteraction, productBlockProps]);
    var carouselItems = React.useMemo(function () {
        if (!isBigScreen || !products) {
            return [];
        }
        var items = [];
        var max = Math.ceil(products.length / itemsPerSlide);
        for (var i = 0; i < max; i++) {
            var start = i * itemsPerSlide;
            var end = (i + 1) * itemsPerSlide;
            items.push(React.createElement("div", { key: "product-banner-slide-" + i, className: "product-banner__carousel-item" }, products.slice(start, end).map(function (product, index) { return renderProductBlock(product, index); })));
        }
        return items;
    }, [isBigScreen, products, itemsPerSlide, renderProductBlock]);
    if (error) {
        return (React.createElement("div", { className: classNames, "data-t": dataT || 'product-banner' },
            React.createElement(Alert, { type: "warning", message: getLabel('products.banner.errorMessage') })));
    }
    if (isLoading) {
        return (React.createElement("div", { className: classNames, "data-t": dataT || 'product-banner' },
            React.createElement(Loader, null)));
    }
    // Render a regular carousel on large screens and a slider carousel on smaller screens
    return (React.createElement("div", { className: classNames, "data-t": dataT || 'product-banner' }, isBigScreen ? (React.createElement(Carousel, { pagination: false, navigation: true }, carouselItems)) : (React.createElement(SliderCarousel, { itemWidth: isPhone ? 186 : 246 }, products.map(renderProductBlock)))));
};

var ProductBannerContainer = function (_a) {
    var skus = _a.skus, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, className = _a.className;
    var _b = useGetProductsBySku(skus), isLoading = _b.isLoading, products = _b.products, error = _b.error;
    var classNames = classnames('product-banner', className);
    var _c = useProductPromotionEventContext(), trackImpression = _c.trackImpression, trackInteraction = _c.trackInteraction;
    return (React.createElement(ProductBanner, { products: products, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, isLoading: isLoading, error: error, className: classNames, onProductImpression: trackImpression, onProductInteraction: trackInteraction }));
};

var ProductCatalogBreadcrumbs = function (_a) {
    var breadcrumbs = _a.breadcrumbs;
    return (React__default.createElement(Container, { className: "product-catalog-breadcrumbs" },
        React__default.createElement(Breadcrumbs, { pages: breadcrumbs })));
};

var Solution = function (_a) {
    var name = _a.name, solutionType = _a.solutionType, volume = _a.volume, image = _a.image, price = _a.price, minimumQuantity = _a.minimumQuantity, quantity = _a.quantity, onQuantityChange = _a.onQuantityChange;
    var isActive = quantity > 0 ? '_is_active' : '';
    return (React.createElement("div", { className: "solution " + (isActive || '') },
        React.createElement("img", { src: image.url, alt: name }),
        React.createElement(Heading, { variant: "small", className: "solution__brand" }, name),
        React.createElement("span", { className: "solution__type" },
            solutionType,
            ", ",
            volume),
        React.createElement(Price, { value: price, className: "solution__price" }),
        React.createElement(QuantitySelector, { quantity: quantity, minimumQuantity: minimumQuantity, onDecreaseQuantity: function () { return onQuantityChange(quantity, 'decrease'); }, onIncreaseQuantity: function () { return onQuantityChange(quantity, 'increase'); } })));
};

/**
 * Product detail discount bar
 */
var ProductDiscountBar = function (_a) {
    var title = _a.title;
    return (React.createElement("div", { className: "product-discount-bar" },
        React.createElement("span", { className: "product-discount-bar__title" }, title)));
};

var frameWidthImg = 'data:image/png;base64,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';
var bridgeWidthImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWYAAACWCAMAAADaHdKJAAAAflBMVEUAAAC/v7+9vb27u7u9vb29vb27u7u9vb28vLy/v7++vr63t7e7u7u8vLy9vb2/v7+9vb28vLy9vb28vLy/v7+7u7u+vr6/v7+/v78zMzMwMDAyMjK6uroyMjIzMzMyMjI0NDQzMzO9vb29vb0wMDAyMjIzMzMzMzO9vb0zMzORtZiXAAAAKHRSTlMAEN9A75+AYJAgvyAwv1Bv3s+vr19wzyF/gyDeYO+fZUC/cXAQ31C+KZyLNgAACShJREFUeNrs2EEKxCAQRNG+hopGIZOh7n/BQQay7tbs8t8R/qKwNbxabhbUsiHmTFUWpJoMEVeR4pmlchi8+pBWMk9flsO7F9Jq5omJ9khVO5lZDo9edLNpyKP/MxPa6fg8krkbHKF3RoN3nUtue5nTafDIYz3zYC8iy7F4nlyGiKVjm73g6wgAgB+7dZDcMAhDARQkIShgGOMMF+iG+5+wwZm2O5MhOM6Cd4I/H1nyNE3TNE3TNE3TeaTzQUejUgYoDwTZWsUxeCk+nfN7eAsAVO4AYM+uEZ24mHSoNRtlM5RjZJNhjR/Xd50NVgmoHKqV1/zopGgYmaxWC1A6ULYmBi8uJr1mlaF0gPxbuRhPuvrsFqiMkRNfU7YMUWUqQ1Cue2XENyp9iCa1cvWXHVGKd/HaWCpnoJxMzwlyrrGzBoLEp3fttMlUTkfZNk6Q8/Wcsar3jMrbZXXz4hQy1Bl+NwJrk2LWAf3fEscBQWDdlOGodUBEt8O7sD/etqzUjmZHj7WPCkoD1eDMe273zyM+5m5ZoLzK3vY0L7Wrnl1LDkM0y9oYaxO+xAASG0NMq2L95B+arMm3lUq3byFE6it4Y931H+mDWeh4W0f/6iY+Th6D63u7H+rtLUltGIgC6G29ZSyMmRB+8jVfvf8VhpAiNZXBlmxsqTkrUN3x9EM2Q0i8hiHA8EImhSO92vbtuEcFOWTqxPjyyaGHD8VL9SBeZAxbVdDorco0xkHTkof4PF8ngqfNqn7iRTwil0vDAZvSIb+oh8wKcNDeZXeO5DQ2Rf6Dy12gizN2hB30j6RLLhbc4B8G52zh0q/cATsgn7iQK4zZBI3daGt4jfYnj1ZxCQvPeUljX+RH3kUaCPvStihmxzlKo4Le8uZsnZMrzkmwnBEIdUS7ccgRlbh8zOdsk6znOnIZCYXuK8/zRnQ86xeq+uRtmAuq0jzrlInZobKr4g2celTmMzGr+Q5ZHZ35ZYlQXVgfs4powHEBYQ8HQGp1zD/QRMcvOaEJvTZmhTauhl8R0UY3G7O4hzk/b8jq2g+XuZiNvMcC+MmrnQiNkJmJmSclNNPzahrNdDMxy9j/Nps2AtrxPMWAJ/VYSEDZOBHaIZ6ETtqc8dflzfrf3Thdf3vDz32gJTJvNczNb4ImAtEacaX5xvIkkV17ujib1OPOK1kte/rIgm5tn7g+C9nRbGcnNEVvNs3dmdxLES+rA94oXg6Njdl/Ly+rzK366GxEY+f84BMkDRqZC1yRw9FNyN/IkhKzTt25N7lonj7zKeIJJ2jQn4o5ueP98+MhiYzZFxyH+CuPyvIxG9fjnxiUvJiPJbtSJ2k2+l6b03/HjlZcbdYlb3GCqJhtvmt/SpuOriV/9IuY+7k/bMEHI1pyzKGksjT/sXJX0pG9hJetEzEf8VyUG7PFhCAqZhSVXSNob4Uq+mCElKRlG0WXQp3UE/+m5tpyHARi2LwHRggJJMT9b7qf3UqrrT182OUEaerEjhNo/0hVI7srBGjyX4zSHFG3vjh1OkhdXkZpzujYsbyxjvgpSAVuRmne0exlH1s/hIQEHY3S3F6hlA8IMvK7CjR4JJ80n7BV0YymbQynp0+aD7jjZiPhjE2kzSfNxLos+Sg6rAR3m4A3wt5sPoYXxsarjQTtROpuG6kRwaiLS5ors2IfLsb+DXaDw8UIPZht2eXCgRsYSDXpcit1FhddijCD1vdlsgvsnFVfTcLO4KCUTeKt3Asw2aQ5d1DrR5MDgkTemJXXYK58GkptxQIWNDqbB6cs6HQ3LNLc/iDAb6jCE73mWyzO/saLANkfOILwGaiH1R0Ob1f+DdBs4RIktKY2h3Bn/uvhsEHBGaIYCP1zgiAuA1L5hdFvQEXhCPB9Eiy6Msz4zL/oza4+Bcyml3QXvsXp+uI7pxIW9YETEI1yZbROXh4OedcYBD6Semztk9/zyPJ2V4jUVbXUSLPKfYjr8GbKsIulRp7+OE3WkSBfTlFce3V+DB06EuS1ziG9LVkffGmpa0nwpDZli9TVqE++gZekNl2i8JmVrsb6yNC8lHC+yTos3J7KB8whFiGcd9IiqMx9pROYQ2hCOFdyqto5Z98HzCFEYXc+SO6OhWjOVmBWio2bthUHNaB4aGa5dv6p7tqS5IRhIH4/ADswWwPfOz+6/wlTm5qKMpsNGXtkme0LoG7kRhZlKxV3YlKROffvZpxiK2iKYxe6hzmjsRqKbuR14MVS/ivCdzBnfKq+R/qtvoJbRfdW9WhrJKJmSupiG67G7zR/SzFIqnsEfI8LQ2NNhWP5XWPBkpnK49eBDVvVZ0Ww+9uOVQZd43cfuGDqjCoyV/kZKF/sO/e99ZusOy3gSlgT5t9Cm1x6GliwV75WoTnTOWjiSSviinfBMWCTtRcbW76dIBYZOtAR59TZVO+rhGarPoNscHxr02w6o+WF+tatbG0bQTYZ5zax6SzkKytf8vS6JlqVEQ6YdDa/n3Pe6jNpVJkY7mCu3Ykqfs9QfWY4UJnuFd4GRCsGptpzWussPNyhUWVSf26+It9et6bQOMqwQONtBA7TjG0MOlMcck/QUues289/RJ1/tFiSO80VEzc4yAayaaJry5rRtxtlvUU8jkh1EFLSZoPTXCcm36FRQidCCqgzrHQJPUXGofRoHGBIKVAmyo1+ELvwUGAYtM/bA/2Ie0u0TUP48DrpHRebTgMLnCRyDqRAziFEQEgfCCIs+CjRJ7TMhBRgofOhmwZAmHo3VSsgZjUwYlto3E8dXJNOZEVYdYiqLIiA0OyDj50ERKyjkK9H0yvohTZTaYDx83w3TqDQiPWtUCSFbtFmOaLQCGmfVVokf4X+Iv8tNET7tFLTHqFAZEKhQa5ZHQs2pmwkPGLG9doBboZHRP8/EmLKRsMjLmpoh4DZgFpHY7NTahzHu7TjqJLL3kSp4TM0xtcLk/kirLgam5OaPkggDeesWZEy42pUBuoxZzGcAMLNUI5jtzhNkLPtPmIAEdx8/kQR7qKhBPpyjjx+VPoiz09C5Vk/G113P/4Xpvyk1Hq2/UhMyR9qLU1OJ3KKryGUvSyHCnvXfRLaR5gp+8u8SHkPS8rZGOvU6QX+E6Ny9hcLfc+QDxY+u4nCJ34Cu51gcoMpErQAAAAASUVORK5CYII=';
var templeLengthImg = 'data:image/png;base64,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';
var lensWidthImg = 'data:image/png;base64,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';
var lensHeightImg = 'data:image/png;base64,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';
var ProductFrameMeasurements = function (_a) {
    var product = _a.product, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl;
    var activeSku = useProductDetailContext().activeSku;
    var variant = getActiveVariant$1(product, activeSku);
    var title = intl.getLabel('products.measurements.frame.title');
    var frameWidth = {
        measurement: Number(getAttrValue(variant, 'frameWidth')),
        label: intl.getLabel('products.measurements.frame.width'),
        key: 'measurements.frame.width',
        image: frameWidthImg,
    };
    var bridgeWidth = {
        measurement: Number(getAttrValue(variant, 'bridgeWidth')),
        label: intl.getLabel('products.measurements.bridge.width'),
        key: 'measurements.bridge.width',
        image: bridgeWidthImg,
    };
    var templeLength = {
        measurement: Number(getAttrValue(variant, 'templeLength')),
        label: intl.getLabel('products.measurements.templeArm.length'),
        key: 'measurements.templeArm.length',
        image: templeLengthImg,
    };
    var lensWidth = {
        measurement: Number(getAttrValue(variant, 'lensWidth')),
        label: intl.getLabel('products.measurements.lens.width'),
        key: 'measurements.lens.width',
        image: lensWidthImg,
    };
    var lensHeight = {
        measurement: Number(getAttrValue(variant, 'lensHeight')),
        label: intl.getLabel('products.measurements.lens.height'),
        key: 'measurements.lens.height',
        image: lensHeightImg,
    };
    var frameMeasurements = [frameWidth, bridgeWidth, templeLength, lensWidth, lensHeight].filter(function (item) { return item.measurement > 0; });
    var isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE ||
        currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
    var FrameMeasurementsBlock = function (_a) {
        var label = _a.label, measurement = _a.measurement, image = _a.image;
        return (React.createElement("section", { className: "product-detail-frame-measurements__item" },
            React.createElement("span", { className: "product-detail-frame-measurements__label" }, label),
            React.createElement("img", { "aria-hidden": "true", src: image, alt: label }),
            React.createElement("span", { className: "product-detail-frame-measurements__details" },
                measurement,
                " ",
                intl.getLabel('products.measurements.metric'))));
    };
    return (React.createElement("section", { className: "product-detail-frame-measurements", "aria-label": title },
        React.createElement("div", { className: "site-container product-detail-frame-measurements__container" },
            React.createElement(Heading, { variant: "medium", className: "product-detail-frame-measurements__title" }, title),
            React.createElement("section", { className: "product-detail-frame-measurements__items" },
                isMobile && (React.createElement(Carousel, { pagination: true }, frameMeasurements.map(function (item) { return (React.createElement(FrameMeasurementsBlock, __assign$1({}, item, { key: item.key }))); }))),
                !isMobile &&
                    frameMeasurements.map(function (item) { return React.createElement(FrameMeasurementsBlock, __assign$1({}, item, { key: item.key })); })))));
};
var ProductFrameMeasurements$1 = withIntl(MediaQuery.WithBreakpoints(ProductFrameMeasurements));

var ClickableImageWrapper = function (_a) {
    var onClick = _a.onClick, url = _a.url, labelId = _a.labelId, hideFromKeyboardUser = _a.hideFromKeyboardUser, children = _a.children;
    var sharedProps = {
        className: 'promotion-block__link',
        'data-t': 'promotion-block-image',
        'aria-labelledby': labelId,
        onClick: onClick,
    };
    if (hideFromKeyboardUser) {
        /**
         * Accessibility note:
         * If there is a CTA button shown in the PromotionBlock, then this wrapper makes the promotion image clickable
         * for a mouse user but NOT for keyboard or screen reader users. This is because the CTA <Button> natively
         * provides the same functionality and having both the image and button in the tab order is redundant for a non-mouse user
         *
         * If there is no CTA button, then the clickable image is not hidden from non-mouse users.
         *
         * In general DO NOT put an onClick on a div, unless it's a situation like this.
         *
         */
        var sharedHiddenProps = __assign$1(__assign$1({}, sharedProps), { 'aria-hidden': true });
        return url ? (React.createElement("a", __assign$1({ href: url, tabIndex: -1 }, sharedHiddenProps), children)) : (
        // Generally, don't put onClick on a div. See above for an explanation for this exception
        React.createElement("div", __assign$1({}, sharedHiddenProps), children));
    }
    else {
        return url ? (React.createElement("a", __assign$1({ href: url }, sharedProps), children)) : (React.createElement("button", __assign$1({}, sharedProps), children));
    }
};
var PromotionBlock = React.forwardRef(function (_a, ref) {
    var id = _a.id, title = _a.title, description = _a.description, image = _a.image, links = _a.links, size = _a.size, onClick = _a.onClick, ctaLabel = _a.ctaLabel, manageContentButton = _a.manageContentButton;
    var imageUrl = MediaQuery.useIsPhone() ? image === null || image === void 0 ? void 0 : image.mobileUrl : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl) {
        return null;
    }
    var buttonStyles = (links === null || links === void 0 ? void 0 : links.style) ? Util$1.createButtonStyles(links.style) : {};
    var classNames = classnames('promotion-block', {
        'promotion-block--overlay': !!title || !!description,
        'promotion-block--large': size === 'large',
    });
    var promotionInfoId = "promotion-info-" + id;
    var url = (links || {}).url;
    var showCta = Boolean(!!ctaLabel && (url || onClick));
    return (React.createElement("div", { "data-t": "promotion-block", ref: ref, className: classNames },
        manageContentButton,
        React.createElement(ClickableImageWrapper, { onClick: onClick, url: url, hideFromKeyboardUser: showCta, labelId: promotionInfoId },
            React.createElement(Image, { url: imageUrl, cover: true, className: "promotion-block__image" })),
        React.createElement("div", { className: "promotion-block__inner" },
            (title || description) && (React.createElement("div", { className: "promotion-block__text", id: promotionInfoId },
                title && (React.createElement(Heading, { component: "h2", variant: "medium", className: "promotion-block__title" }, title)),
                description && (React.createElement(Text, { variant: "body", className: "promotion-block__subtitle" }, description)))),
            showCta && (React.createElement(Button, __assign$1({}, buttonStyles, { className: "promotion-block__button", "data-t": "promotion-block-button", size: "custom", "aria-describedby": promotionInfoId, onClick: onClick, href: url, caption: ctaLabel }))))));
});

var createImpressionEvent = function (currency) {
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: [],
            },
        },
    };
};
var createImpressionObject = function (product, position) {
    var _a;
    return (__assign$1(__assign$1({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined')), { list: "category: " + ((_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name), position: position }));
};

var usePlpDatalayerEvents = function () {
    var currency = useIntl().currency;
    var impressionEvent = createImpressionEvent(currency);
    var impressions = impressionEvent.atfEcommerce.ecommerce.impressions;
    var addImpressionEvent = React.useCallback(function (product, position) {
        impressions.push(createImpressionObject(product, position));
    }, []);
    var pushImpressionsToDatalayer = function () { return DataLayer.pushEvent(impressionEvent); };
    var pushProductClickToDatalayer = React.useCallback(function (product, position) {
        var _a;
        DataLayer.pushEvent(createInteractionEvent(product, position, "category: " + ((_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name), currency));
    }, []);
    return {
        addImpressionEvent: addImpressionEvent,
        pushImpressionsToDatalayer: pushImpressionsToDatalayer,
        pushProductClickToDatalayer: pushProductClickToDatalayer,
    };
};

var ProductListingGrid = function (_a) {
    var hasBigPromo = _a.hasBigPromo, hasSmallPromo = _a.hasSmallPromo, children = _a.children;
    var breakpoint = MediaQuery.useBreakpoint();
    var classNames = classnames('product-listing-grid', {
        'product-listing-grid--with-promos': hasBigPromo && hasSmallPromo,
        'product-listing-grid--with-big-promo': hasBigPromo && !hasSmallPromo,
        'product-listing-grid--single-promo': breakpoint === MediaQuery.BreakpointName.PHONE &&
            ((hasBigPromo && !hasSmallPromo) || (!hasBigPromo && hasSmallPromo)),
        'product-listing-grid--col-2': breakpoint === MediaQuery.BreakpointName.PHONE,
        'product-listing-grid--col-3': breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT ||
            breakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE,
        'product-listing-grid--col-4': breakpoint === MediaQuery.BreakpointName.DESKTOP,
    });
    return React.createElement("div", { className: classNames }, children);
};

var ProductListingGridCell = function (_a) {
    var children = _a.children, _b = _a.isWide, isWide = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: classnames('product-listing-grid-cell', {
            'product-listing-grid-cell--wide': isWide,
        }) }, children));
};

function usePromoIndices(productCount, hasPromotionSmall) {
    var currentBreakpoint = MediaQuery.useBreakpoint();
    switch (currentBreakpoint) {
        case MediaQuery.BreakpointName.PHONE:
        case MediaQuery.BreakpointName.TABLET_PORTRAIT:
        case MediaQuery.BreakpointName.TABLET_LANDSCAPE:
            return {
                smallPromoIndex: 4,
                bigPromoIndex: hasPromotionSmall ? 13 : 4,
            };
        case MediaQuery.BreakpointName.DESKTOP:
            return {
                smallPromoIndex: 5,
                bigPromoIndex: hasPromotionSmall ? (productCount > 16 ? 17 : 13) : 5,
            };
        default:
            return {
                smallPromoIndex: -1,
                bigPromoIndex: -1,
            };
    }
}

var ProductListingPage = function (_a) {
    var products = _a.products, pageSize = _a.pageSize, pageNumber = _a.pageNumber, promotionSmall = _a.promotionSmall, promotionBig = _a.promotionBig, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, reimbursableLogos = _a.reimbursableLogos, forwardedQueryParams = _a.forwardedQueryParams;
    var getLabel = useIntl().getLabel;
    var _b = usePlpDatalayerEvents(), addImpressionEvent = _b.addImpressionEvent, pushImpressionsToDatalayer = _b.pushImpressionsToDatalayer, pushProductClickToDatalayer = _b.pushProductClickToDatalayer;
    var _c = usePromoIndices(products.length, !!promotionSmall), smallPromoIndex = _c.smallPromoIndex, bigPromoIndex = _c.bigPromoIndex;
    var isSmallScreen = MediaQuery.useIsPhone();
    var onProductBlockClick = React.useCallback(function (product, index, handleSearchAnalytics) {
        handleSearchAnalytics(product.objectID, index);
        pushProductClickToDatalayer(product, index);
    }, []);
    var dividerLabel = getLabel('common.page') + " " + pageNumber;
    var showPromos = products.length >= pageSize;
    React.useEffect(function () {
        pushImpressionsToDatalayer();
    }, []);
    var augmentedProductList = React.useMemo(function () {
        return products.reduce(function (result, product, index) {
            var _a, _b, _c, _d;
            if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
                var smallPromoIdentifier = 'promo-small';
                result.push(React.createElement(ProductListingGridCell, { key: smallPromoIdentifier, isWide: isSmallScreen },
                    React.createElement(PromotionBlock, __assign$1({}, promotionSmall, { id: smallPromoIdentifier, size: isSmallScreen ? 'large' : 'small', ctaLabel: (_b = (_a = promotionSmall.links) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '' }))));
            }
            if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
                var bigPromoIdentifier = 'promo-big';
                result.push(React.createElement(ProductListingGridCell, { key: bigPromoIdentifier, isWide: true },
                    React.createElement(PromotionBlock, __assign$1({}, promotionBig, { id: bigPromoIdentifier, size: "large", ctaLabel: (_d = (_c = promotionBig.links) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : '' }))));
                result.push(null);
            }
            result.push(React.createElement(ProductListingGridCell, { key: product.masterVariant.sku },
                React.createElement(AlgoliaAnalytics, null, function (handleSearchAnalytics) { return (React.createElement(AlgoliaProductBlock, { className: "product-listing-product-block", product: product, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, onClick: function () { return onProductBlockClick(product, index, handleSearchAnalytics); }, reimbursableLogos: reimbursableLogos, additionalUrlParams: forwardedQueryParams, onImpression: function () { return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product, index); } })); })));
            return result;
        }, []);
    }, [
        products,
        showPromos,
        promotionSmall,
        smallPromoIndex,
        promotionBig,
        bigPromoIndex,
        isSmallScreen,
        staticsUrl,
        formatProductUrl,
        reimbursableLogos,
        forwardedQueryParams,
        addImpressionEvent,
        onProductBlockClick,
    ]);
    return (React.createElement("div", { "data-t": "product-listing-page-" + pageNumber, className: classnames('product-listing-page', {
            'product-listing-page--with-divider': pageNumber !== 1,
        }) },
        pageNumber !== 1 && React.createElement("div", { className: "product-listing-page__divider" }, dividerLabel),
        React.createElement(ProductListingGrid, { hasSmallPromo: showPromos && !!promotionSmall, hasBigPromo: showPromos && !!promotionBig }, augmentedProductList)));
};

var ProductListingSkeleton = function (_a) {
    var pageSize = _a.pageSize;
    var skeletonGrid = React.useMemo(function () {
        return Array.from({ length: pageSize }).map(function (_, i) { return (React.createElement(ProductListingGridCell, { key: "skeleton-cell-" + i },
            React.createElement(SkeletonLoader, { className: "product-listing-skeleton-loader" }))); });
    }, [pageSize]);
    return (React.createElement("div", { className: "product-listing-skeleton" },
        React.createElement(ProductListingGrid, null, skeletonGrid)));
};

var ProductListing = function (_a) {
    var products = _a.products, showMoreButton = _a.showMoreButton, promotionBig = _a.promotionBig, promotionSmall = _a.promotionSmall, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, reimbursableLogos = _a.reimbursableLogos, forwardedQueryParams = _a.forwardedQueryParams;
    return (React.createElement("div", { className: "product-listing" },
        React.createElement(Container, { className: "product-listing__container" },
            products.pages.map(function (page, i) {
                var pageNr = i + 1;
                return page === null ? (React.createElement(ProductListingSkeleton, { key: "product-listing-skeleton-" + pageNr, pageSize: products.size })) : (React.createElement(ProductListingPage, { key: "product-listing-page-" + pageNr, products: page, pageSize: products.size, pageNumber: pageNr, promotionBig: promotionBig, promotionSmall: promotionSmall, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, reimbursableLogos: reimbursableLogos, forwardedQueryParams: forwardedQueryParams }));
            }),
            showMoreButton && React.createElement("div", { className: "product-listing__show-more" }, showMoreButton))));
};

var ProductOffer = function (_a) {
    var title = _a.title, description = _a.description, imageUrl = _a.imageUrl, fallbackImageUrl = _a.fallbackImageUrl, url = _a.url, className = _a.className, rest = __rest(_a, ["title", "description", "imageUrl", "fallbackImageUrl", "url", "className"]);
    return (React__default.createElement("div", __assign$1({}, rest, { className: classnames('product-offer', className) }),
        url ? (React__default.createElement("a", { href: url, "data-t": "ImageAnchor" },
            React__default.createElement("span", { className: classnames('product-offer__image', {
                    'product-offer__image--fallback': !imageUrl,
                }), "data-t": "ImageContainer" },
                React__default.createElement("img", { src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackImageUrl, "data-t": "Image" })))) : (React__default.createElement("div", { className: classnames('product-offer__image', {
                'product-offer__image--fallback': !imageUrl,
            }), "data-t": "ImageContainer" },
            React__default.createElement("img", { src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackImageUrl, "data-t": "Image" }))),
        React__default.createElement("h4", { className: "product-offer__title" }, url ? (React__default.createElement("a", { href: url, "data-t": "TitleAnchor" }, title)) : (title)),
        description && React__default.createElement("p", null, description)));
};

var ProductOffers = function (_a) {
    var className = _a.className, labels = _a.labels, offers = _a.offers, fallbackImage = _a.fallbackImage, rest = __rest(_a, ["className", "labels", "offers", "fallbackImage"]);
    return (React.createElement("div", __assign$1({}, rest, { className: classnames('product-offers', className) }),
        React.createElement(Heading, { variant: "smallest", component: "h3" }, labels.title),
        React.createElement("div", { className: "product-offers__items" }, offers.map(function (_a) {
            var title = _a.title, description = _a.description, url = _a.url, imageUrl = _a.imageUrl;
            return (React.createElement(ProductOffer, { key: title, className: "product-offers__offer", title: title, description: description, url: url, imageUrl: imageUrl, fallbackImageUrl: fallbackImage }));
        }))));
};

var ProductOffersContainer = function (_a) {
    var labelsProp = _a.labels, props = __rest(_a, ["labels"]);
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () {
        return labelsProp !== null && labelsProp !== void 0 ? labelsProp : {
            title: getLabel('products.offers.title'),
        };
    }, [getLabel, labelsProp]);
    return React.createElement(ProductOffers, __assign$1({}, props, { labels: labels }));
};

var ProductPlaceholder = function () { return (React.createElement("div", { className: "product-placeholder" },
    React.createElement("svg", { width: "282", height: "244", viewBox: "0 0 282 244", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "282", height: "149", rx: "5", fill: "currentColor" }),
        React.createElement("rect", { x: "26", y: "169", width: "230", height: "15", rx: "5", fill: "currentColor" }),
        React.createElement("rect", { x: "26", y: "194", width: "230", height: "15", rx: "5", fill: "currentColor" }),
        React.createElement("rect", { x: "71", y: "229", width: "140", height: "15", rx: "5", fill: "currentColor" })))); };

var ProductPromotions = function (_a) {
    var products = _a.products, supertitle = _a.supertitle, title = _a.title, formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, renderLocation = _a.renderLocation, dataT = _a["data-t"], isLoading = _a.isLoading;
    var currency = useIntl().currency;
    var handleImpression = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createImpressionEvent$1(product, position, "promotion recommendation " + renderLocation, currency));
    }, [currency, renderLocation]);
    var handleInteraction = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createInteractionEvent(product, position, "promotion recommendation " + renderLocation, currency));
    }, [currency, renderLocation]);
    if (products.length === 0 && !isLoading) {
        return null;
    }
    return (React.createElement("div", { className: "product-promotions", "data-t": dataT || 'product-promotions' },
        React.createElement(Container, null,
            React.createElement(Heading, { variant: "small", component: "span", color: "text-secondary", className: "product-promotions__supertitle" }, supertitle),
            React.createElement(Heading, { variant: "medium", component: "h2" }, title),
            React.createElement(ProductBanner, { products: products, isLoading: isLoading, formatProductUrl: formatProductUrl, staticsUrl: staticsUrl, onProductImpression: handleImpression, onProductInteraction: handleInteraction }))));
};

// PRODUCT
function getFrameData(product) {
    var gender = getLocalizedAttrValues(product.masterVariant, 'gender', 'en');
    // Check if it's a kids glasses
    var isKidsGlasses = gender.some(function (a) { return a.toLowerCase() === 'kids'; });
    var framePrice = (product.masterVariant.prices && product.masterVariant.prices[0].value.centAmount) || 0;
    var brand = getLocalizedAttrValue(product.masterVariant, 'brand', 'en');
    return {
        brand: brand,
        framePrice: framePrice,
        gender: gender,
        isKidsGlasses: isKidsGlasses,
    };
}
// LENS PACKS
function getLensPacks(product, isKids) {
    var attributes = product.masterVariant.attributes;
    var lensDetails = attributes && attributes.find(function (attr) { return attr.name === 'lensDetails'; });
    if (!lensDetails) {
        return {
            monofocalLensPacks: [],
            multifocalLensPacks: [],
        };
    }
    function movePackNameUp(lensPack) {
        var packType = (lensPack.attributes || []).find(function (attr) { return attr.name === 'pack'; }).value.key;
        return __assign$1(__assign$1({}, lensPack), { packType: packType || '' });
    }
    var lensPacksData = lensDetails.value.obj.masterData.current;
    var includedLensPack = movePackNameUp(__assign$1(__assign$1({}, lensPacksData.masterVariant), { isIncluded: true }));
    var lensPacks = lensPacksData.variants.map(function (pack) {
        return movePackNameUp(__assign$1(__assign$1({}, pack), { isIncluded: false }));
    });
    var monofocalLensPacks = lensPacks.filter(function (pack) {
        var lens = pack.attributes.find(function (attr) { return attr.name === 'lens'; });
        return lens.value.key === 'singleVision';
    });
    monofocalLensPacks.unshift(includedLensPack);
    var multifocalLensPacks = [];
    if (!isKids) {
        multifocalLensPacks = lensPacks.filter(function (pack) {
            var lens = pack.attributes.find(function (attr) { return attr.name === 'lens'; });
            return lens.value.key === 'multifocal';
        });
    }
    return {
        includedLensPack: includedLensPack,
        monofocalLensPacks: monofocalLensPacks,
        multifocalLensPacks: multifocalLensPacks,
    };
}
// CALCULATIONS
function calcGlassesPrice(opticalData, glassesType) {
    if (glassesType === 'frameAndMonofocal') {
        return opticalData.frameAndMonofocalPrice;
    }
    if (glassesType === 'frameAndMultifocal') {
        return opticalData.frameAndMultifocalPrice;
    }
    return opticalData.framePrice;
}
/**
 * Calculates the +/- price for a selected glasses type compared to the initial type.
 */
function calcGlassesPriceDifference(opticalData, glassesType, initialGlassesType) {
    if (initialGlassesType === void 0) { initialGlassesType = 'frameAndMonofocal'; }
    var priceMapping = {
        frameOnly: opticalData.framePrice,
        frameAndMonofocal: opticalData.frameAndMonofocalPrice,
        frameAndMultifocal: opticalData.frameAndMultifocalPrice,
    };
    return priceMapping[glassesType] - priceMapping[initialGlassesType];
}
function calcLensPackPrice(opticalData, glassesType, lensPack, useIncludedLensPack) {
    var _a, _b, _c, _d, _e, _f;
    if (useIncludedLensPack === void 0) { useIncludedLensPack = false; }
    var brand = opticalData.brand, isKidsGlasses = opticalData.isKidsGlasses;
    var lensPackPrice = 0;
    if (glassesType === 'frameOnly') {
        return lensPackPrice;
    }
    var monofocalLensPacks = opticalData.monofocalLensPacks, multifocalLensPacks = opticalData.multifocalLensPacks;
    var activePackList = glassesType === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
    var selectedPack = activePackList.find(function (pack) { return pack.packType === lensPack; });
    if (!selectedPack) {
        return lensPackPrice;
    }
    if (!useIncludedLensPack) {
        return (_a = getPriceOfLensPack(selectedPack)) !== null && _a !== void 0 ? _a : 0;
    }
    if (opticalData.includedLensPack &&
        opticalData.includedLensPack.packType === lensPack &&
        glassesType === 'frameAndMonofocal') {
        // if the lensPack is already included, then set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMonofocal' &&
        lensPack === 'basic' &&
        (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' is included on Seen and kids glasses --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMonofocal' &&
        lensPack === 'basic' &&
        brand.toLowerCase() !== 'seen' &&
        !isKidsGlasses) {
        // 'bronze' is also included on other brands --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMultifocal' &&
        (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' pack price is also included on Seen and 'kids' glasses when MULTIfocal
        // The price of 'basic' needs to be subtracted from every lenspack to make calculations be correct
        var basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var basicMultiPackPrice = (_b = getPriceOfLensPack(basicMultiPack)) !== null && _b !== void 0 ? _b : 0;
        lensPackPrice = ((_c = getPriceOfLensPack(selectedPack)) !== null && _c !== void 0 ? _c : 0) - basicMultiPackPrice;
    }
    else if (glassesType === 'frameAndMultifocal' && !isKidsGlasses) {
        // 'bronze' pack price is included on non-Seen and non-'kids' glasses when MULTIfocal
        // The price of 'bronze' needs to be subtracted from every lenspack to make calculations be correct
        var basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var basicMultiPackPrice = (_d = getPriceOfLensPack(basicMultiPack)) !== null && _d !== void 0 ? _d : 0;
        lensPackPrice = ((_e = getPriceOfLensPack(selectedPack)) !== null && _e !== void 0 ? _e : 0) - basicMultiPackPrice;
    }
    else {
        lensPackPrice = (_f = getPriceOfLensPack(selectedPack)) !== null && _f !== void 0 ? _f : 0;
    }
    return lensPackPrice;
}
function calcSelectedExtrasPrice(extrasData, selectedExtras) {
    var price = 0;
    if (selectedExtras) {
        return extrasData
            .filter(function (_a) {
            var value = _a.value;
            return selectedExtras.indexOf(value) >= 0;
        })
            .reduce(function (sum, item) { return sum + item.price || 0; }, 0);
    }
    return price;
}
// HELPERS
function findAndSortBenefits(packs, intl, sorting) {
    var map = sorting.reduce(function (main, value, index) {
        var _a;
        return (__assign$1(__assign$1({}, main), (_a = {}, _a[value] = index, _a)));
    }, {});
    return packs.map(function (pack) {
        var benefits = pack.attributes &&
            pack.attributes
                .filter(function (attr) { return attr.name.match('(cb[A-Z])\\w+') && attr.name in map; })
                .sort(function (a, b) { return map[a.name] - map[b.name]; })
                .map(function (benefit) {
                var labelKey = "products.ssp.lenses." + benefit.name;
                var label = (intl && intl.getLabel && intl.getLabel(labelKey)) || '';
                return __assign$1(__assign$1({}, benefit), { label: label });
            });
        if (!benefits) {
            return __assign$1(__assign$1({}, pack), { benefits: [] });
        }
        return __assign$1(__assign$1({}, pack), { benefits: benefits });
    });
}
function getInitialLensPack(lensPackData, selector) {
    var selection = lensPackData.find(function (pack) { return pack.packType === selector; });
    return selection ? selection : lensPackData[0];
}
function getPriceOfLensPack(lensPack) {
    var _a, _b, _c;
    return (_c = (_b = (_a = lensPack === null || lensPack === void 0 ? void 0 : lensPack.prices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.centAmount;
}

var isGlassesType = function (input) {
    return input === 'frameOnly' || input === 'frameAndMonofocal' || input === 'frameAndMultifocal';
};
var ExtraTypes;
(function (ExtraTypes) {
    ExtraTypes["tinted-lenses-pack"] = "tinted-lenses-pack";
    ExtraTypes["manufactured-lenses"] = "manufactured-lenses";
    ExtraTypes["screen-protection-pack"] = "screen-protection-pack";
    ExtraTypes["polarized-pack"] = "polarized-pack";
    ExtraTypes["personalized-pack"] = "personalized-pack";
    ExtraTypes["light-adaptive-pack"] = "light-adaptive-pack";
    ExtraTypes["gradient-pack"] = "gradient-pack";
})(ExtraTypes || (ExtraTypes = {}));
var isExtraType = function (input) { return input in ExtraTypes; };
var Aside = function (_a) {
    var currency = _a.currency, price = _a.price, prefix = _a.prefix, className = _a.className;
    return (React.createElement("div", { className: className },
        prefix,
        " ",
        React.createElement(Price, { value: price, centAmount: true, currency: currency })));
};
var SSP = /** @class */ (function (_super) {
    __extends$1(SSP, _super);
    function SSP(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.setExtrasData = function (selectedGlasses, selectedLensPack, selectedExtras) {
            var _a = _this.createExtrasItems(_this.props.lensExtras), monofocalExtras = _a.monofocalExtras, multifocalExtras = _a.multifocalExtras;
            var allowedExtras = _this.props.lensExtrasResolver(selectedGlasses, selectedLensPack, selectedExtras, _this.opticalData);
            var extrasData = selectedGlasses === 'frameAndMonofocal' ? monofocalExtras : multifocalExtras;
            extrasData = extrasData.map(function (extra) {
                var enabled = allowedExtras && allowedExtras.indexOf(extra.value) > -1;
                var checked = enabled && selectedExtras && selectedExtras.indexOf(extra.value) > -1;
                return __assign$1(__assign$1({}, extra), { isChecked: checked, disabled: !enabled });
            });
            return extrasData;
        };
        _this.createExtrasItems = function (data) {
            var intl = _this.props.intl;
            var monofocalExtras = data
                .filter(function (item) {
                return isExtraType(item.slug.en) && item.masterVariant.prices && item.masterVariant.prices.length;
            })
                .map(function (item) {
                // @ts-ignore, is checked in the filter above
                var price = item.masterVariant.prices[0].value.centAmount;
                var Aside = (React.createElement("div", null,
                    "+ ",
                    React.createElement(Price, { value: price, centAmount: true, currency: intl.currency })));
                return {
                    scope: 'extras',
                    title: getLocalizedValue(item.name, intl.locale),
                    text: item.description ? getLocalizedValue(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: Aside,
                    price: price,
                    disabled: false,
                };
            });
            var multifocalExtras = data
                .filter(function (item) {
                return item.variants.length !== 0 &&
                    item.variants[0].prices &&
                    item.variants[0].prices.length &&
                    isExtraType(item.slug.en);
            })
                .map(function (item) {
                // @ts-ignore, is checked in the filter above
                var price = item.variants[0].prices[0].value.centAmount;
                return {
                    scope: 'extras',
                    title: item.name ? getLocalizedValue(item.name, intl.locale) : '',
                    text: item.description ? getLocalizedValue(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: React.createElement(Aside, { prefix: "+", price: price, currency: intl.currency }),
                    price: price,
                    disabled: false,
                };
            });
            return {
                monofocalExtras: monofocalExtras,
                multifocalExtras: multifocalExtras,
            };
        };
        _this.createGlassesItems = function () {
            var _a = _this.props, initialGlasses = _a.initialGlasses, useIncludedFrame = _a.useIncludedFrame, intl = _a.intl;
            var glassesTypes = ['frameOnly', 'frameAndMonofocal', 'frameAndMultifocal'];
            var glassesItems = glassesTypes
                .filter(function (glassesType) {
                // Only NON-kids frames can have multifocal.
                return !(glassesType === 'frameAndMultifocal' && _this.opticalData.isKidsGlasses);
            })
                .map(function (glassesType) {
                var price = calcGlassesPrice(_this.opticalData, glassesType);
                var prefix = '';
                if (useIncludedFrame) {
                    price = calcGlassesPriceDifference(_this.opticalData, glassesType, initialGlasses);
                    prefix = price < 0 ? '-' : price > 0 ? '+' : '';
                }
                return {
                    title: intl.getLabel("products.ssp.glasses." + glassesType + ".title"),
                    text: intl.getLabel("products.ssp.glasses." + glassesType + ".text"),
                    value: glassesType,
                    scope: 'glasses',
                    aside: useIncludedFrame && price === 0 ? (React.createElement("div", null, intl.getLabel('products.included'))) : (React.createElement(Aside, { prefix: prefix, price: Math.abs(price), currency: intl.currency })),
                    disabled: false,
                };
            });
            return glassesItems;
        };
        _this.handleGlassesTypeChange = function (type) {
            if (!isGlassesType(type)) {
                console.error("Invalid glasses type: \"" + type + "\"");
                return;
            }
            var _a = _this.state, selectedLensPack = _a.selectedLensPack, selectedExtras = _a.selectedExtras;
            _this.extrasData = _this.setExtrasData(type, selectedLensPack, selectedExtras);
            var newExtras = [];
            if (type === 'frameOnly') {
                newExtras = [];
            }
            else {
                newExtras = _this.filterByAllowed(type, selectedLensPack, selectedExtras);
            }
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, type);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, type, selectedLensPack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedGlasses: type,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        _this.handleLensPackChange = function (pack) {
            var _a = _this.state, selectedGlasses = _a.selectedGlasses, selectedExtras = _a.selectedExtras;
            _this.extrasData = _this.setExtrasData(selectedGlasses, pack, selectedExtras);
            var newExtras = _this.filterByAllowed(selectedGlasses, pack, selectedExtras);
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, selectedGlasses);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, selectedGlasses, pack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedLensPack: pack,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        _this.handleExtrasChange = function (items) {
            var extras = items.filter(function (item) { return isExtraType(item.value); });
            var values = extras.map(function (i) { return i.value; });
            var _a = _this.state, selectedGlasses = _a.selectedGlasses, selectedLensPack = _a.selectedLensPack;
            var newExtras = _this.filterByAllowed(selectedGlasses, selectedLensPack, values);
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, selectedGlasses);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, selectedGlasses, selectedLensPack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        // all product data, dynamically created based on data provided by page
        var frameData = getFrameData(_this.props.product);
        var lensPackData = getLensPacks(_this.props.product, frameData.isKidsGlasses);
        _this.opticalData = __assign$1(__assign$1(__assign$1({}, frameData), lensPackData), { lensExtras: _this.props.lensExtras, frameAndMonofocalPrice: 0, frameAndMultifocalPrice: 0 });
        var includedLensPackPrice = _this.opticalData.includedLensPack
            ? (_a = getPriceOfLensPack(_this.opticalData.includedLensPack)) !== null && _a !== void 0 ? _a : 0
            : 0;
        var initialPrice = props.useIncludedLensPack
            ? includedLensPackPrice + frameData.framePrice
            : frameData.framePrice;
        var frameAndMonofocalPrice = initialPrice;
        var initLensPackMultifocal = getInitialLensPack(_this.opticalData.multifocalLensPacks);
        var initialLensPackMultifocalPrice = props.useIncludedLensPack && initLensPackMultifocal
            ? (_b = getPriceOfLensPack(initLensPackMultifocal)) !== null && _b !== void 0 ? _b : 0
            : 0;
        var frameAndMultifocalPrice = !_this.opticalData.isKidsGlasses
            ? initialLensPackMultifocalPrice + initialPrice
            : 0;
        _this.opticalData = __assign$1(__assign$1({}, _this.opticalData), { frameAndMonofocalPrice: frameAndMonofocalPrice, frameAndMultifocalPrice: frameAndMultifocalPrice });
        // initial options
        // Initial selected type of glasses
        var initialGlasses = _this.props.initialGlasses || 'frameAndMonofocal';
        var initialLensPackType = _this.props.initialLensPack || getInitialLensPack(_this.opticalData.monofocalLensPacks).packType;
        // Initial extras start empty
        var initialExtras = _this.props.initialExtras || [];
        // Set extrasData
        _this.extrasData = _this.setExtrasData(initialGlasses, initialLensPackType, initialExtras);
        // Set all prices based on initial selections
        var newGlassesPrice = calcGlassesPrice(_this.opticalData, initialGlasses);
        var newLensPackPrice = calcLensPackPrice(_this.opticalData, initialGlasses, initialLensPackType, props.useIncludedLensPack);
        var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, initialExtras);
        var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
        _this.state = {
            isLoading: true,
            selectedGlasses: initialGlasses,
            selectedLensPack: initialLensPackType,
            selectedExtras: initialExtras,
            glassesPrice: newGlassesPrice,
            lensPackPrice: newLensPackPrice,
            extrasPrice: newExtrasPrice,
            totalPrice: totalPrice,
        };
        return _this;
    }
    SSP.prototype.filterByAllowed = function (glasses, lensPack, extras) {
        // Get allowed extras based on the value and assign to newExtras
        var allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, extras, this.opticalData);
        var newExtras = extras.filter(function (item) { return allowedExtras.indexOf(item) > -1; });
        // With the newExtras, check allowedExtras again and filter it with the newExtras itself
        allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, newExtras, this.opticalData);
        newExtras = extras.filter(function (item) { return allowedExtras.indexOf(item) > -1; });
        return newExtras;
    };
    SSP.prototype.componentDidMount = function () {
        this.setState({ isLoading: false });
        // Need to call onChange on mount to send initial values to parent on load
        this.props.onChange && this.props.onChange(this.state);
    };
    SSP.prototype.render = function () {
        var _this = this;
        var _a = this.opticalData, monofocalLensPacks = _a.monofocalLensPacks, multifocalLensPacks = _a.multifocalLensPacks;
        var _b = this.props, className = _b.className, useIncludedLensPack = _b.useIncludedLensPack, intl = _b.intl;
        var _c = this.state, selectedGlasses = _c.selectedGlasses, selectedExtras = _c.selectedExtras;
        var selectedLensPack = this.state.selectedLensPack || 'bronze';
        var activePacks = selectedGlasses === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
        this.extrasData = this.setExtrasData(selectedGlasses, selectedLensPack, selectedExtras);
        // Monofocal table will show only benefits that match this array and sort them accordingly
        var monoSorting = [
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbReducedEyeFatigue',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses',
        ];
        // Multifocal table will show only benefits that match this array and sort them accordingly
        var multiSorting = [
            'visualField',
            'cbPerfectSight',
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses',
        ];
        var glassesItems = this.createGlassesItems();
        var sorting = selectedGlasses === 'frameAndMonofocal' ? monoSorting : multiSorting;
        var packsWithBenefits = findAndSortBenefits(activePacks, intl, sorting);
        var withVisualField = packsWithBenefits
            .filter(function (pack) { return pack.attributes; })
            .map(function (pack) { return pack.attributes; })
            .reduce(function (a, b) { return a.concat(b); }, [])
            .some(function (attr) { return attr.name === 'visualField'; });
        var withVoucherValues = packsWithBenefits.length > 0 &&
            packsWithBenefits
                .map(function (pack) {
                var voucherAttr = getAttrValue(pack, 'voucher');
                return isPlainObject(voucherAttr) ? getNestedProperty(voucherAttr, 'centAmount', 0) : 0;
            })
                .some(function (value) { return value > 0; });
        var SSPclasses = classnames({
            ssp: true,
            'ssp--with-voucher': withVoucherValues,
            'ssp--with-visual-field': withVisualField,
            className: className,
        });
        var selectedItems = this.state.selectedExtras.reduce(function (acc, name) {
            var extra = _this.extrasData.find(function (e) { return e.value === name; });
            return extra ? __spreadArray$1(__spreadArray$1([], __read(acc)), [extra]) : acc;
        }, []);
        return (React.createElement("div", { className: SSPclasses },
            React.createElement("div", { className: "site-container ssp__container" }, this.state.isLoading ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null,
                React.createElement(Heading, { variant: "small", className: "ssp__section-title" }, intl.getLabel('products.ssp.glasses.title')),
                React.createElement(SelectionGroup, { items: glassesItems, selectedItem: this.state.selectedGlasses, onChange: this.handleGlassesTypeChange }),
                this.state.selectedGlasses !== 'frameOnly' && (React.createElement(React.Fragment, null,
                    intl.getLabel('products.ssp.lenses.title') && (React.createElement(Heading, { variant: "small", className: "ssp__section-title" }, intl.getLabel('products.ssp.lenses.title'))),
                    React.createElement(LensPacks$1, { packs: packsWithBenefits, selectedPack: this.state.selectedLensPack || 'bronze', selectedGlasses: this.state.selectedGlasses, onChange: this.handleLensPackChange, useIncludedLensPack: useIncludedLensPack }),
                    this.extrasData.length > 0 && (React.createElement(React.Fragment, null,
                        intl.getLabel('products.ssp.extras.title') && (React.createElement(Heading, { variant: "small", className: "ssp__section-title" }, intl.getLabel('products.ssp.extras.title'))),
                        React.createElement(CheckboxList, { checkboxAlignment: "middle", className: "ssp__lens-extras", itemClassName: "ssp__lens-extras-item", idPrefix: "ssp-lens-extra__", items: this.extrasData, selectedItems: selectedItems, getItemIdentifier: function (item) { return item.value; }, isItemDisabled: function (item) { return item.disabled; }, renderItem: function (item) { return (React.createElement("div", { className: classnames('ssp-lens-extra__content', {
                                    'ssp-lens-extra__content--disabled': item.disabled,
                                }) },
                                React.createElement("div", { className: "ssp-lens-extra__main" },
                                    React.createElement("span", { className: "ssp-lens-extra__title" }, item.title),
                                    React.createElement("span", { className: "ssp-lens-extra__text" }, item.text)),
                                React.createElement(Aside, { prefix: "+", price: item.price, currency: intl.currency, className: "ssp-lens-extra__price" }))); }, onChange: this.handleExtrasChange }))))))))));
    };
    return SSP;
}(React.Component));
var SSP$1 = withIntl(SSP);

var RecentlyViewedProducts = function (_a) {
    var title = _a.title, renderLocation = _a.renderLocation, rest = __rest(_a, ["title", "renderLocation"]);
    var _b = useIntl(), currency = _b.currency, getLabel = _b.getLabel;
    var _c = useProductViewHistory(), history = _c.history, clear = _c.clear;
    var _d = useGetProductsBySku(history), isLoading = _d.isLoading, products = _d.products, error = _d.error;
    var noHistory = Array.isArray(history) && history.length === 0;
    var noProducts = !error && (products === null || products === void 0 ? void 0 : products.length) === 0;
    var handleImpression = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createImpressionEvent$1(product, position, "recently-viewed recommendation " + renderLocation, currency));
    }, [currency, renderLocation]);
    var handleInteraction = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createInteractionEvent(product, position, "recently-viewed recommendation " + renderLocation, currency));
    }, [currency, renderLocation]);
    // Only return null when we are sure the history is empty or when there are no products matching the SKU's in history,
    // i.e. unpublished products
    // as history will never be defined on the server and can result in HTML mismatches if we always return
    if (noHistory || noProducts) {
        return null;
    }
    return (React.createElement("div", { className: "recently-viewed-products", "data-t": "recently-viewed-products" },
        React.createElement(Container, null,
            React.createElement(Heading, { variant: "medium" }, title || getLabel('products.recentlyViewed.title')),
            React.createElement(ProductBanner, __assign$1({ isLoading: isLoading, error: error, products: products, onProductImpression: handleImpression, onProductInteraction: handleInteraction }, rest)),
            React.createElement("div", { className: "recently-viewed-products__clear" },
                React.createElement(Button, { caption: getLabel('products.recentlyViewed.clear'), onClick: clear, variant: "ghost", size: "custom" })))));
};
var RecentlyViewedProducts$1 = withLazyLoading(RecentlyViewedProducts, {
    rootMargin: '200px 0px',
});

var GET_RECOMMENDATIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getRecommendations($input: RecommendationInput!) {\n    getRecommendations(input: $input) {\n      recommendedProducts {\n        sku\n        price {\n          value {\n            type\n            currencyCode\n            centAmount\n            fractionDigits\n          }\n          discounted {\n            value {\n              type\n              currencyCode\n              centAmount\n              fractionDigits\n            }\n            discount {\n              typeId\n              description\n            }\n          }\n        }\n        brand\n        brandModel\n        productType\n        name\n        slug\n        images {\n          url\n          label\n          dimension {\n            width\n            height\n          }\n        }\n        promotionLabel\n        action {\n          ... on RecommendationProductRedirectAction {\n            slug\n          }\n        }\n      }\n      recommendedBanners {\n        title\n        description\n        image {\n          url\n          label\n          dimension {\n            width\n            height\n          }\n        }\n        position\n        action {\n          ... on RecommendationBannerRedirectToLinkAction {\n            link {\n              url\n              label\n            }\n          }\n          ... on RecommendationBannerApplyDiscountCodeAction {\n            discountCode\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getRecommendations($input: RecommendationInput!) {\n    getRecommendations(input: $input) {\n      recommendedProducts {\n        sku\n        price {\n          value {\n            type\n            currencyCode\n            centAmount\n            fractionDigits\n          }\n          discounted {\n            value {\n              type\n              currencyCode\n              centAmount\n              fractionDigits\n            }\n            discount {\n              typeId\n              description\n            }\n          }\n        }\n        brand\n        brandModel\n        productType\n        name\n        slug\n        images {\n          url\n          label\n          dimension {\n            width\n            height\n          }\n        }\n        promotionLabel\n        action {\n          ... on RecommendationProductRedirectAction {\n            slug\n          }\n        }\n      }\n      recommendedBanners {\n        title\n        description\n        image {\n          url\n          label\n          dimension {\n            width\n            height\n          }\n        }\n        position\n        action {\n          ... on RecommendationBannerRedirectToLinkAction {\n            link {\n              url\n              label\n            }\n          }\n          ... on RecommendationBannerApplyDiscountCodeAction {\n            discountCode\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1;

function pushEvent(event, ecommerce) {
    DataLayer.pushEvent({ event: '', atfEcommerce: null });
    DataLayer.pushEvent({ event: event, atfEcommerce: { ecommerce: ecommerce } });
}
function pushProductImpressions(product, position) {
    pushEvent('gvProductImpressions', {
        currencyCode: product.price.value.currencyCode,
        impressions: [convertProduct(product, position)],
    });
}
function pushProductClick(product, position) {
    pushEvent('gvProductClick', {
        currencyCode: product.price.value.currencyCode,
        click: {
            actionField: { list: 'product recommendation mini cart' },
            products: [convertProduct(product, position)],
        },
    });
}
function pushPromotionImpression(promotion) {
    pushEvent('gvPromotionImpressions', {
        promoView: {
            promotions: [convertPromotion(promotion)],
        },
    });
}
function pushPromotionClick(promotion) {
    pushEvent('gvPromotionClick', {
        promoClick: {
            promotions: [convertPromotion(promotion)],
        },
    });
}
function convertProduct(product, position) {
    return {
        name: product.name,
        id: product.sku,
        price: calcPrice(product.price.value.centAmount),
        brand: product.brand,
        list: 'product recommendation mini cart',
        position: position,
    };
}
function convertPromotion(promotion) {
    return {
        name: promotion.title,
        creative: promotion.recommendationType,
        position: promotion.position,
    };
}

var convertProductRecommendationInfo = function (recommendation, formatProductUrl, locale) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    if (!CommerceToolsApi.isProductTypeName(recommendation.productType)) {
        console.error("Recommendation has invalid product type name \"" + recommendation.productType + "\"");
        return;
    }
    var images = recommendation.images.reduce(function (m, image) {
        return !image.label || !image.dimension
            ? m
            : __spreadArray$1(__spreadArray$1([], __read(m)), [
                {
                    url: image.url,
                    label: image.label,
                    dimensions: {
                        w: image.dimension.width,
                        h: image.dimension.height,
                    },
                },
            ]);
    }, []);
    var hasFrontImage = Boolean(images[0]);
    var hasAngleImage = Boolean(images[1]);
    var front = hasFrontImage
        ? createResponsiveImage((_b = images[0]) === null || _b === void 0 ? void 0 : _b.url, (_d = (_c = images[0]) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : undefined)
        : undefined;
    var angle = hasAngleImage
        ? createResponsiveImage((_e = images[1]) === null || _e === void 0 ? void 0 : _e.url, (_g = (_f = images[1]) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : undefined)
        : undefined;
    return __assign$1({ sku: recommendation.sku, brand: recommendation.brand, url: formatProductUrl({
            slug: (_a = {}, _a[locale] = recommendation.slug, _a),
            sku: recommendation.sku,
            productType: recommendation.productType,
        }), images: {
            front: front,
            angle: angle,
        }, productType: recommendation.productType, name: recommendation.name || recommendation.brandModel || '', price: recommendation.price.value.centAmount, discountedPrice: (_h = recommendation.price.discounted) === null || _h === void 0 ? void 0 : _h.value.centAmount }, (recommendation.promotionLabel ? { promotionLabel: recommendation.promotionLabel } : {}));
};
var convertBannerRecommendationInfo = function (recommendation) {
    var _a;
    var responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
    return {
        title: recommendation.title,
        description: recommendation.description,
        image: {
            url: responsiveImage.url,
            mobileUrl: responsiveImage.url,
            description: recommendation.description,
        },
        action: (_a = recommendation.action) !== null && _a !== void 0 ? _a : undefined,
    };
};

var BannerRecommendation = React__default.forwardRef(function (_a, ref) {
    var recommendation = _a.recommendation, rest = __rest(_a, ["recommendation"]);
    var info = convertBannerRecommendationInfo(recommendation);
    if (!info)
        return null;
    var link;
    if (info.action && 'link' in info.action) {
        link = info.action.link;
    }
    return (React__default.createElement(PromotionBlock, __assign$1({ ref: ref, id: "banner-recommendation_" + info.title, 
        /**
         * CTA will not show if there's no label. This is not clear from the type.
         */
        ctaLabel: (link === null || link === void 0 ? void 0 : link.label) || '', size: "small", links: __assign$1(__assign$1({}, link), { style: '' }) }, info, rest)));
});

var BannerRecommendationContainer = function (props) {
    var recommendation = props.recommendation;
    var clickRef = useRef(false);
    var _a = useWasSeenByUser(), ref = _a.ref, wasSeen = _a.wasSeen;
    var handlePromotionClick = useCallback(function () {
        if (!clickRef.current) {
            clickRef.current = true;
            pushPromotionClick(recommendation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (wasSeen) {
            pushPromotionImpression(recommendation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wasSeen]);
    return (React__default.createElement(BannerRecommendation, { ref: ref, recommendation: recommendation, onClick: handlePromotionClick }));
};

var ListItemWrapper = function (_a) {
    var children = _a.children;
    return (React__default.createElement(motion.li, { variants: {
            start: { opacity: 0 },
            end: { opacity: 1 },
        }, className: "recommendation-list__list-item" }, children));
};

var ProductRecommendation = React__default.forwardRef(function (_a, ref) {
    var recommendation = _a.recommendation, formatProductUrl = _a.formatProductUrl, locale = _a.locale, rest = __rest(_a, ["recommendation", "formatProductUrl", "locale"]);
    var info = convertProductRecommendationInfo(recommendation, formatProductUrl, locale);
    if (!info)
        return null;
    var sku = info.sku, recommendationRest = __rest(info, ["sku"]);
    return (React__default.createElement(ProductBlock, __assign$1({ ref: ref, activeSku: sku }, recommendationRest, { 
        /* We have to pass onVariantChange given it is not optional, even though
         * we know we will never have have variants on recommendations.
         */
        /* eslint-disable-next-line @typescript-eslint/no-empty-function */
        onVariantChange: function () { }, 
        /**
         * Some other props that are required but we don't need (yet).
         */
        variants: [], isInsuranceReimbursable: false }, rest)));
});

var ProductRecommendationContainer = function (props) {
    var recommendation = props.recommendation, position = props.position;
    var clickRef = useRef(false);
    var _a = useWasSeenByUser(), ref = _a.ref, wasSeen = _a.wasSeen;
    var handleRecommendationClick = useCallback(function () {
        if (!clickRef.current) {
            pushProductClick(recommendation, position);
            clickRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (wasSeen) {
            pushProductImpressions(recommendation, position);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wasSeen]);
    return React__default.createElement(ProductRecommendation, __assign$1({ ref: ref }, props, { onClick: handleRecommendationClick }));
};

function isProductRecommendation(recommendation) {
    return recommendation.recommendationType === 'product';
}
function isBannerRecommendation(recommendation) {
    return recommendation.recommendationType === 'banner';
}

var RecommendationList = function (_a) {
    var labels = _a.labels, recommendations = _a.recommendations, locale = _a.locale, formatProductUrl = _a.formatProductUrl;
    var validRecommendations = recommendations.filter(isValidRecommendation);
    if (!validRecommendations.length)
        return null;
    return (React__default.createElement(motion.div, { style: { overflow: 'hidden' }, variants: {
            start: { height: 0 },
            end: { height: 'auto' },
        }, transition: { type: 'tween' }, initial: "start", animate: "end", className: "recommendation-list" },
        React__default.createElement(Heading, { component: "h2", variant: "smallest", className: "recommendation-list__title" }, labels.title),
        React__default.createElement(motion.ul, { variants: {
                start: { opacity: 1 },
                end: { opacity: 1 },
            }, transition: { delayChildren: 0.25, staggerChildren: 0.1 }, className: "recommendation-list__list" }, validRecommendations.map(function (recommendation, index) {
            return isProductRecommendation(recommendation) ? (React__default.createElement(ListItemWrapper, { key: recommendation.sku },
                React__default.createElement(ProductRecommendationContainer, { recommendation: recommendation, locale: locale, formatProductUrl: formatProductUrl, position: index + 1 }))) : (React__default.createElement(ListItemWrapper, { key: recommendation.position + "-" + recommendation.title },
                React__default.createElement(BannerRecommendationContainer, { recommendation: recommendation })));
        }))));
};
function isValidRecommendation(recommendation) {
    return (isBannerRecommendation(recommendation) ||
        (isProductRecommendation(recommendation) &&
            CommerceToolsApi.isProductTypeName(recommendation.productType)));
}

var mergeAndSortRecommendations = function (recommendedProducts, recommendedBanners, options) {
    var positionAscending = function (a, b) { return a.position - b.position; };
    var recommendations = recommendedProducts.map(function (p) { return (__assign$1(__assign$1({}, p), { recommendationType: 'product' })); });
    var banners = recommendedBanners.map(function (b) { return (__assign$1(__assign$1({}, b), { recommendationType: 'banner' })); });
    /*
     * Each promotion (a.k.a. banner) delivered by the backend has a position associated
     * with it. Here we make sure the promotions are interleaved with the
     * products, based on each promotion's "position" property.
     */
    banners.sort(positionAscending).forEach(function (b) {
        if (isBannerRecommendation(b))
            recommendations.splice(b.position, 0, b);
    });
    return (options === null || options === void 0 ? void 0 : options.maxItems) ? recommendations.slice(0, options.maxItems) : recommendations;
};

var RecommendationListContainer = function (_a) {
    var _b, _c;
    var skus = _a.skus, recommendationContext = _a.recommendationContext, formatProductUrl = _a.formatProductUrl, maxItems = _a.maxItems;
    var _d = useIntl(), getLabel = _d.getLabel, locale = _d.locale;
    var _e = useQuery(GET_RECOMMENDATIONS, {
        variables: {
            input: {
                skus: skus,
                recommendationContext: recommendationContext,
                locale: locale,
            },
        },
    }), data = _e.data, loading = _e.loading, error = _e.error;
    var labels = React__default.useMemo(function () { return ({
        title: getLabel('products.recommendationList.title'),
    }); }, [getLabel]);
    if (error || (!loading && !data)) {
        return null;
    }
    var recommendedProducts = ((_b = data === null || data === void 0 ? void 0 : data.getRecommendations) === null || _b === void 0 ? void 0 : _b.recommendedProducts) || [];
    var recommendedBanners = ((_c = data === null || data === void 0 ? void 0 : data.getRecommendations) === null || _c === void 0 ? void 0 : _c.recommendedBanners) || [];
    var recommendations = mergeAndSortRecommendations(recommendedProducts, recommendedBanners, {
        maxItems: maxItems,
    });
    if (!loading && !recommendations.length) {
        return null;
    }
    return (React__default.createElement(RecommendationList, { labels: labels, recommendations: recommendations, locale: locale, formatProductUrl: formatProductUrl }));
};

var RecommendationListMiniCartLayout = function (props) { return (React.createElement(RecommendationListContainer, __assign$1({}, props))); };

var FeaturedProducts = function (_a) {
    var title = _a.title, renderLocation = _a.renderLocation, rest = __rest(_a, ["title", "renderLocation"]);
    var getLabel = useIntl().getLabel;
    return (React.createElement(ProductPromotionEventProvider, { location: "featured reccommendation " + renderLocation },
        React.createElement("div", { className: "featured-products" },
            React.createElement(Container, null,
                React.createElement(Heading, { className: "featured-products__title", variant: "medium", align: "center" }, title || getLabel('products.featured.title')),
                React.createElement(ProductBannerContainer, __assign$1({}, rest))))));
};
var FeaturedProducts$1 = withLazyLoading(FeaturedProducts);

var ProductStructuredDataObject = function (props) {
    var activeSku = useProductDetailContext().activeSku;
    return React.createElement(Product, __assign$1({}, props, { activeSKU: activeSku }));
};

function parseProductDetailQueryParams(queryParams) {
    var _a = queryParams || {}, isInsuranceReimbursable = _a.isInsuranceReimbursable, _b = _a.offerings, offerings = _b === void 0 ? '' : _b;
    return {
        isReimbursable: isInsuranceReimbursable === 'true',
        filteredOfferings: Array.isArray(offerings) ? offerings : offerings.split(',').filter(Boolean),
    };
}

/**
 * Products module
 *
 * Contains all components related to products
 *
 * @grandvisionhq/products
 */
SagaRegistry.register('contactLensSubscription', contactLensSubscriptionSaga);
ReducersRegistry.register('contactLensSubscription', contactLensSubscriptionReducer);
SagaRegistry.register('prescriptionGlasses', prescriptionGlassesSaga);
ReducersRegistry.register('prescriptionGlasses', prescriptionGlassesReducer);

export { actions as Actions, AlgoliaProductBlock, ConfigureContactLenses, CrossSellBlock, CrossSellItem$1 as CrossSellItem, DailyPackageQuantityContainer as DailyPackageQuantity, FeaturedProducts$1 as FeaturedProducts, helpers as Helpers, LensPacks$1 as LensPacks, RecommendationListMiniCartLayout as MiniCartProductRecommendations, PackageQuantityContainer$1 as PackageQuantity, PackageQuantityDropdown, Prescription$1 as Prescription, ProductBannerContainer as ProductBanner, ProductBanner as ProductBannerView, CommerceToolsProductBlock as ProductBlock, ProductBlocksContainer, ProductCatalogBreadcrumbs, ProductDetail, ProductDetailDescription, ProductDetailFeatures, ProductDetailImage, ProductDetailLensesFeatures, ProductDetailOpticsFeatures, ProductDetailProvider, ProductDetailSlotsProvider, ProductDetailTitle$1 as ProductDetailTitle, ProductDetailUnitInfo, ProductDiscountBar, ProductDiscountLabel$1 as ProductDiscountLabel, ProductFrameMeasurements$1 as ProductFrameMeasurements, ProductImageGalleryContainer as ProductImageGallery, ProductListing, ProductOffersContainer as ProductOffers, ProductPlaceholder, ProductPromotionEventProvider, ProductPromotions, ProductStructuredDataObject, types as ProductTypes, ProductVisualSwitcher, RecentlyViewedProducts$1 as RecentlyViewedProducts, SSP$1 as SSP, Solution, PackageQuantityContainer as SubscriptionPackageQuantity, SubscriptionSolutionPicker, SubscriptionSolutionPickerContainer, TryOnButton, VirtualTryOn, VtoConfigProvider, createImpressionEvent$1 as createImpressionEvent, createInteractionEvent, createVtoServerConfig, getProductSeoInfo, isContactLenses, isLightProductModel, isRateplansDaily, parseProductDetailQueryParams, useProductDetailContext, useVtoConfig };
//# sourceMappingURL=index.js.map
